const _ = {
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  T_12_I_GIFT_SENDER_BELL: "벨",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "그가 보이다가 또 안 보이네요. [FFB300](헬멧이 보이지 않습니다)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "산타의 마스크",
  T_12_L_COS_PINKMAN: "핑크 공룡",
  T_12_L_COS_POLAR: "북극곰",
  T_12_L_COS_RENDER: "레인보우 공룡",
  T_12_L_COS_TIGER: "호랑이 공룡",
  T_12_L_MALE_BOTTOM_COS_ELF: "윈터 엘프 (하의)",
  T_12_L_MALE_COS_SANTA: "산타",
  T_12_L_MALE_HAIR_COS_ELF: "윈터 엘프 (머리)",
  T_12_L_MALE_SHOE_COS_ELF: "윈터 엘프 (신발)",
  T_12_L_MALE_TOP_COS_ELF: "윈터 엘프 (상의)",
  T_12_O_CAT_NAME: "냥냥이",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-크리스마스",
  T_12_O_MACHETE_GOLD_NAME: "골든 블레이드",
  T_12_O_PET_TITLE: "펫",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "점핑부츠",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "현대 과학 기술로 만든 신발입니다. 이 신발을 신고 있을 때 더블 점프를 할 수 있습니다.",
  T_12_Q_ITEM_FLYSHOE: "제트팩 신발",
  T_12_Q_ITEM_FLYSHOE_DESC: "날 수 있게 하는 신발입니다. 공중에서 연료가 떨어지지 않기 위해 조심해야 합니다.",
  T_12_Q_ITEM_STOCK1: "개머리판 Lv1",
  T_12_Q_ITEM_STOCK2: "개머리판 Lv2",
  T_12_Q_ITEM_STOCK3: "개머리판 Lv3",
  T_12_Q_ITEM_TREATMENTGUN: "힐링건",
  T_12_Q_ITEM_VEST4: "방탄복Lv4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "안토니오",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "오공",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "슛 댄스",
  T_12_R_EMOTE_WAVE_NAME: "팔 웨이브",
  T_12_R_SKILL_NAME_GANGLEADER: "깡패의 정신",
  T_12_R_SKILL_NAME_MONKEYGOD: "위장술",
  T_13_I_COLLECTION_V_AMPHIBIAN: "수륙양용차",
  T_13_I_COLLECTION_V_JEEP: "지프차",
  T_13_I_COLLECTION_V_MONSTER: "몬스터 트럭",
  T_13_I_COLLECTION_V_MOTOBIKE: "오토바이",
  T_13_I_COLLECTION_V_ROADSTER: "스포츠카",
  T_13_I_COLLECTION_V_SUV: "픽업 트럭",
  T_13_I_COLLECTION_V_TUTU: "툭툭이",
  T_13_L_MALE_ACCESSORY_COS_BJD: "아이스 블루 (머리)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "핑크 스위티 (하의)",
  T_13_L_MALE_HAIR_COS_BJD: "아이스 블루 (머리)",
  T_13_L_MALE_TOP_COS_VALENTINE: "핑크 스위티 (상의)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "무기",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "펫 스킨: 모험가 냥냥이",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- 큐피드",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "모코",
  T_13_R_EMOTE_BABYSHARK_NAME: "상어 가족",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "비일상 팔굽혀펴기",
  T_13_R_EMOTE_EGYPT_NAME: "파라오의 스텝",
  T_13_R_PVE_WEAPON_SLOT: "무기 슬롯",
  T_13_R_PVE_WEAPONSKIN_RANGE: "사거리",
  T_13_R_PVE_WEAPONSKIN_SPEED: "탄속",
  T_13_R_SKILL_DESC_HACKERGIRL: "명중한 적을 {0}초 동안 표시합니다. 표시 정보는 팀원과 공유됩니다",
  T_13_R_SKILL_NAME_HACKERGIRL: "해커의 눈",
  T_13_Z_KICKOFF_BAN: "차단",
  T_13_Z_ROOM_MORNING: "낮",
  T_13_Z_ROOM_NIGHT: "밤",
  T_14_G_ITEM_KATANA: "카타나",
  T_14_I_HEADPIC_SONGKRAN_NAME: "첨벙!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "큐빅 토끼",
  T_14_L_COS_EASTER: "관찰자 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "플레임 킬러 (신발)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "버니 워리어 (마스크)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- 물풍선",
  T_14_O_DOG_NAME: "기계 멍멍이",
  T_14_O_PETSKIN_IRON_DOG_NAME: "펫 스킨: 강철 멍멍이",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "펫 스킨: 번개 멍멍이",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "펫 스킨: 자석 멍멍이",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "펫 스킨: 야밤 냥냥이",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR- 블러드 문",
  T_14_O_SCAR_SHARK_NAME: "SCAR- 상어의 습격",
  T_14_Q_ITEM_RGS50: "유탄총",
  T_14_R_CHARACTER_SAMURAI_NAME: "하야토",
  T_14_R_SKILL_DESC_SAMURAI: "최대 HP가 {0}%만큼 감소되면, 방어관통이 {1}%만큼 증가됩니다.",
  T_14_R_SKILL_NAME_SAMURAI: "부시도",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "기근 기사 (마스크)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "역병 기사 (마스크)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "기근 기사 (하의)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "역병 기사 (하의)",
  T_15_L_MALE_SHOE_COS_FAIM: "기근 기사 (신발)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "역병 기사 (신발)",
  T_15_L_MALE_TOP_COS_FAIM: "기근 기사 (상의)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "역병 기사 (상의)",
  T_15_L_TOP_COS_MOTHERSDAY: "멋진 엄마",
  T_15_O_AN94_APOCALYPSE_NAME: "파멸의 불길",
  T_15_O_BASEBALLBAT_VIKING_NAME: "바이킹 배트",
  T_15_O_M1014_APOCALYPSE_NAME: "죽음의 아포칼립스",
  T_15_O_M4A1_APOCALYPSE_NAME: "역병 재앙",
  T_15_O_PANTHER_NAME: "흑표범",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "팀장",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "펫 스킨: 골든 표범",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "지배",
  T_15_O_SKS_DEATH_NAME: "전쟁이 끝나지 않다",
  T_15_O_UMP_APOCALYPSE_NAME: "종말 기근",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "개틀링",
  T_15_R_CHARACTER_AGENT_NAME: "로라",
  T_15_R_EMOTE_LETSGROOVE_NAME: "나와 함께 흔들어요.",
  T_15_R_SKILL_DESC_AGENT: "스코프인 시 정확도가 {0}% 증가합니다",
  T_15_R_SKILL_NAME_AGENT: "명사수",
  T_15_W_BACKPACK_MECHGIRL_NAME: "퍼플윙 백팩",
  T_16_B_ITEM_GRAPPLINGHOOK: "그래플링 훅",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "그래플 훅 건",
  T_16_L_MALE_COS_LEGO: "매드 브릭맨",
  T_16_L_MALE_SHOE_COS_SUMMER: "썸머 홀리데이 (신발)",
  T_16_P_MANUAL_MONSTER: "몬스터 트럭",
  T_16_P_MANUAL_MUSHROOM1: "버섯 Lv1",
  T_16_P_MANUAL_MUSHROOM2: "버섯 Lv2",
  T_16_P_MANUAL_MUSHROOM3: "버섯 Lv3",
  T_16_P_MANUAL_MUSHROOM4: "버섯 Lv4",
  T_16_P_MANUAL_ROADSTER_DESC: "세련된 스포츠 카입니다. HP는 낮지만 최대 속도가 매우 빠릅니다. 최대 2명의 플레이어를 태울 수 있습니다.",
  T_16_P_MANUAL_STROP: "짚라인",
  T_16_P_MANUAL_SUV: "픽업 트럭",
  T_16_P_MANUAL_SUV_DESC: "프리파이어의 시그니처 차량입니다. 중간 정도 갑옷과 최대 속도. 최대 2명의 플레이어를 태울 수 있습니다.",
  T_16_P_MANUAL_TUTU_DESC: "HP가 낮고 움직임이 느린 차량입니다. 최대 3명의 플레이어를 태울 수 있습니다.",
  T_16_P_MANUAL_WEAPON_AR: "AR",
  T_16_P_MANUAL_WEAPON_BOMB: "수류탄",
  T_16_P_MANUAL_WEAPON_PISTOL: "권총",
  T_16_P_MANUAL_WEAPON_SG: "샷건",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "SR",
  T_16_Q_MINISENTRY: "미니 터렛",
  T_16_Q_MINISENTRY_DESC: "현대 기술로 만들어진 자동 터렛입니다. 주변의 적을 스캔하고 공격합니다.",
  T_16_R_EMOTE_DESERT_NAME: "분노의 충돌",
  T_16_R_EMOTE_EPHUNTER_NAME: "배틀 댄스",
  T_16_R_EMOTE_EPHUNTER2_NAME: "하이파이브",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "공중돌기",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "위글 워크",
  T_16_W_AK_FIRE_NAME: "AK47-불꽃 레드",
  T_16_W_SCAR_LLENN_NAME: "SCAR- 핑크 악마",
  T_16_W_SCAR_WATER_NAME: "SCAR- 수 오행",
  T_16_Y_CHARACTER_HITMAN_NAME: "라파엘",
  T_16_Y_PANDA_NAME: "명탐정 팬더",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "펫 스킨: 야생 팬더",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "펫 스킨: 스컬 팬더",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "펫 스킨: 번개 팬더",
  T_17_B_CS_MODE_NAME: "클래시 스쿼드",
  T_17_C_SKILL_NAME_PLAYBOY: "너티 무브먼트",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "왕실 제스터 (마스크)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "블러디 부인 (마스크)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "블러디 부인 (하의)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "마법 폭스 (머리)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "블러디 부인 (신발)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "블러디 부인 (상의)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "흡혈귀의 복수 (마스크)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "스트릿 떠그 (하의)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "흡혈귀의 복수 (하의)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "퍼플 셰이드 (머리)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "신사 (신발)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "흡혈귀의 복수 (신발)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "흡혈귀의 복수 (상의)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "골든 셰이드 (상의)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "펫 스킨: 냥냥이 공주",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "펫 스킨: 골든 테일",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "펫 스킨: 딥 블루",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "펫 스킨: 럭키 그린",
  T_17_O_SHIBA_NAME: "시바견",
  T_17_Q_FOLDWINGS: "글라이더",
  T_17_Q_FOLDWINGS_DESC: "높은 지형에서 미끄러져 내려갈 수 있습니다.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "파티 댄스",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- 흡혈귀",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- 유령 암살자",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- 올드 패션",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "요셉",
  T_17_Z_CS_NAME: "이름",
  T_17_Z_ROOM_JUMP_SWITCH: "점프 높이",
  T_17_Z_ROOM_SPEED_SWITCH: "이동 속도",
  T_18_B_THROWINGKNIFE_NAME: "FF 칼",
  T_18_C_DUMMY_NAME: "디코이 수류탄",
  T_18_C_SKILL_DESC_DJMALE: "{1}m 아우라를 만들면 아군의 이동 속도를 {3}% 증가하고 {0}초 동안 {2} HP/s를 회복합니다. 효과를 쌓을 수 없습니다. 쿨타임: {4}초",
  T_18_C_SKILL_NAME_DJMALE: "드랍 더 비트",
  T_18_C_SKILL_NAME_JUNKENGINEER: "기어 리사이클",
  T_18_L_COS_INDIANEWYEAR: "디왈리 디노",
  T_18_L_HAIR_COS_HALLOWEEN2019: "찡그린 얼굴",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "불꽃 레드 (마스크)",
  T_18_O_FOX_NAME: "스피릿 폭스",
  T_18_O_PETSKIN_BLACKFOX_NAME: "펫 스킨: 배틀 폭스",
  T_18_O_PETSKIN_BLUEFOX_NAME: "펫 스킨: 블루 폭스",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "펫 스킨: 용암 호박",
  T_18_O_PETSKIN_PINKFOX_NAME: "펫 스킨: 레드 폭스",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "펫 스킨: 스피릿",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- 불꽃 해골",
  T_18_W_UMP_GEISHA_N: "UMP- 손자병법",
  T_18_Y_CHARACTER_DJMALE_N: "알록",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "샤니",
  T_19_B_HB_NAME: "일렉트릭 보드",
  T_19_C_ICE_GUN_NAME: "아이스 건",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "폭발 무기 데미지가 {0}% 증가하고 데미지 범위가 {1}% 증가합니다",
  T_19_C_SKILL_DESC_TOMBOY: "차량에 있을 때 {0}초마다 {1} HP를 회복합니다. 최대 {2}초. 효과는 쌓이지 않습니다",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "데몰리션 아트",
  T_19_C_SKILL_NAME_TOMBOY: "레이서의 축복",
  T_19_I_EVENT_INFI_ITEM: "무한정",
  T_19_L_A_ICEFESTIVAL19_B: "최후의 승리",
  T_19_L_F_S_ICEFESTIVAL: "스노이 노예 (신발)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "디스코 피아스코 (하의)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "디스코 피아스코 (머리)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "디스코 피아스코 (상의)",
  T_19_O_PETSKIN_NAME: "펫 스킨: 디폴트",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "펫 스킨: 힙합 팬더",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "펫 스킨: 폴라 팬더",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "펫 스킨: 파라오의 로보",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "펫 스킨: 봄 축제 로보",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "펫 스킨: 스노이 로보",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "펫 스킨: 힙합 시바견",
  T_19_O_ROBOT_NAME: "로보",
  T_19_O_TDM_NAME: "팀 데스매치",
  T_19_R_EMOTE_MIGUEL_NAME: "브레이크 댄스",
  T_19_S_SECOND_WEAPON_TITLE: "보조무기",
  T_19_S_VEST_TITLE: "방탄복",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "더블 탄창",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA- 태거의 반란",
  T_19_W_M60_ICEFESTIVAL_N: "M60- 산타 초이스",
  T_19_W_MP40_PARK_N: "MP40- 카니발 대학살",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- 오러스 드래곤",
  T_19_X_PVE_SAMURAINAME: "가디언 사무라이",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "알바로",
  T_19_Y_CHARACTER_TOMBOY_N: "노토라",
  T_20_C_INHALER_NAME: "흡입기",
  T_20_C_SKILL_DESC_PARKOURGUY: "총으로 적을 적중하면 일정량 HP가 회복되고, 적을 쓰러뜨리면 사용자의 HP가 {0}% 회복됩니다.",
  T_20_C_SKILL_NAME_GRAFFITIST: "페인티드 레퓨지",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "데드리 벨로시티",
  T_20_C_SKILL_NAME_PARKOURGUY: "서스테인드 레이드",
  T_20_L_A_APRILFOOL2020: "메롱",
  T_20_L_F_A_METALHEAD_RED: "Ms. 화이어리 임프 헤드 (마스크)",
  T_20_L_F_B_THAIGIRL: "피닉스 억세션(하의)",
  T_20_L_F_H_KILLERCUPID: "스윗하트 큐피드(머리)",
  T_20_L_F_H_THAIGIRL: "피닉스 억세션(머리)",
  T_20_L_F_S_THAIGIRL: "피닉스 억세션(신발)",
  T_20_L_F_T_METALHEAD_RED: "Ms. 화이어리 임프 헤드 (상의)",
  T_20_L_F_T_THAIGIRL: "피닉스 억세션(상의)",
  T_20_L_JEANDINO: "데님 디노",
  T_20_L_M_A_METALHEAD_RED: "Mr. 화이어리 임프 헤드 (마스크)",
  T_20_L_M_T_METALHEAD_RED: "Mr. 화이어리 임프 헤드 (상의)",
  T_20_L_M_T_STOCKING: "젠틀맨(상의)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "펫 스킨:발렌타인 데이 폭스",
  T_20_P_CHANNEL_G: "길드",
  T_20_P_WORLD_SSPEAKER: "스피커",
  T_20_S_CSROOM_COIN: "디폴트 코인",
  T_20_U_SHIELD_GUN_NAME: "방패 총",
  T_20_W_AN94_METALHEAD_N: "AN94 - 골드 임프 헤드",
  T_20_W_P90_EVILBONE_N: "P90-퍼니셔",
  T_20_Y_CHARACTER_GRAFFITIST_N: "슈테피",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "켈리．더 스위프트",
  T_20_Y_CHARACTER_PARKOURGUY_N: "조타",
  T_21_B_SMOKEGRENADE_DESC: "연기 생성하는 아이템입니다. 숨을 때 혹은 측방 책략으로 전투할때 사용 권장합니다",
  T_21_B_SMOKEGRENADE_NAME: "연기 수류탄",
  T_21_C_AUTOPICKUP_AVERAGE: "일반 속도",
  T_21_C_SKILL_DESC_KPOPSINGER: "치료 이펙트 {0}%증가, 치료 스킬{1}%증가, 팀원 HP 손실 {2}% 감소 이펙트 추가합니다. 이펙트 쌓이지 않습니다",
  T_21_C_SKILL_DESC_SOCCERSTAR: "킬마다 최대 HP {0}증가합니다. 최대{1}까지 증가 가능합니다",
  T_21_C_SKILL_NAME_KPOPSINGER: "힐링 송",
  T_21_C_SKILL_NAME_SOCCERSTAR: "해트 트릭",
  T_21_L_ANGELICAL: "엔젤 디노",
  T_21_L_S_VNSLIPPER: "베트남 샌들",
  T_21_O_OTTER_NAME: "멜로디",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "팻 스킨: 퇴폐 멜로디",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "펫 스킨: 사쿠라 멜로디",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "팻 스킨: 네온 멜로디",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "팻 스킨: 데스 마스터",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "펫 스킨: 번갯불",
  T_21_R_EMOTE_SORROW_NAME: "왜 또 나야?",
  T_21_U_WEAPON_THOMPSON_NAME: "톰프슨 SMG",
  T_21_W_BACKPACK_SPINE_N: "펑크스터 백팩",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "데스 파이널 스트라이크",
  T_21_W_M79_RABBITKILLER_N: "M79- 힙스터 버니",
  T_21_W_PAN_VOLCANO_N: "프라잉팬- 화산의 분노",
  T_21_W_XM8_RAINBOW_N: "XM8- 송끄란",
  T_21_Y_CHARACTER_KPOPSINGER_N: "지연",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "루케타",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "엎드리거나 앉은 자세가 아닌 {0}m 이내의 적 위치를 찾아냅니다. 지속 시간 {1}초, 쿨타임 {2}초. 적의 위치는 팀원과 공유가능합니다",
  T_22_C_SKILL_NAME_DETECTIVE: "추적 정찰",
  T_22_C_SKILL_NAME_STREAMERGUY: "스포트라이트",
  T_22_L_F_H_COLLEGE: "블러드샷 주니어(머리)",
  T_22_L_F_S_SUMMER20: "썸머 눈호강(신발)",
  T_22_L_M_A_GREENCOAT: "뽀대 클럽돌이(마스크)",
  T_22_L_M_A_PINKFUR: "시선강탈 클럽돌이(마스크)",
  T_22_L_M_A_PLAGUE2: "플러그 고스트(마스크)",
  T_22_L_M_B_FAIM2: "갈망의 화염(하의)",
  T_22_L_M_B_GREENCOAT: "뽀대 클럽돌이(하의)",
  T_22_L_M_B_PINKFUR: "시선강탈 클럽돌이(하의)",
  T_22_L_M_B_PLAGUE2: "플러그 고스트(하의)",
  T_22_L_M_B_REDPANTS: "힙스터 클럽돌이(하의)",
  T_22_L_M_B_TIGERSTRIPE: "호피 클럽돌이(하의)",
  T_22_L_M_H_COLLEGE: "블러드샷 시니어(머리)",
  T_22_L_M_H_FAIM2: "갈망의 화염(머리)",
  T_22_L_M_H_GREENCOAT: "뽀대 클럽돌이(머리)",
  T_22_L_M_H_PINKFUR: "시선강탈 클럽돌이(머리)",
  T_22_L_M_H_PLAGUE2: "플러그 고스트(머리)",
  T_22_L_M_H_REDPANTS: "힙스터 클럽돌이(머리)",
  T_22_L_M_H_TIGERSTRIPE: "호피 클럽돌이(머리)",
  T_22_L_M_S_FAIM2: "갈망의 화염(신발)",
  T_22_L_M_S_PLAGUE2: "플러그 고스트(신발)",
  T_22_L_M_T_FAIM2: "갈망의 화염(상의)",
  T_22_L_M_T_GREENCOAT: "뽀대 클럽돌이(상의)",
  T_22_L_M_T_PINKFUR: "시선강탈 클럽돌이(상의)",
  T_22_L_M_T_PLAGUE2: "플러그 고스트(상의)",
  T_22_L_M_T_REDPANTS: "힙스터 클럽돌이(상의)",
  T_22_L_M_T_TIGERSTRIPE: "호피 클럽돌이(상의)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K- 아카데미 반항기",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "프라잉팬- 수우박",
  T_22_LC_SCAR_HERMIT_N: "SCAR- 미스테리",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "힐링건- 라이프 빔",
  T_22_O_HAWK_NAME: "매",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "펫 스킨: 멸망여우",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "펫 스킨: 불사매",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "펫 스킨: 포레스트매",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "펫 스킨: 썬샤인 시바",
  T_22_Q_BOMB_PLIERS: "펜치",
  T_22_R_EMOTE_SHIMMY_NAME: "어깨 털기",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "방어구 관통",
  T_22_U_WPNSKN_SPEED_RUN: "기동성",
  T_22_Y_CHARACTER_DETECTIVE_N: "클루",
  T_22_Y_CHARACTER_STREAMERGUY_N: "울프라흐",
  T_23_B_CARDIAC_NAME: "호르몬 주사",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "예술의 칼날",
  T_23_C_SKILL_NAME_SWATGUY: "맹렬 재장전",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "하야토‧불타는 각성",
  T_23_D_CHARACTER_SWATGUY_N: "쟈이",
  T_23_L_F_B_GANGSTERRAP_GOLD: "언프리티 골드스터(하의)",
  T_23_L_F_B_MIKOGIRL: "북극성 프리셋(하의)",
  T_23_L_F_B_NAVYGIRL: "세일러 소녀(하의)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "언프리티 골드스터(머리)",
  T_23_L_F_H_MIKOGIRL: "북극성 프리셋(머리)",
  T_23_L_F_H_NAVYGIRL: "세일러 소녀(머리)",
  T_23_L_F_S_MIKOGIRL: "북극성 프리셋(신발)",
  T_23_L_F_S_ORDERCHALLENGER: "와우 펑키(신발)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "언프리티 골드스터(상의)",
  T_23_L_F_T_MIKOGIRL: "북극성 프리셋(상의)",
  T_23_L_F_T_NAVYGIRL: "세일러 소녀(상의)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "쇼미 골드스터(마스크)",
  T_23_L_M_B_FOXGUY: "북극성 프리스트(하의)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "쇼미 골드스터(하의)",
  T_23_L_M_H_FOXGUY: "북극성 프리스트(머리)",
  T_23_LC_SKS_GEMINI_N: "SKS- 미치광이",
  T_23_O_PENGUIN_NAME: "힙펭",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "펫 스킨: 파티 힙펭",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "펫 스킨: 싸이버 힙펭",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "펫스킨: 골드 힙펭",
  T_23_T_ANNI3_LOBBY_NODENAME20: "클래시 스쿼드",
  T_23_T_ANNI3_LOBBY_NODENAME5: "캐릭터",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "WARNING",
  T_24_C_FLAMETHROWER_NAME: "화염방사기",
  T_24_C_SKILL_DESC_PROFESSOR: "최대 EP {0} 증가. 주짓수 모드 : {2} m 이내 아군의 EP 전환율이 {1} % 증가합니다. 심리학 모드 : {4} 초마다 {5} EP를 최대 {6}까지 회복합니다. 스킬 체인지 쿨타임 : {3} 초",
  T_24_C_SKILL_NAME_PARTYGIRL: "렛츠 파티",
  T_24_C_SKILL_NAME_PROFESSOR: "마스터 오브 올",
  T_24_D_CHARACTER_PARTYGIRL_N: "다샤",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX 바지",
  T_24_L_H_PUMPKIN2020_A: "트위스트 펌킨(머리)",
  T_24_L_T_TSHIRT_COMEDIAN: "태국 코미디언 티셔츠",
  T_24_LC_MP5_RICHBOXER_N: "MP5- 복싱 챔피언",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- 파티 러버",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- 레전드 소드맨",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "총 점수",
  T_24_V_TRAINING_BOX_ATTACH: "부품",
  T_24_V_TRAINING_BOX_WEAPON: "무기",
  T_24_W_ARMORY: "무기",
  T_24_W_ARMOTY_MELEE: "근접 무기",
  T_24_W_ARMOTY_PISTOL: "권총",
  T_24_W_ARMOTY_RIFLE: "소총",
  T_24_W_ARMOTY_SHOTGUN: "샷건",
  T_24_W_ARMOTY_SNIPER: "스나이퍼",
  T_24_W_ARMOTY_SPECIAL: "기타",
  T_24_W_ARMOTY_SUBMACHINE: "SMG",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "펫 스킨: BOOYAH 팬더",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "펫 스킨: 해골 락쿤",
  T_24_W_PETSKIN_RACCOON_MECH_N: "펫 스킨: 불금 락쿤",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "펫 스킨: 좀비 락쿤",
  T_24_W_RACCOON_N: "락쿤",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "시공간 실드",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "프리셋 1",
  T_25_E_HUD_02: "프리셋 2",
  T_25_L_F_B_DEMONKILLER: "프렌지 하이스쿨(하의)",
  T_25_L_F_H_DEMONKILLER: "프렌지 하이스쿨(머리)",
  T_25_L_F_S_DEMONKILLER: "프렌지 하이스쿨(신발)",
  T_25_L_F_T_DEMONKILLER: "프렌지 하이스쿨(상의)",
  T_25_L_HA_FP_EVIL: "악마의 얼굴(페이스 페인팅)",
  T_25_L_M_H_ANIMEHAIR: "브리즈(머리)",
  T_25_L_S_MAXSNEAKERS: "MAX 스니커즈",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "싸이버 스윙",
  T_25_LC_GLOO_WINTERFEST2020_N: "얼음 벽- 윈터랜드",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- 윈터랜드",
  T_25_LC_MACHETE_BOUNTY_N: "타임 블레이드",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- 튠 블래스터(그린)",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- 튠 블래스터(레드)",
  T_25_LC_PAN_BOUNTY_N: "프라잉팬- 타임 슬립 헌터",
  T_25_R_LEGEND_REMIND: "알림",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "낫",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "비스턴",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "펫 스킨: 빙하 비스턴",
  T_25_W_PETSKIN_BABOON_HELL_N: "펫 스킨: 화염 비스턴",
  T_25_W_PETSKIN_BABOON_PURE_N: "펫 스킨: 화이트 비스턴",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "펫 스킨: 스노우 흑표범",
  T_25_Z_R_SIMULATOR_OFF: "금지",
  T_26_C_SKILL_DESC_SUPERSTAR: "음파를 앞으로 보내 {0}미터 이내의 {1}개의 얼음 벽을 파괴합니다. 쿨타임: {2}초. 얼음 벽을 사용할때마다 HP 회복 효과가 {3}부터 증가합니다. 효과는 중첩할 수 없습니다",
  T_26_C_SKILL_NAME_SUPERSTAR: "리듬 열풍",
  T_26_D_CHARACTER_DELIVERY_N: "시로우",
  T_26_D_CHARACTER_SUPERSTAR_N: "스카일러",
  T_26_ET_CELLPHONE_NAME: "미니 UAV",
  T_26_L_A_FLAMING_PREM: "지옥 군단(마스크)",
  T_26_L_A_SANTAMODE: "스노우밥(마스크)",
  T_26_L_B_SANTAMODE: "스노우밥(하의)",
  T_26_L_F_B_WATERFEST21_A: "썸머 브리즈(하의)",
  T_26_L_F_H_WATERFEST21_A: "썸머 브리즈(머리)",
  T_26_L_F_S_WATERFEST21_A: "썸머 브리즈(신발)",
  T_26_L_F_T_WATERFEST21_A: "썸머 브리즈(상의)",
  T_26_L_M_A_EGGDAY2021: "싸이버 버니(마스크)",
  T_26_L_M_B_EGGDAY2021: "싸이버 버니(하의)",
  T_26_L_M_B_PAIRING: "블랙테일 수트(하의)",
  T_26_L_M_B_WATERFEST21_A: "썸머 웨이브(하의)",
  T_26_L_M_H_EGGDAY2021: "싸이버 버니(머리)",
  T_26_L_M_H_PAIRING: "블랙테일 수트(머리)",
  T_26_L_M_H_WATERFEST21_A: "썸머 웨이브(머리)",
  T_26_L_M_S_EGGDAY2021: "싸이버 버니(신발)",
  T_26_L_M_S_PAIRING: "블랙테일 수트(신발)",
  T_26_L_M_S_WATERFEST21_A: "썸머 웨이브(신발)",
  T_26_L_M_T_EGGDAY2021: "싸이버 버니(상의)",
  T_26_L_M_T_PAIRING: "블랙테일 수트(상의)",
  T_26_L_M_T_WATERFEST21_A: "썸머 웨이브(상의)",
  T_26_L_S_SANTAMODE: "스노우밥(신발)",
  T_26_L_T_SANTAMODE: "스노우밥(상의)",
  T_26_LC_AWM_KOICARP_N: "AWM- 럭키 코이",
  T_26_LC_KATANA_VALENTINE2021_N: "카타나- 핑크 시즌",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "스포츠카- 코브라",
  T_26_P_SKILL_NAME_DELIVERY: "대미지 딜리버드",
  T_26_V_TRAINING_BHH: "팬시 해머",
  T_26_V_TRAINING_DICE: "거대 주사위",
  T_26_W_DRAGON_N: "드레키",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "펫 스킨: 스플래쉬 드레키",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "펫 스킨: 번개 드레키",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "펫 스킨: 갤럭시 드레키",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "펫 스킨: 사랑에 빠진 힙펭",
  T_26_XL_SETTING_TEAMMATE_INFO: "팀원 정보",
  T_26_YP_HISTORY_WIN: "빅토리",
  T_26_YP_SOCIAL_GENDER_FEMALE: "여자",
  T_26_YP_SOCIAL_GENDER_MALE: "남자",
  T_26_YP_SOCIAL_NAME: "닉네임",
  T_27_C_SKILL_DESC__RACERGIRL: "운전 속도가 {0}% 빨라집니다. 적이 차량 내 캐릭터를 사격 시 빗나갈 수 있으며 명중 시 대미지가 {1}% 감소합니다.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "{0}대미지를 막는 실드를 생성하고 실드 안에서 외부의 적을 사격할 수 없습니다. 모든 효과는 {1}초 동안 지속됩니다. 쿨타임 시간 {2}초.",
  T_27_C_SKILL_DESC_FALCONER: "거리가 멀수록 대미지 최대 {0}% 증가. 표기된 적에 대한 대미지 {1}% 증가.",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "각성: 최대 HP {0}%손실 마다 정면 대미지 {1}% 감소",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "각성: {0}초 동안 전력 질주 후 활성화. 활성화 후 첫 사격부터 {2}발이 {1}%의 대미지를 입힙니다. 지속 시간 {3}초",
  T_27_C_SKILL_NAME_FALCONER: "팔콘 페어",
  T_27_C_SKILL_NAME_XTREME: "익스트림 실행자",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "앤드루‧ 광기",
  T_27_D_CHARACTER_FALCONER_N: "마로",
  T_27_D_CHARACTER_XTREME_N: "세인",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "타이거 페이퍼(마스크)",
  T_27_L_B_CARDBOARD_REG: "베어 페이퍼(하의)",
  T_27_L_M_S_KAZAKHSTAN: "바가투르(신발)",
  T_27_L_S_CARDBOARD_REG: "베어 페이퍼(신발)",
  T_27_L_T_CARDBOARD_REG: "베어 페이퍼(상의)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- 2021 FFWS",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "몬스터 트럭- 2021 FFWS",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "오토바이- K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "스포츠카- 에메랄드 플래시",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "픽업 트럭- 플레임 드라코",
  T_27_P_SKILL_NAME_HITMAN_RE: "소음 킬러",
  T_27_R_EMOTE_GREETING_NAME: "인사",
  T_27_R_VEHICLE_ACCELERATION: "가속",
  T_27_R_VEHICLE_HP: "내구성",
  T_27_R_VEHICLE_SPEED: "최고 속도",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "각성: 방어구 대미지 감면 효과 {0}%향상. 팀원이 동일 스킬 장착 시 1명당 대미지 감면 효과 15%향상",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "울프 하울",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "무니",
  T_27_W_ARMOTY_DMR: "정밀 소총",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "펫 스킨: 크리스탈 무니",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "펫 스킨: 게이머 무니",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "펫 스킨: 힙스터 무니",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "펫 스킨: 2021 FFWS 멍멍이",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "펫 스킨: 2021 FFWS 팬더",
  T_27_XC_REPLAY_DIE: "사망",
  T_27_XC_REPLAY_KILL: "킬",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "수리",
  T_28_C_G_ICE_NAME: "플래시 프리즈",
  T_28_C_SKILL_DESC_STREETBEAT: "이동 중 발사 시 이동 속도 {0} % 정확도가 {1} % 증가합니다",
  T_28_C_SKILL_NAME_STREETBEAT: "불렛 비트",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "미니 Uzi",
  T_28_L_B_BRJERSEY_A: "No.23 축구 유니폼(하의)",
  T_28_L_B_BRJERSEY_B: "No.10 축구 유니폼(하의)",
  T_28_L_B_BRJERSEY_C: "No.24 축구 유니폼(하의)",
  T_28_L_B_BRJERSEY_D: "No.30 축구 유니폼(하의)",
  T_28_L_B_BRJERSEY_E: "No.1 축구 유니폼(하의)",
  T_28_L_B_BRJERSEY_F: "No.20 축구 유니폼(하의)",
  T_28_L_F_B_FOURSYMBOLS_C: "피닉스 윈드(하의)",
  T_28_L_F_H_FOURSYMBOLS_C: "피닉스 윈드(머리)",
  T_28_L_F_HA_FOURSYMBOLS_C: "피닉스 윈드(페이스 페인팅)",
  T_28_L_F_S_FOURSYMBOLS_C: "피닉스 윈드(신발)",
  T_28_L_F_T_FOURSYMBOLS_C: "피닉스 윈드(상의)",
  T_28_L_HA_THUNDER: "라이트닝 아이(페이스 페인팅)",
  T_28_L_M_A_SPORTSUIT: "벨시 스케보이(마스크)",
  T_28_L_M_B_FOURSYMBOLS_D: "그라운드 쉐이커(하의)",
  T_28_L_M_B_SPORTSUIT: "벨시 스케보이(하의)",
  T_28_L_M_H_FOURSYMBOLS_D: "그라운드 쉐이커(머리)",
  T_28_L_M_H_SPORTSUIT: "벨시 스케보이(머리)",
  T_28_L_M_S_FOURSYMBOLS_D: "그라운드 쉐이커(신발)",
  T_28_L_M_S_SPORTSUIT: "벨시 스케보이(신발)",
  T_28_L_M_T_FALLWINTER: "쏘스웨거(상의)",
  T_28_L_M_T_FOURSYMBOLS_D: "그라운드 쉐이커(상의)",
  T_28_L_M_T_SPORTSUIT: "벨시 스케보이(상의)",
  T_28_L_T_BRJERSEY_A: "No.23 축구 유니폼(상의)",
  T_28_L_T_BRJERSEY_B: "No.10 축구 유니폼(상의)",
  T_28_L_T_BRJERSEY_C: "No.24 축구 유니폼(상의)",
  T_28_L_T_BRJERSEY_D: "No.30 축구 유니폼(상의)",
  T_28_L_T_BRJERSEY_E: "No.1 축구 유니폼(상의)",
  T_28_L_T_BRJERSEY_F: "No.20 축구 유니폼(상의)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- 루비 브라이드",
  T_28_LC_GLOO_FALLWINTER_N: "얼음 벽- 쏘 수웩",
  T_28_LC_GLOO_FOURSYMBOLS_N: "얼음 벽- 스톰브링거",
  T_28_LC_KORD_SHINOBI_N: "Kord- 킬스파크 시노비",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- 무자비 주술사",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - 리썰 핀스 투스",
  T_28_LC_PAN_FOURSYMBOLS_N: "프라잉팬- 그라운드 쉐이커",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "지프차- 스톰브링거",
  T_28_T_WS_ITEM1: "사각형 상자",
  T_28_T_WS_ITEM10: "오두막",
  T_28_T_WS_ITEM11: "가드 타워",
  T_28_T_WS_ITEM12: "전초기지",
  T_28_T_WS_ITEM13: "집 A",
  T_28_T_WS_ITEM14: "집 B",
  T_28_T_WS_ITEM15: "집 C",
  T_28_T_WS_ITEM16: "샌드아트",
  T_28_T_WS_ITEM17: "분수",
  T_28_T_WS_ITEM18: "벛꽃 나무",
  T_28_T_WS_ITEM19: "바나나 나무",
  T_28_T_WS_ITEM2: "롱 박스",
  T_28_T_WS_ITEM20: "변기",
  T_28_T_WS_ITEM21: "울타리",
  T_28_T_WS_ITEM3: "관목",
  T_28_T_WS_ITEM4: "건초 더미",
  T_28_T_WS_ITEM5: "자동차",
  T_28_T_WS_ITEM6: "버스",
  T_28_T_WS_ITEM7: "컨테이너 A",
  T_28_T_WS_ITEM8: "컨테이너 B",
  T_28_T_WS_ITEM9: "컨테이너 C",
  T_28_T_WS_TYPE1: "사물",
  T_28_T_WS_TYPE4: "장식물",
  T_28_W_DUCK_N: "닥터.덕",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "펫 스킨: 신수 드레키",
  T_28_W_PETSKIN_DUCK_ARMY_N: "펫 스킨: 홧덕",
  T_28_W_PETSKIN_DUCK_BLACK_N: "펫 스킨: 힙덕",
  T_28_W_PETSKIN_DUCK_SHINY_N: "펫 스킨: DJ 덕",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "각성: 표시된 적이 이동하면 표시가 최대 {0}초까지 지속됩니다.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "에니그마의 눈",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "바이탈 비브즈",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "힐링 하트비트",
  T_29_D_CHARACTER_AMOCO_N: "모코‧ 에니그마",
  T_29_D_CHARACTER_MUSICBRO1_N: "디미트리",
  T_29_D_CHARACTER_MUSICBRO2_N: "티바",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "줄무늬 축구 유니폼(하의)",
  T_29_L_M_A_FALCONER_C: "무디 라비셔(마스크)",
  T_29_L_M_A_JUNGLE_GREEN: "카모우 전쟁-거북이(마스크)",
  T_29_L_M_B_FALCONER_C: "무디 라비셔(하의)",
  T_29_L_M_B_JUNGLE_GREEN: "카모우 전쟁-거북이(하의)",
  T_29_L_M_H_FALCONER_C: "무디 라비셔(머리)",
  T_29_L_M_H_JUNGLE_GREEN: "카모우 전쟁-거북이(머리)",
  T_29_L_M_S_FALCONER_C: "무디 라비셔(신발)",
  T_29_L_M_S_JUNGLE_GREEN: "카모우 전쟁-거북이(신발)",
  T_29_L_M_T_FALCONER_C: "무디 라비셔(상의)",
  T_29_L_M_T_JUNGLE_GREEN: "카모우 전쟁-거북이(상의)",
  T_29_L_T_TRJERSEY: "줄무늬 축구 유니폼(상의)",
  T_29_M_WS_ITEM22: "견고한 컨테이너",
  T_29_M_WS_ITEM23: "견고한 울타리",
  T_29_M_WS_ITEM24: "스폰포인트 A",
  T_29_M_WS_ITEM25: "스폰포인트 B",
  T_29_M_WS_TYPE5: "상호작용",
  T_29_W_PETSKIN_BROWN_TIGER_N: "펫 스킨:어스 센세 티그",
  T_29_W_PETSKIN_FIRE_TIGER_N: "펫 스킨:파이어 센세 티그",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "펫 스킨: 사이버 팔콘",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "펫 스킨:파티 판다",
  T_29_W_PETSKIN_WHITE_TIGER_N: "펫 스킨:아이스 센세 티그",
  T_29_W_TIGER_NINJA_N: "센세 티그",
  T_29_YF_MACHETE_MUSICFEST_N: "사운드웨이브 스레셔",
  T_29_YF_MAGEZINE_CHAIN_N: "AR 탄창",
  T_29_YF_MUZZLE_CRASH_N: "SMG 총구",
  T_29_YF_MUZZLE_WIDE_N: "산탄총 총구",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- 우주 순간이동",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- 앰버 메가시퍼",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "몬스터 트럭- 갉아먹는 분노",
  T_30_AD_RP_ROUNDEND: "라운드 종료",
  T_30_AD_TRAINING_SNOWBALL: "눈덩이",
  T_30_AD_TRAINING_SNOWBALL_DES: "눈싸움을 하자!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "버저 비터",
  T_30_C_SKILL_NAME_MUERTOGUY: "기억 안개",
  T_30_D_CHARACTER_BOOYAHGUY_N: "레온",
  T_30_D_CHARACTER_MUERTOGUY_N: "오토",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "쟈이의 마이크로칩",
  T_30_L_A_BRMASCOT_ADULT: "성난 병아리 머리 장식",
  T_30_L_A_BRMASCOT_KIDS: "귀여운 병아리 머리 장식",
  T_30_L_A_SUGARSKULL21_BANDANA: "데스 바이트 마스크",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF 축구 유니폼-블랙(하의)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF 축구 유니폼-그린(하의)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF 축구 유니폼-그레이(하의)",
  T_30_L_B_BRUNIFORM: "리틀 카나리아(하의)",
  T_30_L_F_A_SUGARSKULL21: "골드림 퀸(마스크)",
  T_30_L_F_B_SUGARSKULL21: "골드림 퀸(하의)",
  T_30_L_F_B_THASIAN: "산호색 트러블(하의)",
  T_30_L_F_H_CATEARS: "귀여운 귀",
  T_30_L_F_H_SUGARSKULL21: "골드림 퀸(머리)",
  T_30_L_F_H_THASIAN: "산호색 트러블(머리)",
  T_30_L_F_S_SUGARSKULL21: "골드림 퀸(신발)",
  T_30_L_F_S_THASIAN: "산호색 트러블(신발)",
  T_30_L_F_T_SUGARSKULL21: "골드림 퀸(상의)",
  T_30_L_F_T_THASIAN: "산호색 트러블(상의)",
  T_30_L_H_CHILDRENSDAY_BLUE: "돌고래 머리 장식",
  T_30_L_H_CHILDRENSDAY_RED: "코끼리 머리 장식",
  T_30_L_H_CLOWNHAT: "서커스 모자 - 노란색",
  T_30_L_H_ZASCARF: "용감한 골드 목도리",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "순수한 깡패(마스크)",
  T_30_L_M_A_SUGARSKULL21: "골드림 킹(마스크)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "순수한 깡패(하의)",
  T_30_L_M_B_PKCRICKET: "챔프 인 그린(하의)",
  T_30_L_M_B_SUGARSKULL21: "골드림 킹(하의)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "윈드 레이서(하의)",
  T_30_L_M_B_THASIAN: "산호색 반란군(하의)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "순수한 깡패(머리)",
  T_30_L_M_H_SUGARSKULL21: "골드림 킹(머리)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "윈드 레이서(머리)",
  T_30_L_M_H_THASIAN: "산호색 반란군(머리)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "알파 본 레이저(페이스 페인팅)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "순수한 깡패(신발)",
  T_30_L_M_S_PKCRICKET: "챔프 인 그린(신발)",
  T_30_L_M_S_SUGARSKULL21: "골드림 킹(신발)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "윈드 레이서(신발)",
  T_30_L_M_S_THASIAN: "산호색 반란군(신발)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "순수한 깡패(상의)",
  T_30_L_M_T_PKCRICKET: "챔프 인 그린(상의)",
  T_30_L_M_T_SUGARSKULL21: "골드림 킹(상의)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "윈드 레이서(상의)",
  T_30_L_M_T_THASIAN: "산호색 반란군(상의)",
  T_30_L_S_BRUNIFORM: "리틀 카나리아(신발)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF 축구 유니폼-블랙(상의)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF 축구 유니폼-그린(상의)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF 축구 유니폼-그레이(상의)",
  T_30_L_T_BRUNIFORM: "리틀 카나리아(상의)",
  T_30_M_WS_PARTY_MODE: "놀이터",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "도발",
  T_30_R_EMOTE_MAX_NAME: "래퍼 댄스",
  T_30_R_LEGEND_HALO_NAME: "서클 오브 히트",
  T_30_T_WS_DEFAULTDESCRIPTION: "Free Fire 전장 커스텀에 재미있는 맵입니다.",
  T_30_T_WS_ITEM26: "타이어",
  T_30_T_WS_ITEM27: "지저분한 타이어 A",
  T_30_T_WS_ITEM28: "지저분한 타이어 B",
  T_30_T_WS_ITEM29: "지저분한 타이어 C",
  T_30_T_WS_ITEM30: "범퍼카",
  T_30_T_WS_ITEM31: "수륙양용차",
  T_30_T_WS_ITEM32: "지프차",
  T_30_T_WS_ITEM33: "쓰레기통",
  T_30_T_WS_ITEM34: "그늘집",
  T_30_T_WS_ITEM35: "의료용 텐트",
  T_30_T_WS_ITEM36: "차고",
  T_30_T_WS_ITEM37: "벽",
  T_30_T_WS_ITEM38: "토리이",
  T_30_T_WS_ITEM39: "대형 무대",
  T_30_T_WS_ITEM40: "컨테이너 트럭 A",
  T_30_T_WS_ITEM41: "컨테이너 트럭 B",
  T_30_T_WS_ITEM42: "벽 A",
  T_30_T_WS_ITEM43: "벽 B",
  T_30_T_WS_ITEM44: "벽 C",
  T_30_T_WS_ITEM45: "벽 D",
  T_30_T_WS_ITEM46: "벽 E",
  T_30_T_WS_ITEM47: "벽 F",
  T_30_U_ATTACHMENT_1: "방탄복 HP 부스터",
  T_30_U_ATTACHMENT_4: "방탄복 확대",
  T_30_U_ATTACHMENT_5: "헬멧 보호",
  T_30_U_ATTACHMENT_6: "방탄복 보호",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "펫 스킨: 해골의 비스턴",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "펫 스킨: 펑크 힙펭",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "펫 스킨: 백발백중의 요원 홉",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "펫 스킨:축제의 요원 홉",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "펫 스킨: 사이버 요원 홉",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "펫 스킨: 로보 스피릿",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "펫 스킨: 그린 프리즈 로보",
  T_30_W_RABBIT_N: "요원 홉",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "얼음 벽-2021년 BOOYAH DAY",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "수류탄-2021년 BOOYAH DAY",
  T_30_YF_Healinggun_Sniper_N: "치료 저격수",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- 왕족 전사",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL-진홍색 계승자",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- 왕족 전사",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson-골드림 찬사",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "스포츠 카- 스컬 펑커",
  T_31_C_SKILL_NAME_WINTERGUY: "불멸 얼음",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "윈터 베이셔",
  T_31_HQ_GLOO_EAGLE_N: "얼음 벽: 금모래의 신",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "치료 저격수-칼바람",
  T_31_HQ_KATANA_WINTERFEST21_N: "카타나- 눈사태",
  T_31_HQ_PAN_WINTERFEST21_N: "프라잉팬- 눈사태",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "펫 스킨:겨울 멜로디",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "펫 스킨: 겨울 힙펭",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "펫 스킨:숲의 예티",
  T_31_HQ_PETSKIN_YETI_RED_N: "펫 스킨:불의 예티",
  T_31_HQ_SICKLE_WINTERFEST21_N: "폭풍설의 낫",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "오토바이-얼음의 꽃",
  T_31_HQ_YETI_N: "예티",
  T_31_KK_WINTER_BUJIX: "보급 상자",
  T_31_KK_WINTER_SANJITOU: "헬멧",
  T_31_L_A_BDCRICKET: "승리 타자(마스크)",
  T_31_L_A_WINTERFEST21: "순록 커버",
  T_31_L_B_BDCRICKET: "승리 타자(하의)",
  T_31_L_B_MEJERSEY_10: "No.10 다홍색 축구 유니폼(하의)",
  T_31_L_B_MEJERSEY_11: "No.11 빨간색 축구 유니폼(하의)",
  T_31_L_B_MEJERSEY_13: "No.13 하얀색 축구 유니폼(하의)",
  T_31_L_B_MEJERSEY_18G: "No. 18 초록색 축구 유니폼(하의)",
  T_31_L_B_MEJERSEY_18R: "No.18 빨간색 축구 유니폼(하의)",
  T_31_L_B_MEJERSEY_7: "No.7 하얀색 축구 유니폼(하의)",
  T_31_L_F_B_RUMUSICIAN: "스트리트 걸(하의)",
  T_31_L_F_B_THAGENT: "나이트 암살자(하의)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "홀치기염 버킷햇",
  T_31_L_F_H_RUMUSICIAN: "스트리트 걸(머리)",
  T_31_L_F_H_THAGENT: "나이트 암살자(머리)",
  T_31_L_F_HA_RUMUSICIAN: "스트리트 걸(페이스 페인팅)",
  T_31_L_F_S_RUMUSICIAN: "스트리트 걸(신발)",
  T_31_L_F_S_THAGENT: "나이트 암살자(신발)",
  T_31_L_F_T_RUMUSICIAN: "스트리트 걸(상의)",
  T_31_L_F_T_THAGENT: "나이트 암살자(상의)",
  T_31_L_HA_RUMUSICIAN_MU: "빨간 X 문신(페이스 페인팅)",
  T_31_L_HA_WINTERFEST21_BLUE: "프로즌 광대(페이스 페인팅)",
  T_31_L_HA_WINTERFEST21_PINK: "핑크 불꽃(페이스 페인팅)",
  T_31_L_M_A_REGGAETON_B: "네온 레게톤(마스크)",
  T_31_L_M_A_REGGAETON_P: "바이브랜트 버니티(마스크)",
  T_31_L_M_A_RUMUSICIAN: "스트리트 보이(마스크)",
  T_31_L_M_A_THAGENT: "나이트 습격자(마스크)",
  T_31_L_M_B_PKCOSTUME: "팔레스타인 그린(하의)",
  T_31_L_M_B_REGGAETON_B: "네온 레게톤(하의)",
  T_31_L_M_B_REGGAETON_P: "바이브랜트 버니티(하의)",
  T_31_L_M_B_RUMUSICIAN: "스트리트 보이(하의)",
  T_31_L_M_B_THAGENT: "나이트 습격자(하의)",
  T_31_L_M_H_GREENCAP: "우승 모자",
  T_31_L_M_H_PKCOSTUME: "팔레스타인 그린(머리)",
  T_31_L_M_H_REGGAETON_B: "네온 레게톤(머리)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "홀치기염 모자",
  T_31_L_M_H_REGGAETON_P: "바이브랜트 버니티(머리)",
  T_31_L_M_H_RUMUSICIAN: "스트리트 보이(머리)",
  T_31_L_M_H_THAGENT: "나이트 습격자(머리)",
  T_31_L_M_S_PKCOSTUME: "팔레스타인 그린(신발)",
  T_31_L_M_S_REGGAETON_B: "네온 레게톤(신발)",
  T_31_L_M_S_REGGAETON_P: "바이브랜트 버니티(신발)",
  T_31_L_M_S_RUMUSICIAN: "스트리트 보이(신발)",
  T_31_L_M_S_THAGENT: "나이트 습격자(신발)",
  T_31_L_M_T_PKCOSTUME: "팔레스타인 그린(상의)",
  T_31_L_M_T_REGGAETON_B: "네온 레게톤(상의)",
  T_31_L_M_T_REGGAETON_P: "바이브랜트 버니티(상의)",
  T_31_L_M_T_REGGAETON_TATOO: "파밀리아 문신",
  T_31_L_M_T_RUMUSICIAN: "스트리트 보이(상의)",
  T_31_L_M_T_THAGENT: "나이트 습격자(상의)",
  T_31_L_S_BDCRICKET: "승리 타자(신발)",
  T_31_L_T_BDCRICKET: "승리 타자(상의)",
  T_31_L_T_BRBANK: "밤색 봄버 재킷",
  T_31_L_T_MEJERSEY_10: "No.10 다홍색 축구 유니폼(상의)",
  T_31_L_T_MEJERSEY_11: "No.11 빨간색 축구 유니폼(상의)",
  T_31_L_T_MEJERSEY_13: "No.13 하얀색 축구 유니폼(상의)",
  T_31_L_T_MEJERSEY_18G: "No. 18 초록색 축구 유니폼(상의)",
  T_31_L_T_MEJERSEY_18R: "No.18 빨간색 축구 유니폼(상의)",
  T_31_L_T_MEJERSEY_7: "No.7 하얀색 축구 유니폼(상의)",
  T_31_L_T_PKMOBILE: "Infinix 티셔츠",
  T_31_L_T_REGGAETON_HOOD: "범죄단 스마일 후드",
  T_31_MF_CHARACTER_WINTERGUY_N: "나이리",
  T_31_R_EMOTE_FALCONER_NAME: "No.1",
  T_31_RW_COMBINEMACHINE_2: "쌍총 활성체(고급)",
  T_31_RW_VIBRATION_EXPLOSION: "폭발",
  T_31_RW_VIBRATION_MELEEWEAPONS: "근접 무기",
  T_31_RW_VIBRATION_OTHERWEAPONS: "기타 총기",
  T_31_T_WS_1PLAYERTEAM: "1인 그룹",
  T_31_T_WS_2PLAYERTEAM: "2인 그룹",
  T_31_T_WS_3PLAYERTEAM: "3인 그룹",
  T_31_T_WS_4PLAYERTEAM: "4인 그룹",
  T_31_T_WS_5PLAYERTEAM: "5대5",
  T_31_T_WS_6PLAYERTEAM: "6인 그룹",
  T_31_T_WS_BUFFTIME_TITLE: "새로고침 시간",
  T_31_T_WS_BUFFTYPE_AMMO: "탄약",
  T_31_T_WS_BUFFTYPE_ARMOR: "갑옷",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "랜덤",
  T_31_T_WS_BUFFTYPE_TITLE: "버프 종류",
  T_31_T_WS_DESC48: "1밀리초 내 여러분을 다른 장소로 데려가겠습니다.",
  T_31_T_WS_DESC49: "피아노 소리를 만듭니다.",
  T_31_T_WS_DESC51: "드럼 소리를 만듭니다.",
  T_31_T_WS_DESC53: "합성기 소리를 만듭니다.",
  T_31_T_WS_DESC59: "정기적으로 버프를 생성하는 장치입니다. 사용해서 버프를 얻을 수 있습니다.",
  T_31_T_WS_DRUMTYPE_CLAPS: "박수",
  T_31_T_WS_DRUMTYPE_HIHATS: "하이햇 심벌",
  T_31_T_WS_DRUMTYPE_KICK: "베이스 드럼",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "오픈 하이햇 심벌",
  T_31_T_WS_DRUMTYPE_RIDES: "라이드 심벌",
  T_31_T_WS_DRUMTYPE_SNARES: "작은북",
  T_31_T_WS_EARLYSHRINK: "빠르게 축소",
  T_31_T_WS_ITEM48: "포탈",
  T_31_T_WS_ITEM49: "음표 - 피아노",
  T_31_T_WS_ITEM51: "음표 - 드럼",
  T_31_T_WS_ITEM53: "음표 -합성기 A",
  T_31_T_WS_ITEM55: "음표 -합성기 B",
  T_31_T_WS_ITEM57: "음표 -합성기 C",
  T_31_T_WS_ITEM59: "버프 생성기",
  T_31_T_WS_LATESHRINK: "늦게 축소",
  T_31_T_WS_ME_DAMAGE: "데미지 입히기",
  T_31_T_WS_ME_DAMAGED: "데미지 입기",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "초기 EP 비율",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "첫째 안전구역 반경",
  T_31_T_WS_ME_EPQUICKRESTORE: "빠른 EP 전환",
  T_31_T_WS_ME_FLOW: "모드",
  T_31_T_WS_ME_GENERALSETTING: "일반",
  T_31_T_WS_ME_INRANDOMSPAWN: "랜덤 부활점",
  T_31_T_WS_ME_KILLSCORE: "킬 보너스",
  T_31_T_WS_ME_MAXEP: "최대 EP",
  T_31_T_WS_ME_MAXHP: "최대 HP",
  T_31_T_WS_ME_NEARTEAM: "근처 팀원",
  T_31_T_WS_ME_REBIRTH: "부활 대기 시간",
  T_31_T_WS_ME_REBIRTHLOCATION: "부활점",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "구역 축소 시작 시간",
  T_31_T_WS_ME_WINSCORE: "승리 점수",
  T_31_T_WS_MINIZONE: "소형 전장",
  T_31_T_WS_MUSICTYPE_TITLE: "음악 유형",
  T_31_T_WS_UNLIMITEDAMMO: "무제한 탄약",
  T_31_WT_WS_DESC1: "보통의 사각형 상자입니다. 쌓아서 사용할 수 있습니다.",
  T_31_WT_WS_DESC10: "낡은 나무집입니다. 계단이 있어 위층으로 올라갈 수 있습니다.",
  T_31_WT_WS_DESC11: "낡은 소형 감시대입니다. 감시대에 총알구멍이 여러 개 있습니다.",
  T_31_WT_WS_DESC12: "금속으로 만든 소형 경비실입니다. 문과 창이 있습니다.",
  T_31_WT_WS_DESC13: "1층 민가입니다. 문과 창문이 여러 개 있습니다.",
  T_31_WT_WS_DESC14: "2층 개방의 대형 민가입니다.",
  T_31_WT_WS_DESC15: "2층 폐쇄의 대형 민가입니다.",
  T_31_WT_WS_DESC16: "장식물-하트형의 모래조각",
  T_31_WT_WS_DESC17: "장식물 - 물을 가득 담은 분수",
  T_31_WT_WS_DESC18: "장식물 - 벚꽃이 만개한 벚나무",
  T_31_WT_WS_DESC19: "장식물 - 바나나 없는 작은 바나나 나무",
  T_31_WT_WS_DESC2: "보통의 직사각형 상자입니다. 쌓아서 사용할 수 있습니다.",
  T_31_WT_WS_DESC20: "흰색 변기입니다. 가구로 사용할 수 있습니다.",
  T_31_WT_WS_DESC21: "작은 울타리입니다. 구역을 나눌 수 있습니다.",
  T_31_WT_WS_DESC22: "깰 수 있는 컨테이너입니다.",
  T_31_WT_WS_DESC23: "깰 수 있는 작은 울타리입니다.",
  T_31_WT_WS_DESC24: "구룹 A 플레이어의 스폰포인트(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서만 유효)",
  T_31_WT_WS_DESC25: "구룹 B 플레이어의 스폰포인트(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서만 유효)",
  T_31_WT_WS_DESC26: "플레이어를 특정한 방향으로 단거리 튕길 수 있는 타이어입니다.",
  T_31_WT_WS_DESC27: "플레이어를 특정한 방향으로 단거리 튕길 수 있는 타이어 더미입니다.",
  T_31_WT_WS_DESC28: "플레이어를 특정한 방향으로 중거리 튕길 수 있는 타이어 더미입니다.",
  T_31_WT_WS_DESC29: "플레이어를 특정한 방향으로 장거리 튕길 수 있는 타이어 더미입니다.",
  T_31_WT_WS_DESC3: "빨갛고 노란 관목입니다. 전장을 장식할 수 있습니다.",
  T_31_WT_WS_DESC30: "운전할 수 있는 범퍼카입니다.",
  T_31_WT_WS_DESC31: "운전할 수 있는 수륙양용차입니다.",
  T_31_WT_WS_DESC32: "운전할 수 있는 지프차입니다.",
  T_31_WT_WS_DESC33: "가득 찬 휴지통입니다. 은폐물로 사용할 수 있습니다.",
  T_31_WT_WS_DESC34: "금속 질감 및 열린 구조의 소형 관람대입니다.",
  T_31_WT_WS_DESC35: "문은 2개 있지만 창문은 없는 중형 의료텐트입니다.",
  T_31_WT_WS_DESC36: "반개방형인 대형 차고입니다. 벽돌로 지어졌습니다.",
  T_31_WT_WS_DESC37: "벽돌로 만든 대형 담장입니다. 구역을 나눌 수 있습니다.",
  T_31_WT_WS_DESC38: "대형 도리이입니다. 랜드마크가 될 수 있습니다.",
  T_31_WT_WS_DESC39: "금속 질감의 대형 플랫폼입니다. 주요 전쟁터로 사용할 수 있습니다.",
  T_31_WT_WS_DESC4: "평범한 풀더미입니다. 은폐물로 사용할 수 있습니다.",
  T_31_WT_WS_DESC40: "자동차 구조와 닮은 소형 건물입니다. 문과 창문이 많습니다.",
  T_31_WT_WS_DESC41: "자동차 구조와 닮은 소형 건물입니다. 문이 하나 있고 창문이 많습니다.",
  T_31_WT_WS_DESC42: "문을 갖춘 벽돌담입니다.",
  T_31_WT_WS_DESC43: "평범한 벽돌담입니다.",
  T_31_WT_WS_DESC44: "평평한 직각 벽돌담입니다.",
  T_31_WT_WS_DESC45: "오목한 직각 벽돌담입니다.",
  T_31_WT_WS_DESC46: "오목한 직각 벽돌담입니다.",
  T_31_WT_WS_DESC47: "창 구조를 갖춘 직각 벽돌담입니다.",
  T_31_WT_WS_DESC5: "낡은 자동차입니다. 은폐물로 사용할 수 있습니다.",
  T_31_WT_WS_DESC6: "작은 버스입니다. 은폐물로 사용할 수 있습니다",
  T_31_WT_WS_DESC7: "앞뒤가 열린 컨테이너입니다. 구역을 구분하거나 통로로 사용할 수 있습니다.",
  T_31_WT_WS_DESC8: "한쪽이 열린 컨테이너입니다. 구역을 구분할 수 있습니다.",
  T_31_WT_WS_DESC9: "컨테이너입니다. 구역을 구분할 수 있습니다.",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "차량",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "빠른 속도로 전방으로 이동합니다. 지속 시간: {0}초. 쿨타임: {1}초. {2}회 사용 가능.",
  T_32_C_SKILL_NAME_YAKUZA: "번개 돌격",
  T_32_HQ_AUG_VNSTREET_N: "AUG-금사자 프린세스",
  T_32_HQ_BACKPACK_REDDRAGON_N: "돈릿 드래고 백팩",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B-흡혈집사",
  T_32_HQ_GLOO_DUNHUANG_N: "얼음 벽-프로즌 플래티넘",
  T_32_HQ_GLOO_HURRICANE_2_N: "얼음 벽-오로라 코어",
  T_32_HQ_GRENADE_HURRICANE_N: "수류탄-브래지 마이크",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10-프로즌 플래티넘",
  T_32_HQ_PETSKIN_DUCK_RED_N: "펫 스킨: 레드 덕",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "펫 스킨: 사이버 플래시",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "펫 스킨: 프로 플레이어 플래시",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "펫 스킨: 축제 플래시",
  T_32_HQ_TORTOISE_N: "플래시",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "스포츠 카-심연의 매장자",
  T_32_L_F_A_PHARAOH: "클레오파트라(마스크)",
  T_32_L_F_B_PHARAOH: "클레오파트라(하의)",
  T_32_L_F_H_PHARAOH: "클레오파트라(머리)",
  T_32_L_F_HA_PHARAOH: "클레오파트라(페이스 페인팅)",
  T_32_L_F_S_PHARAOH: "클레오파트라(신발)",
  T_32_L_F_T_PHARAOH: "클레오파트라(상의)",
  T_32_L_M_A_JUNKFOOD: "햄버거 소년(마스크)",
  T_32_L_M_A_PHARAOH: "금박 미라(마스크)",
  T_32_L_M_B_JUNKFOOD: "햄버거 소년(하의)",
  T_32_L_M_B_PHARAOH: "금박 미라(하의)",
  T_32_L_M_H_JUNKFOOD: "햄버거 소년(머리)",
  T_32_L_M_H_PHARAOH: "금박 미라(머리)",
  T_32_L_M_S_JUNKFOOD: "햄버거 소년(신발)",
  T_32_L_M_S_PHARAOH: "금박 미라(신발)",
  T_32_L_M_T_JUNKFOOD: "햄버거 소년(상의)",
  T_32_L_M_T_PHARAOH: "금박 미라(상의)",
  T_32_L_T_WHITESWEATER: "화이트 터틀넥",
  T_32_LC_NEWVAULT_EMOTE: "감정 표현",
  T_32_LO_WS_IMMORTAL: "무적 구역",
  T_32_LO_WS_ITEM60: "파이프",
  T_32_LO_WS_ITEM60_DESC: "건너갈 갈 수 있는 터널",
  T_32_LO_WS_ITEM61: "T 파이프",
  T_32_LO_WS_ITEM61_DESC: "건너갈 갈 수 있는 T 터널",
  T_32_LO_WS_ITEM62: "교차 파이프",
  T_32_LO_WS_ITEM62_DESC: "건너갈 갈 수 있는 교차 터널",
  T_32_LO_WS_ITEM63: "파이프 코너",
  T_32_LO_WS_ITEM63_DESC: "걸어갈 수 있는 터널 코너",
  T_32_LO_WS_ITEM64: "푸드트럭",
  T_32_LO_WS_ITEM64_DESC: "여기 와서 한입 먹자.",
  T_32_LO_WS_ITEM65: "거대버섯",
  T_32_LO_WS_ITEM65_DESC: "사람을 기댈 수 있는 대형 버섯.",
  T_32_LO_WS_ITEM66: "옷걸이",
  T_32_LO_WS_ITEM66_DESC: "주거 지역에서 흔히 볼 수 있는 것",
  T_32_LO_WS_ITEM67: "널빤지",
  T_32_LO_WS_ITEM67_DESC: "간단한 나무 다리를 만들 수 있다.",
  T_32_LO_WS_ITEM68: "병풍",
  T_32_LO_WS_ITEM68_DESC: "동양적인 느낌을 잘 살린다.",
  T_32_LO_WS_ITEM69: "기둥",
  T_32_LO_WS_ITEM69_DESC: "건설현장에서 흔히 볼 수 있는 것",
  T_32_LO_WS_ITEM70: "선인장",
  T_32_LO_WS_ITEM70_DESC: "엄청 크지만 따끔따끔하지 않다.",
  T_32_LO_WS_ITEM71: "고목",
  T_32_LO_WS_ITEM71_DESC: "수 세기 동안 살아온 나무",
  T_32_LO_WS_ITEM72: "석등",
  T_32_LO_WS_ITEM72_DESC: "황실 정원에서 볼 수 있는 장식",
  T_32_LO_WS_ITEM73: "가로등",
  T_32_LO_WS_ITEM73_DESC: "길거리에서 흔히 볼 수 있는 것.",
  T_32_LO_WS_ITEM74: "태양 전지판",
  T_32_LO_WS_ITEM74_DESC: "태양 에너지를 받아서 전기를 만든다.",
  T_32_LO_WS_ITEM75: "에어컨",
  T_32_LO_WS_ITEM75_DESC: "더운 날씨에 시원하게 지내세요.",
  T_32_LO_WS_ITEM76: "선풍기",
  T_32_LO_WS_ITEM77: "멀리 날리세요! 팬",
  T_32_LO_WS_ITEM78: "큐브",
  T_32_LO_WS_ITEM79: "링",
  T_32_LO_WS_ITEM80: "대형 망치",
  T_32_LO_WS_ITEM81: "보드",
  T_32_LO_WS_ITEM82: "표적",
  T_32_LO_WS_ITEM83: "신축벽",
  T_32_LO_WS_ITEM84AMMO: "탄약 생성점",
  T_32_LO_WS_ITEM84AMMO_DESC: "배치되면 선택한 탄약이 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM84AR: "갑옷 생성점",
  T_32_LO_WS_ITEM84AR_DESC: "배치되면 선택한 갑옷이 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM84ARLV1: "갑옷 Lv. 1",
  T_32_LO_WS_ITEM84ARLV2: "갑옷 Lv. 2",
  T_32_LO_WS_ITEM84ARLV3: "갑옷 Lv. 3",
  T_32_LO_WS_ITEM84CO: "소모품 생성점",
  T_32_LO_WS_ITEM84CO_DESC: "배치되면 선택한 소모품이 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM84JA: "투척 아이템 생성점",
  T_32_LO_WS_ITEM84JA_DESC: "배치되면 선택한 투척 아이템이 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM84TE: "스코프 생성점",
  T_32_LO_WS_ITEM84TE_DESC: "배치되면 선택한 스코프가 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM84W: "무기 생성점",
  T_32_LO_WS_ITEM84W_DESC: "배치되면 선택한 무기가 해당 지점에 생성됩니다.",
  T_32_LO_WS_ITEM85: "트리거",
  T_32_LO_WS_ITEM85_DESC: "배치 후, 플레이어가 지나가면 특별 효과(무적 또는 사망)가 생깁니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_32_LO_WS_ITEM85CP: "체크포인트",
  T_32_LO_WS_ITEM85CP_DESC: "파르쿠르 모드의 필수 아이템입니다. 플레이어들은 체크포인트를 하나씩 통과해야 합니다. 플레이어가 죽게 되면 마지막 통과한 체크포인트에서 부활됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_32_LO_WS_ITEM85TM: "도착점",
  T_32_LO_WS_ITEM85TM_DESC: "파르쿠르 모드의 필수 아이템입니다. 플레이어가 이 아이템의 영역 안에 도착해야 합니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_32_LO_WS_ITEM86: "스폰포인트",
  T_32_LO_WS_ITEM86_DESC: "배치되면, 팀이 무작위로 그곳에서 생성됩니다. 팀이 많으면 한 지점에서 1개 이상의 팀이 생성됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_32_LO_WS_ITEM86L: "대형 스폰포인트",
  T_32_LO_WS_ITEM86L_DESC: "파르쿠르 모드의 대형 스폰포인트입니다. 모든 플레이어가 해당 곳에서 생성됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_32_LO_WS_ITEM87: "블록",
  T_32_LO_WS_ITEM87_DESC: "사이즈를 조정할 수 있는 아이템",
  T_32_LO_WS_ITEM88: "경사지",
  T_32_LO_WS_ITEM88_DESC: "사이즈를 조정할 수 있는 아이템",
  T_32_LO_WS_ITEMLINE: "직선 이동",
  T_32_LO_WS_ITEMMOVE: "트리거 설정",
  T_32_LO_WS_ITEMROT: "회전",
  T_32_LO_WS_ITEMSCALE: "돋보기/졸보기",
  T_32_LO_WS_KILLZONE: "사망 구역",
  T_32_LO_WS_LOOT_AMMOTYPE: "탄약",
  T_32_LO_WS_LOOT_ARTYPE: "갑옷",
  T_32_LO_WS_LOOT_COTYPE: "소모품",
  T_32_LO_WS_LOOT_JATYPE: "투척 무기",
  T_32_LO_WS_LOOT_RANDOM: "랜덤",
  T_32_LO_WS_LOOT_TETYPE: "스코프",
  T_32_LO_WS_LOOT_WEAPONTYPE: "무기",
  T_32_LO_WS_SCALEX: "길이",
  T_32_LO_WS_SCALEY: "높이",
  T_32_LO_WS_SCALEZ: "너비",
  T_32_LO_WS_TRIGGERH: "숨기기",
  T_32_LO_WS_TRIGGERHORP: "트리거 표시/숨기기",
  T_32_LO_WS_TRIGGERP: "표시",
  T_32_LO_WS_TRIGGERTYPE: "트리거 유형",
  T_32_M_WS_MODE_ANNIHILATE: "전멸",
  T_32_M_WS_MODE_SCORE: "점수",
  T_32_M_WS_MODE_SPEED: "파르쿠르",
  T_32_M_WS_MULTIPLETEAMS: "여러 팀 전투",
  T_32_M_WS_ROUNDS: "라운드",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "춤을 추자",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "위험 구역",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "데미지",
  T_32_T_WS_ME_BLUECIRCLESETTING: "위험 구역",
  T_32_T_WS_ME_CUSTOM: "사용자 지정 모드",
  T_32_T_WS_ME_ENDTYPE1: "전멸",
  T_32_T_WS_ME_ENDTYPE2: "점수",
  T_32_T_WS_ME_ENDTYPE3: "파르쿠르",
  T_32_T_WS_ME_ENDTYPEDESC1: "마지막 생존하는 팀이 되어라.",
  T_32_T_WS_ME_ENDTYPEDESC2: "먼저 목표 점수에 도달한 팀이 승리합니다.",
  T_32_T_WS_ME_ENDTYPEDESC3: "모든 멤버가 도착점에 도달한 팀이 승리합니다.",
  T_32_T_WS_ME_MATCHTIME: "매치 시간",
  T_32_T_WS_ME_MECHANIC: "진행 방식",
  T_32_T_WS_ME_NEARCHECKPOINT: "체크포인트 근처",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "플레이어 수가 12명을 넘는 경우, 게임을 플레이할 수 없습니다.",
  T_32_T_WS_ME_PREGAMETIME: "준비 시간",
  T_32_T_WS_ME_RESPAWN: "리스폰",
  T_32_T_WS_ME_RESPAWNSETTING: "리스폰",
  T_32_T_WS_ME_ROUNDNUM: "라운드 수",
  T_32_T_WS_ME_ROUNDOPEN: "복수 라운드 적용",
  T_32_T_WS_ME_ROUNDRESET: "라운드 리셋 내용",
  T_32_T_WS_ME_ROUNDSETTING: "라운드 설정",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "구역 축소 기간",
  T_32_T_WS_ME_SCORESETTING: "점수 설정",
  T_32_T_WS_ME_TEAMMATENUM: "팀당 멤버수",
  T_32_T_WS_ME_TEAMNUM: "팀 수",
  T_32_T_WS_ME_TEAMSETTING: "팀 설정",
  T_32_U_ATTACHMENT_8: "파우치",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "궁극의 칩",
  T_32_WT_WS_BARRIER: "장애물",
  T_32_WT_WS_BDS: "건물",
  T_32_WT_WS_MMINVALIDERROR: "잘못된 맵 번호",
  T_32_WT_WS_TRGS: "트리거",
  T_32_YF_CHARGESHOT_N: "충전 버스터",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "추가 데미지",
  T_32_YS_WEAPON_TAG_3: "연사 속도",
  T_32_YS_WEAPON_TAG_36: "갑옷 파괴",
  T_32_YS_WEAPON_TAG_39: "아킴보 모드",
  T_32_YS_WEAPON_TAG_42: "얼음 벽",
  T_33_C_SKILL_DESC_GRAFFITIST: "던짐 무기를 차단하는 {0}m 영역을 생성합니다. 지역에 있는 아군은 1초마다 {1}% 방어구 내구도를 회복하고 적에게 받는 데미지가 {2}% 감소합니다. {3}초 동안 지속됩니다. 쿨타임: {4}초. 효과가 중복 획득할 수 없음.",
  T_33_C_SKILL_DESC_HITMAN: "저격소총와 정밀 소총을 사용할 경우, 발사 소리가 소음하게 되고 적을 적중 시 출혈 속도가 {0}% 빨라집니다.",
  T_33_C_SKILL_DESC_KENTA: "전방에서 받는 데미지를 {1}%를 감소하는 {0}m 폭의 정면 방패를 생성합니다. {2}초 동안 지속되며 사용자가 발사하면 리셋됩니다. 쿨타임: {3}초",
  T_33_C_SKILL_DESC_MADEMANA: "{0}m 적의 스킬 및 아이템 사용을 강제 중단시키는 전자기파를 방출합니다. {1}초 동안 지속됩니다. 쿨타임: {2}초",
  T_33_C_SKILL_NAME_BODYGUARD: "총기 전문가",
  T_33_C_SKILL_NAME_KENTA: "검객의 분노",
  T_33_C_SKILL_NAME_MADEMANA: "배틀 스릴",
  T_33_DY_AXOLOTL_N: "도롱뇽",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "펫 스킨:열대 과일 도롱뇽",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "펫 스킨:FFWS덕",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "펫 스킨:블루밍 팔콘",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "치명 바게트",
  T_33_HQ_EMOTE_SONGKRAN_N: "함께 춤추자",
  T_33_HQ_G18_CYBERTHIEF_N: "G18-하이퍼코어 블루",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "수류탄-하이퍼코어 블루",
  T_33_HQ_M14_SPIDERLILY_N: "M14- 불타는 백합",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- 그림자 범죄자",
  T_33_HQ_MP40_FFWS03_N: "MP40-천국 전사",
  T_33_HQ_SCAR_FFWS03_N: "SCAR-천국 전사",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "낫-이드 알피트르",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "천국 전사 단검",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector-하이퍼코어 블루",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "지프차- 에메랄드 쉬머",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "픽업 트럭-천국 수호자",
  T_33_LO_WS_BHPARA_A: "액티브",
  T_33_LO_WS_BHPARA_ATKMODE: "공격 유형",
  T_33_LO_WS_BHPARA_GROUP: "팀",
  T_33_LO_WS_BHPARA_NA: "공격 없음",
  T_33_LO_WS_BHPARA_P: "패시브",
  T_33_LO_WS_DICE_DESC: "점프 능력을 강화하는 주사위",
  T_33_LO_WS_DICEVXZ: "수평 속도",
  T_33_LO_WS_DICEVY: "수직 속도",
  T_33_LO_WS_DTOWER: "방어탑",
  T_33_LO_WS_DTOWER_DESC: "방어 시설에서 일정 거리 내에 있는 적을 자동으로 공격합니다. HP가 0에 도달하면 비활성화됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_33_LO_WS_FORT: "요새",
  T_33_LO_WS_FORT_DESC: "중요 건물에서 일정 거리 내에 있는 적을 자동으로 공격합니다. HP가 0에 도달하면 비활성화됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_33_LO_WS_ITEM89: "정유 탱크",
  T_33_LO_WS_ITEM89_DESC: "거대한 물저장 건설",
  T_33_LO_WS_ITEM90: "개집",
  T_33_LO_WS_ITEM90_DESC: "강아지들의 집",
  T_33_LO_WS_ITEM91: "정류장",
  T_33_LO_WS_ITEM91_DESC: "일반 버스 정류장",
  T_33_LO_WS_ITEM92: "그래피티",
  T_33_LO_WS_ITEM92_DESC: "스프레이 페인트로 장식된 벽",
  T_33_LO_WS_ITEM93: "안정성",
  T_33_LO_WS_ITEM93_DESC: "기본 건초 건물",
  T_33_LO_WS_ITEM94: "벤치",
  T_33_LO_WS_ITEM94_DESC: "공원 벤치",
  T_33_LO_WS_ITEM95: "돌다리",
  T_33_LO_WS_ITEM95_DESC: "돌로 만든 다리",
  T_33_LO_WS_ITEM96: "야외 파라솔",
  T_33_LO_WS_ITEM96_DESC: "우산 아래에 있고 햇볕에 타지 말자.",
  T_33_LO_WS_ITEM97: "결승선",
  T_33_LO_WS_ITEM97_DESC: "결승선 표시",
  T_33_LO_WS_ITEM98: "광고판",
  T_33_LO_WS_ITEM98_DESC: "광고의 일반 배너.",
  T_33_LO_WS_PARA_DM: "데미지",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "적 스캔 거리",
  T_33_LO_WS_PARA_SP: "속도",
  T_33_LO_WS_ZBPARA_AMOUNT: "좀비 생성 빈도",
  T_33_LO_WS_ZBPARA_INTERVAL: "생성 간격",
  T_33_LO_WS_ZBPARA_ROUND: "생성 빈도",
  T_33_LO_WS_ZBSPAWNER: "좀비 스폰",
  T_33_LO_WS_ZBSPAWNER_DESC: "자동으로 일부 행동을 통제할 수 있는 좀비가 생성됩니다.(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "켄타",
  T_33_PD_ZOMBIE_LEVELUP: "레벨업",
  T_33_RW_SKILL_DESC_GANGGIRL: "연사 속도가 {0}% 증가합니다. 적에게 데미지를 입히는 경우, 최대 {1}%의 연사 속도가 이동 속도로 전환됩니다. 전투에서 벗어나면 리셋됩니다.",
  T_33_RW_SKILL_NAME_GANGGIRL: "난폭의 춤",
  T_33_WT_WS_BASICSET1: "기본",
  T_33_WT_WS_QCEPRTIP: "EP를 더 빠르게 HP로 변환",
  T_33_WT_WS_SKILLSET_TAG: "무제한 스킬",
  T_33_WT_WS_SKILLSET1: "스킬 설정",
  T_33_WT_WS_SKILLSET10: "시공간 실드(Chrono)",
  T_33_WT_WS_SKILLSET11: "리듬 열풍(스카일러)",
  T_33_WT_WS_SKILLSET12: "익스트림 실행자(세인)",
  T_33_WT_WS_SKILLSET13: "힐링 하트비트(디미트리)",
  T_33_WT_WS_SKILLSET2: "패시브 스킬",
  T_33_WT_WS_SKILLSET2_TIP: "패시브 스킬 켜기/끄기",
  T_33_WT_WS_SKILLSET3: "액티브 스킬(아래의 쿨타임을 조정하려면 켜세요)",
  T_33_WT_WS_SKILLSET3_TIP: "액티브 스킬을 켜기/끄기. 액티브 스킬을 활성화하면 스킬의 재사용 대기 시간은 아래에서 설정할 수 있습니다.",
  T_33_WT_WS_SKILLSET4: "위장술(오공)",
  T_33_WT_WS_SKILLSET5: "배틀 스릴(A124)",
  T_33_WT_WS_SKILLSET6: "드랍 더 비트(알록)",
  T_33_WT_WS_SKILLSET7: "페인티드 레퓨지(슈테피)",
  T_33_WT_WS_SKILLSET8: "추적 정찰(글루)",
  T_33_WT_WS_SKILLSET9: "마스터 오브 올(K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/초",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "초",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "비 인형(하의)",
  T_33_YS_H_ONIGIRI: "주먹밥",
  T_33_YS_H_RAINCOAT: "비 인형(머리)",
  T_33_YS_HA_CRYINGFACE: "난 울보야(페이스 페인팅)",
  T_33_YS_M_H_FROGKING: "개구리 왕 모자",
  T_33_YS_S_RAINCOAT: "비 인형(신발)",
  T_33_YS_T_BLACKHOLE: "도플러의 우주 후드",
  T_33_YS_T_RAINCOAT: "비 인형(상의)",
  T_33_YS_T_SOCCER_GREEN: "에너지 킥(상의)",
  T_33_YS_T_SOCCER_YELLOW: "라이트닝 킥(상의)",
  T_33_YS_T_WIFI: "WiFi T-Shirt",
  T_34_C_SKILL_DESC_STREAMERGUY: "적 처치 시 관전자 한 명이 증가됩니다.(관전자 수는 다시 감소되지 않습니다.) 관전자가 증가할 때마다 헤드샷으로 받는 데미지가 {0}%(최대 {1}%)감소하며, 헤드샷으로 적에게 주는 데미지가 {2}%(최대 {3}%) 증가합니다.",
  T_34_C_SKILL_DESC_TRACKER: "전방 100m 이내의 가장 가까운 적을 향해 드론을 방출합니다. 드론은 직경 5m의 이동속도를 {0}%, 연사 속도를 {1}% 감소시키며 {2}의 데미지를 입히는 펄스 충격을 방출합니다. 지속 시간:{3}초. 쿨타임: {4}초.",
  T_34_C_SKILL_NAME_TRACKER: "감각 충격파",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "펫 스킨: 분노하는 서퍼",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "펫 스킨: 심해 상어",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "펫 스킨:폭풍우 상어",
  T_34_DY_PETSKIN_TIGER_BIS_N: "펫 스킨:디지털 티그",
  T_34_DY_SURFSHARK_N: "상어코치",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "위대한 지휘자",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "폭~발~",
  T_34_HQ_EMOTE_RIDICULE_N: "조롱",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "기본 픽업-이블 엔지니어",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "툭툭이-왈왈 허스키",
  T_34_JL_EAGLE_RAMPAGE4_N: "데저트이글-대폭발",
  T_34_JL_G36_MADBIONIC_N: "G36-난폭운전",
  T_34_JL_GRENADE_BIS_N: "수류탄-픽셀 병사",
  T_34_JL_MACHETE_RAMPAGE4_N: "나이트 블레이드",
  T_34_JL_THROWINGKNIFE_BANANA_N: "바나나 단검",
  T_34_JL_UMP45_BIS_N: "UMP-디지털 대셔",
  T_34_LY_WS_ABS_DESC: "해당 수치의 절댓값을 구하기",
  T_34_LY_WS_ADD_DESC: "열 끝에 새 요소 추가",
  T_34_LY_WS_AUTO_A: "적 감지",
  T_34_LY_WS_BOT: "레귤러",
  T_34_LY_WS_BOT_PATH: "경로",
  T_34_LY_WS_BOT_TYPE: "유형",
  T_34_LY_WS_BOT4: "도끼",
  T_34_LY_WS_BOT5: "던지기",
  T_34_LY_WS_BOT6: "자폭",
  T_34_LY_WS_BOT8: "도살자",
  T_34_LY_WS_COL_DESC: "색상을 선택해 주세요.",
  T_34_LY_WS_DEL_DESC: "배열에서 지정된 인덱스의 요소를 삭제",
  T_34_LY_WS_DF_PER: "방어 %",
  T_34_LY_WS_FORT_INTERVAL: "공격 간격 시간",
  T_34_LY_WS_GET: "획득",
  T_34_LY_WS_GET_DESC: "배열에서 지정된 인덱스의 요소를 획득",
  T_34_LY_WS_GLEN_ARR_DESC: "현재 배열의 요소 수 획득",
  T_34_LY_WS_GLEN_DESC: "해당 문자열의 길이를 획득",
  T_34_LY_WS_GVX: "x 벡터 요소를 획득",
  T_34_LY_WS_GVX_DESC: "벡터의 첫 번째 요소를 구하기",
  T_34_LY_WS_GVY: "y 벡터 요소를 획득",
  T_34_LY_WS_GVY_DESC: "벡터의 두 번째 요소를 구하기",
  T_34_LY_WS_GVZ: "z 벡터 요소를 획득",
  T_34_LY_WS_GVZ_DESC: "벡터의 세 번째 요소를 구하기",
  T_34_LY_WS_INDEX: "인덱스",
  T_34_LY_WS_JOIN: "연결",
  T_34_LY_WS_NEG_DESC: "해당 숫자의 음수 값을 구하기",
  T_34_LY_WS_PATH: "경로설정기",
  T_34_LY_WS_PATH_DESC: "생물의 이동경로를 설정 가능(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_34_LY_WS_POINT: "표기",
  T_34_LY_WS_POINT_DESC: "현재 위치를 표기 가능(클래시 스쿼드, 팀 데스매치, 놀이터 모드에서 유효하지 않음)",
  T_34_LY_WS_RANGE_F: "멂",
  T_34_LY_WS_RANGE_M: "보통",
  T_34_LY_WS_RANGE_N: "가까움",
  T_34_LY_WS_RNDF_DESC: "구간에서 무작위 소수 생성",
  T_34_LY_WS_RNDI_DESC: "구간에서 랜덤 정수 생성",
  T_34_LY_WS_SET: "설정",
  T_34_LY_WS_SET_DESC: "배열에서 지정된 인덱스의 해당 요소 설정",
  T_34_LY_WS_SQRT_DESC: "이 숫자의 제곱근을 구하기",
  T_34_LY_WS_STRC_DESC: "두 줄의 텍스트를 연결",
  T_34_LY_WS_SVX: "x 벡터 성분 설정",
  T_34_LY_WS_SVX_DESC: "벡터의 첫 번째 구성 요소 설정",
  T_34_LY_WS_SVY: "y 벡터 성분 설정",
  T_34_LY_WS_SVY_DESC: "벡터의 두 번째 구성 요소 설정",
  T_34_LY_WS_SVZ: "z 벡터 성분 설정",
  T_34_LY_WS_SVZ_DESC: "벡터의 세 번째 구성 요소 설정",
  T_34_LY_WS_VADD: "벡터 덧셈",
  T_34_LY_WS_VADD_DESC: "벡터 두 개 추가",
  T_34_LY_WS_VAL_DESC: "시나리오에 따라 정수 또는 소수점 입력",
  T_34_LY_WS_VANG_DESC: "두 벡터의 각도 계산",
  T_34_LY_WS_VCP_DESC: "두 벡터의 교차 곱 계산",
  T_34_LY_WS_VDIS_DESC: "두 벡터 사이의 거리를 계산",
  T_34_LY_WS_VDP_DESC: "두 벡터의 도트 곱 계산",
  T_34_LY_WS_VFX1: "구체",
  T_34_LY_WS_VFX2: "빛의 기둥",
  T_34_LY_WS_VFX3: "링",
  T_34_LY_WS_VFX4: "폭발",
  T_34_LY_WS_VFX5: "순간 이동",
  T_34_LY_WS_VFX6: "치료",
  T_34_LY_WS_VMOD_DESC: "벡터의 크기를 계산하기",
  T_34_LY_WS_VMUL: "벡터 곱셈",
  T_34_LY_WS_VMUL_DESC: "두 벡터를 곱하기",
  T_34_LY_WS_VNOR_DESC: "벡터를 정규화하기",
  T_34_LY_WS_VSUB: "벡터 뺄셈",
  T_34_LY_WS_VSUB_DESC: "두 벡터를 빼기",
  T_34_M_WS_ANGLE: "회전",
  T_34_M_WS_ARRAY: "배열",
  T_34_M_WS_ATT: "요소",
  T_34_M_WS_BOOL: "불 방식",
  T_34_M_WS_COLORARRAY: "색상 배열",
  T_34_M_WS_COLOUR: "색상",
  T_34_M_WS_CONFRONBANNER: "배틀 배너",
  T_34_M_WS_COORDINATE: "좌표",
  T_34_M_WS_CUSTOMINF: "사용자 지정 인터페이스",
  T_34_M_WS_CUSTOMMODEDESC: "FF 블록 코딩 모드에서는 모든 규칙을 만들 수 있습니다.",
  T_34_M_WS_DAMAGETYPE: "데미지 유형",
  T_34_M_WS_DAMAGETYPEDESC: "현재 시스템에서 설정한 데미지 유형",
  T_34_M_WS_DESCTEXT: "안내  텍스트",
  T_34_M_WS_DURACTION: "지속 시간",
  T_34_M_WS_ECAMODE: "FF 블록 코딩 모드",
  T_34_M_WS_ENDPHASEDESC: "현재 단계를 즉시 종료하고 다음 단계로 진행합니다.",
  T_34_M_WS_ENTITY: "실체",
  T_34_M_WS_FLOAT: "소수",
  T_34_M_WS_GAME: "게임",
  T_34_M_WS_GAMERESULTS: "경기 결과",
  T_34_M_WS_GETCONTROL2: "플레이어 인터페이스에서 엔터티의 속성(디자인, 색상, 콘텐츠 등)을 편집할 수 있는 제어 엔터티를 획득합니다.",
  T_34_M_WS_HEIGHT: "높이",
  T_34_M_WS_HUDBUTTONWIDGET: "버튼 제어",
  T_34_M_WS_HUDEMPTYWIDGET: "비어 있는 중심",
  T_34_M_WS_HUDIMAGEWIDGET: "이미지 제어",
  T_34_M_WS_HUDINPUTWIDGET: "텍스트 상자 제어",
  T_34_M_WS_HUDLABELWIDGET: "텍스트 제어",
  T_34_M_WS_ICON: "아이콘",
  T_34_M_WS_ICON_AIM: "조준",
  T_34_M_WS_ICON_ARROW: "화살",
  T_34_M_WS_ICON_BLAST: "폭발",
  T_34_M_WS_ICON_CIRCULAR: "동그라미",
  T_34_M_WS_ICON_CLOTH: "종려",
  T_34_M_WS_ICON_COLLIMATION: "십자선",
  T_34_M_WS_ICON_CORPSE: "좀비",
  T_34_M_WS_ICON_CROSS: "십자",
  T_34_M_WS_ICON_DAY: "태양",
  T_34_M_WS_ICON_DEFENSE: "실드",
  T_34_M_WS_ICON_DIALOGUE: "대화",
  T_34_M_WS_ICON_DIAMONDS: "다이아몬드",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "느낌표",
  T_34_M_WS_ICON_FLAG: "깃발",
  T_34_M_WS_ICON_FOLDER: "폴더",
  T_34_M_WS_ICON_GLASSES: "눈",
  T_34_M_WS_ICON_GUN: "총기",
  T_34_M_WS_ICON_HEART: "하트",
  T_34_M_WS_ICON_HEXAGON: "6각형",
  T_34_M_WS_ICON_HOURGLASS: "모래시계",
  T_34_M_WS_ICON_HOUSE: "집",
  T_34_M_WS_ICON_KEY: "열쇠",
  T_34_M_WS_ICON_LIGHTNING: "번개",
  T_34_M_WS_ICON_LOCK: "고정",
  T_34_M_WS_ICON_LOOP: "루프",
  T_34_M_WS_ICON_MAGNIFIER: "돋보기",
  T_34_M_WS_ICON_MONEY: "코인",
  T_34_M_WS_ICON_MONTH: "달",
  T_34_M_WS_ICON_OPENFOLDER: "폴더 열기",
  T_34_M_WS_ICON_PLUS: "플러스",
  T_34_M_WS_ICON_QUADRI: "4각형",
  T_34_M_WS_ICON_QUESTIONMARK: "물음표",
  T_34_M_WS_ICON_RECYCLING: "Recycle",
  T_34_M_WS_ICON_REFRESH: "새로고침",
  T_34_M_WS_ICON_REST: "남음",
  T_34_M_WS_ICON_RETURN: "뒤로가기",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "오른쪽 사다리꼴",
  T_34_M_WS_ICON_SCISSORS: "가위",
  T_34_M_WS_ICON_SETUP: "설정",
  T_34_M_WS_ICON_SIGN: "마크업",
  T_34_M_WS_ICON_SIGNOUT: "나가기",
  T_34_M_WS_ICON_SQUARE: "정사각형",
  T_34_M_WS_ICON_STAR: "별",
  T_34_M_WS_ICON_STONE: "돌",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "수영튜브",
  T_34_M_WS_ICON_TAGGING: "핀",
  T_34_M_WS_ICON_THESWORD: "검",
  T_34_M_WS_ICON_TRAPEZOID: "사다리꼴",
  T_34_M_WS_ICON_TRASHCAN: "쓰레기통",
  T_34_M_WS_ICON_TRIANGLE: "3각형",
  T_34_M_WS_ICON_TROPHY: "트로피",
  T_34_M_WS_ICON_UP: "좋아요",
  T_34_M_WS_ICON_WRONG: "오류",
  T_34_M_WS_ICON_YES: "맞음",
  T_34_M_WS_ICONNAME: "아이콘 이름",
  T_34_M_WS_INT: "정수",
  T_34_M_WS_KILLZONE: "폭발 구역",
  T_34_M_WS_LEFTCOLOR: "좌측 색깔",
  T_34_M_WS_LEFTTEAMINDEX: "좌측 팀 색인",
  T_34_M_WS_LEFTTEAMSCORE: "좌측 팀 스코어",
  T_34_M_WS_LOCSWITCH: "로컬라이제이션 스위치",
  T_34_M_WS_MAX: "최대치",
  T_34_M_WS_MIN: "최소치",
  T_34_M_WS_NUMBER: "숫자",
  T_34_M_WS_OBJECT: "물건",
  T_34_M_WS_OPEN: "켜기",
  T_34_M_WS_OPENSATUS: "상태 오픈",
  T_34_M_WS_PICTURE: "그래픽",
  T_34_M_WS_RANKARRAY: "랭크 배열",
  T_34_M_WS_RESULTS: "결과",
  T_34_M_WS_RIGHTCOLOR: "우측 색깔",
  T_34_M_WS_RIGHTTEAMINDEX: "우측 팀 색인",
  T_34_M_WS_RIGHTTEAMSCORE: "우측 팀 스코어",
  T_34_M_WS_ROUNDBANNER: "라운드 배너",
  T_34_M_WS_ROUNDDESC: "라운드 안내",
  T_34_M_WS_ROUNDHUD: "라운드",
  T_34_M_WS_ROUNDPARAMS: "정수 배열",
  T_34_M_WS_SAME_NAME: "중복 이름. 새로운 이름으로 시도해 주세요.",
  T_34_M_WS_SCOREARRAY: "스코어 배열",
  T_34_M_WS_SCORINGTYPE: "스코어 유형",
  T_34_M_WS_SCORINGTYPEDECS: "플레이어가 획득할 수 있는 점수. 점수는 커스터마이징 가능",
  T_34_M_WS_SCUFFLESCORING: "멀티팀 점수",
  T_34_M_WS_SETATTRIBUTES: "속성 설정",
  T_34_M_WS_SHUT: "끄기",
  T_34_M_WS_SOUND: "사운드 이펙트",
  T_34_M_WS_SOUNDCLICK: "클릭 소리",
  T_34_M_WS_SOUNDDD: "카운트다운",
  T_34_M_WS_SOUNDFEMALEA: "부상(여성)",
  T_34_M_WS_SOUNDM: "총기",
  T_34_M_WS_SOUNDMALEA: "부상(남성)",
  T_34_M_WS_SOUNDUAV: "폭발",
  T_34_M_WS_ST_ASSISTCOUNT: "어시스트",
  T_34_M_WS_ST_CHECKPROGRESS: "체크포인트 진행률",
  T_34_M_WS_ST_DAMAGESUM: "데미지",
  T_34_M_WS_ST_FINISHCOUNT: "달성 목표 수량",
  T_34_M_WS_ST_FINISHORDER: "달성 목표 순서",
  T_34_M_WS_ST_FINISHTIME: "달성 목표 시간",
  T_34_M_WS_ST_KILLCOUNT: "킬",
  T_34_M_WS_ST_MAINSCORE: "목표 점수",
  T_34_M_WS_ST_RANKSCORE: "랭크 점수",
  T_34_M_WS_ST_SURVIVALDURACTION: "생존 시간",
  T_34_M_WS_ST_UNKOWN: "알 수 없음",
  T_34_M_WS_STARTBANNER: "시작 배너",
  T_34_M_WS_STARTTIME: "시작 시간",
  T_34_M_WS_STRING: "텍스트",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "팀 배열",
  T_34_M_WS_TEXTCONTENT: "콘텐츠",
  T_34_M_WS_THEMECOLOR: "테마 색상",
  T_34_M_WS_TIME: "카운트다운",
  T_34_M_WS_TITLETEXT: "제목 텍스트",
  T_34_M_WS_TYPE: "유형",
  T_34_M_WS_UODATETYPE: "업데이트 유형",
  T_34_M_WS_VARNAME: "변수 이름",
  T_34_M_WS_VECTOR: "벡터",
  T_34_M_WS_VFX: "비주얼 이펙트",
  T_34_M_WS_WIDTH: "넓이",
  T_34_MF_CHARACTER_TRACKER_N: "호머",
  T_34_PD_FlagBattle_HYPE_1: "화염",
  T_34_SP_WS_BLOCK1_NAME: "스테이지 전환",
  T_34_SP_WS_BLOCK1_NAMEDESC: "매칭 스테이지를 전환하여 원하는 스테이지(또는 라운드)로 들어갑니다. 라운드에는 스테이지 인덱스가 있으며 스테이지의 특별한 유형입니다.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "목표 스테이지의 색인",
  T_34_SP_WS_BLOCK10_NAME: "비주얼 이펙트 생성",
  T_34_SP_WS_BLOCK10_NAMEDESC: "지정된 비주얼 이펙트를 사용하여 아이콘을 만듭니다. 비주얼 이펙트 엔티티의 속성을 조정하면 더 많은 속성을 구성할 수 있습니다.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "비주얼 이펙트",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "적용할 수 있는 비주얼 이펙트 유형",
  T_34_SP_WS_BLOCK12_NAME: "비주얼 이펙트 삭제",
  T_34_SP_WS_BLOCK12_NAMEDESC: "지정된 비주얼 이펙트 삭제",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "비주얼 이펙트 엔티티",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "삭제할 비주얼 이펙트 엔티티",
  T_34_SP_WS_BLOCK13_NAMEDESC: "클라이언트에 비주얼 이펙트 재생 명령",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "플레이어 리스트",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "The players who will receive the message",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "리소스 경로",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "시스템 리소스 경로가 in:path입니다. 사용자 지정 리소스 경로가 out:path입니다. 기본적으로 비어 있습니다.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA 채널, 각 채널은 int32에 저장된 0에서 255 사이의 값을 사용합니다. 기본 색상은 흰색(255,255,255,255)입니다.",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "급등",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "확대/축소 스케일, 기본값은 1입니다.",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "전역 좌표로 표시되는 위치. 기본적으로 Vector3(0)입니다.",
  T_34_SP_WS_BLOCK14_NAME: "사운드 이펙트 재생",
  T_34_SP_WS_BLOCK14_NAMEDESC: "클라이언트에 사운드 효과 재생 명령",
  T_34_SP_WS_BLOCK15_NAME: "아웃풋 로그",
  T_34_SP_WS_BLOCK15_NAMEDESC: "로그 인터페이스에 콘텐츠 출력",
  T_34_SP_WS_BLOCK2_NAMEDESC: "활성화하면 안전 구역 밖의 플레이어가 데미지를 받을 수 있습니다.",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "안전 구역 중심점",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "반지름",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "안전 구역의 반지름",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "안전 구역이 축소되기 시작하는 카운트다운",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "안전 구역 지속 기간 감소",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "안전 구역 외에 받는 데미지량",
  T_34_SP_WS_BLOCK3_NAMEDESC: "위험 구역을 끄면 안전 구역 밖에 있는 플레이어는 데미지를 입지 않습니다.",
  T_34_SP_WS_BLOCK4_NAMEDESC: "지정 시간 동안 후속 작업을 지연시키는 데 사용합니다.",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "밀리초 단위로 측정된 대기 시간",
  T_34_SP_WS_BLOCK5_NAMEDESC: "후속 동작을 다음 프레임으로 연기하는 데 사용합니다.",
  T_34_SP_WS_BLOCK6_NAME: "사용자 지정 HUD 생성",
  T_34_SP_WS_BLOCK6_NAMEDESC: "지정 커스터마이징 HUD 생성",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "HUD 엔티티를 만드는 데 사용되는 이름입니다. 해당 로컬 변수는 생성 중인 HUD의 엔티티입니다.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "플레이어",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "특정 플레이어의 엔티티입니다. 일부 플레이어만 볼 수 있습니다.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "HUD 고유 인덱스",
  T_34_SP_WS_BLOCK7_NAMEDESC: "지정된 플레이어만 볼 수 있는 기본 HUD 만들기",
  T_34_SP_WS_BLOCK8_NAMEDESC: "삭제하면 기본 HUD가 클라이언트에 표시되지 않습니다(숨김 또는 삭제).",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD 엔티티",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "삭제할 HUD 엔티티",
  T_34_SP_WS_BLOCK9_NAMEDESC: "삭제 시 사용자 지정 HUD가 클라이언트에서 보이지 않습니다.(숨기기, 폐기 포함)",
  T_34_T_WS_BLOCK1_NAMEDESC: "매칭 시작 시 사건 촉발",
  T_34_T_WS_BLOCK10_NAMEDESC: "플레이어가 처치될 때 사건 촉발",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "사건을 촉발할 탈락 플레이어",
  T_34_T_WS_BLOCK13_NAMEDESC: "다른 플레이어를 지원 시 사건 촉발",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "탈락한 플레이어",
  T_34_T_WS_BLOCK14_NAMEDESC: "데미지 입힐 때 사건 촉발",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "데미지 받는 플레이어",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "입히는 데미지의 유형",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "주는 데미지량",
  T_34_T_WS_BLOCK15_NAMEDESC: "적 처치 시 사건 촉발",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "탈락한 플레이어",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "제거의 원인이 되는 손상 유형",
  T_34_T_WS_BLOCK16_NAMEDESC: "매칭에 가입 시 사건 촉발",
  T_34_T_WS_BLOCK17_NAMEDESC: "부활 시 사건 촉발",
  T_34_T_WS_BLOCK18_NAMEDESC: "팀 제거 시 사건 촉발",
  T_34_T_WS_BLOCK19_NAMEDESC: "팀 추가 시 사건 촉발",
  T_34_T_WS_BLOCK2_NAMEDESC: "매칭 종료 시 사건 촉발",
  T_34_T_WS_BLOCK20_NAMEDESC: "팀이 소멸될 때 사건 촉발",
  T_34_T_WS_BLOCK3_NAMEDESC: "라운드 시작 시 사건 촉발",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "라운드 수는 0부터 시작합니다.",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "라운드 색인",
  T_34_T_WS_BLOCK4_NAMEDESC: "라운드 종료 시 사건 촉발",
  T_34_T_WS_BLOCK5_NAMEDESC: "스테이지 시작 시 사건 촉발",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "스테이지 번호는 0부터 시작합니다.",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "스테이지 엔티티",
  T_34_T_WS_BLOCK6_NAMEDESC: "스테이지 종료 시 사건 촉발",
  T_34_T_WS_BLOCK7_NAMEDESC: "매칭에서 탈퇴 시 사건 촉발",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "사건을 촉발할 플레이어",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "플레이어 촉발",
  T_34_T_WS_BLOCK8_NAMEDESC: "플레이어 스코어 변경 시 사건 촉발",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "변경 점수 유형",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "변경 후 스코어 값",
  T_34_T_WS_BLOCK9_NAMEDESC: "팀 스코어 변경 시 사건 촉발",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "사고를 촉발할 팀",
  T_34_WT_WS_BORNENTITY_PARAM1: "스폰포인트",
  T_34_WT_WS_BORNENTITY_PARAM2: "사용 가능한 좌표",
  T_34_WT_WS_BORNENTITY_PARAM3: "기본 스폰포인트로 설정",
  T_34_WT_WS_BORNENTITY_PARAM4: "빛나는 구역",
  T_34_WT_WS_BORNENTITY_PARAM5: "사용 중",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "체크포인트 관리",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "상태 오픈",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "상태 촉발",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "처치 촉발",
  T_34_WT_WS_ENTITY_PARAM1: "게임 엔티티",
  T_34_WT_WS_ENTITY_PARAM10: "# 팀",
  T_34_WT_WS_ENTITY_PARAM11: "# 팀 멤버",
  T_34_WT_WS_ENTITY_PARAM12: "각 라운드 장비 리셋",
  T_34_WT_WS_ENTITY_PARAM13: "구역 외 데미지 허용",
  T_34_WT_WS_ENTITY_PARAM14: "지역 크기",
  T_34_WT_WS_ENTITY_PARAM15: "구역 축소 시작 시간",
  T_34_WT_WS_ENTITY_PARAM16: "구역 축소 기간",
  T_34_WT_WS_ENTITY_PARAM17: "안전 구역 외 데미지",
  T_34_WT_WS_ENTITY_PARAM18: "목표점수",
  T_34_WT_WS_ENTITY_PARAM19: "탈락 스코어",
  T_34_WT_WS_ENTITY_PARAM2: "무효 상태",
  T_34_WT_WS_ENTITY_PARAM20: "부활 유형",
  T_34_WT_WS_ENTITY_PARAM21: "라운드 점수 순위(유저순)",
  T_34_WT_WS_ENTITY_PARAM22: "정렬 방식(유저순)",
  T_34_WT_WS_ENTITY_PARAM23: "라운드 점수 순위(팀순)",
  T_34_WT_WS_ENTITY_PARAM24: "정렬 방식(팀순)",
  T_34_WT_WS_ENTITY_PARAM25: "점수 순위(MVP순)",
  T_34_WT_WS_ENTITY_PARAM26: "비중(MVP순)",
  T_34_WT_WS_ENTITY_PARAM27: "라운드 랭킹 스코어",
  T_34_WT_WS_ENTITY_PARAM28: "결과 점수순",
  T_34_WT_WS_ENTITY_PARAM29: "게임 총 라운드 수",
  T_34_WT_WS_ENTITY_PARAM3: "게임 시간",
  T_34_WT_WS_ENTITY_PARAM4: "현재 라운드 지수",
  T_34_WT_WS_ENTITY_PARAM5: "현재 스테이지 색인",
  T_34_WT_WS_ENTITY_PARAM6: "Mode template ID",
  T_34_WT_WS_ENTITY_PARAM7: "플레이어 부활 가능",
  T_34_WT_WS_ENTITY_PARAM8: "봇 부활 가능",
  T_34_WT_WS_ENTITY_PARAM9: "부활 시간",
  T_34_WT_WS_ENTITY1_NAME: "현재 엔티티",
  T_34_WT_WS_ENTITY1_NAMEDESC: "현재 엔티티로 반환",
  T_34_WT_WS_ENTITY10_NAME: "아이콘 삭제",
  T_34_WT_WS_ENTITY10_NAMEDESC: "지정 아이콘 삭제",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "삭제하고 싶은 아이콘을 선택해 주세요.",
  T_34_WT_WS_ENTITY11_NAME: "텍스트 삭제",
  T_34_WT_WS_ENTITY11_NAMEDESC: "텍스트 엔티티 제거",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "제거할 텍스트를 선택해 주세요.",
  T_34_WT_WS_ENTITY12_NAMEDESC: "지정 플레이어에 아이템 추가",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "아이템을 받을 플레이어",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "획득할 특정 아이템 ID",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "줄 아이템의 수량",
  T_34_WT_WS_ENTITY12_PARAM3: "수량",
  T_34_WT_WS_ENTITY13_PARAM1: "유형",
  T_34_WT_WS_ENTITY13_PARAM2: "위치",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "물건의 생성 위치 좌표",
  T_34_WT_WS_ENTITY13_PARAM4: "물건",
  T_34_WT_WS_ENTITY14_NAME: "물건 제거",
  T_34_WT_WS_ENTITY14_NAMEDESC: "지정 물건 제거",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "물건 삭제",
  T_34_WT_WS_ENTITY15_NAMEDESC: "모든 플레이어 엔티티 획득",
  T_34_WT_WS_ENTITY16_NAMEDESC: "모든 팀 엔티티 획득",
  T_34_WT_WS_ENTITY17_NAMEDESC: "지정 플레이어의 HP 변동 방식을 구성합니다. +는 HP를 더하는 것을 의미하고 -는 HP를 감소하는 것을 의미합니다. 최소 HP 값이 0인 동안 HP가 최대값까지 추가할 수 있습니다.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "HP 변동을 구성하는 플레이어",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "추가 또는 감소할 HP 수치입니다. +는 HP 추가, -는 HP 감소를 의미합니다.",
  T_34_WT_WS_ENTITY18_NAME: "무작위 생성",
  T_34_WT_WS_ENTITY18_NAMEDESC: "지정한 플레이어가 생성 및 부활 위치 구성",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "이 위치에서 무작위로 부활할 플레이어",
  T_34_WT_WS_ENTITY18_RETURNDESC: "플레이어가 배분될 위치 좌표",
  T_34_WT_WS_ENTITY19_NAME: "플레이어 스코어 획득",
  T_34_WT_WS_ENTITY19_NAMEDESC: "지정된 플레이어의 특정 점수 획득",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "이 플레이어의 점수 엔티티 획득",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "스코어 유형 획득",
  T_34_WT_WS_ENTITY19_RETURNDESC: "획득한 구체적인 스코어 수치",
  T_34_WT_WS_ENTITY2_NAME: "속성 설정",
  T_34_WT_WS_ENTITY2_NAMEDESC: "속성 유형이 이미 선택된 속성 값 구성",
  T_34_WT_WS_ENTITY2_PARAM1: "엔티티",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "게임 엔티티의 속성 값",
  T_34_WT_WS_ENTITY2_PARAM3: "속성",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "이 게임 엔티티의 특정 속성",
  T_34_WT_WS_ENTITY2_PARAM4: "수치",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "속성의 특정 값입니다. 속성 유형이 선택한 유형과 일치하고 관련 블록에 구성된 유형과 일치하는지 확인해 주세요.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "지정 플레이어의 특정 스코어 구성",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "이 플레이어의 스코어 엔티티 구성",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "스코어 유형 구성",
  T_34_WT_WS_ENTITY20_PARAM3: "스코어",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "설정 중인 특정 스코어 값",
  T_34_WT_WS_ENTITY21_NAME: "팀 점수 획득",
  T_34_WT_WS_ENTITY21_NAMEDESC: "지정 팀이 지정 스코어 획득",
  T_34_WT_WS_ENTITY21_PARAM1: "팀",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "이 팀의 점수 엔티티 획득",
  T_34_WT_WS_ENTITY22_NAME: "팀 스코어 설정",
  T_34_WT_WS_ENTITY22_NAMEDESC: "지정된 팀의 특정 스코어 구성",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "해당 팀의 스코어 구성",
  T_34_WT_WS_ENTITY23_NAME: "플레이어 라운드 스코어 획득",
  T_34_WT_WS_ENTITY23_NAMEDESC: "지정된 플레이어의 특정 라운드의 특정 스코어 획득",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "해당 플레이어의 라운드 점수 획득",
  T_34_WT_WS_ENTITY23_PARAM2: "라운드",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "이 라운드에서 스코어 획득",
  T_34_WT_WS_ENTITY24_NAME: "팀 라운드 스코어 획득",
  T_34_WT_WS_ENTITY24_NAMEDESC: "지정된 팀을 위해 특정 라운드의 특정 스코어를 획득합니다.",
  T_34_WT_WS_ENTITY25_NAME: "순간 이동",
  T_34_WT_WS_ENTITY25_NAMEDESC: "지정된 플레이어를 지정된 위치로 순간 이동",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "순간 이동할 플레이어",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "플레이어가 순간이동할 위치 좌표",
  T_34_WT_WS_ENTITY26_NAMEDESC: "지정 플레이어가 지정 목표물에 데미지를 줄 수 있습니다. 공격 플레이어가 선택되지 않을 경우, 지정 목표물은 시스템의 데미지를 받게 됩니다.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "데미지 받을 엔티티",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "입히는 데미지량",
  T_34_WT_WS_ENTITY28_NAMEDESC: "지정 플레이어 부활",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "부활할 수 있는 플레이어 엔티티",
  T_34_WT_WS_ENTITY3_NAMEDESC: "블록 유형 구성",
  T_34_WT_WS_ENTITY3_PARAM1: "as",
  T_34_WT_WS_ENTITY4_NAME: "속성 획득",
  T_34_WT_WS_ENTITY4_NAMEDESC: "엔티티의 특정 속성을 획득",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "속성 값의 특정 게임 엔티티 획득",
  T_34_WT_WS_ENTITY4_RETURNDESC: "획득한 구체적인 속성 수치",
  T_34_WT_WS_ENTITY5_NAMEDESC: "모든 플레이어의 이동 기능 구성",
  T_34_WT_WS_ENTITY6_NAME: "아이콘 생성",
  T_34_WT_WS_ENTITY6_PARAM1: "아이콘",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD에 표시되는 이미지입니다. 다양한 디자인 중에서 선택.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "디자인을 적용할 아이콘을 선택해 주세요.",
  T_34_WT_WS_ENTITY7_NAMEDESC: "지정 플레이어에 HUD 아이콘을 만듭니다. 플레이어 엔티티를 선택하지 않으면 모든 플레이어에 HUD가 생성됩니다.",
  T_34_WT_WS_ENTITY7_PARAM1: "플레이어",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "지정 플레이어에 HUD 아이콘 만들기",
  T_34_WT_WS_ENTITY8_NAME: "텍스트 생성",
  T_34_WT_WS_ENTITY8_PARAM1: "텍스트",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "이 명령에서 만들 특정 텍스트 콘텐츠",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "현재 생성 중인 텍스트 엔터티",
  T_34_WT_WS_ENTITY9_NAMEDESC: "지정 플레이어의 HUD 텍스트 줄을 추가합니다. 플레이어 엔티티를 선택하지 않으면 모든 플레이어의 HUD에 텍스트가 생성됩니다.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "선택한 플레이어에 HUD 텍스트 추가",
  T_34_WT_WS_ICONENTITY_PARAM1: "아이콘 엔티티",
  T_34_WT_WS_ICONENTITY_PARAM2: "디자인",
  T_34_WT_WS_ICONENTITY_PARAM3: "색상",
  T_34_WT_WS_ICONENTITY_PARAM4: "규모",
  T_34_WT_WS_ICONENTITY_PARAM5: "표시 위치",
  T_34_WT_WS_ICONENTITY_PARAM6: "목표 따라가기",
  T_34_WT_WS_ICONENTITY_PARAM7: "벽 투시 가능",
  T_34_WT_WS_ICONENTITY_PARAM8: "항상 화면에 표시",
  T_34_WT_WS_ONETEAM_TAG: "1인 팀",
  T_34_WT_WS_PHASEENTITY_PARAM1: "스테이지 엔티티",
  T_34_WT_WS_PHASEENTITY_PARAM2: "스테이지 색인",
  T_34_WT_WS_PHASEENTITY_PARAM3: "시작 시간",
  T_34_WT_WS_PHASEENTITY_PARAM4: "종료 시간",
  T_34_WT_WS_PHASEENTITY_PARAM5: "지속 시간",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "플레이어 엔티티",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "부활 점수",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "무기 데미지 %",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "캐릭터 3D 모델",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "신분",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "현재 HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "최대 HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "처치됨",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "생존 시간",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "무적",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "팀",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Target checkpoint ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "스폰포인트",
  T_34_WT_WS_PROCIRCLE_ICON: "Icon",
  T_34_WT_WS_PVEDESC1: "종료하기 전에 최소 한 명의 플레이어가 결승선에 도달하면 팀이 승리합니다. 모든 플레이어가 동시에 탈락하면 게임이 종료됩니다.",
  T_34_WT_WS_PVEDESC2: "정해진 시간 동안 살아남으면 승리합니다. 모든 플레이어가 동시에 탈락하면 게임이 종료됩니다.",
  T_34_WT_WS_PVENAME1: "서바이벌",
  T_34_WT_WS_PVENAME2: "방어 및 생존",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Current checkpoint ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "파르쿠르 모드 체크포인트 번호",
  T_34_WT_WS_SKILLSET14: "검객의 분노(켄타)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "팀 엔티티",
  T_34_WT_WS_TEAMENTITY_PARAM2: "에이스",
  T_34_WT_WS_TEAMENTITY_PARAM3: "모든 멤버",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "일반 촉발",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "외형",
  T_34_WT_WS_TXTENTITY_PARAM1: "텍스트 엔티티",
  T_34_WT_WS_TXTENTITY_PARAM2: "콘텐츠",
  T_34_WT_WS_VFXENTITY_PARAM1: "비주얼 이펙트 엔티티",
  T_34_WZ_WS_LOGIC10_NAME: "다음 단계로 계속",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "현재 루프 반복을 건너뛰고 다음 실행",
  T_34_WZ_WS_LOGIC11_NAME: "반환",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "현재 실행을 종료하고 기본 프로그램으로 돌아갑니다. 반환 시 데이터를 다시 보낼 수 있습니다.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "반환 수치",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "다시 매인 프로그램으로 보낼 데이터",
  T_34_WZ_WS_LOGIC2_NAME: "비교",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "지정 연산자를 사용하여 두 값을 비교합니다.",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "죄측 수치",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "비교에 사용한 죄측 수치",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "비교 함수",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "값을 비교할 방법을 선택하세요. 지원되는 연산법: >, >=,==, !=, <=, <, AND(부울값 전용) 또는 OR(부울 값 전용)입니다.",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "우측 수치",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "비교에 사용한 우측 수치",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "비교 결과",
  T_34_WZ_WS_LOGIC3_NAME: "아니다.",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "로직 값의 역수를 제공",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "NOT 연산을 사용하려는 값",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT 연산 결과",
  T_34_WZ_WS_LOGIC4_NAME: "empty 확인",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "현재 루프 반복을 건너뛰고 다음 실행",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "엔티티",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "빈칸을 검사할 엔티티",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "엔티티가 비어 있는지 여부",
  T_34_WZ_WS_LOGIC5_NAME: "조건문",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "조건 충족 여부에 따라 실행됩니다. 하위 프로세스는 후속 논리 분기들과 동일합니다.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "값",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "조건 수와 하위 프로세스(논리 분기) 개수는 일치해야 합니다.",
  T_34_WZ_WS_LOGIC6_NAME: "정수 범위 루프",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "x에서 y로 z 단계만큼 반복하세요. 하위 프로세스는 루프 자체입니다.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "로컬 변수 루프 색인 값을 추출하는 데 사용할 수 있는 루프 색인 이름",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "시작 수치",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "루프가 시작되는 값",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "종료 수치",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "루프가 끝나는 값",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "스텝",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "각 루프의 스텝입니다. 시작 값이 종료 값보다 작으면 스텝이 0보다 커야 합니다. 시작 값이 종료 값보다 크면 스텝은 0보다 작아야 합니다.",
  T_34_WZ_WS_LOGIC7_NAME: "컨테이너 범위의 루프",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "데이터 컨테이너의 각 하위 요소를 추출하기 위한 데이터 컨테이너 통과를 활성화합니다. 하위 프로세스는 루프 자체입니다.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "원소",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "이 이름으로 이동하면 로컬 변수의 하위 요소 값이 추출됩니다.",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "데이터 컨테이너",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "통과할 데이터 컨테이너. 현재 배열 컨테이너를 지원합니다.",
  T_34_WZ_WS_LOGIC8_NAME: "조건 루프",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "조건 루프는 조건이 충족될 때까지 반복됩니다. 조건이 False이면 루프가 중지됩니다.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "조건",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "조건이 True이면 루프를 반복하고 조건이 False이면 루프가 중지됩니다.",
  T_34_WZ_WS_LOGIC9_NAME: "루프 중단",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "현재 루프 프로세스를 중지하고 루프에서 점프합니다.",
  T_34_Y_B_DINOSAURS: "환상 공룡(하의)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "블랙 천사(하의)",
  T_34_YS_F_B_PANDACATTLE: "젖소 잠옷(하의)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "폭우 관찰자(하의)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "폭우 관찰자(머리)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "폭우 관찰자(페이스 페인팅)",
  T_34_YS_F_S_PANDACATTLE: "젖소 잠옷(신발)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "폭우 관찰자(신발)",
  T_34_YS_F_T_PANDACATTLE: "젖소 잠옷(상의)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "폭우 관찰자(상의)",
  T_34_YS_M_B_ANGEL_BW: "화이트 천사(하의)",
  T_34_YS_M_B_PANDACATTLE: "판다 잠옷(하의)",
  T_34_YS_M_H_PANDACATTLE: "판다 잠옷(머리)",
  T_34_YS_M_S_PANDACATTLE: "판다 잠옷(신발)",
  T_34_YS_M_T_PANDACATTLE: "판다 잠옷(상의)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Gain [FFB300]{0} EP[-] by knocking down an enemy.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Pet Skin: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Pet Skin: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Pet Skin: Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Pet Skin: Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Pet Skin: Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "Pet Skin: Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "is knocked down",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "For [FFB300]{1}s[-], successfully firing at a Gloo Wall will mark enemies within [FFB300]{3}m[-] of it and penetrate the Gloo Wall to cause damage to marked enemies (damage inflicted will be lower than usual). Effective on [FFB300]{0}[-] Gloo Walls max. Cooldown: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Wall Brawl",
  T_35_KY_INFECTION_MAPNAME: "Wasteland",
  T_35_M_WS_BUTTONCLICKDESC: "Triggers this incident when the corresponding button is tapped. The trigger player can be obtained using parameters.",
  T_35_M_WS_GETTEAMMATEPOS: "Obtain nearby teammates' locations",
  T_35_M_WS_ROUND2: "Current wave",
  T_35_PD_Infection_HUMANSELECT: "Select a weapon",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Object",
  T_35_QX_WS_ICONTYPE_NATURE: "Shapes of Nature",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometric",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Symbol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Weapon",
  T_35_R_EMOTE_TAG_MUSIC_N: "Music",
  T_35_RW_SKILL_DESC_Singers: "Skill user and allies within [FFB300]{0}m[-] can block [FFB300]{1}%[-] DMG using EP. In this case, the amount of EP deducted from allies will be added to the skill user's EP.",
  T_35_RW_SKILL_NAME_Singers: "Silent Sentinel",
  T_35_SP_WS_COMMENTKEY_01: "Suitable Difficulty",
  T_35_SP_WS_COMMENTKEY_02: "Creative",
  T_35_SP_WS_COMMENTKEY_03: "Interesting Gameplay",
  T_35_SP_WS_COMMENTKEY_04: "Can Be Played Repeatedly",
  T_35_SP_WS_COMMENTKEY_05: "Intriguing storyline",
  T_35_SP_WS_COMMENTKEY_06: "Well-Balanced",
  T_35_SP_WS_COMMENTKEY_07: "Pleasant Experience",
  T_35_SP_WS_COMMENTKEY_08: "Flexible",
  T_35_SP_WS_COMMENTKEY_09: "Aesthetically pleasing",
  T_35_SP_WS_COMMENTKEY_10: "Too Difficult",
  T_35_SP_WS_COMMENTKEY_11: "Too Easy",
  T_35_SP_WS_COMMENTKEY_12: "Boring",
  T_35_SP_WS_COMMENTKEY_13: "Too Long",
  T_35_SP_WS_COMMENTKEY_14: "Imbalanced",
  T_35_SP_WS_COMMENTKEY_15: "Unpleasant Experience",
  T_35_SP_WS_IMAGE03: "Texture",
  T_35_SP_WS_IMAGE04: "Frame",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buste - Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenade - Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "Grenade - Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "Grenade - Grim Rider",
  T_35_SY_M24_KUN_N: "M24 - Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep - Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Enjoy the celebration!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motorbike - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Structure & Decor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Structures",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Others",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Architecture",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Large Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Mid-Sized Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Functional Objects",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Mode Essentials",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Music",
  T_35_WT_WS_PVEMODE_TAG: "Survival Mode",
  T_35_WZY_WS_BECRE_NAMEDESC: "Triggers when this entity is created",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Triggers when this entity is eliminated. The source of attack can be identified using "Trigger Entity" and the type of attack can be identified using "Damage Type".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "The entity who triggers the incident",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Create a type of item or a set of items at a specific location. When creating one type of item, the amount is the number of that item. When creating a set of items, the amount is the amount list that corresponds to the item list. The created items will depend on the map's units.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "A list that contains the items that will be created. It can also consist of a single item.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "An amount list that corresponds to the item list. It may only contain the amount of one item type.",
  T_35_WZY_WS_DAMTYPE_CAR: "Vehicle",
  T_35_WZY_WS_DAMTYPE_FALL: "Fall",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Gun",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenade",
  T_35_WZY_WS_DAMTYPE_MELEE: "Melee",
  T_35_WZY_WS_DAMTYPE_ZONE: "Out-of-zone",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Delete a specified number of items of specific players",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Enter trigger area",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" enters a trigger area',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "The player to get the entity. When linked with the player, the entity's info will only be updated for said player. When no player is linked, all players will receive the entity info.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Battle Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Get all objects of a specified type. The result returned is a list.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Object type",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI Control",
  T_35_WZY_WS_HURT_NAMEDESC: 'Triggers when this entity takes damage. The source of attack can be identified using "Trigger Entity".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "The type of item",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Level Object",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Triggers when this entity eliminates another entity. The type of entity being eliminated can be identified using "Eliminated Entity".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "The entity who is eliminated",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Triggers when an entity causes damage",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "The entity that is dealing damage",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Target entity",
  T_35_WZY_WS_PREFABID_NAME: "Template ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "Current EP",
  T_35_WZY_WS_PROPERTY_JUMP: "Jump height",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Exit trigger area",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" exits a trigger area',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Remove a specific element from an list. [List] is the list in which the element lies. [Element] is the element to be removed.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Element value",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "The value of the element to be removed",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Round Entity",
  T_35_WZY_WS_TOWER_PARAM1: "Tower and Fortress",
  T_35_WZY_WS_TOWER_PARAM2: "Team ID",
  T_35_WZY_WS_TOWER_PARAM3: "Current HP",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Damage",
  T_35_WZY_WS_TOWER_PARAM6: "Attack interval",
  T_35_WZY_WS_TOWER_PARAM7: "Range of attack",
  T_35_WZY_WS_TOWER_PARAM8: "Defense %",
  T_35_XYL_PDM_REVENGE: "Avenged",
  T_35_XYL_WS_BISPARTERRE: "Graffiti Flowerbed",
  T_35_XYL_WS_BISPARTERRE_DESC: "A Battle-In-Style-themed stone flowerbed",
  T_35_XYL_WS_BISWALL: "Graffiti Wall",
  T_35_XYL_WS_BISWALL_DESC: "A Battle-In-Style-themed wall that can be combined",
  T_35_XYL_WS_BOTDROP: "Turn on/off loot drop",
  T_35_XYL_WS_CUSTOMTRIGGER: "Custom trigger",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Place an object that triggers a certain customized special effect when a player activates it. The effect must be configured in the script. (Only in Customize mode.)",
  T_35_XYL_WS_DOUBLEDOOR: "Gate",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "A gate that's cracked open",
  T_35_XYL_WS_RESET: "Reset every round",
  T_35_XYL_WS_RESETN: "No",
  T_35_XYL_WS_RESETY: "Yes",
  T_35_XYL_WS_ROADBLOCK: "Roadblock A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Prevents from passing through",
  T_35_XYL_WS_STAIRS: "Stairs",
  T_35_XYL_WS_STAIRS_DESC: "Stairs that can be combined with landings",
  T_35_XYL_WS_STAIRSL: "Landing B",
  T_35_XYL_WS_STAIRSL_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_STAIRSZ: "Landing A",
  T_35_XYL_WS_STAIRSZ_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_TBOOTH: "Phone Booth",
  T_35_XYL_WS_TBOOTH_DESC: "Commonly seen on the streets",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Cub Mask",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (Mask)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (Mask)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (Bottom)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (Bottom)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (Bottom)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (Bottom)",
  T_35_YS_F_H_BEAR_HW: "Cub Cap",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (Head)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (Head)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (Head)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (Head)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (Facepaint)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (Shoes)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (Shoes)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (Shoes)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (Shoes)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (Top)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (Top)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (Top)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (Top)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (Mask)",
  T_35_YS_M_A_RIDERS: "Grim Rider (Mask)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (Bottom)",
  T_35_YS_M_B_RIDERS: "Grim Rider (Bottom)",
  T_35_YS_M_H_BEAR_HW: "Cub Cap",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (Head)",
  T_35_YS_M_H_RIDERS: "Grim Rider (Head)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (Shoes)",
  T_35_YS_M_S_RIDERS: "Grim Rider (Shoes)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (Top)",
  T_35_YS_M_T_RIDERS: "Grim Rider (Top)",
  T_35_YS_T_CHAMPION: "Champion Tee",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Get coins when match begins",
  T_36_JH_WS_CESAYCLOSE: "Disable manual closing or not",
  T_36_JH_WS_CHOOSEEDITSHOP: "Select a store to edit",
  T_36_JH_WS_CHOOSESHOP: "Select a store",
  T_36_JH_WS_COINCOUNT: "Currency amount",
  T_36_JH_WS_COINHUD: "Display coin amount or not",
  T_36_JH_WS_CRAFTSHOP: "Edit store",
  T_36_JH_WS_CREATEGOLD: "Coin Generator",
  T_36_JH_WS_CSHOPENTITY: "Bind store entity",
  T_36_JH_WS_CSHOPHUD: "Store interface",
  T_36_JH_WS_CURRENTLIMIT: "Remaining purchase limit",
  T_36_JH_WS_ECONOMIC: "Economy",
  T_36_JH_WS_INGAMEECONOMI: "Game economy",
  T_36_JH_WS_ITEMINDEXID: "Merchandise number",
  T_36_JH_WS_KILLMONEY: "Get coins for eliminating",
  T_36_JH_WS_KILLMONEYTIP: "The amount of coins to earn for eliminating zombies in Rush mode and Endurance mode",
  T_36_JH_WS_LISTINDEX: "List of merchandise types",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Amount",
  T_36_JH_WS_OPTIONNAME: "Droid Apocalypse Mode Exclusive",
  T_36_JH_WS_REALSHOPENTITY: "Store entity",
  T_36_JH_WS_SEEORHIDE: "Display vending machine",
  T_36_JH_WS_SHOPFRONT: "Store",
  T_36_JH_WS_SHOPITEMLIST: "Merchandise type",
  T_36_JH_WS_SHOPOPENCON: "Open status",
  T_36_JH_WS_SSHOPNAME: "Store name",
  T_36_JH_WS_TOTALLIMIT: "Purchase limit",
  T_36_JH_WS_TRIGGERWIDE: "Trigger range",
  T_36_JH_WS_VENDMACHINE: "Vending Machine",
  T_36_JH_WS_WINMONEY: "Get coins for victory",
  T_36_JH_WS_WORTH: "Worth",
  T_36_JL_FOREGRIP_MR_N: "Marksman Grip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Shotgun Stock",
  T_36_JL_STOCK_SR_N: "Sniper Stock",
  T_36_KK_WS_MONTSTERDES: "A 4-seater truck with high durability and can travel through tough terrains",
  T_36_M_WS_SETTEMPVAR: "Set temporary variable",
  T_36_M_WS_TEMPVAR: "Temporary variable",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG - Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM - Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B - Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster - Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18 - Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36 - Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenade - Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon - Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Heal Sniper - Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun - Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord - Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14 - Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker - Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24 - Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249 - Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500 - Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60 - Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79 - Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90 - Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS - Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD - Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Dagger - Mamba",
  T_36_SY_THROWINGKNIFE_MENA_N: "Dagger - Boho",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Heal Pistol - Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP - Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck - Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motorbike - Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Sports Car - Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS - Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "Back accumulator",
  T_36_WZY_AVAILAB: "Enabled",
  T_36_WZY_BACKANDFORTH: "Round-trip",
  T_36_WZY_BASEMULTIPLIER: "Basic multiplier",
  T_36_WZY_BASIC: "Basic type",
  T_36_WZY_BEFORACCUMULATOR: "Front accumulator",
  T_36_WZY_CYLIC: "Circle-back",
  T_36_WZY_GUNPRO_PARAM1: "Basic damage",
  T_36_WZY_GUNPRO_PARAM10: "Bullet spread start",
  T_36_WZY_GUNPRO_PARAM11: "Max. spread area",
  T_36_WZY_GUNPRO_PARAM12: "Burst",
  T_36_WZY_GUNPRO_PARAM2: "Bullets in magazine",
  T_36_WZY_GUNPRO_PARAM3: "Initial magazine number",
  T_36_WZY_GUNPRO_PARAM4: "Firing interval",
  T_36_WZY_GUNPRO_PARAM7: "Distance for max. damage",
  T_36_WZY_GUNPRO_PARAM8: "Distance for min. damage",
  T_36_WZY_GUNPRO_PARAM9: "Minimum damage",
  T_36_WZY_MULTIPLIR: "Multiplier",
  T_36_WZY_PRICE: "Price",
  T_36_WZY_SUMMULTIPLIER: "Multiplier accumulator",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Absolute value result",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Add all the elements from the [Source list] to the bottom of the [Target list]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "The target list to add the elements",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "The list that contains the elements to be added",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Add a certain amount of designated currency into a designated wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "The wallet to add currency into",
  T_36_WZY_WS_ADDSUB: "Add or subtract values",
  T_36_WZY_WS_AIENTITY: "AI entity",
  T_36_WZY_WS_ALLSHOP_DESC: "A list that consists of store entities",
  T_36_WZY_WS_ANGLE_DESC: "The measurement of the angle",
  T_36_WZY_WS_ANYTYPE: "Any type",
  T_36_WZY_WS_ARILEFT: "Left value in the operation",
  T_36_WZY_WS_ARIRES: "Operation result",
  T_36_WZY_WS_ARIRIGHT: "Right value in the operation",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 arithmetic operations",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "The basic integer operations support addition, subtraction, multiplication, division, and remainder. The float operations support addition, subtraction, multiplication, and division.",
  T_36_WZY_WS_ARRAY_DESC: "The target list",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Check whether a list contains a designated element. The value returned is Boolean.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "The designated list",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ARRCONELERES: "The result of whether a designated element exists in a list. The value is Boolean.",
  T_36_WZY_WS_ATTACK: "Patrol and attack",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Triggers when the player is knocked down",
  T_36_WZY_WS_BIGFLOAT: "Big decimal",
  T_36_WZY_WS_BIGTOYBALL: "Dice",
  T_36_WZY_WS_BOOLLIST: "Boolean list",
  T_36_WZY_WS_CEIL_NAME_DESC: "Round a value to the smallest integer larger than itself",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "The value to round up",
  T_36_WZY_WS_CEILRES: "Result of rounding up",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "The selected AI will chase this entity regardless of distance. [Chased entity] can be any entity. When the [Chased entity] does not have a HP property, then the AI entity will not inflict any damage.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "The entity that is doing the chasing",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "The target entity that is being chased. It can be any entity.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "The template for cloning objects. Select using the cursor. The property and script of the clone will be the same as those of the object chosen.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "The object entity to be cloned",
  T_36_WZY_WS_CONDITION: "Condition",
  T_36_WZY_WS_CONDITIONLIST: "Condition list",
  T_36_WZY_WS_CONOFHUD: "The HUD entity that the control exists in",
  T_36_WZY_WS_CONTROL_DESC: "The only index of a control",
  T_36_WZY_WS_COS_NAMEDESC: "Find the cosine of an angle",
  T_36_WZY_WS_COSRES: "Cosine of the angle",
  T_36_WZY_WS_CREABLEOB: "Creatable object",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Create an object entity at a designated location. (Test version)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "The coordinates of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "The type of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "The entity of the object to be created",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Currency",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Merchandise entity",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Create a merchandise entity",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Create a wallet entity. [Bind player] is the player who can see this wallet. [Owner] is the player to whom the wallet belongs. Invalid if a wallet already exists.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Bound player",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "The player to which the wallet is visible. If no settings are configured, the wallet will be visible to all.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "The owner of the wallet",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Wallet entity",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "The wallet entity created",
  T_36_WZY_WS_CURRAMT: "Currency amount",
  T_36_WZY_WS_DATA_TYPE1: "Added parameter",
  T_36_WZY_WS_DATA_TYPE2: "Basic and logic calculation",
  T_36_WZY_WS_DATA_TYPE3: "List manipulation",
  T_36_WZY_WS_DATA_TYPE4: "Vector calculation",
  T_36_WZY_WS_DESTITEM_NAME: "Destroy player item",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Destroy a designated type of item for a designated player",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Items that can be destroyed are weapons, vests, and helmets",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "The slot index of the type of item selected. Weapon index is [1,3] and Vest and Helmet is 1 by default.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Lose equipment upon elimination",
  T_36_WZY_WS_DESTOBJ: "Destroyable objects",
  T_36_WZY_WS_DIRPOINT: "Direction point",
  T_36_WZY_WS_DIRPOINTDESC: "The direction point to be created",
  T_36_WZY_WS_ELEFINDRES: "Index of an element's first position",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Obtain the index of the first position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Get the index of the last position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELELINDRES: "Index of an element's last position",
  T_36_WZY_WS_ELEMENTSNUM: "# of elements in the list",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Triggers when the [Triggering entity] collides with this trigger",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "The entity that this trigger collides with",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Triggers when a [Triggering entity] drives the vehicle",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "The entity that is driving the vehicle",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Triggers when the player enters the trigger",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "The trigger to enter",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Triggers when a [Triggering entity] exits the vehicle",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "The entity that exits the vehicle",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Triggers when a [Triggering entity] enters the vehicle",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "The entity that enters the vehicle",
  T_36_WZY_WS_ENTITY_TYPE1: "Commonly used",
  T_36_WZY_WS_ENTITY_TYPE2: "Properties",
  T_36_WZY_WS_ENTITY_TYPE3: "Objects and items",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "The element value to be changed",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Target player",
  T_36_WZY_WS_ENTITYLIST: "Entity list",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Triggers when a [Triggering entity] bounces off the tire",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "The entity that bounces off the tire",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Triggers when a [Triggering entity] enters the portal and is teleported",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "The entity that is teleported",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "The type of armor equipped, including vest, helmet, and backpack",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Triggers when a player successfully equips a weapon. [Triggering player] is the player who successfully equips a weapon. [Weapon entity] is the weapon entity that the player equipped.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "The weapon entity equipped",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Weapon type",
  T_36_WZY_WS_EULERANGLE: "Euler angles",
  T_36_WZY_WS_FACECAMERA: "Always face camera",
  T_36_WZY_WS_FLOATLIST: "Float list",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Round a value to the largest integer smaller than itself",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "The value to round down",
  T_36_WZY_WS_FLOORRES: "Result of rounding down",
  T_36_WZY_WS_FORMUENT: "Property formulate-able entity",
  T_36_WZY_WS_FORMUFACT: "Type of property formula factor",
  T_36_WZY_WS_GAME_TYPE2: "Gameplay",
  T_36_WZY_WS_GAME_TYPE3: "Special effects",
  T_36_WZY_WS_GENENT_NAMEDESC: "Triggers when a generator spawns units. [Unit entity list] is the list of units spawned by the generator. [# of waves] is the number of waves spawned by the generation.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Unit entity",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "A list that consists of unit entities spawned by a generator",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "The number of waves that a generator spawns",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obtain all the stores in the match. The value returned is a list that consists of store entities.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Use the RGB to obtain a color",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Get the amount of a certain currency in a specific wallet",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "The wallet from which to get the currency amount",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "The currency type of the currency amount to be obtained",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Get the entity type of a target entity",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "The entity whose type to get",
  T_36_WZY_WS_GETENTTYPERES: "Entity type of target entity",
  T_36_WZY_WS_GETFOR_NAME: "Get direction coordinates",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Get the vector of a designated direction point",
  T_36_WZY_WS_GETFORRES: "Vector of direction point",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obtain the currency entity of a certain currency type in the wallet",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "The wallet in which the currency entity is",
  T_36_WZY_WS_GETPOS_NAME: "Get coordinates",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Get the coordinates of a designated direction point",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "The designated direction point",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Equipment type",
  T_36_WZY_WS_GETWALLET_NAME: "Obtain wallet",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obtain the wallet of the selected owner",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Whether a bound wallet exists",
  T_36_WZY_WS_GETWALLETRES: "Owner's wallet entity",
  T_36_WZY_WS_HUDCONTROL_DESC: "The control entity of a HUD",
  T_36_WZY_WS_HUDTYPE: "HUD type",
  T_36_WZY_WS_INCIDENT_TYPE1: "Global incident",
  T_36_WZY_WS_INCIDENT_TYPE2: "Entity incident",
  T_36_WZY_WS_INDEX_DESC: "An index value of a list. Starts from 0.",
  T_36_WZY_WS_INTLIST: "Integer list",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Check whether an entity type belongs to a certain sub-category. The result returned is Boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "The parent category to check whether the entity belongs in",
  T_36_WZY_WS_JENTSUBCLRES: "Result of parent category check",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Check whether an entity belongs to a certain entity type. The result returned is Boolean.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "The entity to check",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Means that it is the same as the entity type",
  T_36_WZY_WS_JENTTYPERES: "Result of entity check",
  T_36_WZY_WS_JUSTPATROL: "Patrol only",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Triggers when the player exits the trigger",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "The trigger to exit",
  T_36_WZY_WS_LEVELOBLIST: "Object list",
  T_36_WZY_WS_LEVOBJSLIST: "A list of all the map objects in this match",
  T_36_WZY_WS_LEVOBTYPE: "Object type",
  T_36_WZY_WS_LISTT: "Any list",
  T_36_WZY_WS_LOGCONTEXT_DESC: "The content to be printed",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "The left string to be connected",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "The right string to be connected",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "The element value to be added",
  T_36_WZY_WS_LOGOPER: "When conducting logic operations (and & or): if using the and operation and the two Boolean values are TRUE, the result is TRUE, and if using the or operation and one of the Boolean values is TRUE, the result is TRUE.",
  T_36_WZY_WS_LOOTPOINT: "Loot point",
  T_36_WZY_WS_MAINWEAP: "Current weapon",
  T_36_WZY_WS_MAX_DESC: "The upper range of the generated integer (open interval)",
  T_36_WZY_WS_MIN_DESC: "The lower range of the generated integer (closed interval)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Weapon entity",
  T_36_WZY_WS_MONENT: "Currency entity",
  T_36_WZY_WS_MONTYPE: "Currency type",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Make the AI move towards a target point. Use [Return or not] to select whether the AI will return to its original position. Use [Attack or not] to select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "The AI entity that will travel",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "The destination",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Use to set whether the AI will return to original location after arriving to the destination. TRUE means return; FALSE means do not return.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Attack or not",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Use to set whether the AI will attack nearby enemies along the way. TRUE means scan for enemies; FALSE means do not scan for enemies.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Scalar multiplication vector",
  T_36_WZY_WS_NEGRES: "Negative value result",
  T_36_WZY_WS_NEUTRAL: "Neutral",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Forces the designated generator to spawn the next wave. Generators include Zombie Spawns and item spawns.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Generator entity",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "The designated generator entity, such as Zombie Spawns and item spawns",
  T_36_WZY_WS_OBJENT: "Object entity",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Triggers when an item is obtained. [Item type] is the type of item that is obtained.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Triggers when a weapon is got. [Weapon entity] is the weapon obtained.",
  T_36_WZY_WS_ONEWAY: "One-way",
  T_36_WZY_WS_OPENSTATE: "Status",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operation",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "The basic arithmetic operations. Currently, integer operations include addition, subtraction, multiplication, division, and remainder, and the float operations include addition, subtraction, multiplication, and division. ",
  T_36_WZY_WS_OWNERENT_DESC: "The entity whose wallet to obtain",
  T_36_WZY_WS_PERCENTAGE: "Percentage adjustment",
  T_36_WZY_WS_PLACOLLIDE_NAME: "When player collides with trigger",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Triggers when the [Triggering player] collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "The player that collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "The object entity that the player collides with",
  T_36_WZY_WS_PLADRIVEH_NAME: "When player drives vehicle",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Triggers when the [Triggering player] drives a vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "The player that is driving the vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is driving",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "When player exits vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Triggers when the [Triggering player] exits a vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "The player that is exiting the vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is exiting",
  T_36_WZY_WS_PLAGETONVEH_NAME: "When player enters vehicle",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Triggers when the [Triggering player] enters a vehicle",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is entering",
  T_36_WZY_WS_PLAKNOFLY_NAME: "When player bounces off tire",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Triggers when the [Triggering player] bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "The player that bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "The object entity on which the player bounces off",
  T_36_WZY_WS_PLATP_NAME: "After player is teleported",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "The player that uses a portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "The portal entity that the player used",
  T_36_WZY_WS_PLAYERLIST_DESC: "A list of all the players in this match",
  T_36_WZY_WS_POINTPICKER: "Path pivot",
  T_36_WZY_WS_PORTALENT: "Portal entity",
  T_36_WZY_WS_PREFAB: "Template",
  T_36_WZY_WS_PRODLIST: "Merchandise list",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sort order",
  T_36_WZY_WS_PROPMOD: "Method of property change",
  T_36_WZY_WS_RANKABLEE: "Rank-able entity",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consume a certain amount of designated currency in a designated wallet",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "The wallet that spends the currency",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "The type of currency consumed",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "The amount of currency consumed",
  T_36_WZY_WS_RNDFRES: "Generated random float",
  T_36_WZY_WS_RNDIRES: "Result of random integer generation",
  T_36_WZY_WS_ROUND_NAME_DESC: "Round a value to the nearest integer",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "The value to round",
  T_36_WZY_WS_ROUNDRES: "Result of rounding",
  T_36_WZY_WS_RUNAI_NAMEDESC: "The behavior tree that the selected AI will execute",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "The unit entity that stops/runs a default behavior tree",
  T_36_WZY_WS_SCOREABLEE: "Score-able entity",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Triggers when score changes. [Score type] is the type of score that changed. [Score] is the new score.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Create a direction point",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Get a newly created direction point. Use [Location] to set the point's coordinates and [Direction] to set the vector of the direction.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "The coordinates of the direction point",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direction",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "The vector of the direction point",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI entities will travel according to the order set here. Available travel types are circle-back, one-way, and round-trip. You can also select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "A list that consists of the points to which the AI should travel",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Travel type",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "These are the travel types. One-way is for the AI to stop traveling once it arrives at the destination. Circle-back is for the AI to search for a way back once it arrives at the destination. Round-trip is for the AI the return to original location according to the backwards order of the path list.",
  T_36_WZY_WS_SHOPECON: "Store and economy",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Use to display notifications that float on the screen. Configure the content using [Text], the text color using [Color], and the display duration using [Duration] (the unit is milleseconds).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "The content of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "The color of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "The display duration of the floating notification, in milleseconds",
  T_36_WZY_WS_SIN_NAMEDESC: "Find the sine of an angle",
  T_36_WZY_WS_SINRES: "Sine of the angle",
  T_36_WZY_WS_SKIPKNODOWN: "Whether eliminate upon knockdown",
  T_36_WZY_WS_SQRTRES: "Square root result",
  T_36_WZY_WS_STRCONRES: "Result of string connection",
  T_36_WZY_WS_STRINGLIST: "String list",
  T_36_WZY_WS_STRLEN: "String length",
  T_36_WZY_WS_STRVAL: "String result",
  T_36_WZY_WS_TAN_NAMEDESC: "Find the tangent of an angle",
  T_36_WZY_WS_TANRES: "Tangent of the angle",
  T_36_WZY_WS_TEAMLIST: "Team list",
  T_36_WZY_WS_TEAMLIST_DESC: "A list of all the teams in this match",
  T_36_WZY_WS_TIMETWEENTIPS: "Countdown notification entity",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convert the target value into a string",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "The target value to convert into a string",
  T_36_WZY_WS_TOSTRINGRES: "Result of string conversion",
  T_36_WZY_WS_TOWERCAMP_DESC: "The side number and team number are the same. Neutral towers and fortresses attack all players and AIs within range.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Tranfer a certain amount of designated currency from one wallet to another",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "The wallet to transfer the currency out of",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "The type of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "The amount of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "The wallet to transfer the currency into",
  T_36_WZY_WS_TWEENTIPS: "Floating notification entity",
  T_36_WZY_WS_TYPEENUM: "Enum type",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Triggers when a player uses an item. [Triggeri player] is the player who uses an item. [Item type] is the item that the player used.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "The type of item used by the player",
  T_36_WZY_WS_VECADDLEFT: "Left value of vector addition",
  T_36_WZY_WS_VECADDRES: "Vector addition result",
  T_36_WZY_WS_VECADDRIGHT: "Right value of vector addition",
  T_36_WZY_WS_VECANGLEFT: "Left value of vectors angle",
  T_36_WZY_WS_VECANGRES: "Angle between 2 vectors",
  T_36_WZY_WS_VECANGRIGHT: "Right value of vectors angle",
  T_36_WZY_WS_VECCROLEFT: "Left value of cross product",
  T_36_WZY_WS_VECCRORES: "Result of cross product",
  T_36_WZY_WS_VECCRORIGHT: "Right value of cross product",
  T_36_WZY_WS_VECDISLEFT: "Left value of vectors distance",
  T_36_WZY_WS_VECDISRES: "Distance between 2 vectors",
  T_36_WZY_WS_VECDISRIGHT: "Right value of vectors distance",
  T_36_WZY_WS_VECDOCLEFT: "Left value of dot product",
  T_36_WZY_WS_VECDOCRES: "Result of dot product",
  T_36_WZY_WS_VECDOCRIGHT: "Right value of dot product",
  T_36_WZY_WS_VECMULRES: "Result of scalar multiplication",
  T_36_WZY_WS_VECNORRES: "Normalized vector",
  T_36_WZY_WS_VECSIZERES: "Magnitude of a vector",
  T_36_WZY_WS_VECSUBLEFT: "Left value of vector subtraction",
  T_36_WZY_WS_VECSUBRES: "Vector subtraction result",
  T_36_WZY_WS_VECSUBRIGHT: "Right value of vector subtraction",
  T_36_WZY_WS_VECTORLIST: "Vector list",
  T_36_WZY_WS_VECX: "x component",
  T_36_WZY_WS_VECY: "y component",
  T_36_WZY_WS_VECZ: "z component",
  T_36_WZY_WS_VEHENT: "Vehicle entity",
  T_36_WZY_WS_WALLCONT: "Wallet content",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continuous",
  T_36_XYL_WS_AIBOT: "Unit",
  T_36_XYL_WS_AIGENERATOR: "Unit Generator",
  T_36_XYL_WS_AIGENERATOR_DESC: "A generator that can continuously generate designated units (e.g. zombies)",
  T_36_XYL_WS_AIWAVE: "# of units per wave",
  T_36_XYL_WS_ARROW: "Direction Sign",
  T_36_XYL_WS_ARROW_DESC: "A sign that points to a direction",
  T_36_XYL_WS_BREAKBOX: "Breakable Box",
  T_36_XYL_WS_BREAKBOX_DESC: "A wooden box that can be broken when attacked",
  T_36_XYL_WS_FENCE: "Iron Fence",
  T_36_XYL_WS_FENCE_DESC: "A fence that enables bullets to fly through",
  T_36_XYL_WS_STAIRI: "Landing C",
  T_36_XYL_WS_STAIRI_DESC: "A platform that can be combined with stairs",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "A zombie that can be customized and be an obtained and duplicated subject in the Unit Generator",
  T_36_YF_CORRODE_GRENADE_N: "Gloo Melter",
  T_36_YF_SETTING_TYPE3: "Preset 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Bottom)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Bottom)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (Mask)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (Bottom)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (Head)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (Shoes)",
  T_36_YS_SETTING_GRENADE: "Throwables",
  T_36_YS_SETTING_MOVE: "Movement",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Top)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Top)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Pet skin: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Pet skin: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Pet skin: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Pet skin: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Pet Skin: Arctic Fang",
  T_37_B_WS_HIDE: "Hide N Seek",
  T_37_HZ_WS_CATMODEDESC1: "Hide N Seek",
  T_37_JH_WS_CREATEGOLD_DESC: "A Vending Machine from which players can buy items. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)",
  T_37_JH_WS_NAME2: "Groza (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "Gold that can be picked up around the map. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_X: "X Axis",
  T_37_JH_WS_Y: "Y Axis",
  T_37_JH_WS_Z: "Z Axis",
  T_37_JL_FOOTBALL_TIE: "Tie",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "Gift!",
  T_37_M_WS_MISSING: "Missing source",
  T_37_M_WS_NAMEERROR: "Contains sensitive characters. Please change.",
  T_37_PD_HuntingGround_BOSSTITLE: "The Butcher",
  T_37_R_TAILOR_LIMIT: "Limited Time",
  T_37_RW_PROPCATAPULT_DESC: "When inflated, the launch pad can be used to project a player into the air. But make sure to stay in the Safe Zone!",
  T_37_RW_PROPCATAPULT_NAME: "Launch Pad",
  T_37_SP_WS_COLOR_02: "Color",
  T_37_SP_WS_COLOR_03: "Appearance",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "The entity is null when getting or setting its property",
  T_37_SP_WS_LOG_PHASE_END: "Phase {0} ended.",
  T_37_SP_WS_LOG_PHASE_START: "Phase {0} begins",
  T_37_SP_WS_LOG_ROUND_END: "Round {0} ended.",
  T_37_SP_WS_LOG_ROUND_START: "Round {0} started.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Mismatched type when assigning a value to the variable. Required type: {0}. Current type: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Undefined or out-of-scope local variable {0}",
  T_37_SP_WS_RACEMODE_01: "Countdown Mode",
  T_37_SP_WS_RACEMODE_02: "Countdown Time",
  T_37_SP_WS_RACEMODE_04: "When on, there will be a countdown when an entire team reaches the finishing point. The game ends when the countdown ends.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Backpack - Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade - Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Pet Skin: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Pet Skin: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Pet skin: Galaxy Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Pet skin: Firemyth Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Pet Skin: Footie Flash",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Pet Skin: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck - Starsea Beast",
  T_37_WT_WS_PVE2DESC: `A zombie survival mode where players eliminate a certain number of zombies within time limit or survive till the end.
You can set the gameplay rules and adjust the settings of zombies as you like, including the target number of zombies to be eliminated.`,
  T_37_WT_WS_RULEDESC: "Eliminate the target number of zombies to win.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Eliminate zombies",
  T_37_WT_WS_TXT1DESC: "When on, players win by eliminating the specified number of zombies. When off, players win by surviving till the end.",
  T_37_WT_WS_TXT2: "Elimination amount",
  T_37_WZY_FRIDPLA: "Friendly player",
  T_37_WZY_FRIDSIDE: "Friendly faction",
  T_37_WZY_FRIDTEAM: "Friendly team",
  T_37_WZY_HOSTPLA: "Enemy player",
  T_37_WZY_HOSTSIDE: "Enemy faction",
  T_37_WZY_WS_ACCFRAMES: "Accumulated frames",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Add items to a merchandise. You can add a single item or a group of items. The amount can be either the number of the individual items or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "The merchandise entity to add items to",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "The items to add. You can add a single item or a group of items.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "The amount of the individual items to add or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Add a tag for the selected entity",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "The entity to add the tag to",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "The text content to add",
  T_37_WZY_WS_AIMABLEENT: "Aim-able entity",
  T_37_WZY_WS_AIMASSISTTYPE: "Aim assist type",
  T_37_WZY_WS_ALLOWDROP_NAME: "Enable/disable item drop",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Whether a player can drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "The player entity to configure whether to drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Whether a player can drop items. This is Boolean value.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Enable/disable item pick up",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Whether a player can pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "The player entity to configure whether to pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Whether a player can pick up items. This is Boolean value.",
  T_37_WZY_WS_AMBIENTCOLOR: "Ambience light color",
  T_37_WZY_WS_AMRORTOOL: "Repair armor",
  T_37_WZY_WS_ATTACK: "Attack",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancel the player's disguise so that they will return to their normal appearance",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "The player entity whose disguise to cancel",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Boost the speed of a football",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "The football to boost speed for",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "The speed vector of the boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Triggers when the football is hit by the Football Shooter. [Player entity] is the player who owns the Football Shooter. [Speed boost] is the added speed of the football after being hit.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "The player who owns the Football Shooter",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "The speed vector of the football after it has been hit",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Triggers when the football collides with an entity and the ball's speed increases. [Colliding entity] is the entity that collides with the football. [Speed boost] is the added speed of the football after the collision.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "The entity that collides with the football",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "The speed vector that is added to the football upon collision",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Triggers when the entity is being aimed at by a player",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "The player who is aiming at the entity",
  T_37_WZY_WS_BEHAVIORSTAT: "Player behavior status",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "The weapon entity that hits this entity",
  T_37_WZY_WS_BLOODBARENT: "Health bar entity",
  T_37_WZY_WS_BOMBEND: "Prior to explosion",
  T_37_WZY_WS_BOMBSTART: "Bomb indication",
  T_37_WZY_WS_CHANENT: "Channel entity",
  T_37_WZY_WS_CHEER: "Cheer",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Check whether a selected entity contains designated tags",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "The entity to check whether it contains tags",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "The tag to check",
  T_37_WZY_WS_CHELABELRES: "The result of the tag check. This is a Boolean value.",
  T_37_WZY_WS_CJERSEY_NAME: "Change jersey",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "The player whose jersey to change",
  T_37_WZY_WS_CJERSEY_PARAM2: "Jersey design",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "The design to change to",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "The color of part 1 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "The color of part 2 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "The color of part 3 on the jersey",
  T_37_WZY_WS_CJERSEYTYPE1: "Design 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Design 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Design 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Clear all the elements in the list",
  T_37_WZY_WS_CREABLEOB_DESC: "The object type that can be created using blocks",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Create a customizable merchandise and return a merchandise entity. The merchanise content can be configured through property settings.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Create a customizable merchandise list and return a merchandise list entity. The content of this list can be changed through property settings.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "The merchandise list entity to be created",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Create a faction entity",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "The faction entity to be created",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Create a customizable store and return a store entity. The content of the store can be changed through property settings.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "The store entity created",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Change the environment of the sky in the game. Options include day, dusk, and night.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "The type of sky to change to. Options include day, dusk, and night.",
  T_37_WZY_WS_DARKNESS: "Overall darkness",
  T_37_WZY_WS_DELENT_NAMEDESC: "Delete a designated entity. Currently supports icon entity, text entity, HUD entity, visual effects entity, weapon entity, and other object entities.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "The entity to delete",
  T_37_WZY_WS_DROP: "Mistake",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Triggers when the player drops an item. [Item type] is the ID of the item type dropped.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "The type ID of the dropped item",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Triggers when the player drops a weapon. [Weapon entity] is the weapon being dropped.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "The weapon that is dropped",
  T_37_WZY_WS_DUMMYLEOBJ: "Regular level object",
  T_37_WZY_WS_DUST: "Dusk",
  T_37_WZY_WS_EMPTYCH: "Default empty channel",
  T_37_WZY_WS_EMPTYCH1: "Empty channel 1",
  T_37_WZY_WS_EMPTYCH2: "Empty channel 2",
  T_37_WZY_WS_EMPTYCH3: "Empty channel 3",
  T_37_WZY_WS_EMPTYCH4: "Empty channel 4",
  T_37_WZY_WS_EMPTYCH5: "Empty channel 5",
  T_37_WZY_WS_EMPTYCH6: "Empty channel 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Obtain a list that contains all entities that satisfy the 3 conditions. The content inserted for "Includes all", "Excludes", and "Includes" is a single component type or a list of component types. The result returned is a list of entities that satisfy the conditions.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "The entities filtered out must contain all the components from this array",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "The entities filtered out must not contain designated component(s) from this array",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "The entities filtered out must contain at least one component from this array",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "The property type of this entity to change",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "The property value to change to",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Let the player leave the current channel so that they will not be in any channel",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "The player to leave the channel",
  T_37_WZY_WS_FAKEENT: "Disguise entity",
  T_37_WZY_WS_FIND_STR_DESC: "Find the location of a designated text within a string",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "The character to find",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Find a string from the starting location, which begins from 0.",
  T_37_WZY_WS_FINDSTRRES: "The first location that the string appears. Starts from 0.",
  T_37_WZY_WS_FOGCOLOR: "Fog color",
  T_37_WZY_WS_FRICTIONCON: "Regular friction multiplier",
  T_37_WZY_WS_FRICTIONIMP: "Collision friction multiplier",
  T_37_WZY_WS_FROMDEATH: "Revival",
  T_37_WZY_WS_FROMKNODOWN: "Help up",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Get the channel that the designated player is in",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "The player entity whose channel to get",
  T_37_WZY_WS_GETCHANRES: "The channel that the player is currently in",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "According channel ID 1 to 8, get the empty channel that was created by default at the start of the game",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID of the default empty channel",
  T_37_WZY_WS_GETEMPTYCH_RES: "The obtained channel entity",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtain the disguise entity of a player",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "The object whose disguise entity to obtain",
  T_37_WZY_WS_GETGAMEENT_NAME: "Get global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Get the game entity of this match",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Get attackable player",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Faction entity",
  T_37_WZY_WS_GOAL_NAMEDESC: "Triggers when a football enters the goal. [Goal] is the goal that this football enters. [Scorer] is the last player to have come in contact with the ball. [Assist] is the second-to-last player to have come in contact with the ball.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "The goal that this football enters",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "The last player to have come in contact with the ball",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "The second-to-last player to have come in contact with the ball",
  T_37_WZY_WS_HEARTBEAT: "Heartbeat",
  T_37_WZY_WS_HEAVYWEAPON: "Heavy weapon",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Smallest volley angle",
  T_37_WZY_WS_HOSTPLA: "A list of attackable players",
  T_37_WZY_WS_HOSTSIDE: "A list of attackable factions",
  T_37_WZY_WS_HOSTTEAM: "A list of attackable teams",
  T_37_WZY_WS_ICON_CLOCK: "Countdown",
  T_37_WZY_WS_ICON_CLOTHES: "Clothes",
  T_37_WZY_WS_ICON_QUIT: "Exit",
  T_37_WZY_WS_INSERT_ARR_DESC: "Insert a new element to a designated location in the list",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extract a string of a designated length, starting from the index location. If extraction length exceeds string length, it will extract content until the end of the string.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Length of the extraction",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "The string that was extracted",
  T_37_WZY_WS_INTORINTL: "Integer or integer list",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Let a player join a designated faction",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "The faction for the player to join",
  T_37_WZY_WS_JUMP: "Jump",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Lens flare",
  T_37_WZY_WS_LENTH: "Length",
  T_37_WZY_WS_LIGHTATTACK: "Successful hit",
  T_37_WZY_WS_LIGHTCOLOR: "Light source color",
  T_37_WZY_WS_LIGHTINTENSITY: "Light source brightness",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Load a new scenery",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "The name of the scenery to load",
  T_37_WZY_WS_MOROBJECT: "Disguise object",
  T_37_WZY_WS_MOVEAXISX: "Move along x axis",
  T_37_WZY_WS_MOVEAXISY: "Move along y axis",
  T_37_WZY_WS_MOVEAXISZ: "Move along z axis",
  T_37_WZY_WS_MOVEDISTITLE: "Distance of movement",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Quick messages on-off toggle",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Turn quick messages on or off. When off, the quick message HUD cannot be used and players will not be able to send or receive quick messages.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "The player to turn on/off quick messages for",
  T_37_WZY_WS_MUTEVOICE_NAME: "Voice chat on-off toggle",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Turn voice chat on or off. When off, the voice HUD cannot be used and players will not be able to send or receive voice messages.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "The player to turn on/off voice chat for",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. True means off; False means on.",
  T_37_WZY_WS_NIGHTMODE: "Night mode",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Triggers when the player is aiming at an aim-able entity. [Target entity] is the entity being aimed. When there is no entity being aimed, the return value is null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Aimed entity",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "The entity that the weapon has hit",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Triggers when the scenery successfully loads",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "The name of the scenery to load. This is a string.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Triggers when the scenery successfully switches",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "The name of the new scenery. This is a string.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restore the player's clothing to its default look",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "The player whose default clothing to restore",
  T_37_WZY_WS_PETSET: "Pet settings",
  T_37_WZY_WS_PETSKILL: "Pet skills",
  T_37_WZY_WS_PETSWITCH2: "Whether pet skills can be used",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Whether to enable player movement. This is a Boolean value.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Player behavior type",
  T_37_WZY_WS_PRESS: "Gentle click",
  T_37_WZY_WS_PROGRESS: "Current progress",
  T_37_WZY_WS_PROGRESSBAR: "Progress HUD entity",
  T_37_WZY_WS_RANKDOWN: "Rank down",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remove a tag for the selected entity",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "The text content to remove",
  T_37_WZY_WS_REPLACE_STR_DESC: "Replace the content of a string with a designated content",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "The character to be replaced",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "The new character to replace with",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Reverse all the elements in this list",
  T_37_WZY_WS_REVIVEHERE: "The player who is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Triggers when a player is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEWAYDESC: "The method by which a player is revived or helped up from being eliminated or knocked down",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configure the status of different behaviors for players. When disabled, the corresponding buttons on the HUD cannot be used, and manual and automatic movements are not allowed. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "The player to set behavior status for",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "The player's behavior, including moving, attacking, jumping, and sprinting",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status includes disabled, hidden, and enabled. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "The coordinates of the football",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Whether the football should maintain its pre-configuration speed. This is a Boolean value.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Player attack setting",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configure whether [Setting player] can attack [Target player]. The default setting is based on whether the target player belongs to a team and faction that can be attacked. This setting is of a higher priority than the team/faction setting.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "The player to configure enemies for",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "The player who is the enemy",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Attackable or not",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable. The default setting is based on whether the target player belongs to a team and faction that can be attacked.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Shadows",
  T_37_WZY_WS_SHOOTANGLE: "Smallest shooting angle",
  T_37_WZY_WS_SKYBOX: "Sky",
  T_37_WZY_WS_SKYBOXENT: "Sky entity",
  T_37_WZY_WS_SKYBOXTYPE: "Basic sky types",
  T_37_WZY_WS_STEPPED: "Step on trigger",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Switch the voice chat channel of the player",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "The player to switch channels for",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "The channel to switch to",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Switch to a designated scenery",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "The name of the scenery to switch to",
  T_37_WZY_WS_TARGETSTR_DESC: "Target string",
  T_37_WZY_WS_TEAMASIDE: "Team and Faction",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatic",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teleportable or not",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "No",
  T_37_WZY_WS_TELEPORTN_TITLE: "Teleport method",
  T_37_WZY_WS_TELEPORTN_YES: "Yes",
  T_37_WZY_WS_TERRAINWET: "Terrain moisture",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Substitute the appearance of a [Player entity] with the appearance of a [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "The player entity whose appearance to change",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "The player whose disguise entity to obtain",
  T_37_WZY_WS_TRANSP: "Transparency",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Uninstall a designated scenery",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "The name of the scenery to uninstall",
  T_37_WZY_WS_VFX1: "Symbolic",
  T_37_WZY_WS_VFX2: "Smokey",
  T_37_WZY_WS_VFX3: "Curse Explosion",
  T_37_WZY_WS_VFX5: "Frozen",
  T_37_WZY_WS_VFX6: "Spotlight",
  T_37_WZY_WS_VFX7: "Upward Turbulence",
  T_37_WZY_WS_VFX8: "Atmosphere Explosion",
  T_37_WZY_WS_VISABLE: "Visibility",
  T_37_WZY_WS_WEAOPEN: "Show or not",
  T_37_WZY_WS_WEAPONENT: "Weapon entity",
  T_37_WZY_WS_WEATARGETED: "Whether can be targetted by aim assist",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "Use the Jersey Machine to create your ideal jersey",
  T_37_XYL_FOOTGUN: "Football Shooter",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Radius",
  T_37_XYL_SOCCER_DESC: "A football whose properties can be customized",
  T_37_XYL_SOCCER_HIGHT1: "Regular angle",
  T_37_XYL_SOCCER_HIGHT2: "Volley angle",
  T_37_XYL_SOCCER_RESET: "Reset time after a goal",
  T_37_XYL_SOCCER_RESIST1: "Friction (Kick Mode)",
  T_37_XYL_SOCCER_RESIST2: "Friction (Gun Mode)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "This is the goal. Shoot the football into the goal to score. (Only valid in Points Grab.)",
  T_37_XYL_SOCCERITEM: "Item Spawn",
  T_37_XYL_SOCCERITEM_DESC: "When placed, it will generate the selected item",
  T_37_XYL_SPAWN_PEOPLE: "# of players",
  T_37_XYL_WS_AIRCONDITIONER001: "Air Conditioner B",
  T_37_XYL_WS_AMMUCHEST: "War Chest A",
  T_37_XYL_WS_BAFFLE001: "Barrier A",
  T_37_XYL_WS_BARREL001: "Barrels",
  T_37_XYL_WS_BARREL001_DES: "Commonly seen circular wooden barrels",
  T_37_XYL_WS_BOARD001: "Ad Board B",
  T_37_XYL_WS_BOOK001: "Pile of Books A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decor - brightens up the place!",
  T_37_XYL_WS_BOX001: "Pile of Boxes A",
  T_37_XYL_WS_BOX002: "Small Box",
  T_37_XYL_WS_BUSHCOVER: "Bush",
  T_37_XYL_WS_BUSHCOVER_DES: "A bush that can be used to hide in",
  T_37_XYL_WS_CABINET001: "Drawers A",
  T_37_XYL_WS_CHAIR001: "Chair A",
  T_37_XYL_WS_COCONUTTREE: "Coconut Tree",
  T_37_XYL_WS_COCONUTTREE_DES: "Decor - For a beachy vibe!",
  T_37_XYL_WS_COMPUTER001: "Computer A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "Fire Extinguisher",
  T_37_XYL_WS_GUIDEPOSE: "Direction Post",
  T_37_XYL_WS_HUGEHOUSE001: "3-Story House B",
  T_37_XYL_WS_HUGEHOUSE002: "2-Story House B",
  T_37_XYL_WS_JACKSTRAW: "Scarecrow",
  T_37_XYL_WS_LADDER001: "Ladder A",
  T_37_XYL_WS_OILDRUM: "Jerry Can",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Supply Container",
  T_37_XYL_WS_PILLA001: "Concrete Pillar",
  T_37_XYL_WS_PRESENT: "Gift Box",
  T_37_XYL_WS_PRESENT_DES: "Contains holiday gifts",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "A commonly decoration for a spooky festival",
  T_37_XYL_WS_ROADBLOCK001: "Roadblock B",
  T_37_XYL_WS_SHELF001: "Bookshelf A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "All teams",
  T_37_XYL_WS_SUPPLYBOX: "Ammo Crate",
  T_37_XYL_WS_TABLE001: "Table A",
  T_37_XYL_WS_TABLE002: "Table B",
  T_37_XYL_WS_TARGET001: "Target",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Finish Point",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "A portal that can teleport the player to the finishing point of the portal",
  T_37_XYL_WS_TIRES001: "Tire A",
  T_37_XYL_WS_TOOLRACK: "Tool Shelf",
  T_37_XYL_WS_WALL001: "Wall",
  T_37_XYL_WS_WOOD001: "Chopped Wood",
  T_37_XYL_WS_YELLOWDUCK001: "Ducky Float",
  T_37_XYL_WS_YELLOWDUCK001_DES: "An inflated swim ring in the shape of a duck",
  T_37_YM_BOMBSQUAD_DEFUSER: "Defuser",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (Bottom)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (Bottom)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (Head)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (Shoes)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (Top)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (Mask)",
  T_37_YS_M_A_THKOL: "Blaze Banish (Mask)",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (Bottom)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (Bottom)",
  T_37_YS_M_B_THKOL: "Blaze Banish (Bottom)",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (Head)",
  T_37_YS_M_H_THKOL: "Blaze Banish (Head)",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (Shoes)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (Shoes)",
  T_37_YS_M_S_THKOL: "Blaze Banish (Shoes)",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (Top)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (Top)",
  T_37_YS_M_T_THKOL: "Blaze Banish (Top)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (Top)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum players",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Clear Rules",
  T_38_JH_WS_CM2: "Unclear Rules",
  T_38_JH_WS_CM3: "Frequent Quit Outs",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Too many layers of blocks. Current: {0}. Max.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Number of items you've created ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Number of incidents received in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Number of entities created in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Length of the initialized list ({0}) has exceeded the limit ({1}). Auto-creates a max capacity list.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Number of loops ({0}) has exceeded the limit ({1}). Loop interrupted",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "The number of concurrent coroutines  ({0}) in the coroutine scope has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Failed to add element to the list. List {0} is empty",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Mismatched value types when executing the basic arithmetic operation. The left value type is {0} and the right value type is {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Repeated temporary variable definition. Variable name: {0}.",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "Map Name",
  T_38_SP_WS_REVIEW_18: "Description",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "Review under cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Active in scenery or not",
  T_38_WZY_WS_ACTIVEB: "Turn on logic refresh or not",
  T_38_WZY_WS_ACTIVEVALUE: "Activity status",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Moveable or not",
  T_38_WZY_WS_AMMOAMOUNT: "Ammo amount",
  T_38_WZY_WS_AMMONAME: "Ammo Entity",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Explosion DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DURABILITY: "Current durability",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Max. durability",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Damageable or not",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible or not",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Zombie elimination assist.",
  T_38_WZY_WS_BAGNAME: "Backpack Entity",
  T_38_WZY_WS_BAGSPACEEX: "Additional backpack space",
  T_38_WZY_WS_BRIDGING: "Bridge render component",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Clear all items in the [player entity's] backpack",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Clear the unwanted items lying around the map, such as loot, throwable residue, and loot boxes",
  T_38_WZY_WS_CLEARPRO: "Clear single property factor",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone a [scenery object] entity at the location of a [player entity] and return the [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Component",
  T_38_WZY_WS_COSTAMMO: "Consume ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Create a camera and return a [camera entity], whose properties can be modified through property settings",
  T_38_WZY_WS_CYCLES: "Times played",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a circular pole. The [center] is the center of the pole, the [radius] is the radius of the circular surface, the [height] is the height of the pole, the [Euler angles] are the angles of the 3D orientation of the pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "The result of the circular pole scope check. This is a Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG to zombies",
  T_38_WZY_WS_DARKNESS: "Darkness",
  T_38_WZY_WS_DIFCOLOR: "Surface color",
  T_38_WZY_WS_DIFTEXTURE: "Surface texture",
  T_38_WZY_WS_DRUMMUSIC: "Component type: drums",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "The player that was disconnected",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "The player that is reconnecting",
  T_38_WZY_WS_EUIANCHOR: "HUD anchor type enumeration",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Flower",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Set the [entity] to always follow the [followed entity]. [Offset coordinates] is the distance between the two entities.",
  T_38_WZY_WS_FOLLOWENT: "Followed entity",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Get the camera entity that is currently being used by a [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "The camera that is currently being used by the player",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Get the amount of an item in the [designated item type] that a [player] owns",
  T_38_WZY_WS_GETITEMNUM_RES: "The amount of the designated item that the player owns",
  T_38_WZY_WS_GETVEC_NAME: "Get vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Get a vector using the x, y, and z components of a set of coordinates",
  T_38_WZY_WS_GETVECRES: "The vector got from the x, y, and z components",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Flash Freeze Entity",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Freeze zone radius",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Freeze duration",
  T_38_WZY_WS_GRENADENAME: "Grenade Entity",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Max. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Explosion range",
  T_38_WZY_WS_GRENADEPARAM5: "Throwing speed",
  T_38_WZY_WS_GRENADEPARAM6: "Explosion delay",
  T_38_WZY_WS_GRENADEPARAM7: "Self DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM8: "Ally DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM9: "Vehicle DMG multiplier",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Limb shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra DMG",
  T_38_WZY_WS_HELMET_NAME: "Helmet Entity",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Initial location",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "No. of zombies eliminated",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminate the chosen [entity], which must be a battle entity type. Ignores the invulnerable status.",
  T_38_WZY_WS_LABELPARAM: "Text content parameter list",
  T_38_WZY_WS_LEADMUSICA: "Component type: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Component type: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Component type: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Localized key",
  T_38_WZY_WS_LOCALPOS: "Relative location",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Set an [entity] to aways face the [aimed entity]. [Offset coordinates] is the difference in coordinates of the aimed point and the entity's position.",
  T_38_WZY_WS_MAINWEAPONA: "Main Weapon 1",
  T_38_WZY_WS_MAINWEAPONB: "Main Weapon 2",
  T_38_WZY_WS_MOTIONTIME: "Movement duration",
  T_38_WZY_WS_MOTIONTYPE: "Movement method",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Modified EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mushroom Entity",
  T_38_WZY_WS_OBFACTION: "Spectating faction",
  T_38_WZY_WS_OBGLOBAL: "Spectate all",
  T_38_WZY_WS_OBSERVER: "Spectator Options",
  T_38_WZY_WS_OBTEAM: "Spectating team",
  T_38_WZY_WS_OFFSETVEC: "Offset coordinates",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Triggers when a player is buying items from this Vending Machine. [Player entity] is the player that makes the purchase. [Merchandise entity] is the item bought.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Triggers when equipped by a [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Triggers when the player completes the jumping action",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Triggers when the player completes the prone position",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Triggers when the weapon reloads",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Triggers when the player completes the sprinting action",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Triggers when the player completes the crouching action",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Triggers when the weapon eliminates a unit. [Eliminated entity] is the unit that was eliminated.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Triggers when the weapon inflicts damage to a battle entity. [Hit target] is the battle entity that damage was inflicted on. [Damage] is the damage being inflicted.",
  T_38_WZY_WS_OWNER: "Owner",
  T_38_WZY_WS_PARAMLIST: "Parameter list",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause or resume the current emote for a [player entity]. [Pause or not] is a Boolean value. "Yes" means pause. "No" means resume.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activated by player entering the trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activated by player leaving the trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force the [player entity] to play the designated [emote] once and return to original position when finished",
  T_38_WZY_WS_PLAYSPEED: "Playback speed",
  T_38_WZY_WS_PREHUD_NAME: "Preset icon",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Let the [player entity] leave its current faction",
  T_38_WZY_WS_RESETENT: "Reset components every round",
  T_38_WZY_WS_RESUUID: "Resource UUID",
  T_38_WZY_WS_RIMCOLOR: "Border color",
  T_38_WZY_WS_RIMTEXTURE: "Border texture",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Check whether an [entity] is inside a cone. The [center] and [radius] are the center and radius of the cone. The [extracted radius] is the radius of the smaller sector within the cone. The height is the height of the 3D structure. The [angle] is the central angle of the cone. The [direction angle] is the direction vector of the central axis.",
  T_38_WZY_WS_SECTORJUD_RES: "The result of the fan-shaped scope check. This is a Boolean value.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Set the activity status of a [target entity]. [Activity status] is a Boolean value and affects the availability, visibility, and collidability of the entity.",
  T_38_WZY_WS_SETROUNDSCORE: "Set player's round score",
  T_38_WZY_WS_SHOOTANGMAX: "Max. shooting angle",
  T_38_WZY_WS_SHOWMAPINFO: "Display map info for same faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Display name HUD for same faction",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Phase Start",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Medium Heartbeat",
  T_38_WZY_WS_SOUND16: "Slow Heartbeat",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Skill Recover",
  T_38_WZY_WS_SOUND2: "Disappear Notification",
  T_38_WZY_WS_SOUND20: "Join A Game",
  T_38_WZY_WS_SOUND3: "Visual Effects",
  T_38_WZY_WS_SOUND4: "Night Chirps",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaction",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Music entity",
  T_38_WZY_WS_SPAWNPOS: "Old Spawn Point",
  T_38_WZY_WS_SPHERENAME: "Basic sphere",
  T_38_WZY_WS_SPHERERADIUS: "Sphere radius",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Check whether an [entity] is inside a spherical scope. The [center] and [radius] is the center and radius of the spherical structure.",
  T_38_WZY_WS_SPHERICALJUD_RES: "The result of the spherical scope check. This is a Boolean value.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a cube. The [center] is the center of the cube, the [length], [width], and [height] are the length, width, and height of the cube, and the [Euler angles] are the angles of the 3D orientation of the cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "The result of the cubic scope check. This is a Boolean value.",
  T_38_WZY_WS_STARTGENTIME: "Spawn start time",
  T_38_WZY_WS_STAYTIME: "Pause duration",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Switch a player's camera to the [camera entity]. [Switch mode] can be either no animation or progressive movement. [Switch time] is the time of switching during progressive mode.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Switch the camera mode. You can select between No Animation and Progressive Movement.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'The switch time during progressive movement mode. When selected "no animation", this setting is void.',
  T_38_WZY_WS_TEXTHUD: "HUD text component",
  T_38_WZY_WS_TEXTTYPE: "Font Size",
  T_38_WZY_WS_TEXTUREID: "Texture type",
  T_38_WZY_WS_TRANDIST: "Max. distance",
  T_38_WZY_WS_TWEENERENABLED: "Turn on UITweener script or not",
  T_38_WZY_WS_TYPELIST: "Type list",
  T_38_WZY_WS_TYPELISTORLIST: "Type or type list",
  T_38_WZY_WS_VEST_NAME: "Vest Entity",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Door",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Clone Elimination",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Clone",
  T_38_WZY_WS_VFX6: "Disguise",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Visibility type",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Weapon Generator",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Custom Camera",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "The field of view is the observable range of the camera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Horizontal Angle",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Projection Mode",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Default Camera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Default Camera Mode",
  T_38_XXJ_WS_THIRD: "Chase Camera",
  T_38_XXJ_WS_TOPVIEW: "High Angle",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Horizontal Movement",
  T_38_XXJ_WS_VERTICALANGLE: "Vertical Angle",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Start time",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Candle A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Brick House A",
  T_38_XYL_WS_FENCE002: "Iron Fence B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Abnormal Grav Zone",
  T_38_XYL_WS_GRAVITYAREA_DESC: "A zone where players can change gravity",
  T_38_XYL_WS_HOLDWEAPON: "Weapon Hold",
  T_38_XYL_WS_INDOORFURNITURE: "Indoor Furniture",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Oil Barrel Damage Ratio",
  T_38_XYL_WS_OUTDOORPROPS: "Outdoor Items",
  T_38_XYL_WS_PIPEANDBOX: "Pipes and Containers",
  T_38_XYL_WS_PLANT: "Plants",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Rose Bouquet",
  T_38_XYL_WS_SMALLBUILDING: "Small Buildings",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Old 2-Story House",
  T_38_XYL_WS_TV001: "Old TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Mission Complete 1",
  T_39_HJ_WS_SOUND13: "Danger Alert 1",
  T_39_HJ_WS_SOUND14: "Danger Alert 2",
  T_39_HJ_WS_SOUND15: "Countdown 3",
  T_39_HJ_WS_SOUND16: "Tips Sound",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Sound of teleporting to a wrong area",
  T_39_HJ_WS_SOUND19: "Sound of teleporting to a correct area",
  T_39_HJ_WS_SOUND2: "Countdown 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Get Item",
  T_39_HJ_WS_SOUND24: "Electronic & Cute BGM",
  T_39_HJ_WS_SOUND25: "Casual Game BGM",
  T_39_HJ_WS_SOUND4: "Mechanical Device Echo",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Gear Switched On",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Walls",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Special Firing Sound",
  T_39_HQ_UGC_CUSTOMRES: "Custom Resources",
  T_39_M_ACCOUNTID: "Account",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Execute after double click",
  T_39_MF_SKILLTAG_4: "Movement",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "After knocking down an enemy, marks their teammates within [FFB300]{0}m[-] from them and slows down their movement speed by [FFB300]{1}%[-]. Lasts for [FFB300]{2}s[-]. When knocked down by a nearby enemy, marks and slows down the attacker and their teammates.",
  T_39_QL_SKILL_WOLFRAHH_DES: "After knocking down an enemy, enter Highlight mode, which increases rate of fire by [FFB300]{0}%[-] and movement speed by [FFB300]{1}%[-] but then decays quickly. Lasts for [FFB300]{2}s[-]. During Highlight mode, consecutively knocking down enemies will reset countdown and further boost rate of fire by [FFB300]{3}%[-] and movement speed by [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Xtreme Mode: Get [FFB300]{0} temporary HP[-] for [FFB300]{1}s[-]. During this time, HP-healing effects are enhanced by [FFB300]{2}%[-]. Cooldown: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Failed",
  T_39_RW_SKILL_DESC_FORD: "Gain [FFB300]{1} HP/s[-] for [FFB300]{0}s[-] when taking damage. After releasing an active skill, this passive skill will reset immediately. Cooldown: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Item entity",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}s[-] before detonating, grenade produces [FFB300]{1}[-] extra grenades, which can cause [FFB300]{2}%[-] damage of their original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Empty space",
  T_39_WT_WS_FEMAPMODE: "Mode Title",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Number of Players",
  T_39_WT_WS_MEDENTERNUM: "Mid-game joining player limit",
  T_39_WT_WS_MIDENTER: "Mid-game joining",
  T_39_WT_WS_MIDENTERCOUNT: "Quota of joining mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Time limit of mid-game joining",
  T_39_WT_WS_MIDENTERTIME2: "Duration of mid-game joining",
  T_39_WT_WS_MIDENTERTIMETIP: "When the map player number limit is not reached, enable players to join in within N sec after match starts. Players cannot join in after N sec.",
  T_39_WT_WS_MIDENTERTIP: "When enabled, players can join this map mid-game.",
  T_39_WT_WS_PLAYERCOUNT: "Initial player number",
  T_39_WT_WS_PLAYERCOUNTTIP: "The player number when the match starts. More players can join mid-game until it reaches the map's limit.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Easy",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Very Challenging",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Custom Resources",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Music",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Select up to {0} tags",
  T_39_WT_WS_TAGTYPE1: "Gameplay Type",
  T_39_WT_WS_TAGTYPE2: "Map Type",
  T_39_WT_WS_TAGTYPE3: "Mode Type",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Acceleration",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Add script [Script Name] for [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignore zero using Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Ballistic Motion Entity",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Triggers incident when the item is used by [Player Entity]",
  T_39_WZY_WS_BODYSCALE: "Body scale",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Camera transition type",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Check if a specified script [Script Name] exists in [Entity]. (The returned value should be Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Check if the entity has a result of the specified script (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wielding (Different guns)",
  T_39_WZY_WS_COMBINESELF: "Dual-wielding (Same gun)",
  T_39_WZY_WS_CONENAME: "Basic Cone",
  T_39_WZY_WS_COORSYS: "Coordinate system",
  T_39_WZY_WS_CRASHMAXD: "Max Crash Damage",
  T_39_WZY_WS_CRASHMIND: "Minimum Crash Damage",
  T_39_WZY_WS_CRAWLSPEED: "Mvmt. spd. percentage (Prone)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Create Ballistic Motion for [Target Entity]. Can edit [Initial Speed], [Acceleration], and [Max Distance] accumulated in the direction of initial speed for the target entity, and return [Ballistic Motion Entity]",
  T_39_WZY_WS_CRETWEEN_NAME: "Create Interpolation Motion",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Create an Interpolation Motion for [Entity], with [Attributes] of the entity moving smoothly from [Start Value] to [Target Value] within [Time]. [Method] represents the way of motion, including [One-way], [PingPong], [Cycle]. [Curve] is the curve of motion. And [Interpolation Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_CURVE: "Curve",
  T_39_WZY_WS_CUSTRESULT: "Custom Match Result",
  T_39_WZY_WS_CYLINDERNAME: "Basic Cylinder",
  T_39_WZY_WS_DEFAULT: "No animation (Default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Surface Transparency",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energy recovery per sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consume Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Max second jump height",
  T_39_WZY_WS_ENABLEJOIN: "Allow joining midway",
  T_39_WZY_WS_ENDPOS: "End point coordinates",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Explosion Damage",
  T_39_WZY_WS_FEELDSPEED: "Mvmt. spd. percentage (Downed)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Center flash time",
  T_39_WZY_WS_FLASH_CRANGE: "Center range",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Edge flash time",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flashbomb hit effect",
  T_39_WZY_WS_FLASH_RANGE: "Explosion range",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Descending speed",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Horizontal glide speed",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vertical glide speed",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum end height",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum takeoff height",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Descent speed after super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Turning speed",
  T_39_WZY_WS_FOLMOVENT: "Position Following Motion Entity",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Get Skill List of [Player Entity]",
  T_39_WZY_WS_HB_BOOSTCD: "Sprint cooldown",
  T_39_WZY_WS_HB_BOOSTDURATION: "Sprint duration",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Sprint speed",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Jump cooldown",
  T_39_WZY_WS_HB_JUMPH: "Skyboard jump height",
  T_39_WZY_WS_HEADSCALE: "Head scale",
  T_39_WZY_WS_HEADSHOTDESCALE: "Headshot damage reduction",
  T_39_WZY_WS_INTITALSPEED: "Initial Speed",
  T_39_WZY_WS_INVENTORYBASE: "Basic item types",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Energy cost per sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Basic horizontal speed",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Basic vertical speed",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Dash energy cost per sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Sprint horizontal speed",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Sprint distance",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Rush energy cost per sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Sprint vertical speed",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Upward energy cost per sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attackable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Self-triggerable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Whether can be triggered by allies",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Triggerable by vehicle",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duration",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Activation time",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Trigger radius",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Trigger time",
  T_39_WZY_WS_LEAVE: "Quit",
  T_39_WZY_WS_LIMBSCALE: "Limbs scale",
  T_39_WZY_WS_LISTLOCSTR: "Localized text list",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload battle result",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload battle result of [Player], including [Rank], [Result], [Score Name], [Score Value]. The result type is an integer. 1 for victory, 2 for defeat, 3 for Booyah, and 4 for a draw.",
  T_39_WZY_WS_LOOKMOVENT: "Gaze-following Motion Entity",
  T_39_WZY_WS_MAXCOUNT: "Maximum Quantity",
  T_39_WZY_WS_MAXDISTANCE: "Max. Distance",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Turret Depression Angle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Turret Angular Speed",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Turret Elevation Angle",
  T_39_WZY_WS_MINISENTRY_DAM: "Turret Damage",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Damage Reduction Rate",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Firing Angle",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Turret Hit Rate",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Turret Attack Interval",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Max Turret Number",
  T_39_WZY_WS_MINISENTRY_RANGE: "Turret Attack Range",
  T_39_WZY_WS_MOVEENT: "Motion Entity",
  T_39_WZY_WS_NOCOMBINE: "Not dual-wieldable",
  T_39_WZY_WS_ONCE: "Once",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Triggers incident when the item is discarded by [Player Entity]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Triggers incident when the item is equipped by [Player Entity]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Triggers incident when Hook Gun fires",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Triggers incident when Landmine is activated",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Triggers incident when Landmine is triggered by [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Triggers when entity motion pauses",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Triggers when entity restarts moving from pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Triggers when entity starts moving",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Triggers incident when the item is picked up by [Player Entity]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Triggers incident when Throwable hits target",
  T_39_WZY_WS_OPENATTACK: "Whether to enable the attack",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pause Motion Entity or Motion Entity List",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause sound effect",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Sound Entity or Sound Entity List",
  T_39_WZY_WS_PIANOTYPE: "Music Component Type",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Motion Entity List",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restore the paused Motion Entity or Motion Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Play sound effect",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restore the paused Sound Entity or Sound Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [List of Entities Hit] and [List of Coordinates Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [Entity Hit] and [Coordinates Hit]",
  T_39_WZY_WS_REAHEALHP: "Armor recovery value",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Relative coordinate system",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Edge Transparency",
  T_39_WZY_WS_SCORENAME: "Score Name",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Send a signal to Target Entity, the parameters uploaded are defined by predefined signal parameters. The selection of the entity type at the time of definition will generate the corresponding signal accepting event.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Create a position following motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Position Following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Create a Gaze-following Motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Gaze-following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Falling damage percentage",
  T_39_WZY_WS_SHOE_MAXENERGY: "Max. Energy",
  T_39_WZY_WS_SKILLLIST: "Skill List",
  T_39_WZY_WS_SKILLTYPE: "Character skill",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Smoke effect duration",
  T_39_WZY_WS_SMOOTH: "Camera switch",
  T_39_WZY_WS_SOUNDENTL: "Sound Effect Entity List",
  T_39_WZY_WS_SOUNDENTLORSENT: "Sound Effect Entity or List",
  T_39_WZY_WS_SPRINTSPEED: "Sprint speed percentage",
  T_39_WZY_WS_SQUATSPEED: "Mvmt. spd. percentage (Squat)",
  T_39_WZY_WS_STARTCOO: "Initial Coordinates",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "Target value",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "Rotation angle",
  T_39_WZY_WS_TOWER_PARAM11: "Turret status",
  T_39_WZY_WS_TOWER_PARAM12: "Entity ID",
  T_39_WZY_WS_TOWER_PARAM9: "Attack Target",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "Custom Curve",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Custom Curve can be used for Interpolation Motion",
  T_39_WZY_WS_TWEENENT: "Interpolation Motion Entity",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Motion Methods",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Methods of Interpolation Motion",
  T_39_WZY_WS_TWEENSTYLE: "Method",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Delete script [Script Name] for [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomize listed elements ",
  T_39_WZY_WS_VISIBLEONBACK: "Visible on back",
  T_39_WZY_WS_WEAPCOMBINET: "Dual-Wielding Weapon Type",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Extra damage on the downed",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Single shot bullet number",
  T_39_WZY_WS_WEAREPLAY: "Restart motion?",
  T_39_WZY_WS_WORLDCOORSYS: "World coordinate system",
  T_39_XXJ_WS_ADDFRIEND: "Add friend",
  T_39_XXJ_WS_ALLOWZ: "Enable player x-axis movement",
  T_39_XXJ_WS_BLOCKMODEDESC: "Camera's motion when there's an object between the camera and target",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance from target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Multiple types of preset and custom camera are provided",
  T_39_XXJ_WS_CAMERAUSER: "Camera user",
  T_39_XXJ_WS_CURENTCAMERA: "Camera used",
  T_39_XXJ_WS_DETAILS: "Match Details",
  T_39_XXJ_WS_FFECONOMY: "Economy",
  T_39_XXJ_WS_FOCUSTARGET: "Target observed",
  T_39_XXJ_WS_FOLLOWTARGET: "Target followed",
  T_39_XXJ_WS_GAMERESULT: "Match Result",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Gift",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Camera's horizontal rotation angle",
  T_39_XXJ_WS_INVISICAM: "Translucent",
  T_39_XXJ_WS_INVISICAMDESC: "Object between the camera and target becomes translucent",
  T_39_XXJ_WS_LEFTSCORE: "Left Team Score",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Total Score Name",
  T_39_XXJ_WS_MAINSCORENUM: "Total Score Number",
  T_39_XXJ_WS_MAPEVALUATE: "Map Rating",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Result of Multiple Teams",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Observation point offset",
  T_39_XXJ_WS_OFFSET2DESC: "Typically refers to the offset of camera focus point relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_OFFSETDESC: "Typically refers to the offset of camera position relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera portrays distant and nearer targets as the same size",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera uses perspective projection to observe the target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Camera's image formation when rendering",
  T_39_XXJ_WS_RANK1: "Team Rank",
  T_39_XXJ_WS_RANK2: "Player Rank",
  T_39_XXJ_WS_REPORT: "Report",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Right Team Score",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Score Name List",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spectator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Camera remains stable if there's an object in between the camera and the followed entity",
  T_39_XXJ_WS_TEAMNAME1: "Left Team Name",
  T_39_XXJ_WS_TEAMNAME2: "Right Team Name",
  T_39_XXJ_WS_TEAMRANK: "Team Rank",
  T_39_XXJ_WS_TRANSITIONTIME: "Camera transition time",
  T_39_XXJ_WS_TRANSITIONTYPE: "Camera transition type",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Result of 2 Teams",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Camera's vertical rotation angle",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Camera zooms in if there's an object in between the camera and the followed entity",
  T_39_XYL_WS_LIGHTINTENSITY: "Light intensity",
  T_39_XYL_WS_LIGHTRANGE: "Light range",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Custom water zone",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PERSONAID: "Persona ID",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COLOR: "Color",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "검정색 가죽 자켓 (여성)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "배관공 하의",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "검은 운동복 (운동화)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 핫팬츠 (여성)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 스커트 (여성)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "검은 운동복 (후디)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "물의 축제 상의 (검정)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "배관공 상의",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 러닝셔츠 (여성)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "복 받으세요! (하의)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "검정색 츄리닝바지 (남성)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "조직 보스 바지",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "생존자 바지",
  TXT_AVATAR_MALE_PANTS_MARIO: "배관공 하의",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "생존자 신발",
  TXT_AVATAR_MALE_SHOE_RED: "레드 부츠 (남성)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "복 받으세요! (상의)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "검정색 야구 저지 (남성)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "반란군 후드티",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "시원한 운동복 (후디)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "조직 보스 셔츠",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "생존자 셔츠",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "배관공 상의",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "레이서 자켓(남)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "늦밤 광대 (머리)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "레이서 자켓(남)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "소매 없는 자켓(초록)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "문어 아조씨",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "좀비 사무라이 (마스크)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "핑크 재즈 (상의)",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "본연의 모습을 보여주세요",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "빅토리아",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "용의 날개",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "핑크핑크해",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "레드체리",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "아이시",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "쪽빛조각",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "천개의 벚꽃나무",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "델타",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "천사입니다",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "섀도우",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "전쟁 코끼리",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "석회암",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "검은 재앙",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "미확인 혜성",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "아쿠아마린",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "전쟁의 종말",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "내일의 별",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "천하 제일 무술",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "하얀 회오리",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "야구점퍼 하의",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "라이더 자켓(여)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "야구점퍼 상의",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "야구점퍼 하의",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "힙합 머리",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "야구점퍼 신발",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "라이더 자켓(남)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "야구점퍼 상의",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "공룡 잠옷",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "은메달 축구화",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "잉글랜드 유니폼",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "턱시도 (얼굴)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "턱시도 (모자)",
  TXT_AVATAR_PARACHUTE_8: "미소 낙하산",
  TXT_AVATAR_SHIRT_PLAID_2: "프로그래머 (레드)",
  TXT_AVATAR_SHOES_1: "운동화(흰색)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "세일러 교복 (주황)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "여성용 학교 교복 (빨강)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "세일러 교복 (노랑)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "세일러 교복 (분홍)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "세일러 교복 (쟈스민)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "세일러 교복 (파랑)",
  TXT_AVATAR_TSHIRT_WEEK_007: "싱숭생숭 일요일",
  TXT_BANNER_NAME_MISHA: "스피드",
  TXT_CHARACTER_ADAM_NAME: "아담",
  TXT_CHARACTER_BODYGUARD_NAME: "니키타",
  TXT_CHARACTER_COP_NAME: "앤드루",
  TXT_CHARACTER_EVA_NAME: "눌라",
  TXT_CHARACTER_NURSE_NAME: "올리비아",
  TXT_CHARACTER_RACERGIRL_NAME: "미샤",
  TXT_CHARACTER_RUNNER_NAME: "켈리",
  TXT_CHARACTER_SEAMAN_NAME: "포드",
  TXT_CLAN_NAME: "이름",
  TXT_COLLECTION_DESCRIPTION: "설명",
  TXT_COLLECTION_HEADPORTRAIT: "아바타",
  TXT_INVENTORY_TITLE_EQUIPMENT: "장비",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR탄",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "배낭Lv1",
  TXT_ITEM_BAG2: "배낭Lv2",
  TXT_ITEM_BAG3: "배낭Lv3",
  TXT_ITEM_BASEBALLPOLE: "야구배트",
  TXT_ITEM_BOWAMMO: "석궁 화살",
  TXT_ITEM_CHANGUO: "프라잉팬",
  TXT_ITEM_CROSSBOW: "석궁",
  TXT_ITEM_DESC_FLASH: "전략적인 투척무기입니다. 일정 범위 안에 있는 적을 무력화시킬 수 있습니다.",
  TXT_ITEM_EAGLE: "데저트이글",
  TXT_ITEM_FAK: "의료 상자",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "주먹",
  TXT_ITEM_FLASH: "섬광탄",
  TXT_ITEM_FOREGRIP1: "손잡이Lv1",
  TXT_ITEM_FOREGRIP2: "손잡이Lv2",
  TXT_ITEM_FOREGRIP3: "손잡이Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "수류탄",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "핸드 캐넌",
  TXT_ITEM_HEATSIGHT: "열감지 스코프",
  TXT_ITEM_HELMET1: "헬멧Lv1",
  TXT_ITEM_HELMET2: "헬멧Lv2",
  TXT_ITEM_HELMET3: "헬멧Lv3",
  TXT_ITEM_HGAMMO: "권총탄",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "마셰티",
  TXT_ITEM_MAGEZINE1: "탄창Lv1",
  TXT_ITEM_MAGEZINE2: "탄창Lv2",
  TXT_ITEM_MAGEZINE3: "탄창Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "총구Lv1",
  TXT_ITEM_MUZZLE2: "총구Lv2",
  TXT_ITEM_MUZZLE3: "총구Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "샷건탄",
  TXT_ITEM_SIGHT2: "2x 스코프",
  TXT_ITEM_SIGHT4: "4x 스코프",
  TXT_ITEM_SILENCER1: "소음기",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG탄",
  TXT_ITEM_SNAMMO: "스나이퍼 탄약",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "방탄복Lv1",
  TXT_ITEM_VEST2: "방탄복Lv2",
  TXT_ITEM_VEST3: "방탄복Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "경기 결과",
  TXT_MESSAGEBOX_ERROR: "오류",
  TXT_OB10_HQW_ITEM_BIPOD: "총기 받침대",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "오일 통 변장",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "미구엘",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "도살광",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "맥시코식 구운 옥수수",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "폭발 반경",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "집행자",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "지뢰",
  TXT_OB11_HQW_LANDMINE_DESC: "지뢰는 땅에 설치 가능 합니다. 조심하세요, 그 위에 올라가지 마세요!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "캐롤라인",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "박수",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "뎁!",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "치킨",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "안녕!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "하하하하!",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "도발",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "산탄총을 다룰시, 움직임이 {0}% 빨라집니다",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "민첩성",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "치타: 송곳니",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "미래지향",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "수리상자",
  TXT_OB5_HISTORY_HEADSHOOT: "헤드샷",
  TXT_OB5_HISTORY_LIVE: "생존",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "맥심",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "버섯 및 의료 상자 사용 시간이 {0}% 감소합니다",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "푸드파이터",
  TXT_OB7_ZC_CLAN_NICKNAME: "닉네임",
  TXT_OB7_ZJS_HISTORY_TIME: "시간",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "번개",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "클라",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "주먹의 데미지가 {0}% 증가합니다",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "무에타이",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "퍼플헌터",
  TXT_OB8_ZXR_G18_CAMO_NAME: "아톰스플리터",
  TXT_OB8_ZXR_M249_CAMO_NAME: "올드트리",
  TXT_OB8_ZXR_M79_CAMO_NAME: "골든캐넌",
  TXT_OB8_ZXR_USP_CAMO_NAME: "스노우레오파드",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "파로마",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "무기밀매",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "야호",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "얼음 벽",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "디지털",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "블러디메리",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "포레스트헌터",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "사이버",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "퍼플페인",
  TXT_OB9_ZXR_M14_CAMO_NAME: "썬더스톰",
  TXT_OB9_ZXR_M1873_NAME: "캐리비안",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "쏘우피쉬",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "민트초콜릿",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "퍼플스킨",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "브라운킬러",
  TXT_OPTION_HIGH_BRIGHTNESS: "밝게",
  TXT_PLAYER_RANK: "랭크",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "버뮤다",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "어둡게",
  TXT_SKILL_DESC_COP: "갑옷 내구도 감소가 {0}%만큼 줄어듭니다",
  TXT_SKILL_DESC_RUNNER: "달리기 속도가 {0}% 증가합니다",
  TXT_SKILL_NAME_COP: "갑옷 전문가",
  TXT_SKILL_NAME_NURSE: "치유의 손길",
  TXT_SKILL_NAME_RACERGIRL: "애프터버너",
  TXT_SKILL_NAME_RUNNER: "대쉬 달리기",
  TXT_SKILL_NAME_SEAMAN: "철의 의지",
  TXT_TUTORIAL_HUD: "인터페이스",
  TXT_TUTORIAL_HUD_LABEL10: "달리기",
  TXT_TUTORIAL_PICKUP_LABEL0: "무기",
  T_34_M_WS_VFXTYPE: "VFX 유형",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "공격 대상",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "플레이어 UI 유형",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "몬스터 스킬 유형",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "버튼 스타일 유형",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "버튼 유형",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "가속도",
  T_46_META_WS_A_ACCOUNTID: "계정 ID",
  T_46_META_WS_A_ACTIONTYPE: "행동 유형",
  T_46_META_WS_A_ACTIVE: "활성화됨",
  T_46_META_WS_A_ANGLE: "각도",
  T_46_META_WS_A_ANY: "아무거나",
  T_46_META_WS_A_APPEARANCEGROUP: "외형 그룹",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "주장 표현",
  T_46_META_WS_A_ATTACHMENT: "부착물",
  T_46_META_WS_A_ATTACHMENTS: "부착물 목록",
  T_46_META_WS_A_ATTACKABLE: "공격 가능 여부",
  T_46_META_WS_A_ATTACKER: "공격자",
  T_46_META_WS_A_ATTACKTARGET: "공격 대상",
  T_46_META_WS_A_AUTOPLAY: "자동 재생",
  T_46_META_WS_A_AXIS: "축",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "밑수",
  T_46_META_WS_A_BOUNDTARGET: "바운드 타겟",
  T_46_META_WS_A_BTREE: "행동 트리",
  T_46_META_WS_A_BUFF: "버프",
  T_46_META_WS_A_CAMERA: "카메라",
  T_46_META_WS_A_CAPICITY: "용량",
  T_46_META_WS_A_CENTER: "중심",
  T_46_META_WS_A_CHANGEROTATION: "회전 변경",
  T_46_META_WS_A_CHANNEL: "채널",
  T_46_META_WS_A_CHASEENEMY: "적 추격",
  T_46_META_WS_A_CHILD: "자식",
  T_46_META_WS_A_COLOR: "색상",
  T_46_META_WS_A_COLUMN: "열",
  T_46_META_WS_A_COLUMNNAME: "열 이름",
  T_46_META_WS_A_COMEBACK: "돌아오기",
  T_46_META_WS_A_COMPONENT: "구성 요소",
  T_46_META_WS_A_CONTENT: "내용",
  T_46_META_WS_A_COORDINATESYSTEM: "좌표계",
  T_46_META_WS_A_COUNT: "개수",
  T_46_META_WS_A_COUNTS: "개수",
  T_46_META_WS_A_CREATEDENTITY: "생성된 엔티티",
  T_46_META_WS_A_CROSSPLATFORM: "크로스 플랫폼",
  T_46_META_WS_A_CULLINGMASK: "컬링 마스크",
  T_46_META_WS_A_CURVE: "곡선",
  T_46_META_WS_A_CUSTOMTAG: "사용자 정의 태그",
  T_46_META_WS_A_CUTRADIUS: "절단 반지름",
  T_46_META_WS_A_DAMAGE: "피해",
  T_46_META_WS_A_DAMAGESEGMENTS: "피해 세그먼트",
  T_46_META_WS_A_DEGREE: "도",
  T_46_META_WS_A_DELTA: "델타",
  T_46_META_WS_A_DEPTH: "깊이",
  T_46_META_WS_A_DESTVAL: "목적 값",
  T_46_META_WS_A_DIFFICULTY: "난이도",
  T_46_META_WS_A_DIRECTION: "방향",
  T_46_META_WS_A_DISABLE: "비활성화됨",
  T_46_META_WS_A_DISPLACEMENT: "변위",
  T_46_META_WS_A_DISTANCE: "거리",
  T_46_META_WS_A_DIVINGMAXSPEED: "다이빙 최대 속도",
  T_46_META_WS_A_DOTWEEN: "트윈 실행",
  T_46_META_WS_A_DURATION: "지속 시간 (초)",
  T_46_META_WS_A_EMOTE: "감정 표현",
  T_46_META_WS_A_ENABLE: "활성화",
  T_46_META_WS_A_ENDAREACENTER: "종료 영역 중심",
  T_46_META_WS_A_ENDAREARANGE: "종료 영역 범위",
  T_46_META_WS_A_ENDPOSITION: "종료 위치",
  T_46_META_WS_A_ENDRANK: "종료 순위",
  T_46_META_WS_A_EQUIPMENTS: "장비",
  T_46_META_WS_A_EVENTID: "이벤트 ID",
  T_46_META_WS_A_EXPONENT: "지수",
  T_46_META_WS_A_FACTION: "진영",
  T_46_META_WS_A_FACTORTYPE: "요소 유형",
  T_46_META_WS_A_FILTERTYPE: "필터 유형",
  T_46_META_WS_A_FINALRADIUS: "최종 반지름",
  T_46_META_WS_A_FINDVALUE: "값 찾기",
  T_46_META_WS_A_FIXEDRANGE: "고정 범위",
  T_46_META_WS_A_FOLLOWTARGET: "대상 추적",
  T_46_META_WS_A_FONTCOLOR: "글꼴 색상",
  T_46_META_WS_A_FONTSIZE: "글꼴 크기",
  T_46_META_WS_A_FOOTBALL: "축구공",
  T_46_META_WS_A_FORCE: "힘",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "강제 낙하산 높이",
  T_46_META_WS_A_FORCEMODE: "힘 모드",
  T_46_META_WS_A_FORWARD: "방향",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "게임 ID",
  T_46_META_WS_A_HALFEXTENTS: "절반 크기",
  T_46_META_WS_A_HEIGHT: "높이",
  T_46_META_WS_A_HEIGHTSEGMENTS: "높이 세그먼트",
  T_46_META_WS_A_HITDISTANCE: "히트 거리",
  T_46_META_WS_A_HITDISTANCES: "맞은 거리",
  T_46_META_WS_A_HITENTITIES: "맞은 엔티티",
  T_46_META_WS_A_HITENTITY: "히트 엔티티",
  T_46_META_WS_A_HITNORMAL: "히트 노멀",
  T_46_META_WS_A_HITNORMALS: "맞은 표면의 법선",
  T_46_META_WS_A_HITPOINTS: "맞은 지점",
  T_46_META_WS_A_HITPOSITION: "히트 위치",
  T_46_META_WS_A_INCLUDETRIGGER: "트리거 포함",
  T_46_META_WS_A_INDEX: "인덱스",
  T_46_META_WS_A_INDEXS: "인덱스",
  T_46_META_WS_A_INITIALVELOCITY: "초기 속도",
  T_46_META_WS_A_INITRADIUS: "초기 반지름",
  T_46_META_WS_A_INWALLET: "수금 지갑",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "하단 충돌 여부",
  T_46_META_WS_A_ISEXIST: "존재 여부",
  T_46_META_WS_A_ISLOOP: "반복 여부",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "화면에 매핑됨",
  T_46_META_WS_A_ISPAUSE: "일시 정지",
  T_46_META_WS_A_ISSIDECOLLIDING: "측면 충돌 여부",
  T_46_META_WS_A_ISSUCCESS: "성공 여부",
  T_46_META_WS_A_ISTOPCOLLIDING: "상단 충돌 여부",
  T_46_META_WS_A_ITEM: "아이템",
  T_46_META_WS_A_ITEMID: "아이템 ID",
  T_46_META_WS_A_ITEMS: "아이템",
  T_46_META_WS_A_ITEMTYPE: "아이템 유형",
  T_46_META_WS_A_JERSEYTYPE: "유니폼 유형",
  T_46_META_WS_A_KEEPVELOCITY: "속도 유지",
  T_46_META_WS_A_KEY: "키",
  T_46_META_WS_A_KEYCOLUMN: "키 열",
  T_46_META_WS_A_KEYS: "키",
  T_46_META_WS_A_LAYER: "레이어",
  T_46_META_WS_A_LAYERMASK: "레이어 마스크",
  T_46_META_WS_A_LEFT: "왼쪽",
  T_46_META_WS_A_LEFTVALUE: "왼쪽 값",
  T_46_META_WS_A_LENGTH: "길이",
  T_46_META_WS_A_LEVELOBJECT: "레벨 오브젝트",
  T_46_META_WS_A_LOG: "로그",
  T_46_META_WS_A_LOOKATTARGET: "목표를 주시하다",
  T_46_META_WS_A_LOOPTYPE: "반복 유형",
  T_46_META_WS_A_MAINCOLOR1: "메인 색상1",
  T_46_META_WS_A_MAINCOLOR2: "메인 색상2",
  T_46_META_WS_A_MAPCODE: "맵 코드",
  T_46_META_WS_A_MAPPEDPOSITION: "매핑된 위치",
  T_46_META_WS_A_MAX: "최대값",
  T_46_META_WS_A_MAXDISPLACEMENT: "최대 변위",
  T_46_META_WS_A_MAXDISTANCE: "최대 거리",
  T_46_META_WS_A_MIN: "최소값",
  T_46_META_WS_A_MISSIONID: "미션 ID",
  T_46_META_WS_A_MISSIONPROGRESS: "미션 진행도",
  T_46_META_WS_A_MODIFYTYPE: "수정 유형",
  T_46_META_WS_A_MONEYTYPE: "화폐 유형",
  T_46_META_WS_A_MUST: "반드시",
  T_46_META_WS_A_NAME: "이름",
  T_46_META_WS_A_NEWVALUE: "새 값",
  T_46_META_WS_A_NODE: "노드",
  T_46_META_WS_A_NORMAL: "노멀",
  T_46_META_WS_A_NOT: "아니요",
  T_46_META_WS_A_OBSERVER: "관찰자",
  T_46_META_WS_A_OFFSET: "오프셋",
  T_46_META_WS_A_OLDVALUE: "이전 값",
  T_46_META_WS_A_OPERATIOMETHOD: "운영 방법",
  T_46_META_WS_A_OPTIONS: "옵션",
  T_46_META_WS_A_OTHERCOLOR: "다른 색상",
  T_46_META_WS_A_OUTFIT: "복장",
  T_46_META_WS_A_OUTFITS: "복장 목록",
  T_46_META_WS_A_OUTWALLET: "송금 지갑",
  T_46_META_WS_A_OWNER: "소유자",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "낙하산 최대 속도",
  T_46_META_WS_A_PARAMS: "매개변수",
  T_46_META_WS_A_PARENT: "부모",
  T_46_META_WS_A_PARENTWIDGET: "부모 위젯",
  T_46_META_WS_A_PATH: "경로",
  T_46_META_WS_A_PATHPOINTS: "경로 포인트",
  T_46_META_WS_A_PHASEINDEX: "단계 인덱스",
  T_46_META_WS_A_PLATFORM: "플랫폼",
  T_46_META_WS_A_PLAYER: "플레이어",
  T_46_META_WS_A_PLAYSPEED: "재생 속도",
  T_46_META_WS_A_POSITION: "위치",
  T_46_META_WS_A_POSITIONS: "위치들",
  T_46_META_WS_A_POSTION: "위치",
  T_46_META_WS_A_PREFAB: "프리팹",
  T_46_META_WS_A_PROPERTY: "속성",
  T_46_META_WS_A_PROPERTYID: "속성 ID",
  T_46_META_WS_A_PURSUITTARGET: "추적 대상",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "반지름",
  T_46_META_WS_A_RANDOMDECAY: "랜덤 감쇠",
  T_46_META_WS_A_RANDOMRANGE: "랜덤 범위",
  T_46_META_WS_A_RANDOMRATIO: "랜덤 비율",
  T_46_META_WS_A_RANGE: "범위",
  T_46_META_WS_A_RANK: "순위",
  T_46_META_WS_A_REALCOIN: "실제 코인",
  T_46_META_WS_A_REALNUMBER: "실수",
  T_46_META_WS_A_RESET: "재설정",
  T_46_META_WS_A_RESOURCE: "리소스",
  T_46_META_WS_A_RESULT: "결과",
  T_46_META_WS_A_RIGHT: "오른쪽",
  T_46_META_WS_A_RIGHTVALUE: "오른쪽 값",
  T_46_META_WS_A_ROTATION: "회전",
  T_46_META_WS_A_ROW: "행",
  T_46_META_WS_A_SAMPLEPOINT: "샘플 포인트",
  T_46_META_WS_A_SCALE: "스케일",
  T_46_META_WS_A_SCENEID: "장면 ID",
  T_46_META_WS_A_SCORE: "점수",
  T_46_META_WS_A_SCORENAME: "점수 이름",
  T_46_META_WS_A_SCREENPOSITION: "화면 위치",
  T_46_META_WS_A_SCRIPT: "스크립트",
  T_46_META_WS_A_SEAT: "좌석",
  T_46_META_WS_A_SEP: "구분 기호",
  T_46_META_WS_A_SEPSTR: "구분 기호",
  T_46_META_WS_A_SHEETNAME: "시트 이름",
  T_46_META_WS_A_SHOPITEM: "상점 아이템",
  T_46_META_WS_A_SHOWBACKGROUND: "배경 표시",
  T_46_META_WS_A_SHOWMATCHRESULT: "게임 결과 표시",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "취소 시 메시지 표시",
  T_46_META_WS_A_SKILL: "스킬",
  T_46_META_WS_A_SKILLS: "스킬",
  T_46_META_WS_A_SKILLTARGET: "스킬 타겟",
  T_46_META_WS_A_SKIN: "스킨",
  T_46_META_WS_A_SLOT: "슬롯",
  T_46_META_WS_A_SRCVAL: "소스 값",
  T_46_META_WS_A_SRCVALUE: "원본 값",
  T_46_META_WS_A_STARTAREACENTER: "시작 영역 중심",
  T_46_META_WS_A_STARTAREARANGE: "시작 영역 범위",
  T_46_META_WS_A_STARTINDEX: "시작 인덱스",
  T_46_META_WS_A_STARTPOSITION: "시작 위치",
  T_46_META_WS_A_STARTRANK: "시작 순위",
  T_46_META_WS_A_STATE: "상태",
  T_46_META_WS_A_STATUS: "상태",
  T_46_META_WS_A_STATUSCODE: "상태 코드",
  T_46_META_WS_A_STYLE: "스타일",
  T_46_META_WS_A_SURFINGMAXSPEED: "서핑 최대 속도",
  T_46_META_WS_A_TARGET: "목표",
  T_46_META_WS_A_TARGETPOSITION: "목표 위치",
  T_46_META_WS_A_TEAMSEQ: "팀 순서",
  T_46_META_WS_A_THRESHOLD: "임계값",
  T_46_META_WS_A_TIMESTAMP: "타임스탬프",
  T_46_META_WS_A_TIPS: "팁",
  T_46_META_WS_A_TITLE: "제목",
  T_46_META_WS_A_TOKENCOUNT: "토큰 수",
  T_46_META_WS_A_TOKENID: "토큰 ID",
  T_46_META_WS_A_TORQUE: "토크",
  T_46_META_WS_A_TOUCHPOINT: "터치 포인트",
  T_46_META_WS_A_TRANSITIONTIME: "전환 시간 (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "전환 유형",
  T_46_META_WS_A_TRIGGER: "트리거",
  T_46_META_WS_A_TYPE: "유형",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "UI ID",
  T_46_META_WS_A_UPWARD: "위쪽",
  T_46_META_WS_A_VALUE: "값",
  T_46_META_WS_A_VALUEA: "값 A",
  T_46_META_WS_A_VALUEB: "값 B",
  T_46_META_WS_A_VALUES: "값",
  T_46_META_WS_A_VALUET: "값T",
  T_46_META_WS_A_VALUETYPE: "값 유형",
  T_46_META_WS_A_VEHICLE: "차량",
  T_46_META_WS_A_VEHICLESKIN: "차량 스킨",
  T_46_META_WS_A_VELOCITY: "속도",
  T_46_META_WS_A_VELOCITYXZ: "XZ축 속도",
  T_46_META_WS_A_VELOCITYY: "Y축 속도",
  T_46_META_WS_A_VISIBLE: "가시성",
  T_46_META_WS_A_WAITTIME: "대기 시간 (초)",
  T_46_META_WS_A_WALLET: "지갑",
  T_46_META_WS_A_WEAPON: "무기",
  T_46_META_WS_A_WEAPONSKIN: "무기 스킨",
  T_46_META_WS_A_WIDGETID: "위젯 ID",
  T_46_META_WS_A_WIDGETTYPE: "위젯 유형",
  T_46_META_WS_A_WIDTH: "너비",
  T_46_META_WS_A_WORLDPOSITION: "세계 위치",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "세계 위치 유지",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "절대값",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI 특수 팔로우 추가",
  T_46_META_WS_ADDATTACHMENTS: "부착물 추가",
  T_46_META_WS_ADDBUFF: "버프 추가",
  T_46_META_WS_ADDCOMPONENT: "컴포넌트 추가",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "축구 속도 추가",
  T_46_META_WS_ADDFORCE: "힘 추가",
  T_46_META_WS_ADDFORCEATPOSITION: "위치에서 힘 추가",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "수식 속성 계수 추가",
  T_46_META_WS_ADDGAMEEVENTLOG: "게임 이벤트 로그 추가",
  T_46_META_WS_ADDHP: "HP 추가",
  T_46_META_WS_ADDITEM: "아이템 추가",
  T_46_META_WS_ADDITEMINSCENE: "장면에 아이템 생성",
  T_46_META_WS_ADDITEMTOSHOPITEM: "아이템에 아이템 추가",
  T_46_META_WS_ADDMONEY: "돈 추가",
  T_46_META_WS_ADDSCRIPT: "스크립트 추가",
  T_46_META_WS_ADDTAG: "태그 추가",
  T_46_META_WS_ADDTOKEN: "토큰 추가",
  T_46_META_WS_ADDTORQUE: "토크 추가",
  T_46_META_WS_ADDUSEREVENTLOG: "사용자 이벤트 로그 추가",
  T_46_META_WS_ANGEL: "각도",
  T_46_META_WS_APPEND: "추가",
  T_46_META_WS_APPENDRANGE: "범위 추가",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "중간 종료 UI 구성 적용",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "어설트",
  T_46_META_WS_ASSISTPLAYER: "지원 플레이어",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "공격자",
  T_46_META_WS_ATTACKTARGET: "공격 목표",
  T_46_META_WS_AXISANGLETOQUATERNION: "축 각도를 쿼터니언으로 변환",
  T_46_META_WS_BOXCAST: "박스 캐스트",
  T_46_META_WS_BOXOVERLAP: "박스 오버랩",
  T_46_META_WS_BUTTONNAME: "버튼 이름",
  T_46_META_WS_C_ACTIONTYPE: "액션 유형",
  T_46_META_WS_C_AIMABLE: "조준할 수 있는 구성요소",
  T_46_META_WS_C_AIMASSISTABLE: "조준 보조 가능 구성요소",
  T_46_META_WS_C_AIMASSISTTYPE: "조준 보조 유형",
  T_46_META_WS_C_AIRDROP: "공중 투하",
  T_46_META_WS_C_AMMO: "탄약",
  T_46_META_WS_C_AMMOTYPE: "탄약 유형",
  T_46_META_WS_C_AMPHIBIAN: "수륙 양용",
  T_46_META_WS_C_ANIMATIONCLIP: "애니메이션 클립",
  T_46_META_WS_C_ANIMATIONCLIPID: "애니메이션 클립 ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "애니메이션 컨트롤러",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "애니메이션 컨트롤러 부착 가능",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "애니메이션 컨트롤러 ID",
  T_46_META_WS_C_ANIMATIONSTATE: "애니메이션 상태",
  T_46_META_WS_C_ANIMATIONTRIGGER: "애니메이션 트리거",
  T_46_META_WS_C_APPEARENCE: "외관",
  T_46_META_WS_C_ASSETCONFIGID: "자산 구성 ID",
  T_46_META_WS_C_ASSETID: "자산 ID",
  T_46_META_WS_C_ATTACHMENT: "부착물",
  T_46_META_WS_C_ATTACKABLETYPE: "공격 가능한 유형",
  T_46_META_WS_C_AUDIOID: "오디오 ID",
  T_46_META_WS_C_BACKPACK: "백팩",
  T_46_META_WS_C_BACKPACKSKINID: "배낭 스킨 ID",
  T_46_META_WS_C_BASEDATAALIAS: "기본 데이터 별칭",
  T_46_META_WS_C_BASICAPPEARANCE: "기본 외관",
  T_46_META_WS_C_BASICCYLINDER: "기본 실린더",
  T_46_META_WS_C_BASICSCALABLE: "기본 확장 가능",
  T_46_META_WS_C_BASICSPHERE: "기본 구체",
  T_46_META_WS_C_BATCHCOMBINERENDER: "배치 결합 렌더링 구성요소",
  T_46_META_WS_C_BEVTREE: "행동 트리",
  T_46_META_WS_C_BEVTREEATTACHABLE: "행동 트리 부착 가능",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "행동 트리 사용자 정의 노드",
  T_46_META_WS_C_BEVTREEID: "행동 트리 ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "행동 트리 노드 상태",
  T_46_META_WS_C_BEVTREENODETYPE: "행동 트리 노드 유형",
  T_46_META_WS_C_BEZIERCURVE: "베지어 곡선",
  T_46_META_WS_C_BOOL: "불리언",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "봇 난이도 유형",
  T_46_META_WS_C_BOUNCINGTIRE: "튕기는 타이어",
  T_46_META_WS_C_BUFFABLE: "버프 가능",
  T_46_META_WS_C_BUFFGENERATOR: "버프 생성기",
  T_46_META_WS_C_BUFFTYPE: "버프 타입",
  T_46_META_WS_C_BUILTINRENDER: "내장 렌더링",
  T_46_META_WS_C_BUILTINUI: "내장 UI",
  T_46_META_WS_C_BUILTINUITYPE: "내장 UI 타입",
  T_46_META_WS_C_CAMERA: "카메라",
  T_46_META_WS_C_CAMERABLOCKMODE: "카메라 차단 모드",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "카메라 투영 모드",
  T_46_META_WS_C_CAMERARAYCASTUI: "카메라 RayCast UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "카메라 전환 유형",
  T_46_META_WS_C_CAMERATYPE: "카메라 유형",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "카메라 시야 각도 제한 유형",
  T_46_META_WS_C_CAPSULETRIGGER: "캡슐형 트리거",
  T_46_META_WS_C_CAR: "자동차",
  T_46_META_WS_C_CHARACTERCONTROLLER: "캐릭터 컨트롤러",
  T_46_META_WS_C_CHATCHANNEL: "채팅 채널",
  T_46_META_WS_C_CHATCHANNELTYPE: "채팅 채널 유형",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "체크포인트 트리거",
  T_46_META_WS_C_COINGENERATOR: "동전 생성기",
  T_46_META_WS_C_COLLECTIONID: "컬렉션 ID",
  T_46_META_WS_C_COLLIDER: "충돌체",
  T_46_META_WS_C_COLLIDERCOLLECTION: "충돌체 형태",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "콜라이더 수집 ID",
  T_46_META_WS_C_COLOR: "색상",
  T_46_META_WS_C_COLORDRUM: "색상 드럼",
  T_46_META_WS_C_COMBATABLE: "전투 가능",
  T_46_META_WS_C_COMPONENT: "구성 요소",
  T_46_META_WS_C_CONDITION: "조건",
  T_46_META_WS_C_CONTAINER: "컨테이너",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "좌표계 유형",
  T_46_META_WS_C_CROSSBOW: "수류탄 석궁",
  T_46_META_WS_C_CSVID: "CSV ID",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "사용자 정의 트리거",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "사용자 정의 오브젝트",
  T_46_META_WS_C_CUSTOMPATH: "사용자 지정 경로",
  T_46_META_WS_C_CUSTOMUI: "사용자 정의 UI",
  T_46_META_WS_C_CUSTOMUIID: "사용자 정의 UI ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "사용자 정의 UI 또는 위젯",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "사용자 정의 UI 위젯 ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "손상된 신체 부위 유형",
  T_46_META_WS_C_DAMAGETYPE: "피해 유형",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "사망 또는 무적 트리거",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "파괴 가능한 오브젝트",
  T_46_META_WS_C_DICE: "주사위",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "더블 점프 슈즈",
  T_46_META_WS_C_DRUMMUSIC: "드럼 음악",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "듀얼 웨폰 유형",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "일반 레벨 오브젝트",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "동적으로 생성 가능한 레벨 오브젝트 유형",
  T_46_META_WS_C_DYNAMICFENCE: "동적 펜스",
  T_46_META_WS_C_EFFECT: "효과",
  T_46_META_WS_C_EFFECTCONTAINER: "효과 컨테이너",
  T_46_META_WS_C_EFFECTID: "이펙트 ID",
  T_46_META_WS_C_EMOTETYPE: "이모트 유형",
  T_46_META_WS_C_ENDPOINTTRIGGER: "종료점 트리거",
  T_46_META_WS_C_ENTITY: "엔티티",
  T_46_META_WS_C_ENTITYORPREFABID: "엔티티 또는 프리팹 ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "장비 액세서리",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "장비 슬롯 유형",
  T_46_META_WS_C_EQUIPMENTTYPE: "장비 유형",
  T_46_META_WS_C_EVENTID: "이벤트 ID",
  T_46_META_WS_C_FACTION: "진영",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "채우기 방향 유형",
  T_46_META_WS_C_FILLTYPE: "채우기 유형",
  T_46_META_WS_C_FIRETYPE: "화재 유형",
  T_46_META_WS_C_FLOAT: "부동 소수점",
  T_46_META_WS_C_FOLDWING: "접이식 날개",
  T_46_META_WS_C_FOLLOW: "추적",
  T_46_META_WS_C_FONTTYPE: "폰트 유형",
  T_46_META_WS_C_FOOTBALL: "축구",
  T_46_META_WS_C_FORCETYPE: "힘 타입",
  T_46_META_WS_C_FORMULABLE: "공식화 가능한",
  T_46_META_WS_C_FRAMESELFRELATIVE: "프레임 자기 상대",
  T_46_META_WS_C_GAMERESULTTYPE: "게임 결과 유형",
  T_46_META_WS_C_GENDERTYPE: "성별",
  T_46_META_WS_C_GENERALSPAWNPOINT: "일반 스폰 포인트",
  T_46_META_WS_C_GRENADEDEICEWALL: "제빙 벽 수류탄",
  T_46_META_WS_C_GRENADEFLASHBANG: "섬광탄",
  T_46_META_WS_C_GRENADEFROZEN: "냉동 수류탄",
  T_46_META_WS_C_GRENADELAUNCHER: "수류탄 발사기",
  T_46_META_WS_C_GRENADESMOKE: "연막탄",
  T_46_META_WS_C_GRENADEWEAPON: "수류탄 기반",
  T_46_META_WS_C_GRID: "그리드",
  T_46_META_WS_C_HANDCANNON: "수류탄 핸드캐논",
  T_46_META_WS_C_HELMET: "헬멧",
  T_46_META_WS_C_HIERARCHICAL: "계층적",
  T_46_META_WS_C_HOOKGUN: "훅 건",
  T_46_META_WS_C_HORIZALINE: "수평선",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI 변환기",
  T_46_META_WS_C_HUMANMODELID: "인간 모델 ID",
  T_46_META_WS_C_ICEWALL: "얼음 벽",
  T_46_META_WS_C_ICEWALLCREATED: "생성된 얼음 벽",
  T_46_META_WS_C_ICEWALLMAKER: "아이스 월 메이커",
  T_46_META_WS_C_ICON: "아이콘 엔티티",
  T_46_META_WS_C_ICONTYPE: "아이콘 유형",
  T_46_META_WS_C_INHALER: "흡입기",
  T_46_META_WS_C_INT: "정수",
  T_46_META_WS_C_INT64: "64비트 정수",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "정수 맵 템플릿",
  T_46_META_WS_C_INTORINTLIST: "정수 또는 정수 목록",
  T_46_META_WS_C_INVENTORYTYPE: "인벤토리 유형",
  T_46_META_WS_C_ITEMBASE: "아이템 베이스",
  T_46_META_WS_C_ITEMCONTAINER: "아이템 컨테이너",
  T_46_META_WS_C_ITEMID: "항목 ID",
  T_46_META_WS_C_ITEMIDTYPE: "아이템 ID 유형",
  "T_46_META_WS_C_JERSEY STYLE": "유니폼 스타일",
  T_46_META_WS_C_JERSEYMACHINE: "유니폼 교환기",
  T_46_META_WS_C_JETSHOES: "제트 슈즈",
  T_46_META_WS_C_KEYBOARD: "키보드",
  T_46_META_WS_C_KNOCKDOWNTYPE: "넉다운 유형",
  T_46_META_WS_C_LANDMINE: "지뢰",
  T_46_META_WS_C_LANDMINECREATED: "생성된 지뢰",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "발사대 레벨 오브젝트",
  T_46_META_WS_C_LAUNCHPAD: "발사대",
  T_46_META_WS_C_LAYOUTSORTTYPE: "레이아웃 정렬 유형",
  T_46_META_WS_C_LEAD1MUSIC: "리드1 음악",
  T_46_META_WS_C_LEAD2MUSIC: "리드2 음악",
  T_46_META_WS_C_LEAD3MUSIC: "리드3 음악",
  T_46_META_WS_C_LEVELOBJECTID: "레벨 오브젝트 ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "레벨 객체 타입",
  T_46_META_WS_C_LIST: "목록",
  T_46_META_WS_C_LISTORMAP: "리스트 또는 지도",
  T_46_META_WS_C_LISTT: "목록 템플릿",
  T_46_META_WS_C_LISTT_BOOL: "불린 목록",
  T_46_META_WS_C_LISTT_CONDITION: "조건 목록",
  T_46_META_WS_C_LISTT_ENTITY: "엔티티 목록",
  T_46_META_WS_C_LISTT_FLOAT: "부동 소수점 목록",
  T_46_META_WS_C_LISTT_INT: "정수 목록",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "아이템 목록",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "레벨 객체 목록",
  T_46_META_WS_C_LISTT_LOCKEY: "현지화 키 목록",
  T_46_META_WS_C_LISTT_PLAYABLE: "플레이어블 리스트",
  T_46_META_WS_C_LISTT_PLAYER: "플레이어 목록",
  T_46_META_WS_C_LISTT_SKILLID: "스킬 ID 목록",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "음향 효과 목록",
  T_46_META_WS_C_LISTT_STRING: "문자열 목록",
  T_46_META_WS_C_LISTT_TEAM: "팀 목록",
  T_46_META_WS_C_LISTT_TYPE: "유형 목록",
  T_46_META_WS_C_LISTT_VECTOR3: "Vector3 목록",
  T_46_META_WS_C_LOCKEY: "로컬라이제이션 키",
  T_46_META_WS_C_LOOKAT: "바라보기",
  T_46_META_WS_C_LOOPABLE: "반복 가능한",
  T_46_META_WS_C_LOOPTYPE: "루프 유형",
  T_46_META_WS_C_LOOTAMMOTYPE: "전리품 탄약 유형",
  T_46_META_WS_C_LOOTARMOR: "전리품 방어구",
  T_46_META_WS_C_LOOTARMORTYPE: "전리품 방어구 유형",
  T_46_META_WS_C_LOOTCONSUMABLE: "전리품 소모품",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "전리품 소모품 유형",
  T_46_META_WS_C_LOOTIAMMO: "전리품 탄약",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "전리품 축구 아이템 박스",
  T_46_META_WS_C_LOOTSCOPE: "전리품 조준경",
  T_46_META_WS_C_LOOTSCOPETYPE: "전리품 조준경 유형",
  T_46_META_WS_C_LOOTSOCCERTYPE: "전리품 축구 유형",
  T_46_META_WS_C_LOOTTHROWABLE: "전리품 투척물",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "전리품 투척물 유형",
  T_46_META_WS_C_LOOTWEAPON: "전리품 무기",
  T_46_META_WS_C_LOOTWEAPONTYPE: "전리품 무기 유형",
  T_46_META_WS_C_LOWGRAVITY: "저중력 지역",
  T_46_META_WS_C_MAP: "지도",
  T_46_META_WS_C_MAPT: "지도 템플릿",
  T_46_META_WS_C_MATERIALID: "재질 ID",
  T_46_META_WS_C_MEDKIT: "응급 처치 키트",
  T_46_META_WS_C_MESHID: "메시 ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "게임 중 퇴장 구성",
  T_46_META_WS_C_MINIMAP: "미니맵",
  T_46_META_WS_C_MINIMAPICON: "미니맵 아이콘",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "미니맵 픽셀 렌더러",
  T_46_META_WS_C_MINISENTRY: "미니 센트리",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "미니 센트리 공격 범위 유형",
  T_46_META_WS_C_MINISENTRYCREATED: "미니 센트리 생성됨",
  T_46_META_WS_C_MONEY: "화폐",
  T_46_META_WS_C_MONEYTYPE: "화폐 유형",
  T_46_META_WS_C_MONSTER: "몬스터",
  T_46_META_WS_C_MONSTERSPAWN: "몬스터 스폰",
  T_46_META_WS_C_MONSTERTYPE: "몬스터 유형",
  T_46_META_WS_C_MORPHABLEOBJECT: "형태 변화 가능한 오브젝트",
  T_46_META_WS_C_MORPHOBJECT: "형태 변화 가능한 오브젝트",
  T_46_META_WS_C_MOTOBIKE: "오토바이",
  T_46_META_WS_C_MOVEPLATFORM: "이동 플랫폼",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "이동 플랫폼 유형",
  T_46_META_WS_C_MUSHROOM: "버섯",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "자연 상수",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "숫자",
  T_46_META_WS_C_OBJECT: "객체",
  T_46_META_WS_C_OILDRUM: "기름통",
  T_46_META_WS_C_OUTFITID: "의상 ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "의상 슬롯 유형",
  T_46_META_WS_C_PATHPOINT: "경로 점",
  T_46_META_WS_C_PATROLSTYLETYPE: "순찰 스타일 유형",
  T_46_META_WS_C_PATROLTYPE: "순찰 유형",
  T_46_META_WS_C_PERSONA: "페르소나",
  T_46_META_WS_C_PHASE: "단계",
  T_46_META_WS_C_PHYSICALMOVER: "물리적 이동체",
  T_46_META_WS_C_PHYSICALOBJECT: "물리적 객체",
  T_46_META_WS_C_PLATFORMTYPE: "플랫폼 유형",
  T_46_META_WS_C_PLAYABLE: "재생 가능",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "플레이 가능 또는 플레이 가능한 배열",
  T_46_META_WS_C_PLAYER: "플레이어",
  T_46_META_WS_C_PLAYERBACKPACK: "플레이어 배낭",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "플레이어 행동 상태 유형",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "플레이어 행동 유형",
  T_46_META_WS_C_PLAYERCCT: "FF 캐릭터용 캐릭터 컨트롤러",
  T_46_META_WS_C_PLAYERDATAID: "프리셋 캐릭터 유형",
  T_46_META_WS_C_PLAYERORTRANSFORM: "플레이어 또는 변환",
  T_46_META_WS_C_PLAYERORVEHICLE: "플레이어 또는 차량",
  T_46_META_WS_C_PLAYEROUTFIT: "플레이어 복장",
  T_46_META_WS_C_PLAYERPOSETYPE: "플레이어 포즈 유형",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "플레이어 부활 출처 유형",
  T_46_META_WS_C_PLAYERSTATETYPE: "플레이어 상태 유형",
  T_46_META_WS_C_POINTLIGHT: "점 광원",
  T_46_META_WS_C_PORTAL: "포탈",
  T_46_META_WS_C_PREFABID: "프리팹 ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "효과 생성기",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "효과 텍스처 타입",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "프로필 사진 위젯",
  T_46_META_WS_C_PROPERTY: "속성",
  T_46_META_WS_C_PROPERTYFORMULA: "속성 공식",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "속성 공식 요소 유형",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "속성 수정 유형",
  T_46_META_WS_C_QUATERNION: "쿼터니언",
  T_46_META_WS_C_RANKABLE: "순위 매길 수 있는",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "레이 캐스트 레이어 유형",
  T_46_META_WS_C_REPAIRKIT: "수리 키트",
  T_46_META_WS_C_RESETABLE: "재설정 가능",
  T_46_META_WS_C_RIGIDBODY: "리지드 바디",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "리지드 바디 제약 타입",
  T_46_META_WS_C_RIGIDBODYTYPE: "리지드 바디 타입",
  T_46_META_WS_C_ROUND: "라운드",
  T_46_META_WS_C_SAFEZONE: "안전 구역",
  T_46_META_WS_C_SCOREABLE: "점수화 가능한",
  T_46_META_WS_C_SCRIPTID: "스크립트 ID",
  T_46_META_WS_C_SEATTYPE: "좌석 유형",
  T_46_META_WS_C_SELFRELATIVE: "자기 상대",
  T_46_META_WS_C_SHOP: "상점",
  T_46_META_WS_C_SHOPITEM: "상점 아이템",
  T_46_META_WS_C_SHOPSHELF: "상점 선반",
  T_46_META_WS_C_SKATEBOARD: "스케이트보드",
  T_46_META_WS_C_SKELETON: "골격",
  T_46_META_WS_C_SKELETONPART: "골격 부분",
  T_46_META_WS_C_SKILLID: "스킬 ID",
  T_46_META_WS_C_SKYBLASTER: "비행 장치",
  T_46_META_WS_C_SKYBOX: "스카이박스",
  T_46_META_WS_C_SKYBOXTYPE: "스카이박스 유형",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "소셜 섬 눈덩이",
  T_46_META_WS_C_SORTTYPE: "정렬 유형",
  T_46_META_WS_C_SOUNDDRUMTYPE: "사운드 드럼 유형",
  T_46_META_WS_C_SOUNDEFFECT: "음향 효과",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "음향 효과 또는 음향 효과 목록",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "사운드 효과 유형",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "사운드 리드1 유형",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "사운드 리드2 유형",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "사운드 리드3 유형",
  T_46_META_WS_C_SOUNDPIANOTYPE: "사운드 피아노 유형",
  T_46_META_WS_C_SPAWN: "스폰",
  T_46_META_WS_C_SPAWNABLE: "스폰 가능한",
  T_46_META_WS_C_SPAWNBOX: "스폰 박스",
  T_46_META_WS_C_SPAWNPOSITION: "스폰 포인트",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "특별 아이템 ID 유형",
  T_46_META_WS_C_SPHERETRIGGER: "구형 트리거",
  T_46_META_WS_C_SPORTSCAR: "스포츠카",
  T_46_META_WS_C_SPRAYCOLOR: "스프레이 색상",
  T_46_META_WS_C_SPRAYGUN: "스프레이 건",
  T_46_META_WS_C_SPRAYRESULTUI: "스프레이 결과 UI",
  T_46_META_WS_C_SPRAYRIFLE: "스프레이 라이플",
  T_46_META_WS_C_SPRITEID: "스프라이트 ID",
  T_46_META_WS_C_STATICSCRIPTID: "정적 스크립트 ID",
  T_46_META_WS_C_STRING: "문자열",
  T_46_META_WS_C_STRINGORLOCSTRING: "문자열 또는 로컬라이제이션 문자열",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "보급 상자 트리거",
  T_46_META_WS_C_SWINGGUN: "스윙 건",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "장비 슬롯 전환",
  T_46_META_WS_C_TEAM: "팀",
  T_46_META_WS_C_TERRAIN: "지형",
  T_46_META_WS_C_TEXT: "텍스트 엔티티",
  T_46_META_WS_C_TEXTUREID: "텍스처 ID",
  T_46_META_WS_C_TEXTURETYPE: "객체 텍스처",
  T_46_META_WS_C_TIMER: "타이머",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "타임스탬프 형식 스타일 유형",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "타임스탬프 지역화 문자열",
  T_46_META_WS_C_TRAJECTORY: "궤적",
  T_46_META_WS_C_TRANSFORM: "변환",
  T_46_META_WS_C_TUKTUK: "뚝뚝",
  T_46_META_WS_C_TURRET: "포탑",
  T_46_META_WS_C_TWEEN: "트윈",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "트윈 곡선",
  T_46_META_WS_C_TWEENSTYLE: "트윈 스타일 유형",
  T_46_META_WS_C_TYPE: "유형",
  T_46_META_WS_C_TYPEENUM: "타입 열거형",
  T_46_META_WS_C_TYPEORTYPELIST: "유형 또는 유형 목록",
  T_46_META_WS_C_UIADDSCORE: "UI 점수 추가",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI 애니메이션 트리거 HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI 내장 스위치",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI 내장 UI 스위치 컨트롤러",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI 카드 선택 패널",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI 체크 포인트 표시기",
  T_46_META_WS_C_UICOMPASS: "UI 나침반",
  T_46_META_WS_C_UICOUNTDOWN5: "UI 5초 카운트다운",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI 카운트다운 힌트",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI 카운트다운 알림",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "캐릭터 머리 위 체력 바",
  T_46_META_WS_C_UIHEALTHBAR: "UI 체력 바",
  T_46_META_WS_C_UIHEARTBEAT: "UI 심장 박동",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI 아이콘 알림",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI 신원 알림",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI 상호작용 버튼",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI 리더보드 버튼",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI 매치 자막",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI 몬스터 레벨",
  T_46_META_WS_C_UIMONSTERUI: "UI 몬스터 UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI 다중 팀 리더보드",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI 다중 팀 결과 패널",
  T_46_META_WS_C_UIOPENINGBANNER: "UI 오프닝 배너",
  T_46_META_WS_C_UIPANEL: "UI 패널",
  T_46_META_WS_C_UIPANELEMPTY: "빈 UI 패널",
  T_46_META_WS_C_UIPHASETIMER: "UI 단계 타이머",
  T_46_META_WS_C_UIPROGRESSBAR: "UI 진행 바",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI 진행 원",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI 진행 스킬 버튼",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI 구매 요청 유형",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI 라운드 정보 배너",
  T_46_META_WS_C_UIROUNDNUMBER: "UI 라운드 번호",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI 라운드 결과 배너",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI 라운드 시작 배너",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI 라운드 전환",
  T_46_META_WS_C_UISCOREBAR: "UI 점수 바",
  T_46_META_WS_C_UISCROLLPANEL: "UI 스크롤 패널",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI 간단한 라운드 점수 배너",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI 간단한 라운드 시작 배너",
  T_46_META_WS_C_UISIMPLETIP: "UI 간단한 팁",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI 간단한 대결 배너",
  T_46_META_WS_C_UISKILLBUTTON: "UI 스킬 버튼",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "소셜 기능 버튼 위젯",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI 솔로 리더보드",
  T_46_META_WS_C_UISTORE: "UI 상점 UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI 팀 매치 정보",
  T_46_META_WS_C_UITEXTTIP: "UI 텍스트 팁",
  T_46_META_WS_C_UITIMERINFO: "UI 타이머 정보",
  T_46_META_WS_C_UITIPBUTTON: "UI 팁 버튼",
  T_46_META_WS_C_UITITLEBANNER: "UI 제목 배너",
  T_46_META_WS_C_UITWEENTIP: "UI 트윈 팁",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI 두 팀 간단 정보",
  T_46_META_WS_C_UITWOTEAMINFO: "UI 두 팀 정보",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI 두 팀 리더보드",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI 두 팀 결과 패널",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI 두 팀 라운드 점수 배너",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI 두 팀 점수 패널",
  T_46_META_WS_C_UIVERSUSBANNER: "UI 대결 배너",
  T_46_META_WS_C_UIWIDGET: "UI 위젯",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI 위젯 버튼",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI 위젯 컨테이너",
  T_46_META_WS_C_UIWIDGETEMPTY: "빈 UI 위젯",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI 위젯 이미지",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI 위젯 입력 라벨",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI 위젯 조이스틱",
  T_46_META_WS_C_UIWIDGETLABEL: "UI 위젯 라벨",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI 위젯 레이아웃",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI 위젯 프로필",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI 위젯 텍스처",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI 위젯 토글",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI 위젯 터치패드",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI 승패 배너",
  T_46_META_WS_C_UNITSPAWN: "유닛 스폰",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "창문 등반 논리 객체",
  T_46_META_WS_C_VECTOR2: "벡터2",
  T_46_META_WS_C_VECTOR3: "벡터3",
  T_46_META_WS_C_VEHICLE: "차량",
  T_46_META_WS_C_VEHICLEIDTYPE: "차량 ID 유형",
  T_46_META_WS_C_VEHICLESKINID: "차량 스킨 ID",
  T_46_META_WS_C_VENDINGMACHINE: "자판기",
  T_46_META_WS_C_VEST: "조끼",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "교체 가능한 텍스처 VFX 엔티티",
  T_46_META_WS_C_VFXTEXTURE: "VFX 텍스처",
  T_46_META_WS_C_VISIBILITY: "가시성",
  T_46_META_WS_C_WALLET: "지갑",
  T_46_META_WS_C_WALLETHUD: "지갑 UI",
  T_46_META_WS_C_WATERZONE: "수역",
  T_46_META_WS_C_WAVECOUNTTYPE: "웨이브 수 유형",
  T_46_META_WS_C_WAVEINTERVALTYPE: "웨이브 간격 유형",
  T_46_META_WS_C_WEAPON: "무기",
  T_46_META_WS_C_WEAPONGENERATOR: "무기 생성기",
  T_46_META_WS_C_WEAPONSKINID: "무기 스킨 ID",
  T_46_META_WS_C_WEAPONTYPE: "무기 유형",
  T_46_META_WS_C_WIDGETTYPE: "위젯 유형",
  T_46_META_WS_C_ZIPLINE: "집라인",
  T_46_META_WS_CAMERADIRECTION: "카메라 방향",
  T_46_META_WS_CAMERAPOSITION: "카메라 위치",
  T_46_META_WS_CAPSULECAST: "캡슐 캐스트",
  T_46_META_WS_CAPSULEOVERLAP: "캡슐 오버랩",
  T_46_META_WS_CEIL: "올림",
  T_46_META_WS_CHATCHANNEL: "채팅 채널",
  T_46_META_WS_CHECKTRIGGERBYORDER: "순서에 따라 트리거 확인",
  T_46_META_WS_CLAMP: "클램프",
  T_46_META_WS_CLEAR: "지우기",
  T_46_META_WS_CLEARALLCHILDREN: "모든 자식 삭제",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI 특수 팔로우 지우기",
  T_46_META_WS_CLEARBACKPACK: "배낭 비우기",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "수식 속성 계수 삭제",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "남아 있는 레벨 오브젝트 정리",
  T_46_META_WS_CLIPNAME: "클립 이름",
  T_46_META_WS_CLONE: "클론",
  T_46_META_WS_COLLIDEDENTITY: "충돌된 엔터티",
  T_46_META_WS_COLORGET: "색상 가져오기",
  T_46_META_WS_COMPLETECUSTOMMISSION: "사용자 지정 미션 완료",
  T_46_META_WS_CONNECT: "연결",
  T_46_META_WS_CONSUMABLEID: "아이템 ID",
  T_46_META_WS_CONTAIN: "포함됨",
  T_46_META_WS_CONTAINKEY: "키 존재 여부 확인",
  T_46_META_WS_COPYTOMORPH: "변형 복사",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "돈 소비",
  T_46_META_WS_COSTTOKEN: "토큰 소모",
  T_46_META_WS_CREATEAIRDROP: "공중 낙하 상자 생성",
  T_46_META_WS_CREATEBOT: "봇 생성",
  T_46_META_WS_CREATEBUILTINUI: "내장 UI 생성",
  T_46_META_WS_CREATEBUILTINUICLIENT: "내장 UI 생성",
  T_46_META_WS_CREATECAMERA: "카메라 생성",
  T_46_META_WS_CREATECURVE: "곡선 생성",
  T_46_META_WS_CREATECUSTOMUI: "사용자 정의 UI 생성",
  T_46_META_WS_CREATECUSTOMUICLIENT: "사용자 정의 UI 생성",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "사용자 정의 UI 위젯 생성",
  T_46_META_WS_CREATEDAMAGENUM: "피해 숫자 생성",
  T_46_META_WS_CREATEEFFECT: "효과 생성",
  T_46_META_WS_CREATEEFFECTCLIENT: "효과 생성",
  T_46_META_WS_CREATEFACTION: "진영 생성",
  T_46_META_WS_CREATEFOLLOW: "추적 생성",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "프레임별 상대 위치 생성",
  T_46_META_WS_CREATEFROMPREFAB: "프리팹에서 생성",
  T_46_META_WS_CREATELEVELOBJECT: "레벨 오브젝트 생성",
  T_46_META_WS_CREATELOOKAT: "주시 생성",
  T_46_META_WS_CREATEMINIMAPICON: "미니맵 아이콘 만들기",
  T_46_META_WS_CREATEMINIMAPPIXEL: "미니맵 픽셀 만들기",
  T_46_META_WS_CREATEMONSTER: "몬스터 생성",
  T_46_META_WS_CREATEMORPH: "변형 생성",
  T_46_META_WS_CREATESELFRELATIVE: "상대 위치 생성",
  T_46_META_WS_CREATESHOP: "상점 생성",
  T_46_META_WS_CREATESHOPITEM: "아이템 생성",
  T_46_META_WS_CREATESHOPSHELF: "상점 선반 생성",
  T_46_META_WS_CREATESOUND: "소리 생성",
  T_46_META_WS_CREATESOUNDCLIENT: "소리 생성",
  T_46_META_WS_CREATETOKENINSCENE: "장면에 토큰 생성",
  T_46_META_WS_CREATETRAJECTORY: "궤적 생성",
  T_46_META_WS_CREATETWEEN: "트윈 생성",
  T_46_META_WS_CREATEWALLET: "지갑 생성",
  T_46_META_WS_CROSS: "교차",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV 열 이름을 정수로 변환",
  T_46_META_WS_CURRENTAMMOCOUNT: "현재 탄약 수",
  T_46_META_WS_DAMAGE: "피해",
  T_46_META_WS_DAMAGEDBODYPART: "손상된 신체 부위",
  T_46_META_WS_DAMAGEDPLAYERS: "손상된 플레이어",
  T_46_META_WS_DAMAGETYPE: "피해 유형",
  T_46_META_WS_DEALDAMAGE: "피해 입히기",
  T_46_META_WS_DELETE: "삭제",
  T_46_META_WS_DELETEAT: "지정된 위치에서 삭제",
  T_46_META_WS_DELETECUSTOMUI: "사용자 정의 UI 삭제",
  T_46_META_WS_DELETEFROMDATABASE: "데이터베이스에서 삭제",
  T_46_META_WS_DELETEFROMDATASTORE: "데이터 저장소에서 삭제",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "키로 순위 데이터베이스에서 삭제",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "순위로 순위 데이터베이스에서 삭제",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "데이터 저장소에서 랭킹 값 삭제 (키 기준)",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "데이터 저장소에서 랭킹 값 삭제 (순위 기준)",
  T_46_META_WS_DELETETAG: "태그 삭제",
  T_46_META_WS_DELTA: "델타",
  T_46_META_WS_DESTROY: "파괴",
  T_46_META_WS_DESTROYBOT: "봇 파괴",
  T_46_META_WS_DESTROYBUILTINUI: "내장 UI 파괴",
  T_46_META_WS_DESTROYEQUIPMENT: "장비 파괴",
  T_46_META_WS_DESTROYITEM: "아이템 파괴",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "방향을 오일러 각도로 변환",
  T_46_META_WS_DISABLESAFEZONE: "안전 구역 비활성화",
  T_46_META_WS_DISPATCHEVENT: "이벤트 전송",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "플랫폼으로 이벤트 전송",
  T_46_META_WS_DISTANCE: "거리",
  T_46_META_WS_DOT: "점",
  T_46_META_WS_DROPITEM: "아이템 버리기",
  T_46_META_WS_DYEATAREA: "영역에서 염색",
  T_46_META_WS_DYEATPLANE: "평면에서 염색",
  T_46_META_WS_DYEATPOSITION: "위치에서 염색",
  T_46_META_WS_E_ABNORMALGRAVZONE: "저중력 구역",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "가속도",
  T_46_META_WS_E_ACTIONNODE: "동작 노드",
  T_46_META_WS_E_ACTIVE: "능동적",
  T_46_META_WS_E_ACTIVESKILL: "능동 기술",
  T_46_META_WS_E_ADBOARD: "광고판",
  T_46_META_WS_E_ADD: "추가",
  T_46_META_WS_E_ADDFRIEND: "친구 추가",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "조준",
  T_46_META_WS_E_AIR: "공기",
  T_46_META_WS_E_AIRCONDITIONERA: "에어컨",
  T_46_META_WS_E_AIRDROP: "공중 낙하, 좀비 자살",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "살아있는",
  T_46_META_WS_E_AMMO: "총알 VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "수륙 양용 차량",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "아이들 놀이",
  T_46_META_WS_E_AR: "라이플",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR 탄약",
  T_46_META_WS_E_ARMAGAZINE: "AR 탄창",
  T_46_META_WS_E_ARMOR: "방어구",
  T_46_META_WS_E_ARMORBUFF: "갑옷 버프",
  T_46_META_WS_E_ARMORLV1: "갑옷 Lv1",
  T_46_META_WS_E_ARMORLV2: "갑옷 Lv2",
  T_46_META_WS_E_ARMORLV3: "갑옷 Lv3",
  T_46_META_WS_E_ARMORPIERCING: "방어구 파괴",
  T_46_META_WS_E_ARMORSPECIALIST: "스킬 1",
  T_46_META_WS_E_ARROW: "화살",
  T_46_META_WS_E_ASC: "오름차순",
  T_46_META_WS_E_ASCIGNOREZERO: "오름차순 (영 제외)",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "가스 폭발",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "호환성을 위한 부착물1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "호환성을 위한 부착물4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "호환성을 위한 부착물5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "호환성을 위한 부착물6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "호환성을 위한 부착물8",
  T_46_META_WS_E_ATTACK: "공격",
  T_46_META_WS_E_ATTACKGRENADE: "공격용 수류탄",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "자동",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "돌아가기",
  T_46_META_WS_E_BACKANDFORTH: "왕복",
  T_46_META_WS_E_BAG: "가방",
  T_46_META_WS_E_BAG1: "가방1",
  T_46_META_WS_E_BAG2: "가방2",
  T_46_META_WS_E_BAG3: "가방3",
  T_46_META_WS_E_BAMBOOA: "대나무 A",
  T_46_META_WS_E_BANANATREE: "바나나 나무",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "기본 계수",
  T_46_META_WS_E_BASIC: "기본",
  T_46_META_WS_E_BASICCONE: "기본 원뿔",
  T_46_META_WS_E_BASICCYLINDER: "기본 원통",
  T_46_META_WS_E_BASICSPHERE: "기본 구",
  T_46_META_WS_E_BATTLEINSTYLE: "스타일에 맞는 전투",
  T_46_META_WS_E_BELL: "벨",
  T_46_META_WS_E_BENCH: "벤치",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "대형 스크린",
  T_46_META_WS_E_BIPOD: "바이포드",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS 테마 벽",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "블랙홀 폭발 VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "크리스탈 볼 VFX",
  T_46_META_WS_E_BLAST: "폭발",
  T_46_META_WS_E_BLOCK: "정사각형",
  T_46_META_WS_E_BLOODBALL: "블랙홀 VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "파란색",
  T_46_META_WS_E_BLUEDOLL: "얼음 인형",
  T_46_META_WS_E_BOARD: "이동 플랫폼",
  T_46_META_WS_E_BODY: "몸",
  T_46_META_WS_E_BOMBINDICATION: "폭탄 경고",
  T_46_META_WS_E_BOMBPLIERS: "폭탄 집게",
  T_46_META_WS_E_BONFIRE: "타오르는 모닥불",
  T_46_META_WS_E_BOOM: "붐",
  T_46_META_WS_E_BOOYAH: "승리",
  T_46_META_WS_E_BOTH: "둘 다",
  T_46_META_WS_E_BOUNCETIRE: "타이어",
  T_46_META_WS_E_BOWAMMO: "활 탄약",
  T_46_META_WS_E_BREAKABLEBOX: "파괴 가능한 나무 상자",
  T_46_META_WS_E_BREAKABLECONTAINER: "파괴 가능한 컨테이너",
  T_46_META_WS_E_BREAKABLEFENCE: "파괴 가능한 울타리",
  T_46_META_WS_E_BRICKA: "벽돌 A",
  T_46_META_WS_E_BRICKB: "벽돌 B",
  T_46_META_WS_E_BRICKC: "벽돌 C",
  T_46_META_WS_E_BRICKHOUSEA: "작은 집 A",
  T_46_META_WS_E_BRIGHT: "밝은",
  T_46_META_WS_E_BUBBLE: "비누방울",
  T_46_META_WS_E_BUFFGENERATOR: "버프 생성기",
  T_46_META_WS_E_BULLETBUFF: "총알 버프",
  T_46_META_WS_E_BULLETHITTING: "총알 맞음",
  T_46_META_WS_E_BUMPERCAR: "범퍼카",
  T_46_META_WS_E_BUMPERCARFACTORY: "범퍼카 제조업체",
  T_46_META_WS_E_BURNING: "차량 폭발 시 화상 피해",
  T_46_META_WS_E_BUSHES: "덤불",
  T_46_META_WS_E_BUSSTOP: "버스 정류장",
  T_46_META_WS_E_BUTTOM: "하의",
  T_46_META_WS_E_BUTTONWIDGET: "버튼 위젯",
  T_46_META_WS_E_BYHIERARCHY: "계층별",
  T_46_META_WS_E_CABINET: "캐비닛",
  T_46_META_WS_E_CACTUS: "선인장",
  T_46_META_WS_E_CAMOUFLAGE: "스킬 6",
  T_46_META_WS_E_CAPSULETRIGGER: "캡슐 트리거",
  T_46_META_WS_E_CARDIOTONIC: "심장강화제",
  T_46_META_WS_E_CASUALGAMEBGM: "레저 게임 BGM",
  T_46_META_WS_E_CEMENTA: "시멘트 A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "채널 A",
  T_46_META_WS_E_CHANNELB: "채널 B",
  T_46_META_WS_E_CHANNELC: "채널 C",
  T_46_META_WS_E_CHANNELD: "채널 D",
  T_46_META_WS_E_CHANNELE: "채널 E",
  T_46_META_WS_E_CHANNELF: "채널 F",
  T_46_META_WS_E_CHARACTERSKILL: "캐릭터 스킬",
  T_46_META_WS_E_CHARACTOR: "캐릭터",
  T_46_META_WS_E_CHARGE: "충전 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "체크포인트",
  T_46_META_WS_E_CHEER: "응원",
  T_46_META_WS_E_CHERRYBLOSSOM: "벚꽃 나무",
  T_46_META_WS_E_CIRCLE: "원",
  T_46_META_WS_E_CIRCLEBACK: "루프",
  T_46_META_WS_E_CIRCLEOFHEAT: "발 광선",
  T_46_META_WS_E_CITY: "도시",
  T_46_META_WS_E_CLAPS: "박수",
  T_46_META_WS_E_CLEAR: "지우기",
  T_46_META_WS_E_CLIENT: "클라이언트",
  T_46_META_WS_E_CLONE: "외모 변경",
  T_46_META_WS_E_CLONEKILL: "클론 사망",
  T_46_META_WS_E_CLOSE: "닫기",
  T_46_META_WS_E_CLOTHES: "옷",
  T_46_META_WS_E_COINGENERATOR: "금화 생성기",
  T_46_META_WS_E_COLDAIR: "안개",
  T_46_META_WS_E_COLORBLOCK: "염료 블록",
  T_46_META_WS_E_COLOROILBARREL: "염료 오일 드럼",
  T_46_META_WS_E_COMBINEALL: "모두 결합",
  T_46_META_WS_E_COMBINESELF: "자기 자신과 결합",
  T_46_META_WS_E_COMBOKEYA1: "음악적 노트 - 신디사이저 A",
  T_46_META_WS_E_COMBOKEYA2: "음악적 노트 - 신디사이저 A",
  T_46_META_WS_E_COMBOKEYB1: "음악적 노트 - 신디사이저 B",
  T_46_META_WS_E_COMBOKEYB2: "음악적 노트 - 신디사이저 B",
  T_46_META_WS_E_COMBOKEYC1: "음악적 노트 - 신디사이저 C",
  T_46_META_WS_E_COMBOKEYC2: "음악적 노트 - 신디사이저 C",
  T_46_META_WS_E_CONCRETEPILLAR: "콘크리트 기둥",
  T_46_META_WS_E_CONDITIONNODE: "조건 노드",
  T_46_META_WS_E_CONTAINERA: "컨테이너 A",
  T_46_META_WS_E_CONTAINERB: "컨테이너 B",
  T_46_META_WS_E_CONTAINERC: "컨테이너 C",
  T_46_META_WS_E_CONTAINERWIDGET: "컨테이너 위젯",
  T_46_META_WS_E_CONTINUOUS: "연속",
  T_46_META_WS_E_COUNTDOWN: "카운트다운",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "카운트다운",
  T_46_META_WS_E_COUNTDOWNDIDI: "카운트다운 비프",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "카운트다운",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "카운트다운 3",
  T_46_META_WS_E_CROSS: "십자가",
  T_46_META_WS_E_CROSSBOW: "석궁",
  T_46_META_WS_E_CROSSHAIR: "조준경",
  T_46_META_WS_E_CROSSHAIRS: "조준점",
  T_46_META_WS_E_CROUCH: "앉기",
  T_46_META_WS_E_CROUCHING: "웅크린",
  T_46_META_WS_E_CROWCAW: "까마귀 울음소리",
  T_46_META_WS_E_CROWN: "왕관",
  T_46_META_WS_E_CUBE: "블록 메커니즘",
  T_46_META_WS_E_CURSE: "부적",
  T_46_META_WS_E_CURSEEXPLOSION: "부적 폭발",
  T_46_META_WS_E_CUSTOM: "사용자 지정 카메라",
  T_46_META_WS_E_CUSTOMTRIGGER: "맞춤형 트리거",
  T_46_META_WS_E_CUSTOMWATERZONE: "사용자 정의 수역",
  T_46_META_WS_E_CYCLICCOMBUSTION: "루프에서 타는 것",
  T_46_META_WS_E_CYLIC: "순환",
  T_46_META_WS_E_DAGGER: "투척 나이프",
  T_46_META_WS_E_DAMAGEDTRUCK: "손상된 트럭",
  T_46_META_WS_E_DAMAGEZONE: "피해 구역",
  T_46_META_WS_E_DANGERALARM: "위험 2",
  T_46_META_WS_E_DANGERVIBRATING: "위험 1",
  T_46_META_WS_E_DARK: "어두운",
  T_46_META_WS_E_DARKNESS: "어둠",
  T_46_META_WS_E_DASHATTACK: "돌진 공격",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "데이터 저장 한도 초과",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "데이터 저장 매개변수 오류",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "데이터 저장 시간 초과",
  T_46_META_WS_E_DATETIME: "날짜 및 시간",
  T_46_META_WS_E_DAY: "낮",
  T_46_META_WS_E_DEAD: "사망",
  T_46_META_WS_E_DEATH: "사망",
  T_46_META_WS_E_DEFAULT: "기본",
  T_46_META_WS_E_DEFAULTFIST: "주먹",
  T_46_META_WS_E_DEFENCEGRENADE: "방어용 수류탄",
  T_46_META_WS_E_DESC: "내림차순",
  T_46_META_WS_E_DIALOGUE: "대화",
  T_46_META_WS_E_DIAMOND: "다이아몬드",
  T_46_META_WS_E_DIRECTIONSIGN: "표지판",
  T_46_META_WS_E_DIRVEVEHICLE: "차량 조작",
  T_46_META_WS_E_DISABLE: "비활성화",
  T_46_META_WS_E_DISABLED: "비활성화",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "사라짐 알림",
  T_46_META_WS_E_DISCONNECT: "연결 끊기",
  T_46_META_WS_E_DISGUISE: "클론",
  T_46_META_WS_E_DOGHOUSE: "개집",
  T_46_META_WS_E_DOOR: "문",
  T_46_META_WS_E_DOUBLE: "2점사",
  T_46_META_WS_E_DOUBLEDOOR: "이중문",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "더블 점프 슈즈",
  T_46_META_WS_E_DOUBLEMAGEZINE: "더블 탄창",
  T_46_META_WS_E_DRAW: "무승부",
  T_46_META_WS_E_DRILLZOMBIE: "드릴 좀비",
  T_46_META_WS_E_DRIVE: "운전",
  T_46_META_WS_E_DRIVER: "운전사",
  T_46_META_WS_E_DROPBEAT: "스킬 4",
  T_46_META_WS_E_DRUMKEY1: "음악적 노트 - 드럼",
  T_46_META_WS_E_DRUMKEY2: "음악적 노트 - 드럼",
  T_46_META_WS_E_DUEL: "전투",
  T_46_META_WS_E_DUMMY: "더미",
  T_46_META_WS_E_DUMMYGRENADE: "가짜 수류탄",
  T_46_META_WS_E_DUMP: "덤프",
  T_46_META_WS_E_DUSK: "황혼",
  T_46_META_WS_E_DUST: "연기와 먼지",
  T_46_META_WS_E_DYNAMIC: "동적",
  T_46_META_WS_E_E: "자연 상수",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "쉬움",
  T_46_META_WS_E_ELECTRICSHOCK: "전기 충격",
  T_46_META_WS_E_ELECTRICSURFBOARD: "전기 서핑보드",
  T_46_META_WS_E_ELECTRICZONE: "전기 구역",
  T_46_META_WS_E_ELECTRONICBGM: "귀여운 전자 판타지 BGM",
  T_46_META_WS_E_ELIMINATEDBOSS: "길드장 탄핵",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "킬 알림",
  T_46_META_WS_E_EMOTE: "감정 표현",
  T_46_META_WS_E_ENABLE: "활성화",
  T_46_META_WS_E_ENERGETIC: "에너지 넘치는",
  T_46_META_WS_E_ENTERVEHICLE: "차량 탑승",
  T_46_META_WS_E_EP: "EP (에너지)",
  T_46_META_WS_E_EXCLAMATIONMARK: "느낌표",
  T_46_META_WS_E_EXIT: "종료",
  T_46_META_WS_E_EXITVEHICLE: "차량 하차",
  T_46_META_WS_E_EXPLODE: "자폭",
  T_46_META_WS_E_EXPLOSION: "폭발 VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "폭발 화염",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "에너지 구슬 기술",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "폭발 좀비",
  T_46_META_WS_E_EYE: "안경",
  T_46_META_WS_E_FACEPAINT: "페이스 페인트",
  T_46_META_WS_E_FACTION: "진영",
  T_46_META_WS_E_FALLING: "떨어짐",
  T_46_META_WS_E_FALLINGSTAR: "소비 아이템 얻기",
  T_46_META_WS_E_FALSE: "아니오",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "프로펠러 메커니즘",
  T_46_META_WS_E_FAR: "멀리",
  T_46_META_WS_E_FEATHER: "깃털",
  T_46_META_WS_E_FEMALE: "여성",
  T_46_META_WS_E_FENCE: "울타리",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "전투체",
  T_46_META_WS_E_FILLED: "채워진",
  T_46_META_WS_E_FINISH: "종료",
  T_46_META_WS_E_FINISHINGPOINT: "끝점",
  T_46_META_WS_E_FINISHLINEARCH: "결승 배너",
  T_46_META_WS_E_FIRE: "불",
  T_46_META_WS_E_FIRECHARGE: "불덩어리",
  T_46_META_WS_E_FIREWORK: "불꽃놀이",
  T_46_META_WS_E_FIRINGEFFECT: "사격 VFX",
  T_46_META_WS_E_FIRSTPERSON: "1인칭 카메라",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "1인칭 카메라 (클래식)",
  T_46_META_WS_E_FIST: "주먹",
  T_46_META_WS_E_FIT: "맞춤형",
  T_46_META_WS_E_FLAG: "깃발",
  T_46_META_WS_E_FLAME: "불",
  T_46_META_WS_E_FLAMEGUN: "화염 방사기",
  T_46_META_WS_E_FLAMETHROWER: "화염 방사기",
  T_46_META_WS_E_FLASH: "플래시뱅",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "섬광 수류탄 연기",
  T_46_META_WS_E_FLASHFREEZE: "플래시 프리즈",
  T_46_META_WS_E_FLEXWALL: "확장형 벽",
  T_46_META_WS_E_FLICKER: "깜박임",
  T_46_META_WS_E_FLOWER: "꽃",
  T_46_META_WS_E_FLYBOMBBEE: "플라잉 폭탄 벌",
  T_46_META_WS_E_FLYPAN: "프라이팬 메커니즘",
  T_46_META_WS_E_FLYSHOE: "플라이 슈즈",
  T_46_META_WS_E_FOLDER: "폴더",
  T_46_META_WS_E_FOLDWINGS: "접이식 날개",
  T_46_META_WS_E_FOODTRUCK: "음식 트럭",
  T_46_META_WS_E_FOODTRUCKB: "푸드트럭 B",
  T_46_META_WS_E_FOOTBALL: "축구",
  T_46_META_WS_E_FOOTBALLGUN: "축구 총",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "축구 총",
  T_46_META_WS_E_FORCE: "힘",
  T_46_META_WS_E_FOREGRIP_MR: "전방 손잡이 MR",
  T_46_META_WS_E_FOREGRIP1: "전방 손잡이1",
  T_46_META_WS_E_FOREGRIP2: "전방 손잡이2",
  T_46_META_WS_E_FOREGRIP3: "전방 손잡이3",
  T_46_META_WS_E_FORWARD: "앞으로",
  T_46_META_WS_E_FOUNTAIN: "분수",
  T_46_META_WS_E_FREE: "자유 카메라",
  T_46_META_WS_E_FREEZEALL: "전체 고정",
  T_46_META_WS_E_FREEZEPOSITION: "전체 축 고정",
  T_46_META_WS_E_FREEZEPOSITIONX: "X축 고정",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y축 고정",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z축 고정",
  T_46_META_WS_E_FREEZEROTATION: "전체 축 회전 고정",
  T_46_META_WS_E_FREEZEROTATIONX: "X축 회전 고정",
  T_46_META_WS_E_FREEZEROTATIONY: "Y축 회전 고정",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z축 회전 고정",
  T_46_META_WS_E_FREEZEZONE: "동결 지역",
  "T_46_META_WS_E_FROST GALAXY": "서리 은하",
  T_46_META_WS_E_FROZEN: "동결",
  T_46_META_WS_E_FROZENGRENADE: "냉각 수류탄",
  T_46_META_WS_E_FUNCTIONALITEMS: "기능성 아이템",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "게임",
  T_46_META_WS_E_GAMEOVER: "게임 오버 2",
  T_46_META_WS_E_GAMESTART: "게임 시작",
  T_46_META_WS_E_GARAGE: "차고",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "메커니즘 활성화",
  T_46_META_WS_E_GENTLETAP: "부드러운 탭",
  T_46_META_WS_E_GETITEM: "소비 아이템 2 얻기",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "유령",
  T_46_META_WS_E_GIANTDICE: "주사위",
  T_46_META_WS_E_GIANTLOLLIPOP: "거대한 막대사탕",
  T_46_META_WS_E_GIFT: "선물",
  T_46_META_WS_E_GLOOWALL: "젤 벽",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS 테마 꽃밭",
  T_46_META_WS_E_GRAFFITIWALL: "그래피티 벽",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "후크 건",
  T_46_META_WS_E_GREATCONDUCTOR: "위대한 지휘자",
  T_46_META_WS_E_GREEN: "녹색",
  T_46_META_WS_E_GRENADE: "수류탄",
  T_46_META_WS_E_GRID: "격자",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "감시탑",
  T_46_META_WS_E_GUILD: "길드",
  T_46_META_WS_E_GUN: "총기",
  T_46_META_WS_E_GUNFIRE: "총알",
  T_46_META_WS_E_HALO: "오라",
  T_46_META_WS_E_HAMMER: "거대 망치 메커니즘",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "건조대",
  T_46_META_WS_E_HARD: "어려움",
  T_46_META_WS_E_HATTRICK: "스킬 8",
  T_46_META_WS_E_HAYSTACK: "건초 더미",
  T_46_META_WS_E_HEAD: "머리 장식",
  T_46_META_WS_E_HEADSHOOT: "헤드샷",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "치유 총",
  T_46_META_WS_E_HEART: "심장",
  T_46_META_WS_E_HEARTBEAT: "심장 박동",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "중화기",
  T_46_META_WS_E_HELL: "매우 어렵다",
  T_46_META_WS_E_HELMET: "헬멧",
  T_46_META_WS_E_HELMET1: "헬멧1",
  T_46_META_WS_E_HELMET2: "헬멧2",
  T_46_META_WS_E_HELMET3: "헬멧3",
  T_46_META_WS_E_HEXAGON: "육각형",
  T_46_META_WS_E_HGAMMO: "HG 탄약",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "숨바꼭질 화염 방사기",
  T_46_META_WS_E_HIDERKILL: "숨어 있는 적 사살",
  T_46_META_WS_E_HIHATS: "하이햇",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "둔한 타격",
  T_46_META_WS_E_HITEFFECT: "총알 적중 VFX",
  T_46_META_WS_E_HITFEEDBACK: "사격 피드백",
  T_46_META_WS_E_HOOK: "갈고리",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "후크 건 탄약",
  T_46_META_WS_E_HORIZALINE: "호라이즌",
  T_46_META_WS_E_HORIZONTAL: "수평",
  T_46_META_WS_E_HORN: "스피커",
  T_46_META_WS_E_HORROR: "공포",
  T_46_META_WS_E_HOURGLASS: "모래시계",
  T_46_META_WS_E_HOUSE: "집",
  T_46_META_WS_E_HOUSEA: "단층 집",
  T_46_META_WS_E_HOUSEB: "2층 집",
  T_46_META_WS_E_HOUSEC: "삼층 집",
  T_46_META_WS_E_HP: "HP (체력)",
  T_46_META_WS_E_HPBUFF: "HP 버프",
  T_46_META_WS_E_HUT: "캐빈",
  T_46_META_WS_E_ICEA: "얼음 A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "얼음벽 제조기",
  T_46_META_WS_E_ICONOBJECT: "아이콘",
  T_46_META_WS_E_IMAGEWIDGET: "이미지 위젯",
  T_46_META_WS_E_IMPULSE: "임펄스",
  T_46_META_WS_E_INHALER: "흡입기",
  T_46_META_WS_E_INJUREDFEMALE: "여성 맞았을 때 비명",
  T_46_META_WS_E_INJUREDMALE: "남성 맞았을 때 비명",
  T_46_META_WS_E_INK: "잉크 VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "입력 레이블 위젯",
  T_46_META_WS_E_INSECTCHIRPING: "벌레 지저귀기",
  T_46_META_WS_E_INTERVAL10SECONDS: "10초",
  T_46_META_WS_E_INTERVAL15SECONDS: "15초",
  T_46_META_WS_E_INTERVAL30SECONDS: "30초",
  T_46_META_WS_E_INTERVAL3SECONDS: "3초",
  T_46_META_WS_E_INTERVAL5SECONDS: "5초",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999초",
  T_46_META_WS_E_INVISIBLE: "투명",
  T_46_META_WS_E_IPIPE: "I 파이프",
  T_46_META_WS_E_IRONFENCE: "울타리",
  T_46_META_WS_E_IRONFENCEB: "울타리 B",
  T_46_META_WS_E_IRONPLATFORM: "철제 플랫폼",
  T_46_META_WS_E_ITEMENTITY: "소모품 생성기",
  T_46_META_WS_E_JEEP: "지프",
  T_46_META_WS_E_JERRYCAN: "오일 드럼",
  T_46_META_WS_E_JERSEYMACHINE: "저지 기계",
  T_46_META_WS_E_JOINEDGAMEDULL: "전투 참여",
  T_46_META_WS_E_JOINGAME: "게임 참가",
  T_46_META_WS_E_JOYSTICKWIDGET: "조이스틱 위젯",
  T_46_META_WS_E_JUMP: "점프",
  T_46_META_WS_E_JUMPATTACK: "점프 공격",
  T_46_META_WS_E_JUSTPATROL: "단순 순찰",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "열쇠",
  T_46_META_WS_E_KICK: "킥",
  T_46_META_WS_E_KILLINGTIPS: "킬 팁",
  T_46_META_WS_E_KILLZONE: "사망 구역",
  T_46_META_WS_E_KINEMATIC: "운동학",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "쓰러짐",
  T_46_META_WS_E_KNOCKEDDOWN: "넘어짐",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "레이블 위젯",
  T_46_META_WS_E_LANDINGA: "계단 착륙 A",
  T_46_META_WS_E_LANDINGB: "계단 착륙 B",
  T_46_META_WS_E_LANDINGC: "계단 착륙 C",
  T_46_META_WS_E_LANDMINE: "지뢰",
  T_46_META_WS_E_LANUNCHERAMMO: "발사기 탄약",
  T_46_META_WS_E_LASER: "레이저 VFX",
  T_46_META_WS_E_LASERSKILL: "레이저 기술",
  T_46_META_WS_E_LATTICESCREEN: "화면",
  T_46_META_WS_E_LAWNA: "잔디 A",
  T_46_META_WS_E_LAWNB: "잔디 B",
  T_46_META_WS_E_LAYOUTWIDGET: "레이아웃 위젯",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "죽은 나무",
  T_46_META_WS_E_LEVELMAXED: "최대 레벨",
  T_46_META_WS_E_LEVELUP: "랭크 업",
  T_46_META_WS_E_LEVELUPDISCARDED: "랭크 업",
  T_46_META_WS_E_LIGHTBEAM: "광선",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "광선",
  T_46_META_WS_E_LIGHTEFFECT: "빛 효과",
  T_46_META_WS_E_LIGHTNING: "번개",
  T_46_META_WS_E_LIMB: "팔다리",
  T_46_META_WS_E_LINE: "선",
  T_46_META_WS_E_LIQUID: "액체",
  T_46_META_WS_E_LOCAL: "로컬",
  T_46_META_WS_E_LOCALPOSITION: "로컬 좌표",
  T_46_META_WS_E_LOCK: "자물쇠",
  T_46_META_WS_E_LONGBOX: "긴 나무 상자",
  T_46_META_WS_E_LOOP: "루프",
  T_46_META_WS_E_LOOTITEMBOX: "전리품 무기",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "전리품 탄약",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "전리품 방어구",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "전리품 소비재",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "전리품 던질 물건",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "전리품 조준경",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "얼음 수류탄",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "무작위 축구 루팅",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "축구 방패",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "랜덤 무기 루트",
  T_46_META_WS_E_LOSE: "패배",
  T_46_META_WS_E_LOUDSPEAKER: "스피커",
  T_46_META_WS_E_LOWFALLING: "낮은 낙하",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79 수류탄",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79 특수 수류탄",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "기관총",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "탄창1",
  T_46_META_WS_E_MAGEZINE2: "탄창2",
  T_46_META_WS_E_MAGEZINE3: "탄창3",
  T_46_META_WS_E_MAGMAA: "마그마 A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "확대경",
  T_46_META_WS_E_MALE: "남성",
  T_46_META_WS_E_MARK: "마크",
  T_46_META_WS_E_MARKER: "마크",
  T_46_META_WS_E_MASK: "얼굴 장식",
  T_46_META_WS_E_MAXVALUE: "최대값",
  T_46_META_WS_E_MECHANICAL: "빠른 딸깍 소리 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "기계 장치 에코",
  T_46_META_WS_E_MEDICALPROPS: "의료 도구",
  T_46_META_WS_E_MEDICALTENT: "의료 텐트",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "중간 심장 박동",
  T_46_META_WS_E_MEDKIT: "응급 처치 키트",
  T_46_META_WS_E_MELEE: "근접 전투",
  T_46_META_WS_E_MELEEWEAPONS: "근접 무기",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "마이크",
  T_46_META_WS_E_MIDDLE: "중간",
  T_46_META_WS_E_MINIHANDLE: "미니 손잡이",
  T_46_META_WS_E_MINIMAP: "미니 맵",
  T_46_META_WS_E_MINISENTRY: "미니 센트리",
  T_46_META_WS_E_MINVALUE: "최소값",
  T_46_META_WS_E_MISSILEEXPLODE: "미사일 타입 무기",
  T_46_META_WS_E_MISSIONCOMPLETE: "미션 성공 1",
  T_46_META_WS_E_MISTAKE: "실수",
  T_46_META_WS_E_MODERATE: "중간",
  T_46_META_WS_E_MONEY: "돈",
  T_46_META_WS_E_MONSTER: "몬스터",
  T_46_META_WS_E_MONSTERSPAWN: "몬스터 스폰 지점",
  T_46_META_WS_E_MONSTERTRUCK: "몬스터 트럭",
  T_46_META_WS_E_MOON: "달",
  T_46_META_WS_E_MOSQUITO: "모기",
  T_46_META_WS_E_MOTIONTRAIL: "추돌",
  T_46_META_WS_E_MOTOBIKE: "오토바이",
  T_46_META_WS_E_MOTORBIKE: "오토바이",
  T_46_META_WS_E_MOVE: "이동하다",
  T_46_META_WS_E_MOVEMENT: "이동",
  T_46_META_WS_E_MOVINGJOYSTICK: "이동 조이스틱",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "미스터 V",
  T_46_META_WS_E_MULTIPLIER: "승수",
  T_46_META_WS_E_MULTIPLY: "곱하다",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "곱하고 누적하기",
  T_46_META_WS_E_MUSHROOM1: "버섯1",
  T_46_META_WS_E_MUSHROOM2: "버섯2",
  T_46_META_WS_E_MUSHROOM3: "버섯3",
  T_46_META_WS_E_MUSHROOM4: "버섯4",
  T_46_META_WS_E_MUSHSHADE: "거대 버섯 군집",
  T_46_META_WS_E_MUSIC: "음악",
  T_46_META_WS_E_MUZZLE1: "소염기1",
  T_46_META_WS_E_MUZZLE2: "소염기2",
  T_46_META_WS_E_MUZZLE3: "소염기3",
  T_46_META_WS_E_NEAR: "가까이",
  T_46_META_WS_E_NIGHT: "밤",
  T_46_META_WS_E_NOATTACK: "공격 없음",
  T_46_META_WS_E_NODUALWIELDING: "이중 무기 사용 불가",
  T_46_META_WS_E_NOERROR: "오류 없음",
  T_46_META_WS_E_NONE: "없음",
  T_46_META_WS_E_NORMAL: "보통",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "넘어짐 건너뛰지 않기",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "스킬 7",
  T_46_META_WS_E_OBTAINEDCOINS: "중간 금 얻기",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "큰 금 얻기",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "작은 금 얻기",
  T_46_META_WS_E_OILDRUMEXPLODE: "기름통 폭발",
  T_46_META_WS_E_ONCE: "한 번",
  T_46_META_WS_E_ONEWAY: "단방향",
  T_46_META_WS_E_OPENFOLDER: "열린 폴더",
  T_46_META_WS_E_OPENHIHATS: "오픈 하이햇",
  T_46_META_WS_E_OPENINGBOX: "상자 열기",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "길드 보급",
  T_46_META_WS_E_OPENINGWARCHEST: "창고 저장",
  T_46_META_WS_E_ORANGE: "오렌지",
  T_46_META_WS_E_ORTHOGONAL: "직교",
  T_46_META_WS_E_OUTPOST: "경비실",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "칠해진 벽",
  T_46_META_WS_E_PAINTSHIELDSKILL: "혈흔 기술",
  T_46_META_WS_E_PALM: "종이",
  T_46_META_WS_E_PANEL: "패널",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "승객 A",
  T_46_META_WS_E_PASSENGERB: "승객 B",
  T_46_META_WS_E_PASSENGERC: "승객 C",
  T_46_META_WS_E_PASSIVE: "수동적",
  T_46_META_WS_E_PASSIVESKILL: "수동 기술",
  T_46_META_WS_E_PATROLWHILEATTACK: "공격하며 순찰",
  T_46_META_WS_E_PERSONALUAV: "개인 UAV",
  T_46_META_WS_E_PERSPECTIVE: "투시",
  T_46_META_WS_E_PETTABBG: "애완동물",
  T_46_META_WS_E_PHASESTART: "단계 시작",
  T_46_META_WS_E_PHONEBOOTH: "전화 부스",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "음악적 노트 - 피아노",
  T_46_META_WS_E_PIANOKEY2: "음악적 노트 - 피아노",
  T_46_META_WS_E_PICKUPS: "줍기",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "콘크리트 기둥",
  T_46_META_WS_E_PIN: "호출",
  T_46_META_WS_E_PINGPONG: "탁구",
  T_46_META_WS_E_PIPECORNER: "엘보 파이프",
  T_46_META_WS_E_PIPEINTERSECTION: "교차 파이프",
  T_46_META_WS_E_PISTOL: "권총",
  T_46_META_WS_E_PISTOLAMMO: "권총 탄약",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "체크무늬 놀이공원 블록",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "플레이어",
  T_46_META_WS_E_PLUS: "더하기",
  T_46_META_WS_E_PODIUM: "포디엄",
  T_46_META_WS_E_POISONGAS: "독가스",
  T_46_META_WS_E_POISONGASPREDISCARDED: "독가스",
  T_46_META_WS_E_PORTAL: "포탈",
  T_46_META_WS_E_POSTACCUMULATOR: "후속 누산기",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "빠른 심장 박동",
  T_46_META_WS_E_PREACCUMULATOR: "전-누산기",
  T_46_META_WS_E_PRIMARYWEAPONA: "주 무기 A",
  T_46_META_WS_E_PRIMARYWEAPONB: "주 무기 B",
  T_46_META_WS_E_PRIOREXPLOSION: "폭탄 폭발 전",
  T_46_META_WS_E_PROFILEWIDGET: "프로필 위젯",
  T_46_META_WS_E_PRONE: "엎드린",
  T_46_META_WS_E_PUMPKIN: "호박",
  T_46_META_WS_E_PURPLE: "보라색",
  T_46_META_WS_E_QUADRILATERAL: "사각형",
  T_46_META_WS_E_QUESTIONMARK: "물음표",
  T_46_META_WS_E_QUICKCHAT: "빠른 채팅",
  T_46_META_WS_E_QUICKCHATSHOW: "빠른 채팅 표시",
  T_46_META_WS_E_RADIAL180: "방사형 180도",
  T_46_META_WS_E_RADIAL360: "방사형 360도",
  T_46_META_WS_E_RADIAL90: "방사형 90도",
  T_46_META_WS_E_RAMPAGE: "광란",
  T_46_META_WS_E_RANDOM: "무작위",
  T_46_META_WS_E_RANDOMBUFF: "랜덤 버프",
  T_46_META_WS_E_RANKDOWN: "랭크 다운",
  T_46_META_WS_E_REACTION: "응답",
  T_46_META_WS_E_RECOVER: "회복",
  T_46_META_WS_E_RECYCLE: "재활용",
  T_46_META_WS_E_RED: "빨간색",
  T_46_META_WS_E_REFINERYTANK: "물병",
  T_46_META_WS_E_REFLECTIVECUBE: "반사 솔리드 컬러 블록 1",
  T_46_META_WS_E_REFRESH: "새로 고침",
  T_46_META_WS_E_RELEASINGSKILL: "스킬 캐스트 VFX",
  T_46_META_WS_E_RELOAD: "재장전",
  T_46_META_WS_E_REMINDER: "알림",
  T_46_META_WS_E_REPAIR: "수리",
  T_46_META_WS_E_REPAIREQUIP: "장비 수리",
  T_46_META_WS_E_REPAIRKIT: "수리 키트",
  T_46_META_WS_E_REPLACER: "교체기",
  T_46_META_WS_E_REPORT: "신고",
  T_46_META_WS_E_REST: "휴식",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "라이드",
  T_46_META_WS_E_RIDICULE: "조롱",
  T_46_META_WS_E_RIDICULEFUNNY: "재미있는 조롱",
  T_46_META_WS_E_RIFLE: "소총",
  T_46_META_WS_E_RIFLEAMMO: "소총 탄약",
  T_46_META_WS_E_RIGHT: "맞음",
  T_46_META_WS_E_RIGHTTRAPEZOID: "직각 사다리꼴",
  T_46_META_WS_E_RING: "링 메커니즘",
  T_46_META_WS_E_RINGPREDISCARDED: "링",
  T_46_META_WS_E_RIPTIDERHYTHM: "스킬 9",
  T_46_META_WS_E_RISINGPARTICLE: "상승 입자",
  T_46_META_WS_E_ROADBLOCK: "바리케이드",
  T_46_META_WS_E_ROTATE: "회전",
  T_46_META_WS_E_RUNNING: "실행 중",
  T_46_META_WS_E_RUSHTIME: "광란",
  T_46_META_WS_E_SAMURAI: "사무라이",
  T_46_META_WS_E_SANDA: "모래 A",
  T_46_META_WS_E_SANDSTRUCTURE: "모래 조각",
  T_46_META_WS_E_SCALE: "스케일",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "허수아비",
  T_46_META_WS_E_SCISSORS: "가위",
  T_46_META_WS_E_SCOPE2X: "2배 조준경",
  T_46_META_WS_E_SCOPE4X: "4배 조준경",
  T_46_META_WS_E_SCROLLPANEL: "스크롤 패널",
  T_46_META_WS_E_SECONDARYWEAPON: "보조 무기",
  T_46_META_WS_E_SENSESSHOCKWAVE: "스킬 10",
  T_46_META_WS_E_SERVER: "서버",
  T_46_META_WS_E_SET: "바디수트",
  T_46_META_WS_E_SETTING: "설정",
  T_46_META_WS_E_SETTINGS: "설정",
  T_46_META_WS_E_SG: "산탄총",
  T_46_META_WS_E_SGAMMO: "SN 탄약",
  T_46_META_WS_E_SHARPMECHANICAL: "빠른 딸깍 소리 1",
  T_46_META_WS_E_SHIELD: "방어",
  T_46_META_WS_E_SHIELDBROKEN: "방패 파괴",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "방패 올리기",
  T_46_META_WS_E_SHOCKWAVE: "충격파",
  T_46_META_WS_E_SHOES: "신발",
  T_46_META_WS_E_SHOOTINGTARGET: "이동 표적",
  T_46_META_WS_E_SHORTDATE: "짧은 날짜",
  T_46_META_WS_E_SHORTDATETIME: "짧은 날짜 및 시간",
  T_46_META_WS_E_SHORTTIME: "짧은 시간",
  T_46_META_WS_E_SHOTGUN: "산탄총",
  T_46_META_WS_E_SHOTGUNAMMO: "샷건 탄약",
  T_46_META_WS_E_SHOTGUNMUZZLE: "샷건 소염기",
  T_46_META_WS_E_SHOW: "표시",
  T_46_META_WS_E_SHRUB: "덤불로 덮인 긴 나무 상자",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "횡스크롤 카메라",
  T_46_META_WS_E_SIGNAL: "신호",
  T_46_META_WS_E_SIGNOUT: "종료",
  T_46_META_WS_E_SILENCER: "소음기",
  T_46_META_WS_E_SIMPLE: "간단한",
  T_46_META_WS_E_SIMPLEWIDGET: "간단한 위젯",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "단발",
  T_46_META_WS_E_SITEHUT: "컨테이너 하우스",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "기술 충전 완료",
  T_46_META_WS_E_SKILLRECOVER: "기술 회복",
  T_46_META_WS_E_SKIPKNOCKDOWN: "넘어짐 건너뛰기",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "슬라이스",
  T_46_META_WS_E_SLOPE: "경사",
  T_46_META_WS_E_SLOWHEARTBEAT: "느린 심장 박동",
  T_46_META_WS_E_SMG: "기관단총",
  T_46_META_WS_E_SMGAMMO: "SMG 탄약",
  T_46_META_WS_E_SMGMUZZLE: "SMG 소염기",
  T_46_META_WS_E_SMILEY: "웃는 얼굴",
  T_46_META_WS_E_SMOKE: "연기",
  T_46_META_WS_E_SMOKEGRENADE: "연막탄",
  T_46_META_WS_E_SMOKEY: "연기",
  T_46_META_WS_E_SMOOTH: "부드럽게",
  T_46_META_WS_E_SNAMMO: "SN 탄약",
  T_46_META_WS_E_SNARES: "스네어",
  T_46_META_WS_E_SNEAKERS: "러닝화 VFX",
  T_46_META_WS_E_SNIPER: "저격총",
  T_46_META_WS_E_SNIPERAMMO: "저격총 탄약",
  T_46_META_WS_E_SNOWA: "눈 A",
  T_46_META_WS_E_SNOWFLAKE: "눈송이",
  T_46_META_WS_E_SOCCER: "축구",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "소셜 버튼 위젯",
  T_46_META_WS_E_SOLARPANEL: "태양광 패널",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "우선순위 높은 순으로",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "우선순위 낮은 순으로",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "생성 지점 VFX",
  T_46_META_WS_E_SPEAKER: "스피커",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "특수 총 소리",
  T_46_META_WS_E_SPECIALGUN: "특수 총기",
  T_46_META_WS_E_SPHERE: "구",
  T_46_META_WS_E_SPHERETRIGGER: "구형 충돌 트리거",
  T_46_META_WS_E_SPIDERWEB: "스킬 VFX",
  T_46_META_WS_E_SPORTSCAR: "스포츠카",
  T_46_META_WS_E_SPOTLIGHT: "빛",
  T_46_META_WS_E_SPREADOFPOISONGAS: "독가스 확산",
  T_46_META_WS_E_SPRINT: "대시",
  T_46_META_WS_E_SQUARE: "정사각형",
  T_46_META_WS_E_SQUAREBOX: "정사각형 나무 상자",
  T_46_META_WS_E_SR: "저격소총",
  T_46_META_WS_E_STABLE: "초가지붕 오두막",
  T_46_META_WS_E_STAIRS: "계단",
  T_46_META_WS_E_STANDING: "서 있는",
  T_46_META_WS_E_STAR: "별",
  T_46_META_WS_E_STATIC: "정적",
  T_46_META_WS_E_STATUSTRIGGER: "사망 또는 무적 트리거",
  T_46_META_WS_E_STEP: "발자국",
  T_46_META_WS_E_STEPTRIGGER: "메커니즘 활성화",
  T_46_META_WS_E_STOCK_S: "스톡 S",
  T_46_META_WS_E_STOCK_SR: "스톡 SR",
  T_46_META_WS_E_STOCK1: "스톡1",
  T_46_META_WS_E_STOCK2: "스톡2",
  T_46_META_WS_E_STOCK3: "스톡3",
  T_46_META_WS_E_STONE: "바위",
  T_46_META_WS_E_STONEBRIDGE: "석조 아치 다리",
  T_46_META_WS_E_STONELANTERN: "궁전 등불",
  T_46_META_WS_E_STONESPLASH: "날아다니는 파편",
  T_46_META_WS_E_STORE: "상점",
  T_46_META_WS_E_STREETLAMP: "가로등",
  T_46_META_WS_E_STYLEA: "스타일 A",
  T_46_META_WS_E_STYLEB: "스타일 B",
  T_46_META_WS_E_STYLEC: "스타일 C",
  T_46_META_WS_E_SUBMACHINEGUN: "기관단총",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "SMG 탄약",
  T_46_META_WS_E_SUCCESSFULHIT: "히트",
  T_46_META_WS_E_SUN: "태양",
  T_46_META_WS_E_SUNSHADE: "파라솔이 있는 파티오 세트",
  T_46_META_WS_E_SUPERCAR: "스포츠카",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "놀라움 발견",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "빠른 무기 교체",
  T_46_META_WS_E_SWIMRING: "수영 링",
  T_46_META_WS_E_SWORD: "검",
  T_46_META_WS_E_SYMBOLIC: "바닥 마커",
  T_46_META_WS_E_TANKZOMBIE: "탱크 좀비",
  T_46_META_WS_E_TAP: "탭",
  T_46_META_WS_E_TAPPINGBUTTON: "버튼 탭",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "비활성화 버튼 탭",
  T_46_META_WS_E_TEAM: "팀",
  T_46_META_WS_E_TEAMMATESINFO: "팀원 정보",
  T_46_META_WS_E_TELEPORT: "텔레포트",
  T_46_META_WS_E_TELEPORTCORRECT: "올바른 목적지 신호",
  T_46_META_WS_E_TELEPORTWRONG: "잘못된 목적지 신호",
  T_46_META_WS_E_TEXT: "텍스트",
  T_46_META_WS_E_TEXTOBJECT: "텍스트",
  T_46_META_WS_E_TEXTUREWIDGET: "텍스처 위젯",
  T_46_META_WS_E_THERMALSCOPE: "열화상 조준경",
  T_46_META_WS_E_THIRDPERSON: "3인칭 카메라",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "3인칭 카메라 (클래식)",
  T_46_META_WS_E_THIRDPERSONLOCK: "3인칭 고정 카메라",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "호환성을 위한 투척 나이프2",
  T_46_META_WS_E_THRILLBATTLE: "스킬 5",
  T_46_META_WS_E_THROWATTACK: "수류탄 던지기",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "빨간 투척 좀비",
  T_46_META_WS_E_THROWZOMBIE: "투척 좀비",
  T_46_META_WS_E_THUMBSUP: "좋아요",
  T_46_META_WS_E_THUNDER: "전기 충격",
  T_46_META_WS_E_TILEA: "타일 A",
  T_46_META_WS_E_TILEB: "타일 B",
  T_46_META_WS_E_TILEC: "타일 C",
  T_46_META_WS_E_TILED: "타일",
  T_46_META_WS_E_TIPSSOUND: "팁 표시",
  T_46_META_WS_E_TOGGLEWIDGET: "토글 위젯",
  T_46_META_WS_E_TOILETBOWL: "변기",
  T_46_META_WS_E_TONEA: "돌 A",
  T_46_META_WS_E_TOP: "상의",
  T_46_META_WS_E_TOPDOWN: "탑다운 카메라",
  T_46_META_WS_E_TORII: "도리이",
  T_46_META_WS_E_TOUCHPADWIDGET: "터치 패드 위젯",
  T_46_META_WS_E_TOWER: "요새",
  T_46_META_WS_E_TPIPE: "T 파이프",
  T_46_META_WS_E_TRACINGSTEPS: "스킬 3",
  T_46_META_WS_E_TRAILER: "트레일러",
  T_46_META_WS_E_TRANSFORMATION: "모습 변경",
  T_46_META_WS_E_TRANSPARENT: "투명",
  T_46_META_WS_E_TRAPEZOID: "사다리꼴",
  T_46_META_WS_E_TRASHCAN: "쓰레기통",
  T_46_META_WS_E_TRIANGLE: "삼각형",
  T_46_META_WS_E_TRIGGERS: "트리거",
  T_46_META_WS_E_TRIPLE: "3점사",
  T_46_META_WS_E_TROPHY: "트로피",
  T_46_META_WS_E_TRUE: "예",
  T_46_META_WS_E_TUKTUK: "뚝뚝",
  T_46_META_WS_E_TUTUCAR: "틱틱",
  T_46_META_WS_E_TYRANTZOMBIE: "폭군 좀비",
  T_46_META_WS_E_UAVLITE: "경량 UAV",
  T_46_META_WS_E_UIFINISH: "종료",
  T_46_META_WS_E_UITAP: "UI 탭",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "유닛 생성기",
  T_46_META_WS_E_UPWARDTURBULENCE: "상승 기류",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "넘어서기",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "차량",
  T_46_META_WS_E_VEHICLEEXPLODE: "차량 폭발",
  T_46_META_WS_E_VELOCITY: "속도",
  T_46_META_WS_E_VENDINGMACHINE: "자판기",
  T_46_META_WS_E_VERTICAL: "수직",
  T_46_META_WS_E_VEST: "방탄조끼",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "방탄조끼4",
  T_46_META_WS_E_VISUALEFFECTS: "시각 효과",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "벽 A",
  T_46_META_WS_E_WALLBRAWL: "스킬 2",
  T_46_META_WS_E_WARNING: "경고",
  T_46_META_WS_E_WATERRING: "물 튐",
  T_46_META_WS_E_WAVE1: "웨이브1",
  T_46_META_WS_E_WAVE2: "웨이브2",
  T_46_META_WS_E_WAVE3: "웨이브3",
  T_46_META_WS_E_WEAPONGENERATOR: "무기",
  T_46_META_WS_E_WEAPONSLOT: "무기 슬롯",
  T_46_META_WS_E_WHISTLE: "적 처치",
  T_46_META_WS_E_WIDERANGE: "넓은 범위",
  T_46_META_WS_E_WIN: "승리",
  T_46_META_WS_E_WINDATTACK: "바람 공격",
  T_46_META_WS_E_WOODA: "나무 A",
  T_46_META_WS_E_WOODCUTZOMBIE: "나무 자르는 좀비",
  T_46_META_WS_E_WOODENPLANK: "판자 다리",
  T_46_META_WS_E_WORLDPOSITION: "월드 좌표",
  T_46_META_WS_E_WRECKEDBUS: "폐버스",
  T_46_META_WS_E_WRECKEDCAR: "폐차",
  T_46_META_WS_E_WRONG: "틀림",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "좀비",
  T_46_META_WS_E_ZOMBIES: "좀비",
  T_46_META_WS_E_ZOOM: "줌",
  T_46_META_WS_ELIMINATE: "제거",
  T_46_META_WS_ELIMINATEDENTITY: "제거된 엔터티",
  T_46_META_WS_ELIMINATEDPLAYER: "제거된 플레이어",
  T_46_META_WS_ENABLEDEFAULTBTREE: "기본 행동 트리 활성화",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "이동하는 안전 구역 활성화",
  T_46_META_WS_ENABLESAFEZONE: "안전 구역 활성화",
  T_46_META_WS_ENDCURRENTPHASE: "현재 단계 종료",
  T_46_META_WS_ENDMORPH: "변형 종료",
  T_46_META_WS_ENDPOSITION: "종료 위치",
  T_46_META_WS_ENTERVEHICLE: "차량 탑승",
  T_46_META_WS_ENTITY: "엔터티",
  T_46_META_WS_EQUIPMENTID: "장비 ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "오일러 각도를 쿼터니언으로 변환",
  T_46_META_WS_EXITVEHICLE: "차량 하차",
  T_46_META_WS_EXPONENTIATION: "지수 함수",
  T_46_META_WS_FILTERENTITY: "엔티티 필터링",
  T_46_META_WS_FILTERLEVELOBJECTS: "레벨 오브젝트 필터링",
  T_46_META_WS_FIND: "찾기",
  T_46_META_WS_FINDAT: "찾기 위치",
  T_46_META_WS_FINDPATH: "경로 찾기",
  T_46_META_WS_FLOOR: "내림",
  T_46_META_WS_FOOTBALLGOAL: "축구 골",
  T_46_META_WS_FORMAT: "형식",
  T_46_META_WS_GETALLKEYS: "모든 키 가져오기",
  T_46_META_WS_GETALLPLAYERS: "모든 플레이어 가져오기",
  T_46_META_WS_GETALLSHOPS: "모든 상점 가져오기",
  T_46_META_WS_GETALLTEAMS: "모든 팀 가져오기",
  T_46_META_WS_GETATTACKABLEENTITY: "공격 가능한 엔티티 가져오기",
  T_46_META_WS_GETATTACKABLEFACTIONS: "공격 가능한 진영 가져오기",
  T_46_META_WS_GETBACKPACKSKIN: "배낭 스킨 가져오기",
  T_46_META_WS_GETBLACKBOARDVALUE: "블랙보드 값 가져오기",
  T_46_META_WS_GETBUFFS: "버프 가져오기",
  T_46_META_WS_GETCHATCHANNEL: "채팅 채널 가져오기",
  T_46_META_WS_GETCHILDBYINDEX: "인덱스로 자식 가져오기",
  T_46_META_WS_GETCHILDBYNAME: "이름으로 자식 가져오기",
  T_46_META_WS_GETCHILDREN: "자식 모두 가져오기",
  T_46_META_WS_GETCOLORCHANNEL: "색상 채널 가져오기",
  T_46_META_WS_GETCONSUMABLES: "소모품 가져오기",
  T_46_META_WS_GETCULLINGMASK: "컬링 마스크 가져오기",
  T_46_META_WS_GETCURRENTCAMERA: "현재 카메라 가져오기",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "현재 채팅 채널 가져오기",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "사용자 지정 미션 진행 상황 가져오기",
  T_46_META_WS_GETDYEDCOUNT: "염색 개수 가져오기",
  T_46_META_WS_GETDYEDSTATUS: "염색 상태 가져오기",
  T_46_META_WS_GETEQUIPMENTS: "장비 가져오기",
  T_46_META_WS_GETFACTION: "진영 가져오기",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "전역 수면 임계값 가져오기",
  T_46_META_WS_GETITEMCOUNT: "아이템 수 가져오기",
  T_46_META_WS_GETLOADEDSCENES: "로드된 씬 가져오기",
  T_46_META_WS_GETLOCALAIMDIRECTION: "로컬 조준 방향 가져오기",
  T_46_META_WS_GETLOCALPLAYER: "로컬 플레이어 가져오기",
  T_46_META_WS_GETLOCALTIMESTAMP: "로컬 타임스탬프 가져오기",
  T_46_META_WS_GETMAPID: "맵 ID 가져오기",
  T_46_META_WS_GETMINIMAP: "미니맵 가져오기",
  T_46_META_WS_GETMONEY: "돈 가져오기",
  T_46_META_WS_GETMONEYCOUNT: "돈 수량 가져오기",
  T_46_META_WS_GETMORPH: "변형 가져오기",
  T_46_META_WS_GETNODEVARIABLE: "노드 변수 가져오기",
  T_46_META_WS_GETOUTFIT: "의상 가져오기",
  T_46_META_WS_GETOWNER: "소유자 가져오기",
  T_46_META_WS_GETPARENT: "부모 가져오기",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "팀원의 근처 위치 가져오기",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "랜덤 스폰 위치 가져오기",
  T_46_META_WS_GETRESULTFROMCURVE: "곡선에서 결과 가져오기",
  T_46_META_WS_GETSCENESKYBOX: "씬의 하늘박스 가져오기",
  T_46_META_WS_GETSERVERREGION: "서버 지역 가져오기",
  T_46_META_WS_GETSERVERTIMESTAMP: "서버 타임스탬프 가져오기",
  T_46_META_WS_GETSKELETONPARTBYNAME: "뼈대 부위 이름으로 가져오기",
  T_46_META_WS_GETSKILLS: "스킬 가져오기",
  T_46_META_WS_GETSLEEPTHRESHOLD: "수면 임계값 가져오기",
  T_46_META_WS_GETTOKENCOUNT: "토큰 수 가져오기",
  T_46_META_WS_GETTOKENCOUNTTODAY: "오늘의 토큰 수 가져오기",
  T_46_META_WS_GETTYPE: "유형 가져오기",
  T_46_META_WS_GETVEHICLESKIN: "차량 스킨 가져오기",
  T_46_META_WS_GETWALLET: "지갑 가져오기",
  T_46_META_WS_GETWEAPONSKIN: "무기 스킨 가져오기",
  T_46_META_WS_GETWIDGETBYPATH: "경로로 위젯 가져오기",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "사용자 정의 UI에서 위젯 가져오기",
  T_46_META_WS_GIVEJAILBREAKITEM: "탈옥 아이템 제공",
  T_46_META_WS_GIVEJAILBREAKREWARD: "탈옥 보상 제공",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI 특수 팔로우 여부 확인",
  T_46_META_WS_HASCOMPONENT: "컴포넌트 존재 여부",
  T_46_META_WS_HASSCRIPT: "스크립트 존재 여부",
  T_46_META_WS_HASTAG: "태그 존재 여부",
  T_46_META_WS_HELPEDPLAYER: "도움받은 플레이어",
  T_46_META_WS_HELPPLAYER: "도움 플레이어",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "외형 그룹 숨기기",
  T_46_META_WS_HITENTITY: "타격된 엔터티",
  T_46_META_WS_HITFLY: "날리기",
  T_46_META_WS_HITNORMAL: "타격 법선",
  T_46_META_WS_HITOBJECT: "타격된 객체",
  T_46_META_WS_HITPOSITION: "타격 위치",
  T_46_META_WS_INDEXOF: "요소의 첫 번째 발생 위치 가져오기",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "감염 좀비 성장",
  T_46_META_WS_INSERT: "삽입",
  T_46_META_WS_ISATTACKABLE: "공격 가능 여부",
  T_46_META_WS_ISCHATCHANNELEMPTY: "채팅 채널 비어 있는지 확인",
  T_46_META_WS_ISEQUAL: "동일 여부",
  T_46_META_WS_ISFRIEND: "친구 여부 확인",
  T_46_META_WS_ISHIT: "타격 여부",
  T_46_META_WS_ISINSIDEBOX: "상자 내에 있는지 확인",
  T_46_META_WS_ISINSIDECYLINDER: "원통 내에 있는지 확인",
  T_46_META_WS_ISINSIDESECTOR: "섹터 내에 있는지 확인",
  T_46_META_WS_ISINSIDESPHERE: "구체 내에 있는지 확인",
  T_46_META_WS_ISSLEEPING: "잠자기 상태 확인",
  T_46_META_WS_ISSUBTYPEOF: "하위 유형",
  T_46_META_WS_ITEM: "엔터티",
  T_46_META_WS_ITEMID: "아이템 ID",
  T_46_META_WS_JOIN: "결합",
  T_46_META_WS_JOINCHATCHANNEL: "채팅 채널 참여",
  T_46_META_WS_JOINFACTION: "진영 가입",
  T_46_META_WS_LASTINDEXOF: "요소의 마지막 발생 위치 가져오기",
  T_46_META_WS_LENGTH: "길이",
  T_46_META_WS_LERP: "보간",
  T_46_META_WS_LOADSCENE: "씬 로드",
  T_46_META_WS_LOGARITHM: "로그 함수",
  T_46_META_WS_LOGERROR: "오류 로그",
  T_46_META_WS_LOGINFO: "정보 로그",
  T_46_META_WS_LOGWARNING: "경고 로그",
  T_46_META_WS_LOOKROTATION: "회전 방향 보기",
  T_46_META_WS_MAGNITUDE: "크기",
  T_46_META_WS_MAKER: "제작자",
  T_46_META_WS_MAX: "최대",
  T_46_META_WS_MECHANISM: "메커니즘",
  T_46_META_WS_MIN: "최소",
  T_46_META_WS_MONSTERUSESKILL: "스킬 사용",
  T_46_META_WS_MORPHOBJECT: "변형 객체",
  T_46_META_WS_MORPHTO: "변형",
  T_46_META_WS_MORPHTOBYITEMID: "아이템 ID로 변형",
  T_46_META_WS_MOVECCT: "CCT 이동",
  T_46_META_WS_MOVEPOSITION: "위치 이동",
  T_46_META_WS_MOVEROTATION: "회전 이동",
  T_46_META_WS_MULTIPLYQUATERNION: "쿼터니언 곱하기",
  T_46_META_WS_MULTIRAYCAST: "다중 레이캐스트",
  T_46_META_WS_NEGATE: "음수",
  T_46_META_WS_NEW: "새로 만들기",
  T_46_META_WS_NODENAME: "노드 이름",
  T_46_META_WS_NORMALIZE: "정규화",
  T_46_META_WS_NOTIFYPLAYEFFECT: "효과 재생 알림",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "아이콘 애니메이션 재생 알림",
  T_46_META_WS_NOTIFYPLAYSOUND: "소리 재생 알림",
  T_46_META_WS_NOTIFYSHOWTIPS: "팁 표시 알림",
  T_46_META_WS_NUMTOSTRING: "숫자를 문자열로 변환",
  T_46_META_WS_ONACCESSEQUIPMENT: "장비 접근",
  T_46_META_WS_ONACCESSITEM: "아이템 접근",
  T_46_META_WS_ONACCESSWEAPON: "무기 접근",
  T_46_META_WS_ONACE: "ACE 달성",
  T_46_META_WS_ONAIMED: "조준 완료",
  T_46_META_WS_ONAIMING: "조준",
  T_46_META_WS_ONASSIST: "지원",
  T_46_META_WS_ONATTACK: "공격",
  T_46_META_WS_ONATTACKSTOP: "공격 중지",
  T_46_META_WS_ONAWAKE: "깨움",
  T_46_META_WS_ONBEKNOCKEDDOWN: "쓰러짐",
  T_46_META_WS_ONBOUNCEDBYTIRE: "타이어에 의해 튕김",
  T_46_META_WS_ONBOUNCEENTITY: "엔티티 튕김",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "내장 UI 버튼 터치됨",
  T_46_META_WS_ONBULLETHIT: "총알 맞음",
  T_46_META_WS_ONCAMERARAYCAST: "카메라 레이캐스트",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "캐릭터 컨트롤러가 맞음",
  T_46_META_WS_ONCHASE: "추격",
  T_46_META_WS_ONCHASESTOP: "추격 중지",
  T_46_META_WS_ONCLIPEND: "클립 종료",
  T_46_META_WS_ONCOLLISIONENTER: "충돌 시작",
  T_46_META_WS_ONCOLLISIONEXIT: "충돌 종료",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "카운트다운 완료",
  T_46_META_WS_ONCREEP: "은신",
  T_46_META_WS_ONCROUCH: "앉기",
  T_46_META_WS_ONDEALDAMAGE: "피해를 줌",
  T_46_META_WS_ONDESTROY: "파괴",
  T_46_META_WS_ONDISABLE: "비활성화",
  T_46_META_WS_ONDISCONNECT: "연결 끊김",
  T_46_META_WS_ONDOUBLETAPPED: "더블 터치됨",
  T_46_META_WS_ONDRAG: "드래그",
  T_46_META_WS_ONDRAGEND: "드래그 종료",
  T_46_META_WS_ONDRAGSTART: "드래그 시작",
  T_46_META_WS_ONDRIVED: "운전됨",
  T_46_META_WS_ONDRIVEVEHICLE: "차량 운전",
  T_46_META_WS_ONDROPCONSUMABLE: "소모품 버림",
  T_46_META_WS_ONDROPPED: "버림",
  T_46_META_WS_ONDROPWEAPON: "무기 버림",
  T_46_META_WS_ONEACHLOOP: "각 루프",
  T_46_META_WS_ONELIMINATE: "제거",
  T_46_META_WS_ONELIMINATED: "제거됨",
  T_46_META_WS_ONENABLE: "활성화",
  T_46_META_WS_ONEND: "종료",
  T_46_META_WS_ONENTERED: "진입함",
  T_46_META_WS_ONENTERVEHICLE: "차량 탑승",
  T_46_META_WS_ONENTITYENTER: "엔티티가 진입함",
  T_46_META_WS_ONENTITYEXIT: "엔티티가 나감",
  T_46_META_WS_ONEQUIPARMOR: "방어구 장착",
  T_46_META_WS_ONEQUIPED: "장착됨",
  T_46_META_WS_ONEQUIPWEAPON: "무기 장착",
  T_46_META_WS_ONEXPLODE: "폭발",
  T_46_META_WS_ONFALL: "낙하 중",
  T_46_META_WS_ONFALLSTOP: "낙하 종료 시",
  T_46_META_WS_ONFIRE: "발사",
  T_46_META_WS_ONFIXEDUPDATE: "고정 업데이트",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "축구와 충돌함",
  T_46_META_WS_ONFRIENDSUPDATE: "친구 상태 업데이트 ",
  T_46_META_WS_ONGAMEEND: "게임 종료",
  T_46_META_WS_ONGAMEPAUSE: "게임 일시 정지",
  T_46_META_WS_ONGAMERESUME: "게임 재개",
  T_46_META_WS_ONGAMESTART: "게임 시작",
  T_46_META_WS_ONGOAL: "골",
  T_46_META_WS_ONHITBYBULLET: "총알에 맞음",
  T_46_META_WS_ONHITFLY: "비행 맞음",
  T_46_META_WS_ONHITFLYENTITY: "날아가는 엔티티 맞음",
  T_46_META_WS_ONHOOKGUNFIRE: "후크 건 발사",
  T_46_META_WS_ONIDLE: "대기",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "감옥 탈출 구역 시작",
  T_46_META_WS_ONJAILBREAKAREAEND: "감옥 탈출 구역 종료",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "감옥 탈출 플레이어 참가",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "감옥 탈출 플레이어 종료",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "채팅 채널에 성공적으로 참가",
  T_46_META_WS_ONJOYSTICKMOVE: "조이스틱 이동",
  T_46_META_WS_ONJOYSTICKPRESSED: "눌림",
  T_46_META_WS_ONJOYSTICKRELEASED: "놓음",
  T_46_META_WS_ONJUMP: "점프",
  T_46_META_WS_ONJUMPSTOP: "점프 종료 시",
  T_46_META_WS_ONLANDMINEACTIVE: "지뢰 활성화",
  T_46_META_WS_ONLANDMINETRIGGER: "지뢰 트리거",
  T_46_META_WS_ONLEAVECHATCHANNEL: "채팅 채널 나감",
  T_46_META_WS_ONLEAVEVEHICLE: "차량 하차",
  T_46_META_WS_ONLEFT: "나감",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "레벨 오브젝트 변환",
  T_46_META_WS_ONMOVE: "이동",
  T_46_META_WS_ONNODEENTER: "노드 진입",
  T_46_META_WS_ONNODEEXIT: "노드 나감",
  T_46_META_WS_ONPAUSE: "일시 정지",
  T_46_META_WS_ONPHASEEND: "단계 종료",
  T_46_META_WS_ONPHASESTART: "단계 시작",
  T_46_META_WS_ONPICKEDUP: "주움",
  T_46_META_WS_ONPLAYERASSIST: "플레이어 지원",
  T_46_META_WS_ONPLAYERBEELIMINATED: "플레이어가 제거됨",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "플레이어가 쓰러짐",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "플레이어가 피해를 줌",
  T_46_META_WS_ONPLAYERELIMINATE: "플레이어가 제거함",
  T_46_META_WS_ONPLAYERENTER: "플레이어가 진입함",
  T_46_META_WS_ONPLAYERJOIN: "플레이어 참가",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "채팅 채널 참가 실패",
  T_46_META_WS_ONPLAYERLEAVE: "플레이어가 나감",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "플레이어가 구매 요청",
  T_46_META_WS_ONPLAYERQUIT: "플레이어 종료",
  T_46_META_WS_ONPLAYERRANKCHANGE: "플레이어 순위 변경",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "플레이어 구매 요청 완료",
  T_46_META_WS_ONPLAYERREVIVED: "플레이어가 부활함",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "플레이어가 스폰 지점에서 부활함",
  T_46_META_WS_ONPLAYERSCORECHANGE: "플레이어 점수 변경",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "플레이어가 장면 전환",
  T_46_META_WS_ONPREDEALDAMAGE: "피해를 주기 전",
  T_46_META_WS_ONPREPURCHASE: "구매 전",
  T_46_META_WS_ONPRESSED: "눌림",
  T_46_META_WS_ONPRETAKEDAMAGE: "피해를 입기 전",
  T_46_META_WS_ONPURCHASE: "구매",
  T_46_META_WS_ONRANKCHANGED: "엔티티 순위 변경",
  T_46_META_WS_ONRECONNECT: "재연결",
  T_46_META_WS_ONRELEASED: "놓음",
  T_46_META_WS_ONRELOAD: "재장전",
  T_46_META_WS_ONRESUME: "재개",
  T_46_META_WS_ONREVIVED: "부활함",
  T_46_META_WS_ONROUNDEND: "라운드 종료",
  T_46_META_WS_ONROUNDSTART: "라운드 시작",
  T_46_META_WS_ONSCENELOAD: "장면 로드",
  T_46_META_WS_ONSCENESWITCH: "장면 전환",
  T_46_META_WS_ONSCORECHANGE: "엔티티 점수 변경",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "축구 슈터에 의해 맞음",
  T_46_META_WS_ONSLEEP: "수면",
  T_46_META_WS_ONSPAWN: "스폰됨",
  T_46_META_WS_ONSPRAY: "분사",
  T_46_META_WS_ONSPRAYED: "분사됨",
  T_46_META_WS_ONSPRINT: "스프린트",
  T_46_META_WS_ONSPRINTSTOP: "스프린트 중지",
  T_46_META_WS_ONSTANDUP: "일어섬",
  T_46_META_WS_ONSTART: "시작",
  T_46_META_WS_ONSTARTFIRE: "공격",
  T_46_META_WS_ONSTATEEND: "상태 종료",
  T_46_META_WS_ONSURFING: "서핑",
  T_46_META_WS_ONSURFINGSTOP: "서핑 중지",
  T_46_META_WS_ONSWITCHHANDHELD: "휴대 장비 변경",
  T_46_META_WS_ONTAKEDAMAGE: "피해를 입음",
  T_46_META_WS_ONTAPPED: "터치됨",
  T_46_META_WS_ONTEAMACE: "팀 전멸",
  T_46_META_WS_ONTEAMADD: "팀 추가",
  T_46_META_WS_ONTEAMREMOVE: "팀 제거",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "팀 라운드 순위 변경",
  T_46_META_WS_ONTEAMSCORECHANGE: "팀 점수 변경",
  T_46_META_WS_ONTELEPORTENTITY: "엔티티 텔레포트",
  T_46_META_WS_ONTEXTCHANGE: "텍스트 변경",
  T_46_META_WS_ONTHROWABLEEXPLODE: "던진 물건 폭발",
  T_46_META_WS_ONTOGGLE: "전환",
  T_46_META_WS_ONTOUCHDOWN: "터치 다운",
  T_46_META_WS_ONTOUCHUP: "터치 업",
  T_46_META_WS_ONUIHIDE: "UI 숨김",
  T_46_META_WS_ONUISHOW: "UI 표시",
  T_46_META_WS_ONUPDATE: "업데이트",
  T_46_META_WS_ONUSEAVATARSKILL: "아바타 스킬 사용",
  T_46_META_WS_ONUSECONSUMABLE: "소모품 사용",
  T_46_META_WS_ONUSED: "사용됨",
  T_46_META_WS_ONUSEPORTAL: "포털 사용",
  T_46_META_WS_ONWAKEUP: "깨움",
  T_46_META_WS_ONWEAPONBEEQUIPED: "무기 장착됨",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "무기로 피해 줌",
  T_46_META_WS_ONWEAPONELIMINATE: "무기로 제거",
  T_46_META_WS_ONWEAPONSTOPFIRING: "무기 발사 중지",
  T_46_META_WS_OWNER: "소유자",
  T_46_META_WS_P_ACCELERATE: "가속도",
  T_46_META_WS_P_ACCELERATION: "가속도",
  T_46_META_WS_P_ACCOUNTID: "계정 ID",
  T_46_META_WS_P_ACCURACY: "정확도",
  T_46_META_WS_P_ACTIONTYPE: "행동 유형",
  T_46_META_WS_P_ACTIVATEDALPHA: "활성화 알파",
  T_46_META_WS_P_ACTIVE: "활성",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "계층 구조에서 활성",
  T_46_META_WS_P_ACTIVESELF: "활성 자아",
  T_46_META_WS_P_ACTIVETEXT: "활성 텍스트",
  T_46_META_WS_P_ACTUALPOSITION: "실제 위치",
  T_46_META_WS_P_AFTERACCUMULATOR: "후방 누적기",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "조준 보조 중심 오프셋",
  T_46_META_WS_P_AIMASSISTDISTANCE: "조준 보조 거리",
  T_46_META_WS_P_AIMASSISTTYPE: "조준 보조",
  T_46_META_WS_P_AIRDROPSTATE: "에어 드롭 상태",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "수평 정렬",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "수직 정렬",
  T_46_META_WS_P_ALLITEMS: "모든 항목",
  T_46_META_WS_P_ALLMEMBERS: "모든 멤버",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "조준 보조에 의해 잠금 허용",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "외부 누름 허용",
  T_46_META_WS_P_ALLPLAYERS: "모든 플레이어",
  T_46_META_WS_P_ALLTEAMMATES: "모든 팀원",
  T_46_META_WS_P_ALPHA: "알파",
  T_46_META_WS_P_ALWAYSSHOWMARK: "항상 마크 표시",
  T_46_META_WS_P_AMBIENTCOLOR: "주변 색상",
  T_46_META_WS_P_AMMOCLIPSIZE: "탄창 크기",
  T_46_META_WS_P_AMMOMAGSIZE: "총알 탄창 크기",
  T_46_META_WS_P_AMMOPERSHOT: "발사당 탄약",
  T_46_META_WS_P_AMMOTYPE: "탄약 유형",
  T_46_META_WS_P_ANCHORMAX: "앵커 최대",
  T_46_META_WS_P_ANCHORMIN: "앵커 최소",
  T_46_META_WS_P_ANCHOROBJECT: "앵커 오브젝트",
  T_46_META_WS_P_ANCHORPOSITION: "앵커 위치",
  T_46_META_WS_P_ANCHORTYPE: "UITweener 스크립트 활성화",
  T_46_META_WS_P_ANGLE: "각도",
  T_46_META_WS_P_ANGLEDOWN: "하향 각도",
  T_46_META_WS_P_ANGLEUP: "상향 각도",
  T_46_META_WS_P_ANGULARDRAG: "각도 저항",
  T_46_META_WS_P_ANGULARSPEED: "각속도",
  T_46_META_WS_P_ANGULARVELOCITY: "각속도 (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "애니메이션 이름",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "애니메이션 컨트롤러",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "애니메이션 컨트롤러 리소스 ID",
  T_46_META_WS_P_ARMORPENETRATION: "방어구 관통",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "방어구 관통 계수",
  T_46_META_WS_P_ARMORTYPE: "방어구 유형",
  T_46_META_WS_P_ARROWOFFSET: "화살표 오프셋",
  T_46_META_WS_P_ARROWSIZE: "화살표 크기",
  T_46_META_WS_P_ARROWSPRITE: "화살표 스프라이트",
  T_46_META_WS_P_ASKBUYTARGET: "구매 대상 요청",
  T_46_META_WS_P_ATTACHTARGET: "부착 대상",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "공격 가능한 진영",
  T_46_META_WS_P_ATTACKDAMAGE: "공격력",
  T_46_META_WS_P_ATTACKINTERVAL: "공격 간격",
  T_46_META_WS_P_ATTACKRANGE: "공격 범위",
  T_46_META_WS_P_ATTACKTARGET: "공격 목표",
  T_46_META_WS_P_ATTTACKABLETARGETS: "공격 가능한 대상",
  T_46_META_WS_P_AUTOPLAY: "자동 재생 상태",
  T_46_META_WS_P_AVAILABLEPOINT: "사용 가능한 지점",
  T_46_META_WS_P_AVATAR: "아바타",
  T_46_META_WS_P_AVATARID: "아바타 ID",
  T_46_META_WS_P_BACKGROUND: "배경",
  T_46_META_WS_P_BACKGROUNDALPHA: "배경 알파",
  T_46_META_WS_P_BACKGROUNDCOLOR: "배경 색상",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "배경 색상 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "배경 색상 2",
  T_46_META_WS_P_BACKGROUNDFILL: "배경 채우기",
  T_46_META_WS_P_BACKGROUNDICONNAME: "배경 아이콘 이름",
  T_46_META_WS_P_BACKGROUNDNAME: "배경 이름",
  T_46_META_WS_P_BACKGROUNDOFFSET: "배경 오프셋",
  T_46_META_WS_P_BACKGROUNDRADIUS: "배경 반경",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "배경 크기 델타",
  T_46_META_WS_P_BACKGROUNDSPRITE: "배경 스프라이트",
  T_46_META_WS_P_BACKPACK: "백팩",
  T_46_META_WS_P_BACKPACKSKINID: "배낭 스킨 ID",
  T_46_META_WS_P_BACKWARDSPEED: "후진 속도",
  T_46_META_WS_P_BANNERID: "배너 ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "기본 수평 속도",
  T_46_META_WS_P_BASEMULTIPLIER: "기본 배수",
  T_46_META_WS_P_BASETIME: "기준 시간",
  T_46_META_WS_P_BASEVERTICALSPEED: "기본 수직 속도",
  T_46_META_WS_P_BEFOREACCUMULATOR: "전방 누적기",
  T_46_META_WS_P_BEVTREEID: "행동 트리 ID",
  T_46_META_WS_P_BINDPROPERTYID: "바인드 속성 ID",
  T_46_META_WS_P_BODY: "상체",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "몸통 피해 계수",
  T_46_META_WS_P_BONEPOSITION: "뼈 위치",
  T_46_META_WS_P_BONESCALE: "뼈 스케일링",
  T_46_META_WS_P_BOOSTCD: "부스트 쿨다운",
  T_46_META_WS_P_BOOSTDURATION: "부스트 지속 시간",
  T_46_META_WS_P_BOOSTSPEED: "부스트 속도",
  T_46_META_WS_P_BORDERLR: "좌우 경계",
  T_46_META_WS_P_BORDERTB: "상하 경계",
  T_46_META_WS_P_BOTTOMALPHA: "하단 알파",
  T_46_META_WS_P_BOUNDWALLET: "HUD 앵커 유형",
  T_46_META_WS_P_BRAKEHORSEPOWER: "브레이크 마력",
  T_46_META_WS_P_BRAKETORQUE: "브레이크 토크",
  T_46_META_WS_P_BRRANK: "BR 등급",
  T_46_META_WS_P_BUFFTYPE: "버프 유형",
  T_46_META_WS_P_BURNDAMAGE: "연소 피해",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "연소 피해 간격",
  T_46_META_WS_P_BURNTIME: "연소 시간",
  T_46_META_WS_P_BUTTOM: "하의",
  T_46_META_WS_P_BUTTONCOLORS: "버튼 색상",
  T_46_META_WS_P_BUTTONNAMES: "버튼 이름",
  T_46_META_WS_P_BUTTONSTYLE: "버튼 스타일",
  T_46_META_WS_P_CAMERABLOCKMODE: "카메라 차단 모드",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "카메라 투영 모드",
  T_46_META_WS_P_CAMERATYPE: "카메라",
  T_46_META_WS_P_CANCELDRAGIFFITS: "맞으면 드래그 취소",
  T_46_META_WS_P_CANCOSTDURABILITY: "내구도 소모 여부",
  T_46_META_WS_P_CANDAMAGED: "손상될 수 있음",
  T_46_META_WS_P_CANDESTROY: "파괴 가능 여부",
  T_46_META_WS_P_CANDESTROYED: "파괴될 수 있음",
  T_46_META_WS_P_CANSELFTRIGGER: "스스로 트리거 가능",
  T_46_META_WS_P_CANTEAMTRIGGER: "팀에 의해 트리거 가능",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "자신에 의해 트리거 가능 여부",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "팀에 의해 트리거 가능 여부",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "차량에 의해 트리거 가능 여부",
  T_46_META_WS_P_CANVEHICLETRIGGER: "차량에 의해 트리거 가능",
  T_46_META_WS_P_CELLSIZE: "셀 크기",
  T_46_META_WS_P_CELLSPACE: "셀 간격",
  T_46_META_WS_P_CENTER: "중앙",
  T_46_META_WS_P_CENTERINVISIBLE: "중앙 보이지 않음",
  T_46_META_WS_P_CENTEROFFSET: "중심 오프셋",
  T_46_META_WS_P_CENTEROFMASS: "질량 중심",
  T_46_META_WS_P_CENTERRANGE: "중앙 범위",
  T_46_META_WS_P_CENTRALFLASHTIME: "가장자리 플래시 시간",
  T_46_META_WS_P_CENTRALLINEACTIVE: "중앙선 활성화",
  T_46_META_WS_P_CENTRALLINEPOSITION: "중앙선 위치",
  T_46_META_WS_P_CHANNELID: "채팅 채널 ID",
  T_46_META_WS_P_CHARGEMAX: "최대 충전",
  T_46_META_WS_P_CHASETARGET: "추적 대상",
  T_46_META_WS_P_CHATCHANNEL: "채팅 채널",
  T_46_META_WS_P_CHECKPOINTID: "체크포인트 ID",
  T_46_META_WS_P_CHILDINDEX: "자식 인덱스",
  T_46_META_WS_P_CHIPEXP: "칩 경험치",
  T_46_META_WS_P_CLICKSIZE: "클릭 크기",
  T_46_META_WS_P_CLIPLENGTH: "클립 길이",
  T_46_META_WS_P_CLIPPINGTYPE: "클리핑 유형",
  T_46_META_WS_P_COLLIDERID: "충돌체 ID",
  T_46_META_WS_P_COLOR: "색상",
  T_46_META_WS_P_CONSTRAIN: "제약",
  T_46_META_WS_P_CONSTRAINT: "제약",
  T_46_META_WS_P_CONSTRAINTCOUNT: "제약 수",
  T_46_META_WS_P_CONSUMABLETYPE: "소모품 유형",
  T_46_META_WS_P_CONTENT: "콘텐츠",
  T_46_META_WS_P_CONTENTORIGIN: "콘텐츠 원점",
  T_46_META_WS_P_CONTROLPOINTS: "제어 포인트",
  T_46_META_WS_P_COORDINATESYSTEM: "좌표계",
  T_46_META_WS_P_COUNT: "수량",
  T_46_META_WS_P_COUNTDOWNENDTIME: "카운트다운 종료 시간 (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "카운트다운 키",
  T_46_META_WS_P_COUNTDOWNTIME: "카운트다운 시간",
  T_46_META_WS_P_COUNTPERWAVE: "파도당 수",
  T_46_META_WS_P_CRASHMAXDAMAGE: "최대 충돌 피해",
  T_46_META_WS_P_CRASHMAXSPEED: "충돌 최대 속도",
  T_46_META_WS_P_CRASHMESSFACTOR: "충돌 질량 계수",
  T_46_META_WS_P_CRASHMINDAMAGE: "최소 충돌 피해",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "기어가는 이동 속도 비율",
  T_46_META_WS_P_CREATEDENTITY: "생성된 엔티티",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "무릎을 꿇었을 때 이동 속도 비율",
  T_46_META_WS_P_CSRANK: "CS 등급",
  "T_46_META_WS_P_CURRENT AMMO": "현재 총알 수",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "현재 애니메이션 리소스",
  T_46_META_WS_P_CURRENTCLIP: "현재 클립",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "현재 클립 진행률",
  T_46_META_WS_P_CURRENTDURABILITY: "현재 내구성",
  T_46_META_WS_P_CURRENTENERGY: "현재 에너지",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "현재 소지 아이템",
  T_46_META_WS_P_CURRENTHP: "현재 HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "현재 단계 인덱스",
  T_46_META_WS_P_CURRENTPROGRESS: "현재 진행",
  T_46_META_WS_P_CURRENTROUNDINDEX: "현재 라운드 인덱스",
  T_46_META_WS_P_CURRENTSTATE: "현재 상태",
  T_46_META_WS_P_CURRENTVALUE: "현재 값",
  T_46_META_WS_P_CURRENTWAVE: "현재 파도",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "사용자 지정 캐릭터 리소스",
  T_46_META_WS_P_CUSTOMGAMERESULT: "사용자 지정 게임 결과",
  T_46_META_WS_P_CUSTOMGRAVITY: "사용자 정의 중력",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "사용자 정의 밀어내기 힘",
  T_46_META_WS_P_CUSTOMXY: "사용자 정의 XY",
  T_46_META_WS_P_DAMAGE: "피해",
  "T_46_META_WS_P_DAMAGE RANGE": "범위",
  T_46_META_WS_P_DAMAGEFACTOR: "피해 계수",
  T_46_META_WS_P_DAMAGEINTERVAL: "피해 간격 (ms)",
  T_46_META_WS_P_DAMAGERADIUS: "피해 반경",
  T_46_META_WS_P_DAMAGERATIOHEAD: "머리 피해 비율",
  T_46_META_WS_P_DAMAGERATIOLIMB: "사지 피해 비율",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "피해 감소 계수",
  T_46_META_WS_P_DAMAGETAKENPCT: "피해 비율",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "받은 피해 비율",
  T_46_META_WS_P_DAMAGEVALUE: "피해 값",
  T_46_META_WS_P_DARKNESS: "어둠",
  T_46_META_WS_P_DECELERATIONPERCENT: "감속 비율",
  T_46_META_WS_P_DEFAULTTEXT: "기본 텍스트",
  T_46_META_WS_P_DEFENSE: "방어율",
  T_46_META_WS_P_DEFENSERATE: "방어율",
  T_46_META_WS_P_DELTA: "델타",
  T_46_META_WS_P_DELTATIME: "델타 시간",
  T_46_META_WS_P_DELTAVALUE: "델타 값",
  T_46_META_WS_P_DEPTH: "깊이",
  T_46_META_WS_P_DESC: "설명",
  T_46_META_WS_P_DESCRIPTION: "설명",
  T_46_META_WS_P_DESCRIPTIONKEY: "설명 키",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "팁 설명 매개변수",
  T_46_META_WS_P_DESTVAL: "도착 값",
  T_46_META_WS_P_DETECTRANGE: "감지 범위",
  T_46_META_WS_P_DIFFUSEALPHA: "확산 알파",
  T_46_META_WS_P_DIFFUSECOLOR: "확산 색상",
  T_46_META_WS_P_DIFFUSETEXTURE: "확산 텍스처",
  T_46_META_WS_P_DISABLECOLOR: "비활성 색상",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "낙하 피해 비활성화",
  T_46_META_WS_P_DISABLEITEMDROP: "아이템 드롭 비활성화",
  T_46_META_WS_P_DISABLEITEMPICKUP: "아이템 수집 비활성화",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "수동 닫기 비활성화 여부",
  T_46_META_WS_P_DISABLEQUICKCHAT: "빠른 채팅 비활성화",
  T_46_META_WS_P_DISABLERECIPROCATING: "왕복 운동 비활성화",
  T_46_META_WS_P_DISABLEVOICECHAT: "음성 채팅 비활성화",
  T_46_META_WS_P_DISTANCE: "거리",
  T_46_META_WS_P_DOUBLEGUNTYPE: "더블 건 유형",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "기어가는 이동 속도 비율",
  T_46_META_WS_P_DOWNSPEED: "하강 속도",
  T_46_META_WS_P_DRAG: "공기 저항",
  T_46_META_WS_P_DRIVER: "운전사",
  T_46_META_WS_P_DROPITEMS: "드롭 아이템",
  T_46_META_WS_P_DURABILITY: "내구도",
  T_46_META_WS_P_DURABILITYRECOVERY: "내구성 회복",
  T_46_META_WS_P_DURATION: "지속 시간",
  T_46_META_WS_P_EDGEFLASHTIME: "플래시뱅 효과 스위치",
  T_46_META_WS_P_EFFECTACTIVE: "효과 활성화",
  T_46_META_WS_P_EFFECTCOLOR: "효과 색상",
  T_46_META_WS_P_EFFECTDURATION: "트리거 시간",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "유효 시간 간격",
  T_46_META_WS_P_EFFECTRESID: "효과 리소스 경로",
  T_46_META_WS_P_ENABLE: "활성화",
  T_46_META_WS_P_ENABLEATTACK: "공격 활성화 여부",
  T_46_META_WS_P_ENABLEBOTREVIVE: "봇 부활 활성화",
  T_46_META_WS_P_ENABLEDEPTHMAP: "깊이 맵 활성화",
  T_46_META_WS_P_ENABLEDROPONDEATH: "사망 시 드롭 활성화 여부",
  T_46_META_WS_P_ENABLELOCALIZATION: "로컬화 활성화",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "공중에서 이동 가능",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "플레이어 부활 활성화",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "플레이어 뷰 활성화",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "중력과 함께 회전 활성화",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "스킨 속성 활성화",
  T_46_META_WS_P_ENABLESWINGING: "스윙 활성화",
  T_46_META_WS_P_ENABLETRACTION: "견인 활성화",
  T_46_META_WS_P_ENDPOSITION: "종료 위치",
  T_46_META_WS_P_ENDRADIUS: "종료 반경",
  T_46_META_WS_P_ENDTIME: "종료 시간 (ms)",
  T_46_META_WS_P_ENDTIMES: "종료 시간",
  T_46_META_WS_P_ENDVALUE: "종료 값",
  T_46_META_WS_P_ENERGY: "에너지",
  T_46_META_WS_P_ENERGYCOST: "에너지 비용",
  T_46_META_WS_P_ENERGYRECOVERY: "에너지 회복",
  T_46_META_WS_P_ENGINEHORSEPOWER: "엔진 마력",
  T_46_META_WS_P_ENGINETORQUE: "엔진 토크",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "최대 EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP 회복량",
  T_46_META_WS_P_EVENTS: "이벤트",
  T_46_META_WS_P_EXPLODEDAMAGE: "폭발 피해",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "폭발 피해 감소 계수",
  T_46_META_WS_P_EXPLODEDELAY: "폭발 지연",
  T_46_META_WS_P_EXPLODERANGE: "폭발 범위",
  T_46_META_WS_P_EXPLOSIONDELAY: "중앙 플래시 시간",
  T_46_META_WS_P_EXPLOSIONRANGE: "폭발 범위",
  T_46_META_WS_P_EXPLOSIONTIME: "폭발 지연",
  T_46_META_WS_P_EXPPERDAMAGE: "피해당 경험치",
  T_46_META_WS_P_EXPPERMOVEMILE: "이동 거리당 경험치",
  T_46_META_WS_P_EXPPERSECOND: "초당 경험치",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "추가 배낭 용량",
  T_46_META_WS_P_EXTRABAGCAPACITY: "추가 백팩 공간",
  T_46_META_WS_P_EXTRAHPRATIO: "추가 HP 비율",
  T_46_META_WS_P_FACEPAINT: "페이스페인트",
  T_46_META_WS_P_FACTION: "진영",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "낙하 피해 비율",
  T_46_META_WS_P_FALLSPEED: "낙하 속도",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "자동 재장전 속도",
  T_46_META_WS_P_FILEID: "파일 ID",
  T_46_META_WS_P_FILL: "채우기",
  T_46_META_WS_P_FILLAMOUNT: "채우기 값",
  T_46_META_WS_P_FILLDIRECTION: "채우기 방향",
  T_46_META_WS_P_FILLTYPE: "채우기 유형",
  T_46_META_WS_P_FIREANGLELIMIT: "발사 각도 제한",
  T_46_META_WS_P_FIRETYPE: "발사 유형",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "첫 번째 점수 매개변수",
  T_46_META_WS_P_FIRSTSCORETITLE: "첫 번째 점수 제목",
  T_46_META_WS_P_FIRSTSCOREVALUE: "첫 번째 점수 값",
  T_46_META_WS_P_FIXEDDELTATIME: "고정 델타 시간",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "효과 지속 시간",
  T_46_META_WS_P_FLIP: "뒤집기",
  T_46_META_WS_P_FLIPTYPE: "플립 유형",
  T_46_META_WS_P_FLYMAXHEIGHT: "최대 비행 높이",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "수평 비행 속도",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "수직 비행 속도",
  T_46_META_WS_P_FOGCOLOR: "안개 색상",
  T_46_META_WS_P_FOLLOWTARGET: "목표 추적",
  T_46_META_WS_P_FONT: "글꼴",
  T_46_META_WS_P_FONTCOLOR: "글꼴 색상",
  T_46_META_WS_P_FONTSIZE: "글꼴 크기",
  T_46_META_WS_P_FONTSTYLE: "글꼴 스타일",
  T_46_META_WS_P_FONTTYPE: "글꼴 유형",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "클라이언트와 강제 동기화",
  T_46_META_WS_P_FORWARD: "앞으로",
  T_46_META_WS_P_FORWARDSPEED: "전진 속도",
  T_46_META_WS_P_FOV: "시야",
  T_46_META_WS_P_FREEZEDURATION: "동결 지속 시간 (초)",
  T_46_META_WS_P_FRIENDFACTIONS: "아군 진영",
  T_46_META_WS_P_FRIENDLYPLAYERS: "친근한 플레이어",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "완전 피해 거리",
  T_46_META_WS_P_FUNCTIONTYPE: "기능 유형",
  T_46_META_WS_P_GAINHPCOLOR: "HP 증가 색상",
  T_46_META_WS_P_GAMEFRAMECOUNT: "프레임 수",
  T_46_META_WS_P_GAMETIMECOUNT: "게임 시간",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "기어 변속 지연",
  T_46_META_WS_P_GENDER: "성별",
  T_46_META_WS_P_GETONBOOSTCD: "부스트에 올라가는 CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "부스트에 올라가는 CD 스위치",
  T_46_META_WS_P_GETONSKATEBOARDCD: "스케이트보드 CD",
  T_46_META_WS_P_GRADIENT: "그라디언트",
  T_46_META_WS_P_GRADIENTBOTTOM: "그라디언트 하단",
  T_46_META_WS_P_GRADIENTTOP: "그라디언트 상단",
  T_46_META_WS_P_GRAVITY: "중력",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "수류탄 최대 피해",
  T_46_META_WS_P_GRENADEMINDAMAGE: "수류탄 최소 피해",
  T_46_META_WS_P_GRENADERANGE: "수류탄 범위",
  T_46_META_WS_P_GROUPID: "그룹 ID",
  T_46_META_WS_P_HEAD: "머리",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "머리 피해 계수",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "헤드샷 피해 감소",
  T_46_META_WS_P_HEIGHT: "높이",
  T_46_META_WS_P_HELMET: "헬멧",
  T_46_META_WS_P_HIGHESTBRRANK: "최고 BR 등급",
  T_46_META_WS_P_HIGHESTCSRANK: "최고 CS 등급",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "최소 고도 각도",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "고속 조향 제한",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "고속 조향 제한 임계값",
  T_46_META_WS_P_HITPOINTEFFECT: "타격 지점 효과",
  T_46_META_WS_P_HORIZONTALBAR: "수평 막대",
  T_46_META_WS_P_HORIZONTALOFFSET: "수평 오프셋",
  T_46_META_WS_P_HOSTILETEAMS: "적대적 팀",
  T_46_META_WS_P_HOSTTEAM: "호스트 팀",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "최대 HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP 회복량",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP 회복 속도 (밀리초)",
  T_46_META_WS_P_ICON: "아이콘",
  T_46_META_WS_P_ICONCOLOR: "아이콘 색상",
  T_46_META_WS_P_ICONNAME: "아이콘 이름",
  T_46_META_WS_P_ICONRESOURCE: "아이콘 리소스",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "피해 간격 (초)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "공회전 브레이크 입력",
  T_46_META_WS_P_INACTIVATEDALPHA: "비활성화 알파",
  T_46_META_WS_P_INDEX: "인덱스",
  T_46_META_WS_P_INITIALMAGCOUNT: "초기 탄창 수",
  T_46_META_WS_P_INITIALSPEED: "초기 속도",
  T_46_META_WS_P_INITIALVALUE: "초기 값",
  T_46_META_WS_P_INITIALWORLDPOSITION: "초기 세계 위치",
  T_46_META_WS_P_INSCENE: "장면 내",
  T_46_META_WS_P_INSTANCEID: "인스턴스 ID",
  T_46_META_WS_P_INTENSITY: "강도",
  T_46_META_WS_P_INVERTFILL: "채우기 반전",
  T_46_META_WS_P_INVINCIBLE: "무적",
  "T_46_META_WS_P_IS SHOW": "표시 여부",
  T_46_META_WS_P_IS3D: "3D 여부",
  T_46_META_WS_P_ISACE: "ACE 여부",
  T_46_META_WS_P_ISACED: "전멸 여부",
  T_46_META_WS_P_ISAI: "AI 여부",
  T_46_META_WS_P_ISALWAYSINSCREEN: "항상 화면에 표시",
  T_46_META_WS_P_ISAPPLYSHADOW: "그림자 적용",
  T_46_META_WS_P_ISATTACKABLE: "공격 가능",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "자동 적 추적 여부",
  T_46_META_WS_P_ISAUTOPLAY: "자동 재생",
  T_46_META_WS_P_ISAUTOTELEPORT: "자동 텔레포트 여부",
  T_46_META_WS_P_ISBILLBOARD: "항상 비디오 화면에 표시",
  T_46_META_WS_P_ISBOLD: "굵게",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "하단 충돌 여부",
  T_46_META_WS_P_ISCENTERPOS: "중심 위치 여부",
  T_46_META_WS_P_ISCONSUMEAMMO: "탄약 소모 여부",
  T_46_META_WS_P_ISCONTINUOUS: "연속 생성 여부",
  T_46_META_WS_P_ISCOUNTDOWN: "카운트다운",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "현재 애니메이션이 루프인가?",
  T_46_META_WS_P_ISDEADDROP: "사망 지원",
  T_46_META_WS_P_ISDEATHTRIGGER: "사망 트리거 여부",
  T_46_META_WS_P_ISDEBUG: "BTree 디버그 활성화",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "기본 스폰 지점 여부",
  T_46_META_WS_P_ISDROPONELIMINATED: "제거 시 떨어짐",
  T_46_META_WS_P_ISEND: "종료 여부",
  T_46_META_WS_P_ISFEBUTTON: "FE 버튼 여부",
  T_46_META_WS_P_ISGREY: "회색 여부",
  T_46_META_WS_P_ISGROUNDED: "지면에 닿음",
  T_46_META_WS_P_ISIGNOREDEPTH: "깊이 무시",
  T_46_META_WS_P_ISINVINCIBLE: "무적 상태",
  T_46_META_WS_P_ISITALIC: "이탤릭체",
  T_46_META_WS_P_ISLASTROUND: "마지막 라운드 여부",
  T_46_META_WS_P_ISLOCALPOS: "지역 좌표계 활성화",
  T_46_META_WS_P_ISLOOP: "루핑 여부",
  T_46_META_WS_P_ISMATCHPOINT: "결정적 경기 점수 여부",
  T_46_META_WS_P_ISMOVEABLE: "이동 가능",
  T_46_META_WS_P_ISOCCUPIED: "점유 여부",
  T_46_META_WS_P_ISOPENTWEEN: "HP 변경 효과 활성화",
  T_46_META_WS_P_ISPLAYING: "재생 중 여부",
  T_46_META_WS_P_ISPURCHASABLE: "상점 항목",
  T_46_META_WS_P_ISREVERSE: "반전 여부",
  T_46_META_WS_P_ISSERVERDRIVEN: "서버 기반",
  T_46_META_WS_P_ISSHOW: "표시 여부",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD 이름 표시 여부",
  T_46_META_WS_P_ISSHOWMAPINFO: "지도 정보 표시 여부",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "빠른 메시지 표시 여부",
  T_46_META_WS_P_ISSHOWSCAN: "스캔 표시 여부",
  T_46_META_WS_P_ISSHOWTAG: "태그 표시 여부",
  T_46_META_WS_P_ISSIDECOLLIDING: "측면 충돌 여부",
  T_46_META_WS_P_ISSILENCE: "소음 없음",
  T_46_META_WS_P_ISSINGLESHOT: "단일 발사",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "낙하 시 애니메이션 건너뛰기",
  T_46_META_WS_P_ISSLIDING: "미끄러짐 여부",
  T_46_META_WS_P_ISTOPCOLLIDING: "상단 충돌 여부",
  T_46_META_WS_P_ISUNDERLINE: "밑줄",
  T_46_META_WS_P_ISVISIBLE: "표시 여부",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "아이템 배경 색상",
  T_46_META_WS_P_ITEMBACKGROUNDS: "아이템 배경",
  T_46_META_WS_P_ITEMCOUNTS: "구매 가능 여부",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "아이템 설명",
  T_46_META_WS_P_ITEMICONS: "아이템 아이콘",
  T_46_META_WS_P_ITEMID: "아이템 ID",
  T_46_META_WS_P_ITEMIDS: "아이템 ID 목록",
  T_46_META_WS_P_ITEMNAMES: "아이템 이름",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "아이템 수집 금지 목록",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "조이스틱 캡 드래그 반경",
  T_46_META_WS_P_JOYSTICKIMAGE: "조이스틱 캡 이미지",
  T_46_META_WS_P_JOYSTICKRADIUS: "조이스틱 캡 반경",
  T_46_META_WS_P_JUMPCD: "점프 쿨다운",
  T_46_META_WS_P_JUMPHEIGHT: "점프 높이",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "점프 높이 비율",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "넉다운 데미지 보너스",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "넉다운 상태",
  T_46_META_WS_P_LABEL: "레이블",
  T_46_META_WS_P_LABELCOLOR: "레이블 색상",
  T_46_META_WS_P_LABELKEY: "레이블 키",
  T_46_META_WS_P_LABELPARAMS: "레이블 매개변수",
  T_46_META_WS_P_LASTCHECKPOINTID: "현재 체크포인트 ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "마지막 생존 시간",
  T_46_META_WS_P_LAYERTYPE: "레이어 유형",
  T_46_META_WS_P_LAYOUTTYPE: "레이아웃 유형",
  T_46_META_WS_P_LEFTARM: "왼팔",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "왼쪽 배경 색상",
  T_46_META_WS_P_LEFTCOLOR: "왼쪽 색상",
  T_46_META_WS_P_LEFTDESCRIPTION: "왼쪽 설명",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "왼쪽 효과 활성화",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "왼쪽 사격 호각",
  T_46_META_WS_P_LEFTFOOT: "왼발",
  T_46_META_WS_P_LEFTHAND: "왼손",
  T_46_META_WS_P_LEFTICON: "왼쪽 아이콘",
  T_46_META_WS_P_LEFTICONNAME: "왼쪽 아이콘 이름",
  T_46_META_WS_P_LEFTLEG: "왼쪽 다리",
  T_46_META_WS_P_LEFTPLAYERS: "왼쪽 플레이어",
  T_46_META_WS_P_LEFTSCORE: "왼쪽 점수",
  T_46_META_WS_P_LEFTSCOREAFTER: "왼쪽 최종 점수",
  T_46_META_WS_P_LEFTSCORETEXT: "왼쪽 점수",
  T_46_META_WS_P_LEFTTEAM: "오른쪽 팀",
  T_46_META_WS_P_LEFTTEAMINDEX: "왼쪽 팀 인덱스",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "왼쪽 팀원 생존 수",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "왼쪽 팀원 깃발 수",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "왼쪽 팀원 상태",
  T_46_META_WS_P_LEFTTEAMNAME: "왼쪽 팀 이름",
  T_46_META_WS_P_LEFTTEAMSCORE: "왼쪽 팀 점수",
  T_46_META_WS_P_LEFTTEXT: "왼쪽 텍스트",
  T_46_META_WS_P_LENGTH: "길이",
  T_46_META_WS_P_LENSFLARE: "렌즈 플레어",
  T_46_META_WS_P_LEVEL: "레벨",
  T_46_META_WS_P_LIFETIME: "생존 시간 (초)",
  T_46_META_WS_P_LIGHTCOLOR: "조명 색상",
  T_46_META_WS_P_LIGHTINTENSITY: "빛의 세기",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "팔다리 피해 계수",
  T_46_META_WS_P_LINESPACING: "줄 간격",
  T_46_META_WS_P_LOCALPOSITION: "로컬 위치",
  T_46_META_WS_P_LOCALROTATION: "지역 회전",
  T_46_META_WS_P_LOCALROTATIONQ: "지역 회전 쿼터니언",
  T_46_META_WS_P_LOCALSCALE: "지역 스케일",
  T_46_META_WS_P_LOCKEY: "지역화 키",
  T_46_META_WS_P_LOOPCOUNT: "루프 수",
  T_46_META_WS_P_LOOTSOCCER: "루트 축구",
  T_46_META_WS_P_LOSEHPCOLOR: "HP 감소 색상",
  T_46_META_WS_P_LOSEMVPS: "패배 MVP",
  T_46_META_WS_P_LOSETEXT: "패배 텍스트",
  "T_46_META_WS_P_MAIN CAMERA": "주 카메라",
  T_46_META_WS_P_MAINCOLOR: "주요 색상",
  T_46_META_WS_P_MAINSCORELIST: "주요 점수",
  T_46_META_WS_P_MAINSCORETITLE: "주요 점수 제목",
  T_46_META_WS_P_MAINWEAPON: "주요 무기",
  T_46_META_WS_P_MAPSIZE: "지도 크기",
  T_46_META_WS_P_MASK: "마스크",
  T_46_META_WS_P_MASKNAME: "마스크 이름",
  T_46_META_WS_P_MASS: "질량 (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "경기 제목 왼쪽",
  T_46_META_WS_P_MATCHTITLERIGHT: "경기 제목 오른쪽",
  T_46_META_WS_P_MAXCAPACITY: "최대 용량",
  T_46_META_WS_P_MAXCOUNT: "최대 수",
  T_46_META_WS_P_MAXDAMAGE: "최대 피해",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "최대 하강 각도",
  T_46_META_WS_P_MAXDISPLACEMENT: "최대 변위",
  T_46_META_WS_P_MAXDISTANCE: "최대 거리",
  T_46_META_WS_P_MAXDURABILITY: "최대 내구성",
  T_46_META_WS_P_MAXDURABILITYRATIO: "최대 내구성 비율",
  T_46_META_WS_P_MAXENERGY: "최대 에너지",
  T_46_META_WS_P_MAXEP: "최대 에너지",
  T_46_META_WS_P_MAXHP: "최대 HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "최대 점프 횟수",
  T_46_META_WS_P_MAXJUMPHEIGHT: "최대 점프 높이",
  T_46_META_WS_P_MAXLENGTH: "최대 길이",
  T_46_META_WS_P_MAXPROGRESS: "최대 진행",
  T_46_META_WS_P_MAXSCATTERRATIO: "최대 확산 비율",
  T_46_META_WS_P_MAXSPEED: "최대 속도",
  T_46_META_WS_P_MAXTURRETCOUNT: "최대 포탑 수",
  T_46_META_WS_P_MAXVALUE: "최대 값",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "최소 피해",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "최소 피해 거리",
  T_46_META_WS_P_MINDISTANCE: "최소 거리",
  T_46_META_WS_P_MINELEVATIONANGLE: "최소 상승 각도",
  T_46_META_WS_P_MINENDHEIGHT: "최소 종료 높이",
  T_46_META_WS_P_MINFLYHEIGHT: "최소 비행 높이",
  T_46_META_WS_P_MINMOVEDISTANCE: "최소 이동 거리",
  T_46_META_WS_P_MINVALUE: "최소값",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "미사일 최대 피해",
  T_46_META_WS_P_MISSILEMINDAMAGE: "미사일 최소 피해",
  T_46_META_WS_P_MISSILERANGE: "미사일 범위",
  T_46_META_WS_P_MODEL: "모델",
  T_46_META_WS_P_MODELVISIBILITY: "모델 가시성",
  T_46_META_WS_P_MODELVISIBLE: "모델 가시성",
  T_46_META_WS_P_MONEY: "화폐",
  T_46_META_WS_P_MONEYLIST: "화폐 목록",
  T_46_META_WS_P_MONEYS: "바인드된 지갑",
  T_46_META_WS_P_MONEYTYPE: "통화 유형",
  T_46_META_WS_P_MONSTERTYPE: "몬스터 유형",
  T_46_META_WS_P_MOTIONTYPE: "운동 유형",
  T_46_META_WS_P_MOTIONVALUEX: "X축 운동 값",
  T_46_META_WS_P_MOTIONVALUEY: "Y축 운동 값",
  T_46_META_WS_P_MOTIONVALUEZ: "Z축 운동 값",
  T_46_META_WS_P_MOVEMENTDURATION: "이동 지속 시간",
  T_46_META_WS_P_MULTIPLIER: "배수",
  T_46_META_WS_P_MUSICELEMENTTYPE: "음악 요소 유형",
  T_46_META_WS_P_MUZZLEVELOCITY: "총구 속도",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "이름",
  T_46_META_WS_P_NEXTROUNDINDEX: "다음 라운드 인덱스",
  T_46_META_WS_P_NICKNAME: "닉네임",
  T_46_META_WS_P_NORMALCOLOR: "기본 색상",
  T_46_META_WS_P_NORMALIZEDPOSITION: "정규화된 위치",
  T_46_META_WS_P_NUMBERINFACTION: "진영 내 번호",
  T_46_META_WS_P_OBJECTID: "객체 ID",
  T_46_META_WS_P_OFFSET: "오프셋",
  T_46_META_WS_P_OPTIONS: "옵션",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "기타 피해 계수",
  T_46_META_WS_P_OUTFIT: "의상",
  T_46_META_WS_P_OVERFLOW: "오버플로우",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "초과 높이 낙하 속도",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "플레이어 구성 우선 순위",
  T_46_META_WS_P_OWNER: "소유자",
  T_46_META_WS_P_PARAMS: "매개변수",
  T_46_META_WS_P_PARENT: "부모",
  T_46_META_WS_P_PARENTID: "부모 ID",
  T_46_META_WS_P_PARENTUI: "부모 UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "부모 위젯 엔티티 ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "부모 위젯 파일 ID ",
  T_46_META_WS_P_PARTMASKA: "부품 마스크 1",
  T_46_META_WS_P_PASSENGERS: "승객",
  T_46_META_WS_P_PATHID: "경로 ID",
  T_46_META_WS_P_PAUSEEVENT: "이벤트 일시 정지",
  T_46_META_WS_P_PERSONAID: "페르소나 ID",
  T_46_META_WS_P_PHASEDURATION: "지속 시간 (ms)",
  T_46_META_WS_P_PHASEENDTIME: "종료 시간 (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "물리 계층",
  T_46_META_WS_P_PINID: "배지 ID",
  T_46_META_WS_P_PITCH: "피치",
  T_46_META_WS_P_PIVOT: "피벗",
  T_46_META_WS_P_PLAYER: "플레이어",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "플레이어 조준 속도 계수",
  T_46_META_WS_P_PLAYERLIST: "플레이어 목록",
  T_46_META_WS_P_PLAYERNAME: "플레이어 이름",
  T_46_META_WS_P_PLAYERRANK: "플레이어 순위",
  T_46_META_WS_P_PLAYERRANKS: "플레이어 순위",
  T_46_META_WS_P_PLAYERS: "플레이어들",
  T_46_META_WS_P_PLAYERSCORETYPES: "플레이어 점수 유형",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "플레이어 속도 계수",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "발사 시 플레이어 속도 계수",
  T_46_META_WS_P_PLAYERSTATUS: "플레이어 상태",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "플레이어 견인 속도",
  T_46_META_WS_P_PLAYINGSTATUS: "재생 상태",
  T_46_META_WS_P_PLAYSPEED: "재생 속도",
  T_46_META_WS_P_POINTPOSITION: "지점 위치",
  T_46_META_WS_P_POINTS: "포인트",
  T_46_META_WS_P_POSITION: "위치",
  T_46_META_WS_P_PREFABID: "프리팹 ID",
  T_46_META_WS_P_PRESSEDCOLOR: "눌림 색상",
  T_46_META_WS_P_PRESSEDSPRITE: "눌린 스프라이트",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "눌린 스프라이트 유형",
  T_46_META_WS_P_PRICE: "가격",
  T_46_META_WS_P_PRIORITY: "우선순위",
  T_46_META_WS_P_PROFILEINFO: "프로필 정보",
  T_46_META_WS_P_PROGRESS: "진행 [0,1]",
  T_46_META_WS_P_PROGRESSICON: "진행 아이콘",
  T_46_META_WS_P_PROGRESSICONNAME: "진행 아이콘 이름",
  T_46_META_WS_P_PROPID: "속성 ID",
  T_46_META_WS_P_PURCHASELIMIT: "구매 한도",
  T_46_META_WS_P_RADIUS: "반경",
  T_46_META_WS_P_RANGE: "범위",
  T_46_META_WS_P_RANK: "순위",
  T_46_META_WS_P_RATIOSELFFACTOR: "자기 피해 비율",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "팀원 피해 비율",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "차량 피해 비율",
  T_46_META_WS_P_REFRESHTIME: "버프 새로 고침 시간 (초)",
  T_46_META_WS_P_RELOADSPEED: "재장전 속도",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "재장전 속도 계수",
  T_46_META_WS_P_REMAINJUMPCOUNT: "남은 점프 횟수",
  T_46_META_WS_P_REMAINQUANTITY: "남은 수량",
  T_46_META_WS_P_RENDERTYPE: "렌더 유형",
  T_46_META_WS_P_REPEATTIMES: "반복 횟수",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "교체 우선 순위",
  T_46_META_WS_P_REQUESTEDITEMLIST: "트리거된 엔티티 ID",
  T_46_META_WS_P_REQUESTTYPE: "요청된 항목 목록",
  T_46_META_WS_P_RESETPERROUND: "라운드별 리셋",
  T_46_META_WS_P_RESETPOSITION: "리셋 위치",
  T_46_META_WS_P_RESETTIME: "리셋 시간",
  T_46_META_WS_P_RESOURCE: "자원",
  T_46_META_WS_P_RESOURCEID: "리소스 ID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "패널 내 제한",
  T_46_META_WS_P_RESULT: "결과",
  T_46_META_WS_P_RESULTTYPE: "결과 유형",
  T_46_META_WS_P_REVIVALPOINT: "부활 지점",
  T_46_META_WS_P_REVIVECD: "부활 대기 시간",
  T_46_META_WS_P_RIGHT: "오른쪽",
  T_46_META_WS_P_RIGHTARM: "오른팔",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "오른쪽 배경 색상",
  T_46_META_WS_P_RIGHTCOLOR: "오른쪽 색상",
  T_46_META_WS_P_RIGHTDESCRIPTION: "오른쪽 설명",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "오른쪽 효과 활성화",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "오른쪽 사격 호각",
  T_46_META_WS_P_RIGHTFOOT: "오른발",
  T_46_META_WS_P_RIGHTHAND: "오른손",
  T_46_META_WS_P_RIGHTICON: "오른쪽 아이콘",
  T_46_META_WS_P_RIGHTICONNAME: "오른쪽 아이콘 이름",
  T_46_META_WS_P_RIGHTLEG: "오른쪽 다리",
  T_46_META_WS_P_RIGHTPLAYERS: "오른쪽 플레이어",
  T_46_META_WS_P_RIGHTSCORE: "오른쪽 점수",
  T_46_META_WS_P_RIGHTSCOREAFTER: "오른쪽 최종 점수",
  T_46_META_WS_P_RIGHTSCORETEXT: "오른쪽 점수",
  T_46_META_WS_P_RIGHTTEAM: "제목",
  T_46_META_WS_P_RIGHTTEAMINDEX: "오른쪽 팀 인덱스",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "오른쪽 팀원 생존 수",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "오른쪽 팀원 깃발 수",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "오른쪽 팀원 상태",
  T_46_META_WS_P_RIGHTTEAMNAME: "오른쪽 팀 이름",
  T_46_META_WS_P_RIGHTTEAMSCORE: "오른쪽 팀 점수",
  T_46_META_WS_P_RIGHTTEXT: "오른쪽 텍스트",
  T_46_META_WS_P_RIMALPHA: "가장자리 알파",
  T_46_META_WS_P_RIMCOLOR: "가장자리 색상",
  T_46_META_WS_P_RIMTEXTURE: "가장자리 텍스처",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "마찰 계수",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "돌진 시 마찰 계수",
  T_46_META_WS_P_ROTATION: "회전",
  T_46_META_WS_P_ROTATIONANGLE: "회전 각도",
  T_46_META_WS_P_ROTATIONQ: "회전 쿼터니언",
  T_46_META_WS_P_ROUNDINCOME: "라운드 수익",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "라운드 수입 세부 항목 숫자",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "라운드 수입 세부 항목 제목",
  T_46_META_WS_P_ROUNDINCOMETITLE: "라운드 수익 제목",
  T_46_META_WS_P_ROUNDNUM: "라운드 번호",
  T_46_META_WS_P_ROUNDNUMKEY: "라운드 번호 키",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "라운드 번호 로컬 키 매개변수",
  T_46_META_WS_P_RUNSPEED: "이동 속도",
  T_46_META_WS_P_RUNSPEEDSCALE: "달리기 속도 비율",
  T_46_META_WS_P_RUSHDISTANCE: "돌진 거리",
  T_46_META_WS_P_RUSHENERGYCOST: "돌진 에너지 비용",
  T_46_META_WS_P_RUSHVERTICALSPEED: "돌진 수직 속도",
  T_46_META_WS_P_SCALE: "크기 조정",
  T_46_META_WS_P_SCATTERINCREASESPEED: "확산 증가 속도",
  T_46_META_WS_P_SCATTERMAX: "최대 확산",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "이동 중 확산 배율",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "확산 회복 속도",
  T_46_META_WS_P_SCATTERSPEED: "확산 속도",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "앉거나 엎드릴 때 확산 속도",
  T_46_META_WS_P_SCATTERTHRESHOLD: "확산 임계값",
  T_46_META_WS_P_SCOPETYPE: "조준경 유형",
  T_46_META_WS_P_SCORE: "점수",
  T_46_META_WS_P_SCORES1: "점수 목록 1",
  T_46_META_WS_P_SCORES2: "점수 목록 2",
  T_46_META_WS_P_SCORES3: "점수 목록 3",
  T_46_META_WS_P_SCORES4: "점수 목록 4",
  T_46_META_WS_P_SCORES5: "점수 목록 5",
  T_46_META_WS_P_SCORETEXTKEY: "점수 텍스트 키",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "점수 텍스트 키 매개변수",
  T_46_META_WS_P_SCROLLCONTINUITY: "스크롤 연속성",
  T_46_META_WS_P_SCROLLDIRECTION: "스크롤 방향",
  T_46_META_WS_P_SCROLLEFFECT: "스크롤 효과",
  T_46_META_WS_P_SCROLLWHEELSPEED: "스크롤 휠 속도",
  T_46_META_WS_P_SECONDSCORETITLE: "두 번째 점수 제목",
  T_46_META_WS_P_SECONDSCOREVALUE: "두 번째 점수 값",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "두 번째 점수 매개변수",
  T_46_META_WS_P_SELECTEDCOLOR: "선택된 색상",
  T_46_META_WS_P_SELECTEDINDEX: "선택된 인덱스",
  T_46_META_WS_P_SELECTEDSPRITE: "선택된 스프라이트",
  T_46_META_WS_P_SELECTEDTYPE: "선택된 유형",
  T_46_META_WS_P_SELF: "자기",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "자기 피해 계수",
  T_46_META_WS_P_SET: "세트",
  T_46_META_WS_P_SHADERNAME: "셰이더 이름",
  T_46_META_WS_P_SHADOWCOLOR: "그림자 색상",
  T_46_META_WS_P_SHADOWOFFSET: "그림자 오프셋",
  T_46_META_WS_P_SHADOWSTRENGTH: "그림자 강도",
  T_46_META_WS_P_SHELFS: "수동 종료 비활성화 여부",
  T_46_META_WS_P_SHOES: "신발",
  T_46_META_WS_P_SHOOTANGLEMAX: "최대 사격 각도",
  T_46_META_WS_P_SHOOTANGLEMIN: "최소 사격 각도",
  T_46_META_WS_P_SHOP: "상점",
  T_46_META_WS_P_SHOPITEMS: "선반",
  T_46_META_WS_P_SHOWADDFRIEND: "친구 추가 표시",
  T_46_META_WS_P_SHOWATTACKGRENADE: "공격 수류탄 표시",
  T_46_META_WS_P_SHOWBACKGROUND: "배경 표시",
  T_46_META_WS_P_SHOWCROUCH: "앉기 표시",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "피해 숫자 표시",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "방어 수류탄 표시",
  T_46_META_WS_P_SHOWECCONOMY: "경제 표시",
  T_46_META_WS_P_SHOWECONOMY: "경제 표시",
  T_46_META_WS_P_SHOWFIRE: "발사 표시",
  T_46_META_WS_P_SHOWFRAME: "프레임 표시",
  T_46_META_WS_P_SHOWGIFT: "선물 표시",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "타격 지점 효과 표시",
  T_46_META_WS_P_SHOWJUMP: "점프 표시",
  T_46_META_WS_P_SHOWLIKE: "좋아요 표시",
  T_46_META_WS_P_SHOWLOBBY: "로비 표시",
  T_46_META_WS_P_SHOWMAPEVALUATE: "지도 평가 표시",
  T_46_META_WS_P_SHOWMATCHDETAIL: "경기 상세 정보 표시",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "조이스틱 이동 표시",
  T_46_META_WS_P_SHOWNAME: "닉네임 표시",
  T_46_META_WS_P_SHOWPIN: "핀 표시",
  T_46_META_WS_P_SHOWPRONE: "기어 표시",
  T_46_META_WS_P_SHOWRANK: "순위 표시",
  T_46_META_WS_P_SHOWREPLAY: "재생 표시",
  T_46_META_WS_P_SHOWREPORT: "신고 표시",
  T_46_META_WS_P_SHOWSHARE: "공유 표시",
  T_46_META_WS_P_SHOWSPRINT: "스프린트 표시",
  T_46_META_WS_P_SHOWTAG: "태그 표시",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "팀원 정보 표시",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "팀원 상태 표시",
  T_46_META_WS_P_SHOWTEAMSCORE: "팀 점수 표시",
  T_46_META_WS_P_SHOWTIMETYPE: "시간 유형 표시",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "두 팀 점수 표시",
  T_46_META_WS_P_SHRINKDURATION: "축소 시간 (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "축소 종료 시간 (ms)",
  T_46_META_WS_P_SHRINKSPEED: "수렴 속도",
  T_46_META_WS_P_SHRINKSTARTTIME: "축소 시작 시간 (ms)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS 조준 지원 허용",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "조준 지원 거리 감쇠 계수 (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "조준 지원 거리 우선 영향 계수 (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "조준 지원 최대 우선 거리",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "조준 지원 최소 우선 거리",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "조준 지원 거리 우선 허용",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "조준 지원 십자선 화면 범위 흡인 비율 (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "시야 확대 계수",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV 확대",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS 회전 민감도",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS 최소 피해 거리 보정 계수",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS 확대 시간 (초)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "조준 확대 (ADS)",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS 회복 시간 (초)",
  T_46_META_WS_P_SIZE: "크기",
  T_46_META_WS_P_SIZEDELTA: "크기 변화",
  T_46_META_WS_P_SKELETON: "해골",
  T_46_META_WS_P_SKIN: "피부",
  T_46_META_WS_P_SKINID: "스킨 ID",
  T_46_META_WS_P_SKINWIDTH: "피부 두께",
  T_46_META_WS_P_SKYBOXENV: "하늘 박스",
  T_46_META_WS_P_SKYBOXRESOURCE: "하늘 상자 리소스",
  T_46_META_WS_P_SLOPELIMIT: "경사 한계",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "부드러운 스크롤 시작",
  T_46_META_WS_P_SOFTNESS: "부드러움",
  T_46_META_WS_P_SORTTYPE: "정렬 유형",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "웨이브당 스폰 수",
  T_46_META_WS_P_SPAWNPOINT: "스폰 지점",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "스폰 지점 수",
  T_46_META_WS_P_SPAWNPOSITION: "스폰 위치",
  T_46_META_WS_P_SPEED: "속도",
  T_46_META_WS_P_SPEEDWHILEAIMING: "조준 시 이동 속도 비율",
  T_46_META_WS_P_SPRAYCOLOR: "스프레이 색상",
  T_46_META_WS_P_SPRINTENERGYCOST: "스프린트 에너지 비용",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "스프린트 수평 속도",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "스프린트 시 이동 속도 비율",
  T_46_META_WS_P_SPRITENAME: "스프라이트 형태",
  T_46_META_WS_P_SPRITERESOURCE: "스프라이트 리소스",
  T_46_META_WS_P_SRCVAL: "출발 값",
  T_46_META_WS_P_STARTDROPTIME: "드롭 시작 시간 (ms)",
  T_46_META_WS_P_STARTEVENT: "이벤트 시작",
  T_46_META_WS_P_STARTPOSITION: "시작 위치",
  T_46_META_WS_P_STARTRADIUS: "시작 반경",
  T_46_META_WS_P_STARTSPAWNTIME: "스폰 시작 시간 (초)",
  T_46_META_WS_P_STARTTIME: "시작 시간",
  T_46_META_WS_P_STARTVALUE: "시작 값",
  T_46_META_WS_P_STATICICONCOLORS: "정적 아이콘 색상",
  T_46_META_WS_P_STATICICONS: "정적 아이콘",
  T_46_META_WS_P_STATUS: "미니 센트리 상태",
  T_46_META_WS_P_STEPOFFSET: "단계 오프셋",
  T_46_META_WS_P_STOPDURATION: "정지 지속 시간",
  T_46_META_WS_P_STOPEVENT: "이벤트 중지",
  T_46_META_WS_P_STORE: "상점",
  T_46_META_WS_P_STROPID: "스트롭 ID",
  T_46_META_WS_P_STYLE: "스타일",
  T_46_META_WS_P_SUBTITLE: "자막",
  T_46_META_WS_P_SUMMULTIPLIER: "합계 배수",
  T_46_META_WS_P_SWINGEXITACCELERATION: "스윙 종료 가속도",
  T_46_META_WS_P_SWINGINGSPEED: "스윙 속도",
  T_46_META_WS_P_TAGS: "태그",
  T_46_META_WS_P_TARGET: "공격 목표",
  T_46_META_WS_P_TARGETCHECKPOINTID: "목표 체크포인트 ID",
  T_46_META_WS_P_TARGETICONCOLORS: "대상 아이콘 색상",
  T_46_META_WS_P_TARGETICONS: "대상 아이콘",
  T_46_META_WS_P_TARGETID: "목표 ID",
  T_46_META_WS_P_TARGETITEMID: "대상 아이템 ID",
  T_46_META_WS_P_TARGETROTATION: "대상 회전",
  T_46_META_WS_P_TARGETSCALE: "대상 스케일",
  T_46_META_WS_P_TEAMCOLOR: "팀 색상",
  T_46_META_WS_P_TEAMCOLORS: "팀 색상",
  T_46_META_WS_P_TEAMINDEXS: "팀 인덱스",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "팀원 피해 계수",
  T_46_META_WS_P_TEAMMEMBERNUM: "팀원 수",
  T_46_META_WS_P_TEAMNUM: "팀 수",
  T_46_META_WS_P_TEAMRANK: "팀 순위",
  T_46_META_WS_P_TEAMRANKDISPLAY: "팀 순위 표시",
  T_46_META_WS_P_TEAMRANKS: "팀 순위",
  T_46_META_WS_P_TEAMSCORES: "팀 점수",
  T_46_META_WS_P_TEAMSEQ: "팀 순서",
  T_46_META_WS_P_TEMPLATEENTITY: "템플릿 엔티티",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "임시 방어막 포인트",
  T_46_META_WS_P_TERRAINWETNESS: "지형 습기",
  T_46_META_WS_P_TEXT: "텍스트",
  T_46_META_WS_P_TEXTCOLOR: "텍스트 색상",
  T_46_META_WS_P_TEXTKEY: "텍스트 키",
  T_46_META_WS_P_TEXTKEYPARAMS: "텍스트 키 매개변수",
  T_46_META_WS_P_TEXTURERESOURCE: "텍스처 리소스",
  T_46_META_WS_P_THEMECOLOR: "테마 색상",
  T_46_META_WS_P_THROWABLETYPE: "던질 수 있는 물체 유형",
  T_46_META_WS_P_THROWINGSPEED: "던지기 속도",
  T_46_META_WS_P_THROWSPEED: "던지기 속도",
  T_46_META_WS_P_TICKINTERVAL: "틱 간격",
  T_46_META_WS_P_TIMEREQUIRED: "필요 시간 (ms)",
  T_46_META_WS_P_TIPSTYPE: "팁 유형",
  T_46_META_WS_P_TITLE: "제목",
  T_46_META_WS_P_TITLELIST: "제목",
  T_46_META_WS_P_TITLES: "점수 1",
  T_46_META_WS_P_TOP: "상의",
  T_46_META_WS_P_TOPALPHA: "상단 알파",
  T_46_META_WS_P_TOTALHP: "총 HP",
  T_46_META_WS_P_TOTALLEVEL: "총 레벨",
  T_46_META_WS_P_TOTALROUNDCOUNT: "총 라운드 수",
  T_46_META_WS_P_TOWSPEED: "견인 속도",
  T_46_META_WS_P_TRANSITIONSTAGE: "전환 단계",
  T_46_META_WS_P_TRANSITIONTYPE: "전환 유형",
  T_46_META_WS_P_TRIGGERPLAYERID: "통화",
  T_46_META_WS_P_TRIGGERRADIUS: "트리거 범위",
  T_46_META_WS_P_TRIGGERRANGE: "트리거 범위",
  T_46_META_WS_P_TRIGGERTIME: "트리거 시간",
  T_46_META_WS_P_TURNSPEED: "회전 속도",
  T_46_META_WS_P_TWEENERENABLED: "왼쪽 팀",
  T_46_META_WS_P_TWEENSTYLE: "트윈 스타일",
  T_46_META_WS_P_TYPE: "유형",
  T_46_META_WS_P_UNSELECTEDCOLOR: "선택되지 않은 색상",
  T_46_META_WS_P_UNSELECTEDSPRITE: "선택되지 않은 스프라이트",
  T_46_META_WS_P_UNSELECTEDTYPE: "선택되지 않은 유형",
  T_46_META_WS_P_UP: "위쪽",
  T_46_META_WS_P_UPDATETYPE: "업데이트 유형",
  T_46_META_WS_P_UPENERGYCOST: "상승 에너지 비용",
  T_46_META_WS_P_UPSPEED: "상승 속도",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "사용자 정의 밀어내기 힘 사용",
  T_46_META_WS_P_USECUSTOMRESOURCE: "사용자 정의 리소스 사용",
  T_46_META_WS_P_USEDCAPACITY: "사용된 용량",
  T_46_META_WS_P_USEGRAVITY: "중력 사용",
  T_46_META_WS_P_USEPHYSICALCCT: "물리적 CCT 사용",
  T_46_META_WS_P_USERUID: "사용자 UID",
  T_46_META_WS_P_UVOFFSET: "UV 오프셋",
  T_46_META_WS_P_UVSIZE: "UV 크기",
  T_46_META_WS_P_VALUE: "값",
  T_46_META_WS_P_VAULTDISTANCE: "장애물 넘기 거리",
  T_46_META_WS_P_VAULTHEIGHT: "장애물 넘기 높이",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "차량 피해 계수",
  T_46_META_WS_P_VEHICLESKINID: "차량 스킨 ID",
  T_46_META_WS_P_VEHICLESKINIDS: "차량 스킨 ID",
  T_46_META_WS_P_VELOCITY: "속도 (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "XZ축 속도",
  T_46_META_WS_P_VELOCITYY: "Y축 속도",
  T_46_META_WS_P_VERTICALBAR: "수직 막대",
  T_46_META_WS_P_VERTICALOFFSET: "수직 오프셋",
  T_46_META_WS_P_VEST: "방탄 조끼",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX 텍스처 유형",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "시야 제한",
  T_46_META_WS_P_VISIBILITYLAYER: "가시성 레이어",
  T_46_META_WS_P_VISIBLE: "보이는",
  T_46_META_WS_P_VISIBLEONBACK: "등에 보이는",
  T_46_META_WS_P_VISIBLEPLAYERS: "표시된 플레이어",
  T_46_META_WS_P_VOLUME: "볼륨",
  T_46_META_WS_P_WALLETID: "지갑 ID",
  T_46_META_WS_P_WANDERRANGE: "방황 범위",
  T_46_META_WS_P_WAVECOUNT: "파도 수",
  T_46_META_WS_P_WAVEINTERVAL: "파도 간격",
  T_46_META_WS_P_WEAPONDAMAGERATE: "무기 피해율",
  T_46_META_WS_P_WEAPONSKINIDS: "무기 스킨 ID",
  T_46_META_WS_P_WEAPONSUBTYPE: "무기 하위 유형",
  T_46_META_WS_P_WEAPONTYPE: "무기 유형",
  T_46_META_WS_P_WIDTH: "너비",
  T_46_META_WS_P_WINMVPS: "승리 MVP",
  T_46_META_WS_P_WINTEXT: "승리 텍스트",
  T_46_META_WS_P_WORDWRAP: "단어 줄 바꿈",
  T_46_META_WS_P_WORLDPOSITION: "월드 위치",
  T_46_META_WS_P_YAW: "요",
  T_46_META_WS_PATROLALONG: "순찰 경로",
  T_46_META_WS_PATROLTO: "순찰 이동",
  T_46_META_WS_PAUSE: "일시 정지",
  T_46_META_WS_PAUSEEMOTE: "이모트 일시 정지",
  T_46_META_WS_PAUSEFIXEDUPDATE: "고정 업데이트 일시 정지",
  T_46_META_WS_PHASE: "단계",
  T_46_META_WS_PLAY: "재생",
  T_46_META_WS_PLAYABLE: "플레이 가능",
  T_46_META_WS_PLAYANIMATION: "애니메이션 재생",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "캐릭터 애니메이션 클립 재생",
  T_46_META_WS_PLAYEMOTE: "이모트 재생",
  T_46_META_WS_PLAYER: "플레이어",
  T_46_META_WS_PORTAL: "포털",
  T_46_META_WS_POSE: "포즈",
  T_46_META_WS_POSITION: "위치",
  T_46_META_WS_PREPOSE: "사전 포즈 ",
  T_46_META_WS_PROFANITYFILTER: "욕설 필터",
  T_46_META_WS_PURSUITTARGET: "추적 목표",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "쿼터니언을 축 각도로 변환",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "쿼터니언을 오일러 각도로 변환",
  T_46_META_WS_QUITCHATCHANNEL: "채팅 채널 나가기",
  T_46_META_WS_QUITFACTION: "진영 탈퇴",
  T_46_META_WS_QUITGAME: "게임 종료",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "탈옥 미니게임 종료",
  T_46_META_WS_RANDOMFLOAT: "랜덤 실수",
  T_46_META_WS_RANDOMINT: "랜덤 정수",
  T_46_META_WS_RANK: "순위",
  T_46_META_WS_READCSV: "CSV 읽기",
  T_46_META_WS_READCSVCELL: "CSV 셀 읽기",
  T_46_META_WS_READCSVCELLBYNAME: "CSV 셀을 행과 열 이름으로 읽기",
  T_46_META_WS_READCSVCELLFROMSERVER: "서버에서 CSV 셀 읽기",
  T_46_META_WS_READCSVCOLUMN: "CSV 열 읽기",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "서버에서 CSV 열 읽기",
  T_46_META_WS_READCSVFROMSERVER: "서버에서 CSV 읽기",
  T_46_META_WS_READCSVROW: "CSV 행 읽기",
  T_46_META_WS_READCSVROWBYKEY: "키로 CSV 행 읽기",
  T_46_META_WS_READCSVROWFROMSERVER: "서버에서 CSV 행 읽기",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "누적 데이터 저장소에서 읽기",
  T_46_META_WS_READFROMDATASTORE: "데이터 저장소에서 읽기",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "랭킹 데이터 저장소에서 읽기",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "랭킹 데이터 저장소에서 순위 기준으로 읽기",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI 특수 팔로우 제거",
  T_46_META_WS_REMOVEBACKPACKSKIN: "배낭 스킨 제거",
  T_46_META_WS_REMOVEBUFF: "버프 제거",
  T_46_META_WS_REMOVECOMPONENT: "컴포넌트 제거",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "수식 속성 계수 제거",
  T_46_META_WS_REMOVEOUTFIT: "의상 제거",
  T_46_META_WS_REMOVESCRIPT: "스크립트 제거",
  T_46_META_WS_REMOVEVEHICLESKIN: "차량 스킨 제거",
  T_46_META_WS_REMOVEWEAPONSKIN: "무기 스킨 제거",
  T_46_META_WS_REPLACE: "대체",
  T_46_META_WS_REQUESTMATCHMAKING: "매치메이킹 요청",
  T_46_META_WS_RESET: "초기화",
  T_46_META_WS_RESETBACKPACKSKIN: "배낭 스킨 초기화",
  T_46_META_WS_RESETDYEING: "염색 초기화",
  T_46_META_WS_RESETJERSEY: "유니폼 리셋",
  T_46_META_WS_RESETOUTFIT: "의상 초기화",
  T_46_META_WS_RESETVEHICLESKIN: "차량 스킨 초기화",
  T_46_META_WS_RESETWEAPONSKIN: "무기 스킨 초기화",
  T_46_META_WS_RESUMEFIXEDUPDATE: "고정 업데이트 재개",
  T_46_META_WS_REVERSE: "반전",
  T_46_META_WS_REVIVALSOURCE: "부활 소스",
  T_46_META_WS_REVIVE: "부활",
  T_46_META_WS_ROUND: "반올림",
  T_46_META_WS_ROUNDINDEX: "라운드 인덱스",
  T_46_META_WS_SAMPLEONCURVE: "곡선에서 샘플링",
  T_46_META_WS_SCENENAME: "장면 이름",
  T_46_META_WS_SCORE: "점수",
  T_46_META_WS_SCORER: "득점자",
  T_46_META_WS_SCORETYPE: "점수 유형",
  T_46_META_WS_SCREENMULTIRAYCAST: "화면 다중 레이캐스트",
  T_46_META_WS_SCREENSINGLERAYCAST: "화면 단일 레이캐스트",
  T_46_META_WS_SCREENTOUCHRAY: "화면 터치 레이",
  T_46_META_WS_SCREENTOWORLDPOINT: "화면에서 월드로",
  T_46_META_WS_SENDEVENT: "이벤트 전송",
  T_46_META_WS_SETACTIVE: "활성화 설정",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "모든 플레이어의 이동 상태 설정",
  T_46_META_WS_SETATTACKABLEENTITY: "공격 가능한 엔티티 설정",
  T_46_META_WS_SETATTACKABLEFACTION: "공격 가능한 진영 설정",
  T_46_META_WS_SETATTACKABLETEAM: "공격 가능한 팀 설정",
  T_46_META_WS_SETBACKPACKSKIN: "배낭 스킨 설정",
  T_46_META_WS_SETBEHAVIORSTATUS: "행동 상태 설정",
  T_46_META_WS_SETBLACKBOARDVALUE: "블랙보드 값 설정",
  T_46_META_WS_SETBUNDLE: "번들 설정",
  T_46_META_WS_SETCAMERAFOCUS: "카메라 초점 설정",
  T_46_META_WS_SETCAMERAFOLLOW: "카메라 추적 설정",
  T_46_META_WS_SETCHARACTER: "캐릭터 설정",
  T_46_META_WS_SETCULLINGMASK: "컬링 마스크 설정",
  T_46_META_WS_SETCULLINGMASKLAYER: "컬링 마스크 레이어 설정",
  T_46_META_WS_SETDEFAULTUISTATUS: "기본 UI 상태 설정",
  T_46_META_WS_SETDROPSTATUS: "드롭 상태 설정",
  T_46_META_WS_SETFALLINGDAMAGE: "낙하 피해 설정",
  T_46_META_WS_SETFOOTBALLPOSITION: "축구 위치 설정",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "수식 속성 절대적 설정",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "수식 속성 상대적 설정",
  T_46_META_WS_SETFORWARD: "방향 설정",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "전역 수면 임계값 설정",
  T_46_META_WS_SETINVINCIBILITY: "무적 상태 설정",
  T_46_META_WS_SETJERSEY: "유니폼 설정",
  T_46_META_WS_SETOUTFIT: "의상 설정",
  T_46_META_WS_SETPARENT: "부모 설정",
  T_46_META_WS_SETPARENTCLIENT: "부모 설정",
  T_46_META_WS_SETPICKUPSTATUS: "픽업 상태 설정",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "플레이어 빠른 메시지 상태 설정",
  T_46_META_WS_SETPLAYERVOICESTATUS: "플레이어 음성 상태 설정",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "속성 부드럽게 설정",
  T_46_META_WS_SETSKILLS: "스킬 설정",
  T_46_META_WS_SETSKYBOX: "스카이박스 설정",
  T_46_META_WS_SETSLEEPTHRESHOLD: "수면 임계값 설정",
  T_46_META_WS_SETSPECIALITEMSTATUS: "특수 아이템 상태 설정",
  T_46_META_WS_SETVEHICLESKIN: "차량 스킨 설정",
  T_46_META_WS_SETWEAPONSKIN: "무기 스킨 설정",
  T_46_META_WS_SETWIDGETPARENT: "위젯 부모 설정",
  T_46_META_WS_SHOPITEM: "상점 아이템",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "외형 그룹 표시",
  T_46_META_WS_SHUFFLE: "셔플",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "단일 레이캐스트",
  T_46_META_WS_SKILL: "스킬",
  T_46_META_WS_SLEEP: "잠자기",
  T_46_META_WS_SLERPQUATERNION: "쿼터니언 Slerp",
  T_46_META_WS_SPAWNABLES: "생성 가능한 아이템",
  T_46_META_WS_SPAWNEDITEM: "생성된 아이템",
  T_46_META_WS_SPAWNNEXTWAVE: "다음 웨이브 스폰",
  T_46_META_WS_SPHERECAST: "구형 캐스트",
  T_46_META_WS_SPHEREOVERLAP: "구형 오버랩",
  T_46_META_WS_SPLIT: "나누기",
  T_46_META_WS_SQRT: "제곱근",
  T_46_META_WS_STARTPARACHUTE: "낙하산 시작",
  T_46_META_WS_STARTPOSITION: "시작 위치",
  T_46_META_WS_STATENAME: "상태 이름",
  T_46_META_WS_STATUS: "상태",
  T_46_META_WS_STRINGTOFLOAT: "문자열을 부동 소수점으로 변환",
  T_46_META_WS_STRINGTOINT: "문자열을 정수로 변환",
  T_46_META_WS_STRIP: "공백 제거",
  T_46_META_WS_SUB: "빼기",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI 프록시 옵저버 전환",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "외형 그룹 전환",
  T_46_META_WS_SWITCHAREA: "지역 전환",
  T_46_META_WS_SWITCHCAMERA: "카메라 전환",
  T_46_META_WS_SWITCHPHASE: "단계 전환",
  T_46_META_WS_SWITCHSCENE: "씬 전환",
  T_46_META_WS_SWITCHWEAPON: "무기 전환",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "대상",
  T_46_META_WS_TEAM: "팀",
  T_46_META_WS_TELEPORT: "텔레포트",
  T_46_META_WS_TELEPORTCCT: "CCT 텔레포트",
  T_46_META_WS_TEXT: "텍스트",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "타임스탬프를 지역화 문자열로 변환",
  T_46_META_WS_TIRE: "타이어",
  T_46_META_WS_TOLOWER: "소문자로 변환",
  T_46_META_WS_TOSTRING: "문자열로 변환",
  T_46_META_WS_TOUPPER: "대문자로 변환",
  T_46_META_WS_TRANSFERMONEY: "돈 전송",
  T_46_META_WS_TRIGGER: "트리거",
  T_46_META_WS_TYPEIS: "유형이",
  T_46_META_WS_UNLOADSCENE: "씬 언로드",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "탈옥 미션 업데이트",
  T_46_META_WS_UPLOADGAMERESULT: "게임 결과 업로드",
  T_46_META_WS_VALUE: "피해",
  T_46_META_WS_VECTOR2ANGLE: "2D 벡터 각도",
  T_46_META_WS_VECTOR2DISTANCE: "2D 벡터 거리",
  T_46_META_WS_VECTOR2DOT: "2D 벡터 점",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D 벡터 크기",
  T_46_META_WS_VECTOR2NORMALIZE: "2D 벡터 정규화",
  T_46_META_WS_VECTOR2REFLECT: "2D 벡터 반사",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D 벡터를 3D 벡터로 변환",
  T_46_META_WS_VECTOR3REFLECT: "3D 벡터 반사",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D 벡터를 2D 벡터로 변환",
  T_46_META_WS_VEHICLE: "차량",
  T_46_META_WS_VELOCITY: "속도",
  T_46_META_WS_WAITFORMILESECOND: "밀리초 대기",
  T_46_META_WS_WAITFORNEXTFRAME: "다음 프레임까지 대기",
  T_46_META_WS_WAKEUP: "깨우기",
  T_46_META_WS_WAVES: "파동",
  T_46_META_WS_WEAPON: "무기",
  T_46_META_WS_WORLDTOSCREENPOINT: "월드에서 화면으로",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "누적 데이터 저장소에 쓰기",
  T_46_META_WS_WRITETODATASTORE: "데이터 저장소에 쓰기",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "랭킹 데이터 저장소에 쓰기",
  T_48_META_API_1_D: "현재 게임에 있는 모든 플레이어를 가져와서 플레이어 목록을 반환합니다.",
  T_48_META_API_1_R_D: "플레이어 목록",
  T_48_META_API_10_D: "씬 오브젝트 가져오기",
  T_48_META_API_10_P0_D: "필터링할 씬 오브젝트 유형",
  T_48_META_API_10_R_D: "장면 개체 목록",
  T_48_META_API_100_D: "이미 로드된 시나리오를 자동으로 언로드하지 않고 시나리오 로드하기",
  T_48_META_API_100_P0_D: "로드할 장면 ID",
  T_48_META_API_10000_D: "현재 스크립트가 바인딩된 엔티티를 반환합니다.",
  T_48_META_API_10000_R_D: "현재 스크립트가 바인딩된 엔티티입니다.",
  T_48_META_API_10001_D: "엔티티 ID를 사용하여 해당 엔티티를 찾으려면 이 API는 편집자 전용이며, 사용자 측에서 이 API를 사용한다고 해서 제거하거나 조정하는 등 호환성이 보장되는 것은 아닙니다.",
  T_48_META_API_10001_P0_D: "대상 엔터티 ID",
  T_48_META_API_10001_R_D: "물질적으로 존재하는 것(개념적, 가상적 또는 온라인상의 존재와 반대되는 개념)",
  T_48_META_API_10002_D: "게임의 글로벌 엔티티 확보",
  T_48_META_API_10002_R_D: "글로벌 법인",
  T_48_META_API_10003_D: "플레이어를 특정 좌표로 순간이동(사용 중단, 텔레포트 사용)",
  T_48_META_API_10003_P0_D: "순간이동한 플레이어",
  T_48_META_API_10003_P1_D: "전송된 지점의 좌표",
  T_48_META_API_10004_D: "팀원 근처의 위치를 구하고, 서 있을 수 없는 플레이어의 위치를 우회합니다(사용 중단, GetTeamateNearPosition 사용).",
  T_48_META_API_10004_P0_D: "대상 플레이어",
  T_48_META_API_10004_R_D: "팀원 근처의 좌표",
  T_48_META_API_10005_D: "인수 법인에 소속된 플레이어",
  T_48_META_API_10005_P0_D: "대상 엔티티, 엔티티는 해당 엔티티가 속한 플레이어와만 동기화됩니다.",
  T_48_META_API_10005_R_D: "대상 엔티티가 속한 플레이어",
  T_48_META_API_10006_D: "무적의 플레이어 만들기",
  T_48_META_API_10006_P0_D: "대상 플레이어",
  T_48_META_API_10006_P1_D: "무적 효과 지속 시간, 초 단위",
  T_48_META_API_10007_D: "선택한 엔티티와 모든 프로퍼티를 원래 위치에 복제합니다.",
  T_48_META_API_10007_P0_D: "생성된 엔티티",
  T_48_META_API_10007_P1_D: "복제할 엔티티",
  T_48_META_API_10008_D: "플레이어에게 피해를 입히고, 피해원이 선택되지 않은 경우 대상은 시스템에서 피해를 받습니다.",
  T_48_META_API_10008_P0_D: "부상당한 게임 개체",
  T_48_META_API_10008_P1_D: "피해를 유발하는 게임 개체",
  T_48_META_API_10008_P2_D: "손상 유형",
  T_48_META_API_10008_P3_D: "손상 수량",
  T_48_META_API_10009_D: "지정 플레이어 부활",
  T_48_META_API_10009_P0_D: "부활한 플레이어",
  T_48_META_API_1001_D: "조건이 충족되면 IF 아래의 노드가 실행됩니다. 조건이 충족되지 않으면 ELSE가 있는 경우 ELSE 아래의 노드를 실행하고, 그렇지 않으면 IF 문을 종료합니다.",
  T_48_META_API_1001_P0_D: "조건 목록은 하위 프로시저 목록(논리적 분기 목록)의 수와 일치해야 합니다.",
  T_48_META_API_10010_D: "지정된 위치에 항목 또는 항목 목록을 만듭니다.",
  T_48_META_API_10010_P0_D: "아이템 생성 위치",
  T_48_META_API_10010_P1_D: "생성된 항목 또는 항목 목록",
  T_48_META_API_10010_P2_D: "생성할 항목 수. 항목 목록을 생성할 때 항목 목록의 순서에 해당하는 항목 수를 입력해야 합니다.",
  T_48_META_API_10011_D: "목표 지점을 순찰하는 AI 개체",
  T_48_META_API_10011_P0_D: "타겟팅된 AI 개체",
  T_48_META_API_10011_P1_D: "목표 지점 이동",
  T_48_META_API_10011_P2_D: "출발 지점으로 돌아갈지 여부",
  T_48_META_API_10011_P3_D: "순찰 중 적대적인 목표가 탐지되어 공격당했는지 여부",
  T_48_META_API_10012_D: "좌표 목록 순서대로 순찰하는 AI 엔티티",
  T_48_META_API_10012_P0_D: "타겟팅된 AI 개체",
  T_48_META_API_10012_P1_D: "이동 좌표점 목록",
  T_48_META_API_10012_P2_D: "단일, 왕복 루프 또는 주기 옵션이 있는 순찰 유형",
  T_48_META_API_10012_P3_D: "순찰 중 적대적인 목표가 탐지되어 공격당했는지 여부",
  T_48_META_API_10013_D: "생성기는 다음 단위 엔티티의 물결을 즉시 새로 고칩니다.",
  T_48_META_API_10013_P0_D: "발전기 엔티티",
  T_48_META_API_10014_D: "계산 가능한 속성을 계산하기 위한 요소를 추가하면 요소로 구성된 공식에 의해 계산되어 최종 결과를 생성합니다.",
  T_48_META_API_10014_P0_D: "대상 엔티티",
  T_48_META_API_10014_P1_D: "계산 가능한 속성 유형",
  T_48_META_API_10014_P2_D: "계산 계수 유형",
  T_48_META_API_10014_P3_D: "계수 값 계산",
  T_48_META_API_10015_D: "계산 가능한 속성에 대한 계산 계수 지우기",
  T_48_META_API_10015_P0_D: "대상 엔티티",
  T_48_META_API_10015_P1_D: "계산 가능한 속성 유형",
  T_48_META_API_10016_D: "대상 엔티티의 계산 가능한 모든 속성에 대한 모든 계산 인자를 지웁니다.",
  T_48_META_API_10016_P0_D: "대상 엔티티",
  T_48_META_API_10017_D: "속성 수정",
  T_48_META_API_10017_P0_D: "대상 엔티티",
  T_48_META_API_10017_P1_D: "속성 유형",
  T_48_META_API_10017_P2_D: "수정 방법",
  T_48_META_API_10017_P3_D: "(될) 가치",
  T_48_META_API_10018_D: "계산 가능한 프로퍼티의 값 설정하기",
  T_48_META_API_10018_P0_D: "대상 엔티티",
  T_48_META_API_10018_P1_D: "속성 유형",
  T_48_META_API_10018_P2_D: "(될) 가치",
  T_48_META_API_10019_D: "계산 가능한 개별 속성 수정 사항 지우기",
  T_48_META_API_10019_P0_D: "대상 엔티티",
  T_48_META_API_10019_P1_D: "속성 유형",
  T_48_META_API_1002_D: "매개변수 i는 최소값에서 시작하여 아래 노드가 실행될 때마다 i가 최대값보다 크거나 같을 때까지 단계 값을 증가시킵니다.",
  T_48_META_API_1002_P0_D: "로컬 변수에서 순환 인덱스의 값을 가져오는 데 사용할 수 있는 순환 인덱스의 이름입니다.",
  T_48_META_API_1002_P1_D: "주기적 초기값",
  T_48_META_API_1002_P2_D: "주기 종료 값",
  T_48_META_API_1002_P3_D: "루프 스텝 크기, 시작 값이 끝 값보다 작으면 스텝 크기는 0보다 커야 하고, 시작 값이 끝 값보다 크면 스텝 크기는 0보다 작아야 합니다.",
  T_48_META_API_10020_D: "게임에서 필터 기준을 충족하는 모든 엔티티를 가져옵니다.",
  T_48_META_API_10020_P0_D: "필터 결과에는 이 매개변수에 입력한 유형이 포함되어야 합니다.",
  T_48_META_API_10020_P1_D: "필터 결과에는 이 매개변수에 입력된 유형이 포함되어서는 안 됩니다.",
  T_48_META_API_10020_P2_D: "필터 결과에는 이 매개변수에 입력된 유형 중 하나 이상이 포함됩니다.",
  T_48_META_API_10020_R_D: "필터링 결과 엔티티 목록",
  T_48_META_API_10021_D: "축구공에 속도를 추가하면 같은 방향의 가속도에 따라 속도가 변경됩니다.",
  T_48_META_API_10021_P0_D: "골 축구",
  T_48_META_API_10021_P1_D: "3D 공간 속도 추가",
  T_48_META_API_10022_D: "지정된 엔티티의 파기",
  T_48_META_API_10022_P0_D: "삭제할 대상 엔터티",
  T_48_META_API_10023_D: "엔티티에 레이블 추가",
  T_48_META_API_10023_P0_D: "대상 엔티티",
  T_48_META_API_10023_P1_D: "사용자 지정 레이블",
  T_48_META_API_10024_D: "엔티티에 대한 레이블 제거",
  T_48_META_API_10024_P0_D: "대상 엔티티",
  T_48_META_API_10024_P1_D: "사용자 지정 레이블",
  T_48_META_API_10025_D: "대상 엔티티에 지정된 레이블이 포함되어 있는지 확인합니다.",
  T_48_META_API_10025_P0_D: "대상 엔티티",
  T_48_META_API_10025_P1_D: "사용자 지정 레이블",
  T_48_META_API_10025_R_D: "지정된 태그를 포함할지 여부",
  T_48_META_API_10026_D: "축구 위치 설정",
  T_48_META_API_10026_P0_D: "축구 단체",
  T_48_META_API_10026_P1_D: "배치",
  T_48_META_API_10026_P2_D: "속도 유지",
  T_48_META_API_10027_D: "타깃 플레이어가 현재 사용 중인 카메라 엔티티를 가져옵니다.",
  T_48_META_API_10027_P0_D: "대상 플레이어",
  T_48_META_API_10027_R_D: "현재 사용 중인 카메라 엔티티",
  T_48_META_API_10028_D: "타깃 플레이어의 카메라를 타깃 카메라로 전환하면",
  T_48_META_API_10028_P0_D: "대상 플레이어",
  T_48_META_API_10028_P1_D: "대상 카메라",
  T_48_META_API_10028_P2_D: "전환 방법, 원래 로직을 유지하거나 점진적으로 전환하도록 선택할 수 있습니다.",
  T_48_META_API_10028_P3_D: "전환 시간은 프로그레시브 모드에서 카메라를 전환하는 시간입니다.",
  T_48_META_API_10029_D: "카메라 만들기",
  T_48_META_API_10029_P0_D: "생성된 카메라 유형",
  T_48_META_API_10029_P1_D: "생성된 카메라 엔티티",
  T_48_META_API_1003_D: "하위 프로시저를 포함하는 각 하위 요소로 이동하기 위해 데이터 컨테이너의 탐색을 구현하고, 루프 본문은 하위 프로시저입니다.",
  T_48_META_API_1003_P0_D: "자식 요소의 이름을 반복하여 로컬 변수에 있는 자식 요소의 값을 가져오는 데 사용할 수 있습니다.",
  T_48_META_API_1003_P1_D: "로컬 변수에서 순환 인덱스의 값을 가져오는 데 사용할 수 있는 순환 인덱스의 이름입니다.",
  T_48_META_API_1003_P2_D: "트래버스할 데이터 컨테이너, 현재 지원되는 유형은 다음과 같습니다: 배열 유형",
  T_48_META_API_10030_D: "전투 가능한 개체 처치",
  T_48_META_API_10030_P0_D: "전투 준비 상태여야 하는 대상 개체",
  T_48_META_API_10031_D: "대상 엔티티와 그 자식 노드의 활성 상태를 설정합니다. 비활성 오브젝트의 경우 가용성, 가시성, 충돌 등이 꺼집니다.",
  T_48_META_API_10031_P0_D: "대상 엔티티",
  T_48_META_API_10031_P1_D: "활성 또는 비활성",
  T_48_META_API_10032_D: "카메라 엔티티의 위치를 항상 대상 엔티티를 따르도록 설정합니다.",
  T_48_META_API_10032_P0_D: "대상 카메라 엔티티",
  T_48_META_API_10032_P1_D: "팔로우할 대상 엔터티",
  T_48_META_API_10032_P2_D: "대상 엔티티 좌표에서 오프셋",
  T_48_META_API_10032_P3_D: "오프셋을 위한 좌표계",
  T_48_META_API_10033_D: "카메라 엔티티가 항상 대상 엔티티를 향하도록 설정합니다.",
  T_48_META_API_10033_P0_D: "대상 카메라 엔티티",
  T_48_META_API_10033_P1_D: "대상 엔티티",
  T_48_META_API_10033_P2_D: "대상 좌표에서 시선 포인트의 오프셋",
  T_48_META_API_10033_P3_D: "오프셋을 위한 좌표계",
  T_48_META_API_10034_D: "트윈 만들기",
  T_48_META_API_10034_P0_D: "대상 엔티티",
  T_48_META_API_10034_P1_D: "속성 ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "스타일",
  T_48_META_API_10034_P5_D: "커브",
  T_48_META_API_10034_P6_D: "기간",
  T_48_META_API_10034_P7_D: "엔티티 간",
  T_48_META_API_10035_D: "부모 노드를 설정하려면 부모와 자식 모두 트랜스폼 컴포넌트가 있어야 합니다.",
  T_48_META_API_10035_P0_D: "부모 노드",
  T_48_META_API_10035_P1_D: "자식 노드",
  T_48_META_API_10035_P2_D: "현재 월드 위치, 자손 노드의 회전 및 스케일 유지 여부, UI 설정 시 이 항목은 유효하지 않습니다.",
  T_48_META_API_10036_D: "뉴커브(더 이상 사용되지 않음, CreateTweenCurve를 사용하세요)",
  T_48_META_API_10036_P0_D: "컨트롤 포인트",
  T_48_META_API_10036_R_D: "트웬커브 엔티티",
  T_48_META_API_10037_D: "플레이 가능한 컴포넌트가 있어야 하는 대상 엔티티를 플레이하려고 시도합니다.",
  T_48_META_API_10037_P0_D: "대상 플레이 가능 엔티티",
  T_48_META_API_10037_P1_D: `재생 여부 
참: 재생 
거짓: 계속 재생`,
  T_48_META_API_10038_D: "플레이 가능한 엔티티 일시 중지",
  T_48_META_API_10038_P0_D: "대상 플레이 가능 엔티티",
  T_48_META_API_10039_D: "타깃 엔티티에 초기 속도와 방향 가속도를 부여하는 탄도 모션을 생성합니다.",
  T_48_META_API_10039_P0_D: "대상 엔티티",
  T_48_META_API_10039_P1_D: "초기 속도",
  T_48_META_API_10039_P2_D: "동작 가속도",
  T_48_META_API_10039_P3_D: "최대 변위 거리",
  T_48_META_API_10039_P4_D: "탄도 모션 엔티티 생성",
  T_48_META_API_10039_P5_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_1004_D: "현재 루프 프로세스를 중단하고 루프를 종료합니다.",
  T_48_META_API_10040_D: "대상 개체가 지정된 개체를 따라가는 위치 추종 모션을 만듭니다.",
  T_48_META_API_10040_P0_D: "대상 엔티티",
  T_48_META_API_10040_P1_D: "움직임을 따르는 개체 개체",
  T_48_META_API_10040_P2_D: "거리는 대상 좌표의 오프셋을 따릅니다.",
  T_48_META_API_10040_P3_D: "사용된 좌표계",
  T_48_META_API_10040_P4_D: "팔로우 모션 엔티티 생성",
  T_48_META_API_10040_P5_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_10041_D: "대상 개체가 지정된 개체를 향한 방향을 유지하는 시선 추적 모션을 만듭니다.",
  T_48_META_API_10041_P0_D: "대상 엔티티",
  T_48_META_API_10041_P1_D: "고려 대상 엔티티",
  T_48_META_API_10041_P2_D: "오브젝트 엔티티에서 시선 포인트의 오프셋",
  T_48_META_API_10041_P3_D: "사용된 좌표계",
  T_48_META_API_10041_P4_D: "시선 추적 모션 엔티티 생성",
  T_48_META_API_10041_P5_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_10042_D: "버려진",
  T_48_META_API_10042_P0_D: "플레이어 엔티티",
  T_48_META_API_10042_P1_D: "대회 결과",
  T_48_META_API_10042_P2_D: "버려진",
  T_48_META_API_10042_P3_D: "버려진",
  T_48_META_API_10042_P4_D: "버려진",
  T_48_META_API_10043_D: "스무딩은 대상 엔티티의 속성을 설정하고 속성은 즉시 변경되지만 클라이언트는 부드러운 전환 성능을 재생합니다.",
  T_48_META_API_10043_P0_D: "대상 엔티티",
  T_48_META_API_10043_P1_D: "대상 엔티티의 속성",
  T_48_META_API_10043_P2_D: "프로퍼티를 정의할 때 필요한 유형과 일치해야 하는 대상 값입니다.",
  T_48_META_API_10044_D: "광선 감지를 수행하고 광선 방향으로 히트한 첫 번째 엔티티를 반환하며, 히트 엔티티에는 콜리전 컴포넌트가 있어야 합니다.",
  T_48_META_API_10044_P0_D: "시작 위치 좌표",
  T_48_META_API_10044_P1_D: "방사선 감지 방향",
  T_48_META_API_10044_P2_D: "방사선 감지 거리, 양수 값만 허용됩니다.",
  T_48_META_API_10044_P3_D: "광선 감지 레이어 마스크, 채워진 레이어만 스캔에 참여하며 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_10044_P4_D: "트리거를 검색할 수 있나요?",
  T_48_META_API_10044_P5_D: "히트 엔티티",
  T_48_META_API_10044_P6_D: "히트 포인트 좌표",
  T_48_META_API_10044_P7_D: "시작 지점에서 적중 지점까지의 거리",
  T_48_META_API_10044_P8_D: "표면 법선 타격",
  T_48_META_API_10045_D: "단일 광선 감지를 수행하고 광선 방향에서 가까운 곳에서 먼 곳까지 광선 방향에 닿은 모든 엔티티를 반환합니다.",
  T_48_META_API_10045_P0_D: "시작 위치 좌표",
  T_48_META_API_10045_P1_D: "방사선 감지 방향",
  T_48_META_API_10045_P2_D: "방사선 감지 거리, 양수 값만 허용됩니다.",
  T_48_META_API_10045_P3_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_10045_P4_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_10045_P5_D: "히트된 엔티티 목록",
  T_48_META_API_10045_P6_D: "히트 포인트 목록",
  T_48_META_API_10045_P7_D: "시작 지점으로부터 적중 지점까지의 거리 목록",
  T_48_META_API_10045_P8_D: "표면 법선 타격",
  T_48_META_API_10046_D: "조립식 바디를 사용하여 템플릿용 솔리드 만들기",
  T_48_META_API_10046_P0_D: "생성된 엔티티",
  T_48_META_API_10046_P1_D: "조립식 본체 ID",
  T_48_META_API_10047_D: "변색",
  T_48_META_API_10047_P0_D: "오브젝트 노멀 설정",
  T_48_META_API_10047_P1_D: "색점 설정",
  T_48_META_API_10047_P2_D: "색상",
  T_48_META_API_10048_D: "색상 상태",
  T_48_META_API_10048_P0_D: "색점 설정",
  T_48_META_API_10048_P1_D: "방향 설정",
  T_48_META_API_10048_P2_D: "거리 설정",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "컬러링 통계",
  T_48_META_API_10049_P0_D: "색상",
  T_48_META_API_10049_R_D: "색상 수",
  T_48_META_API_1005_D: "나머지 루프 본문은 건너뛰고 다음 루프로 바로 이동합니다.",
  T_48_META_API_10050_D: "플랫 레인지 컬러링",
  T_48_META_API_10050_P0_D: "오브젝트 노멀 설정",
  T_48_META_API_10050_P1_D: "색점 설정",
  T_48_META_API_10050_P2_D: "염색 범위 설정",
  T_48_META_API_10050_P3_D: "색상",
  T_48_META_API_10050_P4_D: "색상 수",
  T_48_META_API_10051_D: "지역 얼룩",
  T_48_META_API_10051_P0_D: "오브젝트 노멀 설정",
  T_48_META_API_10051_P1_D: "색점 설정",
  T_48_META_API_10051_P2_D: "염색 범위 설정",
  T_48_META_API_10051_P3_D: "색상",
  T_48_META_API_10051_P4_D: "고정 염색 영역",
  T_48_META_API_10051_P5_D: "랜덤 계수(수학)",
  T_48_META_API_10051_P6_D: "랜덤 감쇠 계수",
  T_48_META_API_10051_P7_D: "색상 수",
  T_48_META_API_10052_D: "대상 부모 엔티티의 모든 자식 가져오기",
  T_48_META_API_10052_P0_D: "상위 엔티티",
  T_48_META_API_10052_R_D: "하위 노드 목록",
  T_48_META_API_10053_D: "인덱스에 따라 대상 부모 엔티티의 지정된 자식 노드를 가져옵니다.",
  T_48_META_API_10053_P0_D: "상위 엔티티",
  T_48_META_API_10053_P1_D: "서브노드 인덱스",
  T_48_META_API_10053_R_D: "하위 엔티티",
  T_48_META_API_10054_D: "대상 자식 노드 엔티티의 부모를 가져옵니다.",
  T_48_META_API_10054_P0_D: "하위 엔티티",
  T_48_META_API_10054_R_D: "상위 엔티티",
  T_48_META_API_10055_D: "지정된 부모 노드 엔티티 아래의 모든 자식 노드를 삭제합니다(노드에는 트랜스폼 컴포넌트가 있어야 함).",
  T_48_META_API_10055_P0_D: "상위 엔티티",
  T_48_META_API_10056_D: "대상을 지정된 위치로 순간이동",
  T_48_META_API_10056_P0_D: "운송 단위(예: 군대)",
  T_48_META_API_10056_P1_D: "전송 지점의 좌표",
  T_48_META_API_10056_P2_D: "전송 후 단위 방향",
  T_48_META_API_10057_D: "무작위로 팀원의 주변 위치를 획득하고, 팀원이 없을 경우 자신의 주변 좌표로 돌아가 일어서지 못하는 플레이어의 위치를 피할 수 있습니다.",
  T_48_META_API_10057_P0_D: "대상 플레이어",
  T_48_META_API_10057_R_D: "대상 플레이어의 팀원 근처 좌표",
  T_48_META_API_10058_D: "컬러링 상태 지우기",
  T_48_META_API_10059_D: "지정된 사운드 효과를 재생하고 설정할 속성이 더 있는 경우 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다.",
  T_48_META_API_10059_P0_D: "코드에서 사운드 효과를 생성하는 엔티티를 나타내는 데 사용되는 공식 파라미터의 이름이며, 해당 로컬 변수 값은 사운드 효과를 생성하는 엔티티입니다.",
  T_48_META_API_10059_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_10059_P2_D: "사운드 유형, 플레이어가 선택할 수 있는 음향 효과의 종류",
  T_48_META_API_1006_D: "현재 실행 프로세스를 종료하고 호출 위치로 바로 돌아가면 반환과 함께 데이터를 전달할 수 있습니다.",
  T_48_META_API_1006_P0_D: "발신 위치로 반환하려는 데이터",
  T_48_META_API_10060_D: "대상 플레이어를 게임에서 내쫓기",
  T_48_META_API_10060_P0_D: "대상 플레이어",
  T_48_META_API_10060_P1_D: "결제 정보 표시 여부",
  T_48_META_API_10061_D: "대상 플레이어가 특정 맵에 대한 매치 요청",
  T_48_META_API_10061_P0_D: "대상 플레이어",
  T_48_META_API_10061_P1_D: "전장 코드",
  T_48_META_API_10061_P2_D: "경기 취소 시 원래 게임에 다시 참여할지 묻는 팝업 창이 표시되는지 여부입니다.",
  T_48_META_API_10062_D: "재생 중인 사운드 엔티티 중단하기",
  T_48_META_API_10062_P0_D: "일시 중단해야 하는 사운드 엔티티",
  T_48_META_API_10063_D: "사운드 효과 계속 재생, 선택적으로 처음부터 계속 재생",
  T_48_META_API_10063_P0_D: "일시 정지된 후에도 계속 재생해야 하는 사운드 엔티티",
  T_48_META_API_10063_P1_D: "처음부터 시작할지 여부",
  T_48_META_API_10064_D: "드롭을 생성하면 드롭에는 1. 준비, 2. 낙하, 3. 착륙의 세 단계가 있으며, 1 상태에서만 드롭의 속성을 수정할 수 있습니다.",
  T_48_META_API_10064_P0_D: "Dropbox 엔티티 생성",
  T_48_META_API_1007_D: "조건이 참인지 아닌지에 따라 조건이 거짓이 되어 루프가 종료될 때까지 계속 실행되는 루프를 구현합니다.",
  T_48_META_API_1007_P0_D: "조건이 참이면 루프가 계속되고 조건이 거짓이면 루프가 종료됩니다.",
  T_48_META_API_1008_D: `다음 논리적 프레임이 시작될 때까지 기다림
서버에서 낮은 프레임 속도 모드를 켜면 더 오래 기다립니다
클라이언트에서 대기 시간은 장치의 성능과 현재 프레임의 로직 복잡성에 영향을받습니다
이 API를 사용하는 함수는 비동기로 선언해야합니다.`,
  T_48_META_API_1009_D: "일정 시간 동안 기다렸다가 이 API를 사용하는 함수를 비동기식으로 선언해야 합니다.",
  T_48_META_API_1009_P0_D: "대기 시간(밀리초)",
  T_48_META_API_101_D: "지정된 씬 제거하기",
  T_48_META_API_101_P0_D: "제거할 장면 ID",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "이벤트 발생 시 트리거되는 작업",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "로컬 변수에서 실제 파라미터 값을 얻을 수 있는 이벤트 파라미터의 공식 파라미터 이름입니다.",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "API 조합을 호스팅하는 코드 블록",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "코드 블록이 사용자 정의 함수인 경우 공식적인 매개 변수 이름",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "사용자 정의 함수를 직렬 방식으로 호출하고, 사용자 정의 함수에서 대기 중이면 호출 위치도 대기합니다.",
  T_48_META_API_1012_P0_D: "사용자 정의 함수가 있는 엔티티",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "사용자 정의 함수가 있는 스크립트의 스크립트 ID",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "대상 호출의 함수 ID",
  T_48_META_API_1012_P3_D: "사용자 정의 함수에 전달된 실제 매개변수 목록",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "사용자 지정 함수를 병렬 방식으로 호출하여 사용자 지정 함수에서 대기 중인지 여부에 관계없이 호출 위치로 즉시 돌아와 계속 진행합니다.",
  T_48_META_API_1013_P0_D: "사용자 정의 함수가 있는 엔티티",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "사용자 정의 함수가 있는 스크립트의 스크립트 ID",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "대상 호출의 함수 ID",
  T_48_META_API_1013_P3_D: "사용자 정의 함수에 전달된 실제 매개변수 목록",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "현재 스크립트에서 사용자 정의 함수를 직렬 방식으로 호출하고, 사용자 정의 함수에 대기가 있는 경우 호출 위치도 대기합니다.",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "대상 호출의 함수 ID",
  T_48_META_API_1014_P1_D: "사용자 정의 함수에 전달된 실제 매개변수 목록",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "사용자 지정 함수를 병렬 방식으로 호출하여 사용자 지정 함수에서 대기 중인지 여부에 관계없이 호출 위치로 즉시 돌아와 계속 진행합니다.",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "대상 호출의 함수 ID",
  T_48_META_API_1015_P1_D: "사용자 정의 함수에 전달된 실제 매개변수 목록",
  T_48_META_API_1016_D: "이 API를 호출할 때 대상의 유형을 가져옵니다.",
  T_48_META_API_1016_P0_D: "쿼리 대상",
  T_48_META_API_1016_R_D: "변수 유형",
  T_48_META_API_1017_D: "대상 변수가 지정된 유형인지 확인합니다.",
  T_48_META_API_1017_P0_D: "쿼리 대상",
  T_48_META_API_1017_P1_D: "비교 유형",
  T_48_META_API_1017_R_D: "일관성",
  T_48_META_API_1018_D: "대상 변수가 특정 유형의 서브 클래스인지 여부를 결정하며, 반환 값은 부울 값입니다.",
  T_48_META_API_1018_P0_D: "쿼리 중인 대상 변수",
  T_48_META_API_1018_P1_D: "비교 유형",
  T_48_META_API_1018_R_D: "하위 클래스인지 여부",
  T_48_META_API_1019_D: "대상 엔티티가 지정된 사용자 지정 이벤트를 트리거하도록 합니다.",
  T_48_META_API_1019_P0_D: "사용자 지정 이벤트 ID 전송",
  T_48_META_API_1019_P1_D: "대상 엔티티",
  T_48_META_API_1019_P2_D: "매개변수 목록",
  T_48_META_API_102_D: "특정 장면으로 전환하면 로드된 다른 장면이 언로드됩니다.",
  T_48_META_API_102_P0_D: "전환할 장면 ID",
  T_48_META_API_1020_D: "각 키-값 쌍에 도달하기 위해 컨테이너를 트래버스하는 구현에는 하위 프로시저가 포함되어 있으며, 루프 본문은 하위 프로시저입니다.",
  T_48_META_API_1020_P0_D: "키 이름을 반복하여 로컬 변수에서 키의 값을 가져오는 데 사용할 수 있습니다.",
  T_48_META_API_1020_P1_D: "로컬 변수의 값을 가져오는 데 사용할 수 있는 값의 이름을 반복합니다.",
  T_48_META_API_1020_P2_D: "트래버스할 컨테이너",
  T_48_META_API_1021_D: "봇 삭제",
  T_48_META_API_1021_P0_D: "봇 플레이어 엔티티 삭제",
  T_48_META_API_1022_D: "대상 플레이어가 캐리어를 떠나도록 강제",
  T_48_META_API_1022_P0_D: "대상 플레이어",
  T_48_META_API_1023_D: "부상 점퍼 만들기",
  T_48_META_API_1023_P0_D: "단어 건너뛰기 콘텐츠",
  T_48_META_API_1023_P1_D: "글꼴 크기",
  T_48_META_API_1023_P2_D: "글꼴 색상",
  T_48_META_API_1023_P3_D: "체류 시간(밀리초)",
  T_48_META_API_1023_P4_D: "부상당한 개체",
  T_48_META_API_1023_P5_D: "대상 개체의 월드 좌표에 대한 피해 점프 단어의 오프셋입니다.",
  T_48_META_API_1023_P6_D: "데미지 점프 위치에서 무작위 위치 보정의 범위 크기 재조정",
  T_48_META_API_1023_P7_D: "채우기 애니메이션 실행 여부",
  T_48_META_API_1024_D: "버려진",
  T_48_META_API_1024_P0_D: "버려진",
  T_48_META_API_1024_P1_D: "대상 엔티티",
  T_48_META_API_1024_P2_D: "이 옵션을 선택하면 서버에서 호출된 경우 클라이언트로, 클라이언트에서 호출된 경우 서버로 전송됩니다.",
  T_48_META_API_1024_P3_D: "매개변수 목록",
  T_48_META_API_1025_D: "사용자 지정 작업의 진행 상황 쿼리하기",
  T_48_META_API_1025_P0_D: "대상 플레이어",
  T_48_META_API_1025_P1_D: "사용자 지정 작업 ID",
  T_48_META_API_1025_R_D: "미션 진행 상황",
  T_48_META_API_1026_D: "대상 플레이어의 배낭 스킨 획득",
  T_48_META_API_1026_P0_D: "대상 플레이어",
  T_48_META_API_1026_R_D: "배낭 스킨 ID",
  T_48_META_API_1027_D: "대상 플레이어의 배낭 스킨 설정",
  T_48_META_API_1027_P0_D: "대상 플레이어",
  T_48_META_API_1027_P1_D: "배낭 스킨 ID",
  T_48_META_API_1028_D: "대상 플레이어의 배낭 스킨을 기본 국외 구성으로 복원합니다.",
  T_48_META_API_1028_P0_D: "대상 플레이어",
  T_48_META_API_1029_D: "대상 플레이어의 배낭 스킨 비우기",
  T_48_META_API_1029_P0_D: "대상 플레이어",
  T_48_META_API_103_D: "게임의 스카이박스 환경 스타일을 낮, 황혼, 밤 등으로 변경할 수 있습니다.",
  T_48_META_API_103_P0_D: "스카이박스 유형",
  T_48_META_API_1030_D: "이름으로 스켈레톤 파트 가져오기",
  T_48_META_API_1030_P0_D: "대상 엔티티",
  T_48_META_API_1030_P1_D: "스켈레탈 행잉 포인트 이름",
  T_48_META_API_1030_R_D: "뼈 골격",
  T_48_META_API_1031_D: "트랜스폼, 스켈레톤 파트, 플레이어, 마운트 포인트 컴포넌트가 마운트된 엔티티를 지원하는 오브젝트 엔티티의 부모 노드를 설정합니다.",
  T_48_META_API_1031_P0_D: "부모 노드",
  T_48_META_API_1031_P1_D: "자식 노드",
  T_48_META_API_1031_P2_D: "자손 노드의 현재 월드 위치, 회전, 스케일 유지 여부, UI 설정 이 항목은 유효하지 않습니다.",
  T_48_META_API_1032_D: "재생 속도에 따라 아이콘이 시작 위치에서 끝 위치로 이동하는 애니메이션 아이콘 효과를 재생합니다.",
  T_48_META_API_1032_P0_D: "아이콘 리소스 ID",
  T_48_META_API_1032_P1_D: "색상",
  T_48_META_API_1032_P2_D: "아이콘 줌",
  T_48_META_API_1032_P3_D: "시작 위치 중앙",
  T_48_META_API_1032_P4_D: "지역 범위 시작",
  T_48_META_API_1032_P5_D: "끝 위치 중앙",
  T_48_META_API_1032_P6_D: "끝 위치 범위",
  T_48_META_API_1032_P7_D: "재생 속도: 아이콘이 초당 이동하는 거리입니다.",
  T_48_META_API_1033_D: "역탄젠트 연산을 수행하여 각도를 구합니다.",
  T_48_META_API_1033_P0_D: "Y축 좌표",
  T_48_META_API_1033_P1_D: "X축 좌표",
  T_48_META_API_1033_R_D: "각도, 범위(-180, 180]",
  T_48_META_API_1034_D: "엔티티에 컴포넌트 추가, 사용자가 만든 사용자 지정 컴포넌트만 지원됨",
  T_48_META_API_1034_P0_D: "대상 엔티티",
  T_48_META_API_1034_P1_D: "컴포넌트 유형 ID, 사용자가 만든 사용자 정의 컴포넌트만 지원됩니다.",
  T_48_META_API_1034_P2_D: "성공적으로 추가되었는지 여부에 관계없이 기존 컴포넌트나 사용자 정의 컴포넌트가 아닌 컴포넌트는 추가되지 않습니다.",
  T_48_META_API_1035_D: "엔티티에서 구성 요소를 제거하면 사용자 지정 구성 요소만 지원됩니다.",
  T_48_META_API_1035_P0_D: "대상 엔티티",
  T_48_META_API_1035_P1_D: "컴포넌트 유형 ID, 사용자가 만든 사용자 정의 컴포넌트만 지원됩니다.",
  T_48_META_API_1035_P2_D: "제거 성공 여부와 관계없이 존재하지 않는 구성 요소나 사용자 정의 구성 요소가 아닌 구성 요소는 제거되지 않습니다.",
  T_48_META_API_1036_D: "플레이어 종료 화면 사용자 지정",
  T_48_META_API_1036_P0_D: "캡션",
  T_48_META_API_1036_P1_D: "요소",
  T_48_META_API_1036_P2_D: "옵션",
  T_48_META_API_1036_P3_D: "배경 표시 여부",
  T_48_META_API_1037_D: "현재 로드된 모든 장면 가져오기",
  T_48_META_API_1037_R_D: "장면 목록",
  T_48_META_API_1038_D: "플레이어의 로컬 조준 방향 가져오기",
  T_48_META_API_1038_R_D: "올바른 방향으로 조준",
  T_48_META_API_1039_D: "로컬 타임스탬프 가져오기",
  T_48_META_API_1039_R_D: "타임스탬프",
  T_48_META_API_104_D: "플레이어를 지정된 장면의 지정된 위치로 전환하고, 로드되지 않은 장면은 자동으로 로드되며, 이미 로드된 장면은 자동으로 언로드되지 않습니다.",
  T_48_META_API_104_P0_D: "플레이어",
  T_48_META_API_104_P1_D: "로드할 장면 ID",
  T_48_META_API_104_P2_D: "새 시나리오에서 플레이어의 위치",
  T_48_META_API_104_P3_D: "새 시나리오의 플레이어 오리엔테이션",
  T_48_META_API_1040_D: "현재 플랫폼에 대한 고정 프레임 업데이트를 일시 중지하면 일시 중지 후 해당 플랫폼의 고정 프레임 업데이트 이벤트가 트리거되지 않습니다.",
  T_48_META_API_1041_D: "현재 플랫폼에 대한 고정 프레임 업데이트를 재개하면 재개 후 해당 플랫폼의 고정 프레임 업데이트 이벤트가 다시 트리거되기 시작합니다.",
  T_48_META_API_1042_D: "현재 클라이언트 플레이어와 대상 플레이어의 버디 관계를 결정합니다. 현재 클라이언트 자체는 현재 클라이언트의 버디가 아닙니다.",
  T_48_META_API_1042_P0_D: "대상 플레이어",
  T_48_META_API_1042_R_D: "현재 클라이언트와 친구인지 여부",
  T_48_META_API_1043_D: "사용자 지정 이벤트 트리거하기",
  T_48_META_API_1043_P0_D: "사용자 지정 이벤트 ID",
  T_48_META_API_1043_P1_D: "대상 엔티티",
  T_48_META_API_1043_P2_D: "서버 측 또는 클라이언트 측 플랫폼에서 실행됩니다.",
  T_48_META_API_1043_P3_D: "매개변수 목록",
  T_48_META_API_1044_D: "오픈 스카이다이브",
  T_48_META_API_1044_P0_D: "대상 플레이어",
  T_48_META_API_1044_P1_D: "이 고도 이하에서는 낙하산이 강제로 열립니다.",
  T_48_META_API_1044_P2_D: "활공 중 속도, X 성분은 수평 속도, Y 성분은 수직 속도를 나타내며, Y 성분이 음수일 때 플레이어는 아래로 착지합니다.",
  T_48_META_API_1044_P3_D: "다이빙의 속도, X 성분은 수평 속도를, Y 성분은 수직 속도를 나타내며, Y 성분이 음수이면 플레이어는 아래로 하강합니다.",
  T_48_META_API_1044_P4_D: "낙하산을 펼칠 때의 속도, X 성분은 수평 속도, Y 성분은 수직 속도를 나타내며, Y 성분이 음수이면 플레이어는 아래쪽으로 착지합니다.",
  T_48_META_API_1045_D: "데이터 테이블에서 지정된 식별자에 해당하는 값을 읽습니다.",
  T_48_META_API_1045_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_1045_P1_D: "플레이어 고유 ID",
  T_48_META_API_1045_P2_D: "지정된 식별자",
  T_48_META_API_1045_P3_D: "판독 결과",
  T_48_META_API_1045_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1045_P5_D: "오류 코드",
  T_48_META_API_1046_D: "차트 데이터 테이블에서 지정된 식별자에 해당하는 값을 검색합니다.",
  T_48_META_API_1046_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_1046_P1_D: "지정된 식별자",
  T_48_META_API_1046_P2_D: "판독 결과",
  T_48_META_API_1046_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1046_P4_D: "오류 코드",
  T_48_META_API_1047_D: "순위표 데이터 테이블에서 지정된 순위 간격의 값을 검색합니다.",
  T_48_META_API_1047_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_1047_P1_D: "시작 위치",
  T_48_META_API_1047_P2_D: "마무리 위치",
  T_48_META_API_1047_P3_D: "판독 결과",
  T_48_META_API_1047_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1047_P5_D: "오류 코드",
  T_48_META_API_1048_D: "누적 데이터 테이블에서 지정된 식별자에 해당하는 값을 읽습니다.",
  T_48_META_API_1048_P0_D: "데이터베이스의 누적 데이터 테이블 이름",
  T_48_META_API_1048_P1_D: "지정된 식별자",
  T_48_META_API_1048_P2_D: "판독 결과",
  T_48_META_API_1048_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1048_P4_D: "오류 코드",
  T_48_META_API_1049_D: "데이터 테이블에 지정된 식별자에 해당하는 값을 씁니다.",
  T_48_META_API_1049_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_1049_P1_D: "플레이어 고유 ID",
  T_48_META_API_1049_P2_D: "지정된 식별자",
  T_48_META_API_1049_P3_D: "기록된 값",
  T_48_META_API_1049_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1049_P5_D: "오류 코드",
  T_48_META_API_105_D: "씬의 스카이박스 가져오기",
  T_48_META_API_105_P0_D: "장면 ID",
  T_48_META_API_105_R_D: "스카이박스",
  T_48_META_API_1050_D: "목록에 있는 요소 수 가져오기",
  T_48_META_API_1050_P0_D: "대상 목록",
  T_48_META_API_1050_R_D: "요소 수",
  T_48_META_API_1051_D: "목록에서 지정된 인덱스에 있는 요소의 값을 가져옵니다.",
  T_48_META_API_1051_P0_D: "대상 목록",
  T_48_META_API_1051_P1_D: "인덱스 값, 0부터 시작",
  T_48_META_API_1051_R_D: "원소 값",
  T_48_META_API_1052_D: "목록에서 지정된 인덱스에 해당하는 요소의 값을 설정합니다.",
  T_48_META_API_1052_P0_D: "대상 목록",
  T_48_META_API_1052_P1_D: "인덱스 값, 0부터 시작",
  T_48_META_API_1052_P2_D: "원소 값",
  T_48_META_API_1053_D: "목록 끝에 요소 추가",
  T_48_META_API_1053_P0_D: "대상 목록",
  T_48_META_API_1053_P1_D: "추가할 요소",
  T_48_META_API_1054_D: "목록에서 지정된 인덱스에 있는 요소를 제거합니다.",
  T_48_META_API_1054_P0_D: "대상 목록",
  T_48_META_API_1054_P1_D: "인덱스 값, 0부터 시작",
  T_48_META_API_1055_D: "모든 요소 목록 비우기",
  T_48_META_API_1055_P0_D: "대상 목록",
  T_48_META_API_1056_D: "지정된 목록에 있는 요소의 순서를 반대로 바꿉니다.",
  T_48_META_API_1056_P0_D: "대상 목록",
  T_48_META_API_1057_D: "목록 복사",
  T_48_META_API_1057_P0_D: "대상 목록",
  T_48_META_API_1057_R_D: "새 목록 복사",
  T_48_META_API_1058_D: "목록에서 지정된 인덱스 위치에 새 요소를 삽입하면 해당 인덱스 위치 이후의 요소가 순차적으로 한 위치 뒤로 이동합니다.",
  T_48_META_API_1058_P0_D: "대상 목록",
  T_48_META_API_1058_P1_D: "삽입할 인덱스 위치, 인덱스는 0부터 카운트됩니다.",
  T_48_META_API_1058_P2_D: "삽입할 새 요소의 값입니다.",
  T_48_META_API_1059_D: "목록의 요소를 다시 무작위화합니다.",
  T_48_META_API_1059_P0_D: "대상 목록",
  T_48_META_API_1060_D: "인수의 양쪽을 비교하여 참 또는 거짓을 반환합니다.",
  T_48_META_API_1060_P0_D: "비교에 사용되는 왼쪽 값",
  T_48_META_API_1060_P1_D: "비교 메서드는 다음과 같이 지원됩니다: >,>=,==,! =,<=,<,And(정규화된 부울 유형),Or(정규화된 부울 유형)",
  T_48_META_API_1060_P2_D: "비교에 사용되는 왼쪽 값",
  T_48_META_API_1060_R_D: "비교 결과",
  T_48_META_API_1061_D: "더하기, 빼기, 곱하기, 나누기, 나머지를 포함한 기본 네 가지 연산이 있습니다. 나머지 연산은 정수만 지원하며 나머지 연산은 정수 또는 소수를 지원합니다.",
  T_48_META_API_1061_P0_D: "연산 왼쪽 값",
  T_48_META_API_1061_P1_D: "더하기, 빼기, 곱하기, 나누기, 나머지를 포함한 네 가지 연산 유형(소수를 지원하지 않음)",
  T_48_META_API_1061_P2_D: "작업의 올바른 값",
  T_48_META_API_1061_R_D: "계산 결과",
  T_48_META_API_1062_D: "최소값 정수(포함)와 최대값 정수(포함되지 않음) 사이의 임의의 정수를 생성합니다.",
  T_48_META_API_1062_P0_D: "채워진 값으로 무작위화할 가능성이 있는 무작위 범위 왼쪽 간격",
  T_48_META_API_1062_P1_D: "무작위 범위 오른쪽 간격, 채워진 값으로 무작위화되지 않습니다.",
  T_48_META_API_1062_R_D: "임의 결과, 정수",
  T_48_META_API_1063_D: "최소값 소수점(포함)과 최대값 소수점(포함되지 않음) 사이의 임의의 소수점을 생성합니다.",
  T_48_META_API_1063_P0_D: "무작위 범위 왼쪽 간격, 채워진 값으로 무작위화될 확률이 적습니다.",
  T_48_META_API_1063_P1_D: "무작위 범위 오른쪽 간격, 채워진 값으로 무작위화되지 않습니다.",
  T_48_META_API_1063_R_D: "무작위 결과, 소수점 이하 소수점 7자리까지",
  T_48_META_API_1064_D: "개체가 비어 있는지 확인",
  T_48_META_API_1064_P0_D: "판단할 빈 객체",
  T_48_META_API_1064_R_D: "비어 있음",
  T_48_META_API_1065_D: "논리 역, 입력 값: 참 또는 거짓, 반환 값: 거짓 또는 참",
  T_48_META_API_1065_P0_D: "비회원에게 요청해야 하는 값",
  T_48_META_API_1065_R_D: "논스의 결과",
  T_48_META_API_1066_D: "절대값을 취하고, 정수와 소수를 지원합니다.",
  T_48_META_API_1066_P0_D: "절대값이 필요한 값",
  T_48_META_API_1066_R_D: "절대값을 취한 결과",
  T_48_META_API_1067_D: "제곱근 계산",
  T_48_META_API_1067_P0_D: "제곱근의 값을 요청해야 합니다.",
  T_48_META_API_1067_R_D: "제곱근을 구한 결과",
  T_48_META_API_1068_D: "음수 값 계산",
  T_48_META_API_1068_P0_D: "요청할 음수 값",
  T_48_META_API_1068_R_D: "부정적 결과",
  T_48_META_API_1069_D: "두 문자열을 함께 결합하기",
  T_48_META_API_1069_P0_D: "문자열의 왼쪽 값",
  T_48_META_API_1069_P1_D: "문자열의 올바른 값",
  T_48_META_API_1069_R_D: "문자열 연결 결과",
  T_48_META_API_1070_D: "문자열 길이 가져오기",
  T_48_META_API_1070_P0_D: "문자열",
  T_48_META_API_1070_R_D: "문자열 길이",
  T_48_META_API_1071_D: "지정된 값을 가장 가까운 정수로 반올림합니다.",
  T_48_META_API_1071_P0_D: "반올림할 값",
  T_48_META_API_1071_R_D: "반올림",
  T_48_META_API_1072_D: "지정된 값을 가장 가까운 정수로 반올림합니다.",
  T_48_META_API_1072_P0_D: "반올림할 값",
  T_48_META_API_1072_R_D: "반올림 결과",
  T_48_META_API_1073_D: "지정된 값을 가장 가까운 정수로 반올림합니다.",
  T_48_META_API_1073_P0_D: "반올림할 값의 개수",
  T_48_META_API_1073_R_D: "반올림 결과",
  T_48_META_API_1074_D: "대상 문자열에서 지정된 모든 문자열을 바꾼 후 새 문자열을 출력합니다.",
  T_48_META_API_1074_P0_D: "대상 문자열",
  T_48_META_API_1074_P1_D: "대체할 이전 문자열",
  T_48_META_API_1074_P2_D: "대체할 새 문자열",
  T_48_META_API_1074_R_D: "완성된 문자열 교체",
  T_48_META_API_1075_D: "대상 문자열에서 지정된 문자열의 첫 번째 항목을 찾습니다.",
  T_48_META_API_1075_P0_D: "대상 문자열",
  T_48_META_API_1075_P1_D: "조회할 지정된 문자열",
  T_48_META_API_1075_P2_D: "시작 위치에서 문자열을 찾습니다. 문자열 위치는 0부터 카운트됩니다.",
  T_48_META_API_1075_R_D: "대상 문자열에서 문자열이 처음 발생하는 위치를 지정하며, 문자열 위치는 0부터 카운트됩니다.",
  T_48_META_API_1076_D: "지정된 위치에서 지정된 길이의 문자열을 가로챈 후 새 문자열을 출력합니다.",
  T_48_META_API_1076_P0_D: "대상 문자열",
  T_48_META_API_1076_P1_D: "가로채기를 시작할 위치, 문자열 위치는 0부터 카운트됩니다.",
  T_48_META_API_1076_P2_D: "인터셉트 길이, 기본값은 문자열 끝입니다.",
  T_48_META_API_1076_R_D: "가로챈 문자열",
  T_48_META_API_1077_D: "동일한 요소를 가진 두 목록을 비교하면 목록 크기는 결과에 영향을 미치지 않습니다.",
  T_48_META_API_1077_P0_D: "비교에 사용되는 목록의 왼쪽 값",
  T_48_META_API_1077_P1_D: "비교에 사용된 목록의 올바른 값",
  T_48_META_API_1077_R_D: "결과를 비교하면 콘텐츠 일관성은 참을 반환하고 콘텐츠 불일치는 거짓을 반환합니다.",
  T_48_META_API_1078_D: "지정된 문자열을 구분 기호로 사용하고 대상 문자열을 여러 조각으로 잘라 새 문자열을 출력하면 문자열 목록 요소가 출력될 때 연속된 구분 기호는 N-1 개의 반폭 공백으로 잘립니다.",
  T_48_META_API_1078_P0_D: "대상 문자열",
  T_48_META_API_1078_P1_D: "구분자 문자열",
  T_48_META_API_1078_R_D: "항상 절반 너비의 공백 요소로 끝나는 문자열 목록을 출력합니다.",
  T_48_META_API_1079_D: "문자열 위치 목록에서 문자를 추출하여 새 문자열 출력으로 결합합니다.",
  T_48_META_API_1079_P0_D: "대상 문자열",
  T_48_META_API_1079_P1_D: "문자열 위치 목록, 문자열 위치는 0부터 카운트됩니다.",
  T_48_META_API_1079_R_D: "출력 문자열",
  T_48_META_API_1080_D: "모든 대상 문자열 문자를 대문자로 변환합니다.",
  T_48_META_API_1080_P0_D: "대상 문자열",
  T_48_META_API_1080_R_D: "출력 문자열",
  T_48_META_API_1081_D: "모든 대상 문자열 문자를 소문자로 변환합니다.",
  T_48_META_API_1081_P0_D: "대상 문자열",
  T_48_META_API_1081_R_D: "출력 문자열",
  T_48_META_API_1082_D: "대상 문자열의 첫 번째 공백이 아닌 문자 앞과 마지막 공백이 아닌 문자 뒤의 모든 공백을 제거합니다.",
  T_48_META_API_1082_P0_D: "대상 문자열",
  T_48_META_API_1082_R_D: "출력 문자열",
  T_48_META_API_1083_D: "지정된 식별자와 연결한 후 새 문자열을 출력합니다.",
  T_48_META_API_1083_P0_D: "대상 문자열 목록",
  T_48_META_API_1083_P1_D: "문자열을 연결하는 데 사용되는 지정된 식별자",
  T_48_META_API_1083_R_D: "출력 문자열",
  T_48_META_API_1084_D: "리더보드 데이터 테이블에 지정된 식별자에 해당하는 값을 씁니다.",
  T_48_META_API_1084_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_1084_P1_D: "지정된 식별자",
  T_48_META_API_1084_P2_D: "기록된 값",
  T_48_META_API_1084_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1084_P4_D: "오류 코드",
  T_48_META_API_1085_D: "누적 데이터 테이블에 지정된 식별자에 해당하는 오프셋 값을 기록합니다.",
  T_48_META_API_1085_P0_D: "데이터베이스의 누적 데이터 테이블 이름",
  T_48_META_API_1085_P1_D: "지정된 식별자",
  T_48_META_API_1085_P2_D: "이차 연산 유형",
  T_48_META_API_1085_P3_D: "오프셋 값 기록",
  T_48_META_API_1085_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1085_P5_D: "오류 코드",
  T_48_META_API_1086_D: "데이터 테이블에서 지정된 식별자에 해당하는 값을 삭제합니다.",
  T_48_META_API_1086_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_1086_P1_D: "플레이어 고유 ID",
  T_48_META_API_1086_P2_D: "지정된 식별자",
  T_48_META_API_1086_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1086_P4_D: "오류 코드",
  T_48_META_API_1087_D: "차트 데이터 테이블에서 지정된 식별자에 해당하는 값을 삭제합니다.",
  T_48_META_API_1087_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_1087_P1_D: "지정된 식별자",
  T_48_META_API_1087_P2_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1087_P3_D: "오류 코드",
  T_48_META_API_1088_D: "리더보드 테이블에서 지정된 순위에 해당하는 값을 삭제합니다.",
  T_48_META_API_1088_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_1088_P1_D: "권위 있는 지위를 부여받았습니다.",
  T_48_META_API_1088_P2_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_1088_P3_D: "오류 코드",
  T_48_META_API_1089_D: "페르소나에게 사용자 메시지 보내기",
  T_48_META_API_1089_P0_D: "대상 페르소나ID",
  T_48_META_API_1089_P1_D: "메시지",
  T_48_META_API_1090_D: "페르소나에게 시스템 메시지 보내기",
  T_48_META_API_1090_P0_D: "대상 페르소나ID",
  T_48_META_API_1090_P1_D: "메시지",
  T_48_META_API_1090_P2_D: "답장 여부",
  T_48_META_API_1091_D: "페르소나의 기억 지우기",
  T_48_META_API_1091_P0_D: "오류 코드",
  T_48_META_API_1092_D: "Evoke 회원 센터",
  T_48_META_API_1092_P0_D: "오류 코드",
  T_48_META_API_1093_D: "회원 만료 타임스탬프 가져오기",
  T_48_META_API_1093_P0_D: "대상 플레이어",
  T_48_META_API_1093_P1_D: "타임스탬프",
  T_48_META_API_1093_P2_D: "오류 코드",
  T_48_META_API_1094_D: "플레이어가 회원인지 확인",
  T_48_META_API_1094_P0_D: "오류 코드",
  T_48_META_API_1094_P1_D: "회원 여부",
  T_48_META_API_1095_D: "회원 만료 타임스탬프 가져오기",
  T_48_META_API_1095_P0_D: "타임스탬프",
  T_48_META_API_1095_P1_D: "오류 코드",
  T_48_META_API_1096_D: "플레이어가 회원인지 확인",
  T_48_META_API_1096_P0_D: "대상 플레이어",
  T_48_META_API_1096_P1_D: "오류 코드",
  T_48_META_API_1096_P2_D: "회원 여부",
  T_48_META_API_1097_D: "Evoke 회원 센터",
  T_48_META_API_1097_P0_D: "대상 플레이어",
  T_48_META_API_1097_P1_D: "오류 코드",
  T_48_META_API_1099_D: "페르소나 옵저버를 설정하면 페르소나와의 대화가 옵저버에게도 전송됩니다.",
  T_48_META_API_1099_P0_D: "대상 페르소나ID",
  T_48_META_API_1099_P1_D: "관심 목록",
  T_48_META_API_11_D: "현재 단계를 종료하고 다음 단계로 이동합니다.",
  T_48_META_API_1100_D: "스트리밍을 사용하여 페르소나에게 사용자 메시지 보내기",
  T_48_META_API_1100_P0_D: "대상 페르소나ID",
  T_48_META_API_1100_P1_D: "메시지",
  T_48_META_API_1101_D: "스트리밍을 사용하여 페르소나에게 시스템 메시지 보내기",
  T_48_META_API_1101_P0_D: "대상 페르소나ID",
  T_48_META_API_1101_P1_D: "메시지",
  T_48_META_API_1101_P2_D: "답장 여부",
  T_48_META_API_1103_D: "무작위 시드 만들기",
  T_48_META_API_1103_P0_D: "토렌트",
  T_48_META_API_1103_R_D: "난수 생성기",
  T_48_META_API_1104_D: "지정된 난수 생성기의 다음 난수(최대값 32767)를 가져옵니다.",
  T_48_META_API_1104_P0_D: "난수 생성기",
  T_48_META_API_1104_P1_D: "최소 범위",
  T_48_META_API_1104_P2_D: "최대 범위",
  T_48_META_API_1104_R_D: "난수",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "콘솔에 로그 인쇄",
  T_48_META_API_12_P0_D: "인쇄할 내용",
  T_48_META_API_13_D: "매개변수가 포함된 문자열을 출력합니다.",
  T_48_META_API_13_P0_D: "매개변수에 %v 자리 표시자를 사용하며, %v의 수와 매개변수의 수는 같아야 합니다.",
  T_48_META_API_13_P1_D: "출력에 참여하는 매개변수 목록은 형식 설명의 %v 수와 일치해야 합니다.",
  T_48_META_API_13_R_D: "출력 문자열",
  T_48_META_API_14_D: "사망 상자, 생성된 오브젝트, 배치된 오브젝트, 투사체 잔여물 등 맵 오브젝트 잔여물을 정리합니다.",
  T_48_META_API_15_D: "사용자 경험 데이터 분석을 위한 사용자 지정 콘테스트 매몰 로그",
  T_48_META_API_15_P0_D: "보고할 필드 이름 목록",
  T_48_META_API_15_P1_D: "보고할 필드 값 목록",
  T_48_META_API_1500_D: "3D 벡터의 x 성분 가져오기",
  T_48_META_API_1500_P0_D: "3D 벡터",
  T_48_META_API_1500_R_D: "3D 벡터 X-컴포넌트",
  T_48_META_API_1501_D: "3D 벡터의 y-성분 가져오기",
  T_48_META_API_1501_P0_D: "3D 벡터",
  T_48_META_API_1501_R_D: "3D 벡터의 Y-컴포넌트",
  T_48_META_API_1502_D: "3D 벡터의 z-성분 가져오기",
  T_48_META_API_1502_P0_D: "3D 벡터",
  T_48_META_API_1502_R_D: "3차원 벡터 Z-컴포넌트",
  T_48_META_API_1503_D: "3D 벡터의 X-컴포넌트를 설정합니다.",
  T_48_META_API_1503_P0_D: "3D 벡터",
  T_48_META_API_1503_P1_D: "X-컴포넌트",
  T_48_META_API_1504_D: "3D 벡터의 Y 컴포넌트 설정",
  T_48_META_API_1504_P0_D: "3D 벡터",
  T_48_META_API_1504_P1_D: "Y-컴포넌트",
  T_48_META_API_1505_D: "3D 벡터의 z 성분을 설정합니다.",
  T_48_META_API_1505_P0_D: "3D 벡터",
  T_48_META_API_1505_P1_D: "Z-컴포넌트",
  T_48_META_API_1506_D: "두 개의 3D 벡터를 함께 추가",
  T_48_META_API_1506_P0_D: "좌측 피연산자",
  T_48_META_API_1506_P1_D: "우측 피연산자",
  T_48_META_API_1506_R_D: "3D 벡터 합산 결과",
  T_48_META_API_1507_D: "두 개의 3D 벡터 빼기",
  T_48_META_API_1507_P0_D: "좌측 피연산자",
  T_48_META_API_1507_P1_D: "우측 피연산자",
  T_48_META_API_1507_R_D: "3D 벡터의 왼쪽 값에서 오른쪽 값을 뺀 결과입니다.",
  T_48_META_API_1508_D: "3D 벡터 스케일링",
  T_48_META_API_1508_P0_D: "스케일링할 3D 벡터",
  T_48_META_API_1508_P1_D: "3D 벡터 디플레이션",
  T_48_META_API_1508_R_D: "3D 벡터 스케일링 결과",
  T_48_META_API_1509_D: "두 개의 3D 벡터를 점 단위로 곱하면 점 단위 곱셈의 결과는 스칼라가 됩니다.",
  T_48_META_API_1509_P0_D: "좌측 피연산자",
  T_48_META_API_1509_P1_D: "우측 피연산자",
  T_48_META_API_1509_R_D: "도트 제품 결과",
  T_48_META_API_1510_D: "두 개의 3D 벡터를 교차 곱하면 교차 곱셈의 결과는 두 벡터가 위치한 평면에 수직인 벡터가 됩니다.",
  T_48_META_API_1510_P0_D: "좌측 피연산자",
  T_48_META_API_1510_P1_D: "우측 피연산자",
  T_48_META_API_1510_R_D: "연산에 관련된 두 벡터가 위치한 평면에 수직으로 배향된 교차 곱의 결과입니다.",
  T_48_META_API_1511_D: "3D 벡터의 정규화",
  T_48_META_API_1511_P0_D: "3D 벡터",
  T_48_META_API_1511_R_D: "새로운 정규화된 벡터를 반환합니다. 모듈러스 길이는 1입니다.",
  T_48_META_API_1512_D: "3D 벡터 모델링",
  T_48_META_API_1512_P0_D: "3D 벡터",
  T_48_META_API_1512_R_D: "모델링 결과, 벡터 모듈러스의 길이",
  T_48_META_API_1513_D: "두 3D 벡터 사이의 유클리드 거리 계산하기",
  T_48_META_API_1513_P0_D: "좌측 피연산자",
  T_48_META_API_1513_P1_D: "우측 피연산자",
  T_48_META_API_1513_R_D: "두 벡터를 뺀 후 결과 벡터의 계수는 다음과 같습니다.",
  T_48_META_API_1514_D: "두 3D 벡터 사이의 각도 계산하기",
  T_48_META_API_1514_P0_D: "좌측 피연산자",
  T_48_META_API_1514_P1_D: "우측 피연산자",
  T_48_META_API_1514_R_D: "벡터 각도, 각도 범위 0-180",
  T_48_META_API_1515_D: "3D 벡터 만들기",
  T_48_META_API_1515_P0_D: "3D 벡터의 X-컴포넌트",
  T_48_META_API_1515_P1_D: "3D 벡터의 Y-컴포넌트",
  T_48_META_API_1515_P2_D: "3D 벡터의 Z-컴포넌트",
  T_48_META_API_1515_R_D: "생성된 3D 벡터",
  T_48_META_API_1516_D: "새 구조체의 방향점 가져오기(더 이상 사용되지 않으므로 사용하지 마세요.)",
  T_48_META_API_1516_P0_D: "배치",
  T_48_META_API_1516_P1_D: "쪽으로 돌립니다.",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "방향 포인트 위치 가져오기(더 이상 사용되지 않음, 사용하지 마세요)",
  T_48_META_API_1517_P0_D: "방향 지점",
  T_48_META_API_1517_R_D: "위치",
  T_48_META_API_1518_D: "방향 포인트 방향 잡기(더 이상 사용되지 않음, 사용하지 마세요)",
  T_48_META_API_1518_P0_D: "방향 지점",
  T_48_META_API_1518_R_D: "앞으로",
  T_48_META_API_1519_D: "목록 만들기",
  T_48_META_API_1519_P0_D: "목록의 초기 길이로, 초기 용량보다 작거나 같아야 합니다.",
  T_48_META_API_1519_P1_D: "목록의 초기 용량은 초기 길이보다 크거나 같아야 합니다. 용량은 동적으로 확장할 수 있지만 약간의 성능을 소모하므로 구성할 때 적절한 값을 설정하는 것이 좋습니다.",
  T_48_META_API_1519_R_D: "목록 만들기",
  T_48_META_API_1520_D: "목록에 지정된 요소가 포함되어 있는지 확인합니다.",
  T_48_META_API_1520_P0_D: "대상 목록",
  T_48_META_API_1520_P1_D: "검사할 지정된 요소",
  T_48_META_API_1520_R_D: "지정된 요소가 포함되어 있는지 여부",
  T_48_META_API_1521_D: "대상 목록의 끝에 여러 요소를 추가합니다.",
  T_48_META_API_1521_P0_D: "대상 목록",
  T_48_META_API_1521_P1_D: "추가 목록",
  T_48_META_API_1522_D: "목록에서 지정된 요소를 제거합니다.",
  T_48_META_API_1522_P0_D: "대상 목록",
  T_48_META_API_1522_P1_D: "제거할 요소의 값입니다.",
  T_48_META_API_1523_D: "목록에 대상 요소가 없으면 -1이 반환되고, 목록에 있는 요소의 첫 번째 위치의 인덱스를 가져옵니다.",
  T_48_META_API_1523_P0_D: "대상 목록",
  T_48_META_API_1523_P1_D: "원소 값",
  T_48_META_API_1523_R_D: "위치 색인",
  T_48_META_API_1524_D: "목록에 대상 요소가 없으면 -1을 반환하고, 목록에 있는 요소의 마지막 위치의 인덱스를 가져옵니다.",
  T_48_META_API_1524_P0_D: "대상 목록",
  T_48_META_API_1524_P1_D: "원소 값",
  T_48_META_API_1524_R_D: "위치 색인",
  T_48_META_API_1525_D: "각도의 사인을 구합니다.",
  T_48_META_API_1525_P0_D: "각도, 360도, 360도",
  T_48_META_API_1525_R_D: "사인",
  T_48_META_API_1526_D: "각도의 코사인 구하기",
  T_48_META_API_1526_P0_D: "각도, 360도, 360도",
  T_48_META_API_1526_R_D: "코사인",
  T_48_META_API_1527_D: "각의 접선 찾기",
  T_48_META_API_1527_P0_D: "각도, 360도, 360도",
  T_48_META_API_1527_R_D: "탄젠트",
  T_48_META_API_1528_D: "투명도가 10진수 255로 고정된 색상 값을 구성하고, 먼저 채널을 이진수로 변환하고, 채널을 나타내는 8비트마다 R, G, B 및 투명도에 따라 접합한 다음, 해당 이진수를 Int32 유형 반환으로 변환합니다.",
  T_48_META_API_1528_P0_D: "색상의 빨간색 채널 값은 [0,255] 범위이며, 이 범위를 초과하면 법적 값으로 고정됩니다.",
  T_48_META_API_1528_P1_D: "색상의 녹색 채널 값은 [0,255] 범위이며, 이 범위를 초과하면 법적 값으로 고정됩니다.",
  T_48_META_API_1528_P2_D: "색상의 파란색 채널 값은 [0,255] 범위이며, 이 범위를 초과하면 법적 값으로 고정됩니다.",
  T_48_META_API_1528_R_D: "구성된 색상 값",
  T_48_META_API_1529_D: "역 사인 연산을 수행하여 각도를 구합니다.",
  T_48_META_API_1529_P0_D: "역 사인 연산이 수행되는 값으로, [-1,1] 범위입니다.",
  T_48_META_API_1529_R_D: "관점",
  T_48_META_API_1530_D: "역 코사인 연산을 수행하여 각도를 구합니다.",
  T_48_META_API_1530_P0_D: "역 코사인 연산 값, [-1,1] 범위 내입니다.",
  T_48_META_API_1530_R_D: "관점",
  T_48_META_API_1531_D: "역탄젠트 연산을 수행하여 각도를 구합니다.",
  T_48_META_API_1531_P0_D: "아크탄젠트 연산이 수행되는 값입니다.",
  T_48_META_API_1531_R_D: "관점",
  T_48_META_API_1532_D: "대상 엔티티가 지정된 구체 내에 있는지 확인하고, 엔티티에 위치 속성이 없는 경우 거짓을 반환합니다.",
  T_48_META_API_1532_P0_D: "대상 엔티티",
  T_48_META_API_1532_P1_D: "구의 중심을 지정합니다.",
  T_48_META_API_1532_P2_D: "구의 반지름을 지정합니다.",
  T_48_META_API_1532_R_D: "결과",
  T_48_META_API_1533_D: "대상 엔티티가 지정된 원통 범위 내에 있는지 여부를 결정하며, 엔티티에 위치 속성이 없는 경우 false를 반환합니다.",
  T_48_META_API_1533_P0_D: "대상 엔티티",
  T_48_META_API_1533_P1_D: "원통의 중심을 지정합니다.",
  T_48_META_API_1533_P2_D: "원통의 단면 반경을 지정합니다.",
  T_48_META_API_1533_P3_D: "원통의 높이를 지정합니다.",
  T_48_META_API_1533_P4_D: "중심점을 중심으로 3차원에서 회전하는 원통의 오일러 각도를 지정합니다.",
  T_48_META_API_1533_R_D: "결과",
  T_48_META_API_1534_D: "대상 엔티티가 지정된 큐브 범위 내에 있는지 확인합니다.",
  T_48_META_API_1534_P0_D: "대상 엔티티",
  T_48_META_API_1534_P1_D: "큐브의 중심을 지정합니다.",
  T_48_META_API_1534_P2_D: "큐브의 길이를 지정합니다.",
  T_48_META_API_1534_P3_D: "큐브의 너비를 지정합니다.",
  T_48_META_API_1534_P4_D: "큐브의 높이 지정",
  T_48_META_API_1534_P5_D: "중심점을 중심으로 큐브의 3차원 회전에 대한 오일러 각을 지정합니다.",
  T_48_META_API_1534_R_D: "결과",
  T_48_META_API_1535_D: "대상 엔티티가 지정된 섹터 열 내에 있는지 확인합니다.",
  T_48_META_API_1535_P0_D: "대상 엔티티",
  T_48_META_API_1535_P1_D: "섹터 모양 열의 중간 부분의 원 중심을 지정합니다.",
  T_48_META_API_1535_P2_D: "섹터 모양 열의 중앙 부분 반경을 지정합니다.",
  T_48_META_API_1535_P3_D: "중심점을 원으로 하여 감지되지 않는 부채꼴 기둥의 단면 반경은 이 작은 부채꼴 기둥 영역에서 감지되지 않으며, 규정된 부채꼴 기둥과 작은 부채꼴 테마의 차이만 감지됩니다.",
  T_48_META_API_1535_P4_D: "부채꼴 기둥의 높이를 지정합니다.",
  T_48_META_API_1535_P5_D: "중심 각도의 부채꼴 원통형 단면을 감지하며, 원통형 감지 시 360보다 크고 감지 영역의 크기가 0보다 작을 경우 0보다 작습니다.",
  T_48_META_API_1535_P6_D: "중심점을 중심으로 부채꼴 기둥의 오일러 회전 각도를 세 곳에서 지정합니다.",
  T_48_META_API_1535_R_D: "결과",
  T_48_META_API_1536_D: "두 숫자의 값을 비교하여 더 큰 값을 반환합니다.",
  T_48_META_API_1536_P0_D: "좌측 피연산자",
  T_48_META_API_1536_P1_D: "우측 피연산자",
  T_48_META_API_1536_R_D: "더 큰 그림",
  T_48_META_API_1537_D: "목록의 최대값을 반환합니다.",
  T_48_META_API_1537_P0_D: "대상 목록, 숫자 유형의 목록 요소만 허용합니다.",
  T_48_META_API_1537_P1_D: "결과를 비교할 때 목록 등에 숫자가 아닌 항목이 있으면 비교가 실패하고 거짓을 반환합니다.",
  T_48_META_API_1537_P2_D: "비교가 성공하면 목록에서 가장 큰 값을 반환하고, 비교가 실패하면 0을 반환합니다.",
  T_48_META_API_1538_D: "두 숫자의 값을 비교하여 더 작은 값을 반환합니다.",
  T_48_META_API_1538_P0_D: "좌측 피연산자",
  T_48_META_API_1538_P1_D: "우측 피연산자",
  T_48_META_API_1538_R_D: "더 작은 수치",
  T_48_META_API_1539_D: "목록에서 가장 작은 값을 반환합니다.",
  T_48_META_API_1539_P0_D: "대상 목록, 숫자 유형의 목록 요소만 허용합니다.",
  T_48_META_API_1539_P1_D: "결과를 비교할 때 목록 등에 숫자가 아닌 항목이 있으면 비교가 실패하고 거짓을 반환합니다.",
  T_48_META_API_1539_P2_D: "비교가 성공하면 목록에서 가장 작은 값을 반환하고, 비교가 실패하면 0을 반환합니다.",
  T_48_META_API_1540_D: "선형 보간, 시작 값과 목표 값 사이의 보간 진행률, 보간 계수 [0,1] 사이의 보간 진행률에 해당하는 값을 반환합니다.",
  T_48_META_API_1540_P0_D: "보간 진행률이 0일 때 반환되는 선형 보간 시작 값입니다.",
  T_48_META_API_1540_P1_D: "보간 진행률이 1일 때 반환되는 선형 보간 목표 값입니다.",
  T_48_META_API_1540_P2_D: "보간 진행률, 값 범위 [0,1], 시작 값으로 돌아가려면 0의 값, 목표 값으로 돌아가려면 1의 값, 시작 값과 목표 값의 평균으로 돌아가려면 0.5의 값을 입력합니다.",
  T_48_META_API_1540_R_D: "선형 보간 반환값",
  T_48_META_API_1541_D: "목표 값의 범위를 제한하고 세 입력의 중간에있는 값을 가져옵니다. 그 역할은 목표 값을 지정된 범위로 제한하는 것이며, 목표 값은 최소값보다 작아서 가장 작은 값으로 돌아가고 최대 값보다 커서 최대 값으로 돌아가는 범위에서 자체로 돌아갑니다.",
  T_48_META_API_1541_P0_D: "목표 값",
  T_48_META_API_1541_P1_D: "제한 범위의 최소값",
  T_48_META_API_1541_P2_D: "제한 범위의 최대값",
  T_48_META_API_1541_R_D: "제한 후 반환 값",
  T_48_META_API_1542_D: "대상 색상의 채널 값 가져오기",
  T_48_META_API_1542_P0_D: "대상 색상",
  T_48_META_API_1542_P1_D: "0, 255] 범위의 색상 R값입니다.",
  T_48_META_API_1542_P2_D: "색상의 G값, 범위 [0, 255].",
  T_48_META_API_1542_P3_D: "색상의 B 값, 범위 [0, 255].",
  T_48_META_API_1542_P4_D: "0, 255] 범위의 색상 A 값입니다.",
  T_48_META_API_1543_D: "전력 연산",
  T_48_META_API_1543_P0_D: "기수",
  T_48_META_API_1543_P1_D: "지수",
  T_48_META_API_1543_R_D: "계산 결과",
  T_48_META_API_1544_D: "로그 연산",
  T_48_META_API_1544_P0_D: "기수",
  T_48_META_API_1544_P1_D: "로그",
  T_48_META_API_1544_R_D: "계산 결과",
  T_48_META_API_1545_D: "오일러 각도에 대한 방향 벡터",
  T_48_META_API_1545_P0_D: "방향 벡터",
  T_48_META_API_1545_R_D: "오일러의 각도",
  T_48_META_API_1546_D: "오일러 각도 회전 방향 벡터",
  T_48_META_API_1546_P0_D: "오일러의 각도",
  T_48_META_API_1546_R_D: "방향 벡터",
  T_48_META_API_1547_D: "정수를 부동 소수점 숫자로 변환하기",
  T_48_META_API_1547_P0_D: "정수",
  T_48_META_API_1547_R_D: "부동 소수점",
  T_48_META_API_1548_D: "쿼터니언에 따라 대상 벡터를 회전합니다.",
  T_48_META_API_1548_P0_D: "대상 벡터",
  T_48_META_API_1548_P1_D: "회전 쿼터니언",
  T_48_META_API_1548_R_D: "회전 벡터",
  T_48_META_API_1549_D: "대상 번호를 문자열로 변환",
  T_48_META_API_1549_P0_D: "변환할 문자열의 대상 번호입니다.",
  T_48_META_API_1549_P1_D: "출력 숫자 문자열 형식",
  T_48_META_API_1549_R_D: "문자열",
  T_48_META_API_1598_D: "서버 타임스탬프 가져오기",
  T_48_META_API_1598_R_D: "1970년 1월 1일 0:0:0에서 0:0:0까지의 초 수를 반환합니다.",
  T_48_META_API_1599_D: "서버 영역 가져오기",
  T_48_META_API_1599_R_D: "지역 약어로 돌아가기(BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "사용자 경험 데이터 분석을 위한 사용자 지정 사용자 매몰 로그",
  T_48_META_API_16_P0_D: "신고된 플레이어를 추적하려면",
  T_48_META_API_16_P1_D: "보고할 필드 이름 목록",
  T_48_META_API_16_P2_D: "보고할 필드 값 목록",
  T_48_META_API_1601_D: "사전 만들기",
  T_48_META_API_1601_R_D: "사전 생성",
  T_48_META_API_1602_D: "사전에서 지정된 키에 해당하는 값을 가져옵니다.",
  T_48_META_API_1602_P0_D: "대상 사전",
  T_48_META_API_1602_P1_D: "키",
  T_48_META_API_1602_R_D: "값",
  T_48_META_API_1603_D: "사전에서 지정된 키에 해당하는 값을 설정합니다.",
  T_48_META_API_1603_P0_D: "대상 사전",
  T_48_META_API_1603_P1_D: "키",
  T_48_META_API_1603_P2_D: "값",
  T_48_META_API_1604_D: "사전에서 지정된 키-값 쌍을 제거합니다.",
  T_48_META_API_1604_P0_D: "대상 사전",
  T_48_META_API_1604_P1_D: "키",
  T_48_META_API_1605_D: "사전에서 모든 키-값 쌍 지우기",
  T_48_META_API_1605_P0_D: "대상 사전",
  T_48_META_API_1606_D: "사전에서 키-값 쌍의 개수 가져오기",
  T_48_META_API_1606_P0_D: "대상 사전",
  T_48_META_API_1606_R_D: "사전 길이",
  T_48_META_API_1607_D: "사전에 키가 있는지 확인하기",
  T_48_META_API_1607_P0_D: "대상 사전",
  T_48_META_API_1607_P1_D: "키",
  T_48_META_API_1607_R_D: "존재합니까?",
  T_48_META_API_1608_D: "사전의 모든 키를 가져와 목록으로 반환합니다.",
  T_48_META_API_1608_P0_D: "대상 사전",
  T_48_META_API_1608_R_D: "모든 키 값 목록",
  T_48_META_API_17_D: "탐지는 선형적으로 움직이는 박스형 영역을 사용하여 수행되며, 박스형 영역의 경로에서 만나는 모든 엔티티를 가까운 곳에서 먼 곳으로 반환합니다(처음에는 박스형 범위 내에 있으면 감지되지 않음).",
  T_48_META_API_17_P0_D: "박스형 영역의 삼변 길이의 절반, 양수 값만 허용됩니다.",
  T_48_META_API_17_P1_D: "박스형 영역의 중심점",
  T_48_META_API_17_P2_D: "상자 영역 회전",
  T_48_META_API_17_P3_D: "박스형 영역의 이동 방향",
  T_48_META_API_17_P4_D: "박스형 영역에서 이동한 거리, 양수 값만 허용됩니다.",
  T_48_META_API_17_P5_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_17_P6_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_17_P7_D: "히트된 엔티티 목록",
  T_48_META_API_1700_D: "문자열을 정수로 변환",
  T_48_META_API_1700_P0_D: "대상 문자열",
  T_48_META_API_1700_P1_D: "결과 정수",
  T_48_META_API_1700_P2_D: "전환 성공 여부",
  T_48_META_API_1701_D: "문자열을 부동 소수점 숫자로 변환",
  T_48_META_API_1701_P0_D: "대상 문자열",
  T_48_META_API_1701_P1_D: "결과 플로트",
  T_48_META_API_1701_P2_D: "전환 성공 여부",
  T_48_META_API_18_D: "탐지는 선형적으로 움직이는 구형 영역을 사용하여 수행되며, 구형 영역의 경로에서 처음에 구형 영역 내에 있지만 감지되지 않은 모든 개체를 가까운 곳에서 먼 곳으로 반환합니다.",
  T_48_META_API_18_P0_D: "구형 영역의 반경, 양수 값만 허용됩니다.",
  T_48_META_API_18_P1_D: "구형 영역의 중심점",
  T_48_META_API_18_P2_D: "구형 영역에서의 이동 방향",
  T_48_META_API_18_P3_D: "구형 영역 이동 거리, 양수 값만 허용됩니다.",
  T_48_META_API_18_P4_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_18_P5_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_18_P6_D: "히트된 엔티티 목록",
  T_48_META_API_19_D: "탐지는 선형적으로 움직이는 캡슐 영역을 사용하여 수행되며, 캡슐 영역의 경로를 따라 처음에 캡슐 영역 내에 있는 모든 엔티티를 가까운 곳에서 먼 곳으로 되돌아가면서 탐지하지 않습니다.",
  T_48_META_API_19_P0_D: "캡슐 본체 영역의 양쪽 끝에 있는 반구의 반경, 양수 값만 허용됩니다.",
  T_48_META_API_19_P1_D: "캡슐 본체 영역의 양쪽 끝에 있는 반구의 구형 중심 사이의 거리는 양쪽 끝에 있는 반구 반경의 두 배 이상이어야 합니다.",
  T_48_META_API_19_P2_D: "캡슐 바디 영역의 중심점",
  T_48_META_API_19_P3_D: "캡슐 본체 영역의 회전",
  T_48_META_API_19_P4_D: "캡슐 본체 영역의 이동 방향",
  T_48_META_API_19_P5_D: "캡슐 영역에서 이동 거리, 양수만을 수용합니다",
  T_48_META_API_19_P6_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_19_P7_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_19_P8_D: "히트된 엔티티 목록",
  T_48_META_API_2_D: "현재 게임에 있는 모든 팀을 가져와서 팀 목록을 반환합니다.",
  T_48_META_API_2_R_D: "팀 목록",
  T_48_META_API_20_D: "고정된 박스 영역을 사용하여 감지하고, 박스 영역 내의 모든 엔티티를 반환합니다.",
  T_48_META_API_20_P0_D: "박스형 영역의 삼변 길이의 절반, 양수 값만 허용됩니다.",
  T_48_META_API_20_P1_D: "박스형 영역의 중심점",
  T_48_META_API_20_P2_D: "상자 영역 회전",
  T_48_META_API_20_P3_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_20_P4_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_20_P5_D: "히트된 엔티티 목록",
  T_48_META_API_2000_D: "대상 엔티티의 속성 값을 설정하려면 해당 속성이 이미 정의되어 있어야 합니다.",
  T_48_META_API_2000_P0_D: "대상 엔티티",
  T_48_META_API_2000_P1_D: "대상 엔티티의 속성",
  T_48_META_API_2000_P2_D: "프로퍼티를 정의할 때 필요한 유형과 일치해야 하는 대상 값입니다.",
  T_48_META_API_2000_P3_D: "모든 유형은 할당을 지원하며 숫자 유형은 자기 덧셈, 자기 뺄셈, 자기 곱셈, 자기 나눗셈, 자기 나머지를 지원합니다.",
  T_48_META_API_2001_D: "엔티티의 속성 값 가져오기",
  T_48_META_API_2001_P0_D: "대상 엔티티",
  T_48_META_API_2001_P1_D: "이 엔티티의 속성 ID입니다.",
  T_48_META_API_2001_R_D: "속성 값",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "스크립트 변수 설정",
  T_48_META_API_2002_P0_D: "대상 엔티티",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "대상 스크립트 ID",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "스크립트에 정의된 멤버 속성의 ID",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "프로퍼티를 정의할 때 필요한 유형과 일치해야 하는 대상 값입니다.",
  T_48_META_API_2002_P4_D: "모든 유형은 할당을 지원하며 숫자 유형은 자기 덧셈, 자기 뺄셈, 자기 곱셈, 자기 나눗셈, 자기 나머지를 지원합니다.",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "스크립트 변수 가져오기",
  T_48_META_API_2003_P0_D: "대상 엔티티",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "대상 스크립트 ID",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "대상 속성 ID",
  T_48_META_API_2003_R_D: "속성 값",
  T_48_META_API_2004_D: "선언 위치에서 해당 변수가 위치한 문 블록의 끝까지 범위가 지정된 로컬 변수를 정의하고 초기화합니다.",
  T_48_META_API_2004_P0_D: "변수 이름",
  T_48_META_API_2004_P1_D: "가변 초기값",
  T_48_META_API_2004_P2_D: "변수 선언 유형, 할당은 선언된 유형과 일치해야 합니다.",
  T_48_META_API_2005_D: "선언 위치에서 해당 선언이 위치한 문 블록의 끝까지 범위가 지정된 지역 변수의 값을 설정합니다.",
  T_48_META_API_2005_P0_D: "변수 이름",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "변수 값",
  T_48_META_API_2005_P2_D: "모든 유형은 할당을 지원하며 숫자 유형은 자기 덧셈, 자기 뺄셈, 자기 곱셈, 자기 나눗셈, 자기 나머지를 지원합니다.",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "선언 위치에서 문 블록의 끝까지 범위가 지정된 지역 변수의 값을 가져옵니다.",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "변수 이름",
  T_48_META_API_2006_R_D: "변수 값",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "글로벌 사용자 정의 함수를 직렬 방식으로 호출하고, 사용자 정의 함수에서 대기 중이면 호출 위치도 대기합니다.",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "사용자 정의 함수가 있는 스크립트의 스크립트 ID",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "호출되는 사용자 정의 함수의 ID",
  T_48_META_API_2009_P2_D: "사용자 정의 함수에 전달된 인수 목록",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "전역 사용자 정의 함수를 병렬 방식으로 호출하여 사용자 정의 함수에서 대기 중인지 여부에 관계없이 호출 위치로 즉시 반환하여 라인을 계속 진행합니다.",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "사용자 정의 함수가 있는 스크립트의 스크립트 ID",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "호출되는 사용자 정의 함수의 ID",
  T_48_META_API_2010_P2_D: "사용자 정의 함수에 전달된 인수 목록",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "현재 스크립트에 대한 변수 설정",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "대상 속성 ID",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "목표 값",
  T_48_META_API_2013_P2_D: "모든 유형은 할당을 지원하며 숫자 유형은 자기 덧셈, 자기 뺄셈, 자기 곱셈, 자기 나눗셈, 자기 나머지를 지원합니다.",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "현재 스크립트에 대한 변수 가져오기",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "대상 속성 ID",
  T_48_META_API_2014_R_D: "속성 값",
  T_48_META_API_21_D: "고정된 구형 영역을 사용하여 감지하고 구형 영역 내의 모든 엔티티를 반환합니다.",
  T_48_META_API_21_P0_D: "구형 영역의 반경, 양수 값만 허용됩니다.",
  T_48_META_API_21_P1_D: "구형 영역의 중심점",
  T_48_META_API_21_P2_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_21_P3_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_21_P4_D: "히트된 엔티티 목록",
  T_48_META_API_22_D: "고정된 캡슐 바디 영역을 사용하여 감지하여 캡슐 바디 영역 내의 모든 엔티티를 반환합니다.",
  T_48_META_API_22_P0_D: "캡슐 본체 영역의 양쪽 끝에 있는 반구의 반경, 양수 값만 허용됩니다.",
  T_48_META_API_22_P1_D: "캡슐 본체 영역의 양쪽 끝에 있는 반구의 구형 중심 사이의 거리는 양쪽 끝에 있는 반구 반경의 두 배 이상이어야 합니다.",
  T_48_META_API_22_P2_D: "캡슐 바디 영역의 중심점",
  T_48_META_API_22_P3_D: "캡슐 본체 영역의 회전",
  T_48_META_API_22_P4_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_22_P5_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_22_P6_D: "히트된 엔티티 목록",
  T_48_META_API_23_D: "플레이어의 특수 아이템 상태 설정, 특수 아이템은 하나만 가질 수 있습니다.",
  T_48_META_API_23_P0_D: "플레이어",
  T_48_META_API_23_P1_D: "항목 ID",
  T_48_META_API_23_P2_D: "항목 활성화 여부",
  T_48_META_API_23_P3_D: "특수 물질",
  T_48_META_API_24_D: "대상에 하나의 힘을 가하며, 이 힘은 물리적 물체여야 합니다.",
  T_48_META_API_24_P0_D: "대상 물리적 개체",
  T_48_META_API_24_P1_D: "힘 벡터",
  T_48_META_API_24_P2_D: "힘의 유형",
  T_48_META_API_25_D: "한 지점에 한 번 힘을 가할 때, 대상은 강체여야 합니다.",
  T_48_META_API_25_P0_D: "타깃 리지드 바디",
  T_48_META_API_25_P1_D: "힘 벡터",
  T_48_META_API_25_P2_D: "강제 적용 위치",
  T_48_META_API_25_P3_D: "힘의 유형",
  T_48_META_API_26_D: "타겟에 하나의 토크를 적용하며, 이 토크는 단단해야 합니다.",
  T_48_META_API_26_P0_D: "타깃 리지드 바디",
  T_48_META_API_26_P1_D: "비틀림",
  T_48_META_API_26_P2_D: "가해지는 힘의 유형",
  T_48_META_API_27_D: "타깃 리지드 바디를 지정된 위치로 이동합니다.",
  T_48_META_API_27_P0_D: "타깃 리지드 바디",
  T_48_META_API_27_P1_D: "지정된 위치",
  T_48_META_API_28_D: "타깃 리지드 바디 회전",
  T_48_META_API_28_P0_D: "타깃 리지드 바디",
  T_48_META_API_28_P1_D: "회전 쿼터니언",
  T_48_META_API_29_D: "대상 엔티티의 지정된 속성을 설정에 따라 부드럽게 보간하는 보간 모션을 생성합니다.",
  T_48_META_API_29_P0_D: "대상 엔티티",
  T_48_META_API_29_P1_D: "모션 변경이 필요한 속성 ID",
  T_48_META_API_29_P2_D: "속성 시작 값",
  T_48_META_API_29_P3_D: "속성 최종 값",
  T_48_META_API_29_P4_D: `단일, 루프 및 상호를 선택할 수 있습니다. 
엔 순환은 각 이동이 완료된 후 엔티티가 시작 값에서 다시 이동하는 것을 의미합니다. 왕복은 시작 값에서 목표 값으로의 이동이 완료된 후 엔티티가 목표 값에서 시작 값으로 한 번 더 이동한 다음 프로세스를 반복하는 것을 의미합니다.`,
  T_48_META_API_29_P5_D: "베셀 커브 제어점",
  T_48_META_API_29_P6_D: "밀리초 단위의 변경 기간",
  T_48_META_API_29_P7_D: "보간된 모션 엔티티 생성",
  T_48_META_API_29_P8_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_3_D: "게임을 목표 단계로 전환하는 턴은 특수 단계이기도 합니다. 한 라운드에서 스테이지로 전환할 때 라운드 수는 0입니다.",
  T_48_META_API_3_P0_D: "대상 라운드 또는 단계의 인덱스",
  T_48_META_API_30_D: "대상 플레이어가 지정된 전차에 탑승하도록 강제합니다.",
  T_48_META_API_30_P0_D: "대상 플레이어",
  T_48_META_API_30_P1_D: "이동 통신사 엔티티",
  T_48_META_API_30_P2_D: "좌석 번호",
  T_48_META_API_30_P3_D: "플레이어를 캐리어로 이동시키는 데 성공했는지 여부",
  T_48_META_API_3001_D: "대상 플레이어가 아이템을 버리게 합니다.",
  T_48_META_API_3001_P0_D: "대상 플레이어",
  T_48_META_API_3001_P1_D: "물리적 실체",
  T_48_META_API_3002_D: "현재 사용 가능한 랜덤 생성 지점 내에서 완전히 점유되지 않은 좌표를 가져옵니다(사용 중단, GetRandomSpawnPosition을 사용하세요).",
  T_48_META_API_3002_P0_D: "출생지 지역을 할당해야 하는 플레이어",
  T_48_META_API_3002_R_D: "무작위로 할당된 임의의 점 좌표",
  T_48_META_API_3003_D: "지정된 점수 유형에 대한 플레이어의 총점 가져오기",
  T_48_META_API_3003_P0_D: "플레이어",
  T_48_META_API_3003_P1_D: "포인트 유형",
  T_48_META_API_3003_R_D: "포인트 값",
  T_48_META_API_3004_D: "플레이어가 지정한 점수 유형에 대한 라운드 점수 설정하기",
  T_48_META_API_3004_P0_D: "플레이어 엔티티",
  T_48_META_API_3004_P1_D: "포인트 유형",
  T_48_META_API_3004_P2_D: "포인트 값",
  T_48_META_API_3005_D: "지정된 점수 유형에 대한 팀의 총점 가져오기",
  T_48_META_API_3005_P0_D: "팀 엔티티",
  T_48_META_API_3005_P1_D: "포인트 유형",
  T_48_META_API_3005_R_D: "포인트 값",
  T_48_META_API_3006_D: "팀의 지정된 점수 유형에 대한 라운드 점수 설정하기",
  T_48_META_API_3006_P0_D: "팀 엔티티",
  T_48_META_API_3006_P1_D: "포인트 유형",
  T_48_META_API_3006_P2_D: "포인트 값",
  T_48_META_API_3007_D: "지정된 라운드 및 점수 유형에 대한 플레이어의 점수 가져오기",
  T_48_META_API_3007_P0_D: "플레이어 엔티티",
  T_48_META_API_3007_P1_D: "라운드 색인",
  T_48_META_API_3007_P2_D: "포인트 유형",
  T_48_META_API_3007_R_D: "포인트 값",
  T_48_META_API_3008_D: "지정된 라운드, 점수 유형에 대한 팀의 점수를 가져옵니다.",
  T_48_META_API_3008_P0_D: "팀 엔티티",
  T_48_META_API_3008_P1_D: "라운드 색인",
  T_48_META_API_3008_P2_D: "포인트 유형",
  T_48_META_API_3008_R_D: "포인트 값",
  T_48_META_API_3009_D: "플레이어의 전체 게임 순위 확인",
  T_48_META_API_3009_P0_D: "플레이어 엔티티",
  T_48_META_API_3009_R_D: "이름 순위에서 위치",
  T_48_META_API_3011_D: "팀의 전체 게임 순위 확인",
  T_48_META_API_3011_P0_D: "버려진",
  T_48_META_API_3011_R_D: "이름 순위에서 위치",
  T_48_META_API_3013_D: "특정 라운드에 대한 플레이어의 순위 가져오기",
  T_48_META_API_3013_P0_D: "플레이어 엔티티",
  T_48_META_API_3013_P1_D: "라운드 색인",
  T_48_META_API_3013_R_D: "이름 순위에서 위치",
  T_48_META_API_3014_D: "특정 라운드의 팀 순위 확인",
  T_48_META_API_3014_P0_D: "버려진",
  T_48_META_API_3014_P1_D: "라운드 색인",
  T_48_META_API_3014_R_D: "이름 순위에서 위치",
  T_48_META_API_3015_D: "대상 엔티티의 지갑 가져오기",
  T_48_META_API_3015_P0_D: "대상 엔티티",
  T_48_META_API_3015_P1_D: "지갑의 존재 여부",
  T_48_META_API_3015_P2_D: "획득한 지갑 엔티티",
  T_48_META_API_3016_D: "대상 플레이어의 지갑을 생성합니다. 플레이어가 이미 지갑을 가지고 있는 경우 유효하지 않습니다.",
  T_48_META_API_3016_P0_D: "대상 플레이어",
  T_48_META_API_3016_P1_D: "지갑에 연결된 엔티티, 지갑의 소유자",
  T_48_META_API_3016_P2_D: "지갑 엔티티",
  T_48_META_API_3017_D: "특정 지갑에 통화 추가",
  T_48_META_API_3017_P0_D: "대상 지갑",
  T_48_META_API_3017_P1_D: "추가된 통화 유형",
  T_48_META_API_3017_P2_D: "통화 수 증가",
  T_48_META_API_3018_D: "특정 지갑에 대한 통화 감소",
  T_48_META_API_3018_P0_D: "대상 지갑",
  T_48_META_API_3018_P1_D: "통화 유형 감소",
  T_48_META_API_3018_P2_D: "통화 수 감소",
  T_48_META_API_3019_D: "한 지갑에서 다른 지갑으로 통화 이체하기",
  T_48_META_API_3019_P0_D: "송금용 지갑",
  T_48_META_API_3019_P1_D: "송금 유형",
  T_48_META_API_3019_P2_D: "송금한 통화 수",
  T_48_META_API_3019_P3_D: "통화가 이체되는 지갑",
  T_48_META_API_3020_D: "지정된 지갑에 있는 지정된 유형의 통화 수 가져오기",
  T_48_META_API_3020_P0_D: "대상 지갑",
  T_48_META_API_3020_P1_D: "문의 통화 유형",
  T_48_META_API_3020_R_D: "통화 금액",
  T_48_META_API_3021_D: "지정한 지갑에서 지정한 유형의 통화 엔티티를 가져옵니다.",
  T_48_META_API_3021_P0_D: "대상 지갑",
  T_48_META_API_3021_P1_D: "문의 통화 유형",
  T_48_META_API_3021_R_D: "화폐 엔티티",
  T_48_META_API_3022_D: "게임 내 모든 상점을 가져와 목록으로 반환합니다.",
  T_48_META_API_3022_R_D: "스토어 엔티티 목록",
  T_48_META_API_3023_D: "대상 플레이어의 모양을 지정된 씬 오브젝트의 모양으로 바꿉니다.",
  T_48_META_API_3023_P0_D: "대상 플레이어",
  T_48_META_API_3023_P1_D: "교체할 대상 씬 오브젝트",
  T_48_META_API_3023_P2_D: "플레이어 변신 위장 컴포넌트 교체 후 생성된",
  T_48_META_API_3024_D: "플레이어의 위장 상태를 취소합니다.",
  T_48_META_API_3024_P0_D: "대상 플레이어",
  T_48_META_API_3025_D: "대상 플레이어의 씬 엔티티 모양으로 분신을 만듭니다.",
  T_48_META_API_3025_P0_D: "대상 플레이어",
  T_48_META_API_3025_P1_D: "분할 이미지용 씬 엔티티",
  T_48_META_API_3025_P2_D: "이중 위치 엔티티 생성",
  T_48_META_API_3026_D: "플레이어의 위장된 엔티티 얻기",
  T_48_META_API_3026_P0_D: "플레이어",
  T_48_META_API_3026_R_D: "엔티티를 변장하는 플레이어",
  T_48_META_API_3027_D: "인덱스로 채팅 채널 엔티티 가져오기",
  T_48_META_API_3027_P0_D: "채팅 채널 인덱스, 범위 [1,8]",
  T_48_META_API_3027_R_D: "채팅 채널 엔티티",
  T_48_META_API_3028_D: "지정된 플레이어가 현재 있는 채팅 채널 엔티티를 가져옵니다.",
  T_48_META_API_3028_P0_D: "대상 플레이어",
  T_48_META_API_3028_R_D: "채팅 채널 엔티티",
  T_48_META_API_3029_D: "플레이어가 지정된 채팅 채널에 참여할 수 있도록 하고, 플레이어가 이미 다른 채팅 채널에 있는 경우 대상 채널로 전환합니다.",
  T_48_META_API_3029_P0_D: "대상 플레이어",
  T_48_META_API_3029_P1_D: "채팅 채널 엔티티",
  T_48_META_API_3030_D: "플레이어가 현재 있는 채널에서 나가게 하고, 그 이후에는 어떤 채팅 채널에도 들어가지 않는 상태가 됩니다.",
  T_48_META_API_3030_P0_D: "대상 플레이어",
  T_48_META_API_3031_D: "버려진",
  T_48_META_API_3031_P0_D: "채팅 채널 엔티티, 채널에 플레이어가 없을 때 비어 있음",
  T_48_META_API_3032_D: "플레이어의 행동 상태 설정하기",
  T_48_META_API_3032_P0_D: "대상 플레이어",
  T_48_META_API_3032_P1_D: "플레이어 행동 유형",
  T_48_META_API_3032_P2_D: `활성화: HUD 버튼 사용 가능, 정상적으로 사용 가능
 비활성화: HUD 버튼 비활성화, 능동적 또는 수동적으로 동작 상태에 액세스할 수 없음
 마스크됨: HUD 버튼 숨김, 능동적으로 동작 상태에 액세스할 수 없으나 수동적으로 동작 상태에 액세스할 수 있음.`,
  T_48_META_API_3033_D: "플레이어가 주어진 장면에서 오브젝트로 변신합니다.",
  T_48_META_API_3033_P0_D: "대상 플레이어",
  T_48_META_API_3033_P1_D: "객체로 변환할",
  T_48_META_API_3033_P2_D: "변환 후 생성된 엔티티",
  T_48_META_API_3034_D: "플레이어는 자신의 분신과 같은 외모를 만듭니다.",
  T_48_META_API_3034_P0_D: "대상 플레이어",
  T_48_META_API_3034_P1_D: "생성된 자아 개체 변경",
  T_48_META_API_3035_D: "다음 단계의 상점으로 진열대가 있는 사용자 지정 상점 만들기",
  T_48_META_API_3035_P0_D: "생성된 상점 엔티티",
  T_48_META_API_3036_D: "선반의 위쪽은 상점, 아래쪽은 제품인 사용자 지정 선반을 만듭니다.",
  T_48_META_API_3036_P0_D: "선반 엔티티 생성",
  T_48_META_API_3037_D: "사용자 지정 제품 생성, 제품에서 항목 추가 가능",
  T_48_META_API_3037_P0_D: "생성된 상품 개체",
  T_48_META_API_3038_D: "제품에 품목을 추가하면 해당 요소를 여러 번 사용하여 제품에 여러 품목을 추가할 수 있습니다.",
  T_48_META_API_3038_P0_D: "상품 엔티티",
  T_48_META_API_3038_P1_D: "추가할 항목",
  T_48_META_API_3038_P2_D: "항목 수",
  T_48_META_API_3039_D: "탈옥 보상 제공",
  T_48_META_API_3039_P0_D: "플레이어 엔티티",
  T_48_META_API_3039_P1_D: "수량",
  T_48_META_API_3039_P2_D: "실제 돈",
  T_48_META_API_3040_D: "탈옥 작업 업데이트",
  T_48_META_API_3040_P0_D: "플레이어 엔티티",
  T_48_META_API_3040_P1_D: "작업 ID",
  T_48_META_API_3040_P2_D: "(될) 가치",
  T_48_META_API_3041_D: "완전히 점유되지 않은 사용 가능한 출생지 중에서만 임의의 출생지 좌표를 가져옵니다.",
  T_48_META_API_3041_P0_D: "대상 플레이어",
  T_48_META_API_3041_R_D: "생성 지점의 좌표를 무작위로 지정하고, 기준에 맞는 생성 지점이 없는 경우 (0, 0, 0) 근처의 위치를 반환합니다.",
  T_48_META_API_3042_D: "탈옥 게임 종료",
  T_48_META_API_3042_P0_D: "플레이어 엔티티",
  T_48_META_API_3042_P1_D: "작업 ID",
  T_48_META_API_3043_D: "탈옥 소품 기반",
  T_48_META_API_3043_P0_D: "플레이어 엔티티",
  T_48_META_API_3043_P1_D: "소품 유형",
  T_48_META_API_3043_P2_D: "소품 ID",
  T_48_META_API_31_D: "대상 엔티티가 현재 속성 값을 기준으로 매번 변경되는 자체에 상대적인 모션을 생성합니다.",
  T_48_META_API_31_P0_D: "대상 엔티티",
  T_48_META_API_31_P1_D: "모션 변경이 필요한 속성",
  T_48_META_API_31_P2_D: "이동당 변경 금액",
  T_48_META_API_31_P3_D: "베셀 커브 제어점",
  T_48_META_API_31_P4_D: `단일: 속성이 델타 양을 변경하면 이동이 중지됩니다 
 주기적: 속성이 델타 양을 변경할 때마다 이동이 반복됩니다.`,
  T_48_META_API_31_P5_D: "밀리초 단위의 변경 기간",
  T_48_META_API_31_P6_D: "자신을 기준으로 이동하는 생성된 엔티티",
  T_48_META_API_31_P7_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_3100_D: "대상은 지정된 상태에서 애니메이션을 재생합니다.",
  T_48_META_API_3100_P0_D: "마운트 가능한 애니메이션 컨트롤러로 애니메이션을 재생하는 엔티티 컴포넌트",
  T_48_META_API_3100_P1_D: "애니메이션 컨트롤러의 지정된 상태",
  T_48_META_API_3100_P2_D: "애니메이션 재생 속도 스케일링",
  T_48_META_API_3100_P3_D: "루프 유형을 선택하면 애니메이션의 원래 로직을 유지하거나 한 번만 재생하거나 반복할 수 있습니다.",
  T_48_META_API_3101_D: "캐릭터 애니메이션 재생, 커스텀 애니메이션 리소스 지원",
  T_48_META_API_3101_P0_D: "대상 플레이어",
  T_48_META_API_3101_P1_D: "커스텀 애니메이션 리소스 ID",
  T_48_META_API_3101_P2_D: "루프 여부",
  T_48_META_API_3102_D: "특정 플레이어의 캐릭터 리소스 설정",
  T_48_META_API_3102_P0_D: "대상 플레이어",
  T_48_META_API_3102_P1_D: "사용자 지정 역할 리소스 ID",
  T_48_META_API_3109_D: "스위치를 켜면 안전 구역 끝까지 부드럽게 이동합니다.",
  T_48_META_API_3109_P0_D: "보안 영역의 시작 위치",
  T_48_META_API_3109_P1_D: "보안 구역의 끝 위치",
  T_48_META_API_3109_P2_D: "안전 구역의 초기 반경",
  T_48_META_API_3109_P3_D: "안전 구역의 최종 반경",
  T_48_META_API_3109_P4_D: "안전 영역이 최종 상태에 도달하는 데 걸리는 시간(초)",
  T_48_META_API_3109_P5_D: "안전 지대 밖에서 받는 초당 피해량",
  T_48_META_API_3110_D: "캐릭터 모양 그룹 전환",
  T_48_META_API_3110_P0_D: "목표",
  T_48_META_API_3110_P1_D: "표시 그룹",
  T_48_META_API_3111_D: "역할 표시 그룹 표시",
  T_48_META_API_3111_P0_D: "목표",
  T_48_META_API_3111_P1_D: "표시 그룹",
  T_48_META_API_3112_D: "숨겨진 캐릭터 모양 그룹",
  T_48_META_API_3112_P0_D: "목표",
  T_48_META_API_3112_P1_D: "표시 그룹",
  T_48_META_API_3121_D: "통계적 사용을 위해 어설션 결과를 크래프트랜드 스튜디오 PC로 보내기",
  T_48_META_API_3121_P0_D: "어설션 표현식",
  T_48_META_API_3121_P1_D: "STH에 주목하세요.",
  T_48_META_API_32_D: "플레이어의 오늘 토큰 데이터 가져오기",
  T_48_META_API_32_P0_D: "대상 플레이어",
  T_48_META_API_32_P1_D: "토큰 ID",
  T_48_META_API_32_P2_D: "토큰 수",
  T_48_META_API_32_P3_D: "튜플이 성공적으로 호출되었는지 여부",
  T_48_META_API_3200_D: "플레이어에 아이템을 추가하고 발급된 아이템 목록을 반환합니다.",
  T_48_META_API_3200_P0_D: "플레이어",
  T_48_META_API_3200_P1_D: "항목 ID",
  T_48_META_API_3200_P2_D: "항목 수",
  T_48_META_API_3200_P3_D: "플레이어에게 추가된 아이템의 목록으로, 아이템이 하나만 추가되더라도 목록으로 반환됩니다.",
  T_48_META_API_3201_D: "혈액 한도를 초과하지 않고 지정된 플레이어에게 혈액을 회복시킵니다.",
  T_48_META_API_3201_P0_D: "대상 플레이어",
  T_48_META_API_3201_P1_D: "플레이어에게 피를 더하는 값으로, 양수만 허용됩니다.",
  T_48_META_API_3202_D: "대상 플레이어의 스킬 목록 설정",
  T_48_META_API_3202_P0_D: "대상 플레이어",
  T_48_META_API_3202_P1_D: "기술 목록",
  T_48_META_API_3203_D: "대상 플레이어의 스킬 목록 가져오기",
  T_48_META_API_3203_P0_D: "대상 플레이어",
  T_48_META_API_3203_R_D: "기술 목록",
  T_48_META_API_3205_D: "플레이어에서 특정 개수의 아이템 삭제",
  T_48_META_API_3205_P0_D: "대상 플레이어",
  T_48_META_API_3205_P1_D: "삭제할 항목 유형",
  T_48_META_API_3205_P2_D: "삭제할 아이템 수, 플레이어가 보유한 아이템 수를 초과할 경우 보유한 아이템만 삭제됩니다.",
  T_48_META_API_3206_D: "플레이어가 보유한 아이템의 지정된 개수 가져오기",
  T_48_META_API_3206_P0_D: "대상 플레이어",
  T_48_META_API_3206_P1_D: "항목 유형",
  T_48_META_API_3206_R_D: "플레이어 보유 수",
  T_48_META_API_3207_D: "플레이어가 현재 체크포인트를 트리거할 수 있는지 감지합니다.",
  T_48_META_API_3207_P0_D: "대상 플레이어",
  T_48_META_API_3207_P1_D: "트리거",
  T_48_META_API_3207_R_D: "참: 트리거 가능, 거짓: 트리거 불가능",
  T_48_META_API_3208_D: "감염 모드 좀비 진화",
  T_48_META_API_3208_P0_D: "대상 플레이어",
  T_48_META_API_3209_D: "AI 엔티티가 기본 동작 트리를 중지/적용합니다.",
  T_48_META_API_3209_P0_D: "행동 트리의 목표를 활성화하려면 다음과 같이 하세요.",
  T_48_META_API_3209_P1_D: "기본 동작 트리 구현 여부",
  T_48_META_API_3210_D: "지정된 목표를 추구하는 AI 개체",
  T_48_META_API_3210_P0_D: "추적을 수행하는 AI 개체",
  T_48_META_API_3210_P1_D: "대상",
  T_48_META_API_3211_D: "플레이어 아이템 파괴(더 이상 사용되지 않음, DeleteEquipment 사용)",
  T_48_META_API_3211_P0_D: "아이템이 파괴된 플레이어",
  T_48_META_API_3211_P1_D: "파괴된 아이템 유형",
  T_48_META_API_3211_P2_D: "무기 슬롯, 무기 전용.",
  T_48_META_API_3212_D: "유니폼 갈아입기",
  T_48_META_API_3212_P0_D: "대상 플레이어",
  T_48_META_API_3212_P1_D: "의류 스타일",
  T_48_META_API_3212_P2_D: "주요 색상 I",
  T_48_META_API_3212_P3_D: "메인 컬러 II",
  T_48_META_API_3212_P4_D: "구성",
  T_48_META_API_3213_D: "플레이어의 유니폼을 원래 상태로 복원하기",
  T_48_META_API_3213_P0_D: "대상 플레이어",
  T_48_META_API_3214_D: "스위치 플레이어 음성 채팅",
  T_48_META_API_3214_P0_D: "대상 플레이어",
  T_48_META_API_3214_P1_D: "음성 채팅을 닫을지 여부, 참:닫기 거짓:열기",
  T_48_META_API_3215_D: "스위치 플레이어 빠른 채팅",
  T_48_META_API_3215_P0_D: "대상 플레이어",
  T_48_META_API_3215_P1_D: "빠른 채팅을 닫을지 여부, 참:닫기 거짓:열기",
  T_48_META_API_3216_D: "대상 플레이어의 아이템 획득 가능 여부 설정",
  T_48_META_API_3216_P0_D: "대상 플레이어",
  T_48_META_API_3216_P1_D: "아이템 픽업 금지 여부(참: 픽업 금지 거짓: 픽업 허용)",
  T_48_META_API_3217_D: "대상 플레이어가 아이템을 버릴 수 있는지 설정",
  T_48_META_API_3217_P0_D: "대상 플레이어",
  T_48_META_API_3217_P1_D: "아이템 드롭 금지 여부, 참: 픽업 금지 거짓: 픽업 가능",
  T_48_META_API_3218_D: "플레이어가 지정한 슬롯에 있는 무기를 파괴합니다.",
  T_48_META_API_3218_P0_D: "대상 플레이어",
  T_48_META_API_3218_P1_D: "파괴할 무기 슬롯",
  T_48_META_API_3218_P2_D: "파기할 번호",
  T_48_META_API_3218_P3_D: "파괴 성공 여부와 관계없이 무기 슬롯에 무기가 장착되어 있지 않으면 파괴에 실패합니다.",
  T_48_META_API_3219_D: "대상 플레이어의 배낭에서 장착 아이템을 포함한 모든 아이템을 비웁니다.",
  T_48_META_API_3219_P0_D: "대상 플레이어",
  T_48_META_API_3220_D: "플레이어 방향 설정",
  T_48_META_API_3220_P0_D: "대상 플레이어",
  T_48_META_API_3220_P1_D: "플레이어 오리엔테이션",
  T_48_META_API_3221_D: "<Player>(더 이상 사용되지 않음, 자세한 내용은 속성:스켈레톤 참조)",
  T_48_META_API_3221_P0_D: "플레이어 엔티티",
  T_48_META_API_3221_P1_D: "확대/축소 영역",
  T_48_META_API_3221_P2_D: "확대/축소 값",
  T_48_META_API_3222_D: "플레이어에게 넉백 효과를 부여하여, 대상 플레이어는 고정 가속도로 떨어지며 공중 충돌 시 넉백이 강제로 중지됩니다",
  T_48_META_API_3222_P0_D: "대상 플레이어",
  T_48_META_API_3222_P1_D: "녹아웃 방향",
  T_48_META_API_3222_P2_D: "뺑소니 시간",
  T_48_META_API_3222_P3_D: "임팩트 시 Y축의 초기 속도",
  T_48_META_API_3222_P4_D: "충돌 시 XZ 평면의 초기 속도",
  T_48_META_API_3222_P5_D: "플레이어 방향 변경 여부",
  T_48_META_API_3223_D: "대상 플레이어 또는 NPC의 코스튬 ID를 가져옵니다.",
  T_48_META_API_3223_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3223_P1_D: "의류 유형",
  T_48_META_API_3223_R_D: "의류 ID",
  T_48_META_API_3224_D: "대상 플레이어 또는 NPC의 코스튬 ID 설정하기",
  T_48_META_API_3224_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3224_P1_D: "의류 ID",
  T_48_META_API_3225_D: "대상 플레이어의 기본 의상을 복원하며, NPC에게는 적용할 수 없습니다.",
  T_48_META_API_3225_P0_D: "대상 플레이어",
  T_48_META_API_3226_D: "지정된 대상을 공격하는 AI 개체",
  T_48_META_API_3226_P0_D: "공격을 수행하는 AI 엔티티",
  T_48_META_API_3226_P1_D: "대상",
  T_48_META_API_3227_D: "플레이어의 무기를 지정된 슬롯에 있는 무기로 전환합니다.",
  T_48_META_API_3227_P0_D: "대상 플레이어",
  T_48_META_API_3227_P1_D: "전환할 무기 슬롯",
  T_48_META_API_3227_P2_D: "전환 성공 여부와 관계없이 무기 슬롯에 무기가 장착되어 있지 않으면 전환은 실패합니다.",
  T_48_META_API_3228_D: "대상 플레이어 또는 NPC의 무기 스킨 얻기",
  T_48_META_API_3228_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3228_P1_D: "무기 스킨 ID",
  T_48_META_API_3228_R_D: "무기 스킨 ID",
  T_48_META_API_3229_D: "대상 플레이어 또는 NPC의 무기 스킨 설정하기",
  T_48_META_API_3229_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3229_P1_D: "무기 스킨 ID",
  T_48_META_API_3230_D: "대상 플레이어의 기본 무기 스킨을 복원하며, NPC에게는 적용할 수 없습니다.",
  T_48_META_API_3230_P0_D: "대상 플레이어",
  T_48_META_API_3230_P1_D: "무기 ID",
  T_48_META_API_3231_D: "플레이어의 슈트 설정",
  T_48_META_API_3231_P0_D: "대상 플레이어",
  T_48_META_API_3231_P1_D: "의류 목록",
  T_48_META_API_3232_D: "대상 플레이어 또는 NPC에서 지정된 의상 유형의 모든 의상을 제거합니다.",
  T_48_META_API_3232_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3232_P1_D: "의류 유형",
  T_48_META_API_3233_D: "플레이어 또는 NPC가 지정한 무기의 스킨을 제거합니다.",
  T_48_META_API_3233_P0_D: "대상 플레이어 또는 NPC",
  T_48_META_API_3233_P1_D: "무기 ID",
  T_48_META_API_3234_D: "대상에게 버프를 추가합니다.",
  T_48_META_API_3234_P0_D: "대상 엔티티, 버프를 추가할 수 있는 엔티티여야 합니다.",
  T_48_META_API_3234_P1_D: "버프 ID",
  T_48_META_API_3235_D: "대상에서 버프 제거",
  T_48_META_API_3235_P0_D: "대상 엔티티, 버프를 추가할 수 있는 엔티티여야 합니다.",
  T_48_META_API_3235_P1_D: "버프 ID",
  T_48_META_API_3236_D: "대상의 현재 버프 획득",
  T_48_META_API_3236_P0_D: "대상 엔티티, 버프를 추가할 수 있는 엔티티여야 합니다.",
  T_48_META_API_3236_R_D: "버프 목록",
  T_48_META_API_3237_D: "대상 플레이어의 배낭 소품 바에서 아이템을 획득하세요.",
  T_48_META_API_3237_P0_D: "대상 플레이어",
  T_48_META_API_3237_P1_D: "소품 목록",
  T_48_META_API_3238_D: "무기의 지정된 슬롯에 액세서리를 추가하면 슬롯과 일치하지 않는 액세서리는 실패하고, 일치하지만 중복되는 액세서리는 원래 액세서리를 대체하며, 원래 액세서리는 플레이어의 배낭으로 보내지고, 플레이어의 배낭이 가득 차면 그 때 플레이어의 위치로 원래 액세서리가 떨어집니다.",
  T_48_META_API_3238_P0_D: "대상 플레이어",
  T_48_META_API_3238_P1_D: "장비 바 슬롯",
  T_48_META_API_3238_P2_D: "교체(부품)",
  T_48_META_API_3238_P3_D: `액세서리 추가 성공 여부
 참: 해당 슬롯에 있는 무기에 액세서리가 장착됨
 거짓: 액세서리 추가에 실패하여 플레이어의 배낭에 나타나지 않음`,
  T_48_META_API_3238_P4_D: "액세서리 추가, 실패 시 무효화",
  T_48_META_API_3239_D: "배낭 장비 열에서 장비 가져오기",
  T_48_META_API_3239_P0_D: "대상 플레이어",
  T_48_META_API_3239_P1_D: "장비 바 슬롯",
  T_48_META_API_3239_P2_D: "지정된 슬롯의 장비, 장착되지 않은 경우 비어 있음",
  T_48_META_API_3239_P3_D: "이 장비의 모든 액세서리",
  T_48_META_API_3240_D: "2D 벡터는 X-컴포넌트인",
  T_48_META_API_3240_P0_D: "2차원 벡터",
  T_48_META_API_3240_R_D: "2D 벡터 X-컴포넌트",
  T_48_META_API_3241_D: "2차원 벡터는 Y 성분을 취합니다.",
  T_48_META_API_3241_P0_D: "2차원 벡터",
  T_48_META_API_3241_R_D: "2D 벡터의 Y-컴포넌트",
  T_48_META_API_3242_D: "2D 벡터 설정 X-컴포넌트",
  T_48_META_API_3242_P0_D: "2차원 벡터",
  T_48_META_API_3242_P1_D: "2D 벡터 X-컴포넌트",
  T_48_META_API_3243_D: "2D 벡터 설정 Y-컴포넌트",
  T_48_META_API_3243_P0_D: "2차원 벡터",
  T_48_META_API_3243_P1_D: "2D 벡터의 Y-컴포넌트",
  T_48_META_API_3244_D: "두 개의 2D 벡터를 함께 추가",
  T_48_META_API_3244_P0_D: "좌측 피연산자",
  T_48_META_API_3244_P1_D: "우측 피연산자",
  T_48_META_API_3244_R_D: "2D 벡터 합산 결과",
  T_48_META_API_3245_D: "두 개의 2D 벡터 빼기",
  T_48_META_API_3245_P0_D: "좌측 피연산자",
  T_48_META_API_3245_P1_D: "우측 피연산자",
  T_48_META_API_3245_R_D: "2D 벡터 빼기 결과",
  T_48_META_API_3246_D: "2차원 벡터에 다음을 곱합니다.",
  T_48_META_API_3246_P0_D: "2차원 벡터",
  T_48_META_API_3246_P1_D: "2D 벡터 스케일링 값",
  T_48_META_API_3246_R_D: "2D 벡터 곱셈 결과",
  T_48_META_API_3247_D: "두 2D 벡터를 점 단위로 곱하면 점 단위 곱셈의 결과는 두 벡터 사이의 각도를 특징짓는 스칼라가 됩니다.",
  T_48_META_API_3247_P0_D: "좌측 피연산자",
  T_48_META_API_3247_P1_D: "우측 피연산자",
  T_48_META_API_3247_R_D: "도트 제품 결과",
  T_48_META_API_3248_D: "두 2D 벡터 사이의 유클리드 거리 계산하기",
  T_48_META_API_3248_P0_D: "좌측 피연산자",
  T_48_META_API_3248_P1_D: "우측 피연산자",
  T_48_META_API_3248_R_D: "두 벡터를 뺀 후 결과 벡터의 계수는 다음과 같습니다.",
  T_48_META_API_3249_D: "두 2D 벡터 사이의 각도 계산하기",
  T_48_META_API_3249_P0_D: "좌측 피연산자",
  T_48_META_API_3249_P1_D: "우측 피연산자",
  T_48_META_API_3249_R_D: "벡터 각도, 각도 범위 0-180",
  T_48_META_API_3250_D: "2D 벡터 정규화",
  T_48_META_API_3250_P0_D: "2차원 벡터",
  T_48_META_API_3250_R_D: "벡터와 같은 방향으로 길이가 1m인 벡터에 대한 정규화된 결과",
  T_48_META_API_3251_D: "2D 벡터 모델링",
  T_48_META_API_3251_P0_D: "2차원 벡터",
  T_48_META_API_3251_R_D: "모델링 결과(벡터 길이)",
  T_48_META_API_3252_D: "일반 수직선에 의해 반사된 후 2D 벡터의 벡터 계산하기",
  T_48_META_API_3252_P0_D: "인시던트 2D 벡터",
  T_48_META_API_3252_P1_D: "일반 2D 벡터",
  T_48_META_API_3252_R_D: "반사형 2D 벡터",
  T_48_META_API_3253_D: "일반 수직면에 의한 반사 후 3D 벡터 계산하기",
  T_48_META_API_3253_P0_D: "인시던트 3D 벡터",
  T_48_META_API_3253_P1_D: "일반 3D 벡터",
  T_48_META_API_3253_R_D: "반사 3D 벡터",
  T_48_META_API_3254_D: "3D 벡터를 2D 벡터로 변환하고 3D 벡터의 Z 성분을 제거합니다.",
  T_48_META_API_3254_P0_D: "타겟 3D 벡터",
  T_48_META_API_3254_R_D: "변환된 2D 벡터",
  T_48_META_API_3255_D: "2D 벡터를 3D 벡터로 변환, 3D 벡터의 Z 성분이 0으로 설정됨",
  T_48_META_API_3255_P0_D: "대상 2D 벡터",
  T_48_META_API_3255_R_D: "변환된 3D 벡터",
  T_48_META_API_3256_D: "2D 벡터 만들기",
  T_48_META_API_3256_P0_D: "2D 벡터의 x-컴포넌트",
  T_48_META_API_3256_P1_D: "2D 벡터의 Y-컴포넌트",
  T_48_META_API_3256_R_D: "생성된 2D 벡터",
  T_48_META_API_3257_D: "사용자 경험 데이터 분석을 위한 사용자 지정 콘테스트 매몰 로그",
  T_48_META_API_3257_P0_D: "로그",
  T_48_META_API_3258_D: "사용자 경험 데이터 분석을 위한 사용자 지정 콘테스트 매몰 로그",
  T_48_META_API_3258_P0_D: "신고된 플레이어를 추적하려면",
  T_48_META_API_3258_P1_D: "로그",
  T_48_META_API_33_D: "불쾌한 단어 필터",
  T_48_META_API_33_P0_D: "더티 워드 필터링이 필요한 원본 텍스트",
  T_48_META_API_33_R_D: "필터링된 텍스트",
  T_48_META_API_3301_D: "캠프 엔티티 만들기",
  T_48_META_API_3301_P0_D: "포메이션 엔티티",
  T_48_META_API_3302_D: "대상 단체가 지정된 캠프에 합류",
  T_48_META_API_3302_P0_D: "대상 엔티티",
  T_48_META_API_3302_P1_D: "포메이션 엔티티",
  T_48_META_API_3303_D: "공격 가능한 야영지 확보",
  T_48_META_API_3303_P0_D: "공격 캠프",
  T_48_META_API_3303_R_D: "캠프 엔티티 목록",
  T_48_META_API_3304_D: "캠프 설치를 위한 공격 가능 캠프",
  T_48_META_API_3304_P0_D: "공격 캠프",
  T_48_META_API_3304_P1_D: "타겟 캠프",
  T_48_META_API_3304_P2_D: "공격 가능성",
  T_48_META_API_3305_D: "공격 가능한 플레이어 설정",
  T_48_META_API_3305_P0_D: "플레이어",
  T_48_META_API_3305_P1_D: "공격 가능한 플레이어",
  T_48_META_API_3305_P2_D: "공격 가능성",
  T_48_META_API_3306_D: "팀의 공격 가능한 팀 설정",
  T_48_META_API_3306_P0_D: "스트라이크 팀",
  T_48_META_API_3306_P1_D: "대상 그룹",
  T_48_META_API_3306_P2_D: "공격 가능성",
  T_48_META_API_3307_D: "버려진",
  T_48_META_API_3307_P0_D: "버려진",
  T_48_META_API_3307_R_D: "플레이어 엔티티 목록",
  T_48_META_API_3308_D: "현재 캠프에서 지정된 단체의 탈퇴",
  T_48_META_API_3308_P0_D: "대상 엔티티",
  T_48_META_API_3309_D: "목표물 획득 캠프",
  T_48_META_API_3309_P0_D: "대상 엔티티",
  T_48_META_API_3309_R_D: "포메이션 엔티티",
  T_48_META_API_3310_D: "대상의 공격 가능 여부 확인",
  T_48_META_API_3310_P0_D: "공격자",
  T_48_META_API_3310_P1_D: "대상 엔티티",
  T_48_META_API_3310_R_D: "공격 가능성",
  T_48_META_API_3311_D: "엔티티의 공격 가능한 대상 설정하기",
  T_48_META_API_3311_P0_D: "공격자",
  T_48_META_API_3311_P1_D: "대상 엔티티",
  T_48_META_API_3311_P2_D: "공격 가능성",
  T_48_META_API_3312_D: "엔티티의 공격 가능한 대상 획득",
  T_48_META_API_3312_P0_D: "공격자",
  T_48_META_API_3312_R_D: "공격 가능한 엔티티 목록",
  T_48_META_API_34_D: "대상 엔티티에 대한 컴포넌트가 존재하는지 확인합니다.",
  T_48_META_API_34_P0_D: "대상 엔티티",
  T_48_META_API_34_P1_D: "구성 요소 유형",
  T_48_META_API_34_R_D: "존재합니까?",
  T_48_META_API_35_D: "봇 추가",
  T_48_META_API_35_P0_D: "봇 난이도",
  T_48_META_API_35_P1_D: "Bot의 팀",
  T_48_META_API_35_P2_D: "생성된 봇 플레이어 엔티티",
  T_48_META_API_3500_D: "플레이어 토큰 데이터 가져오기",
  T_48_META_API_3500_P0_D: "대상 플레이어",
  T_48_META_API_3500_P1_D: "토큰 ID",
  T_48_META_API_3500_P2_D: "토큰 수",
  T_48_META_API_3500_P3_D: "성공 또는 실패",
  T_48_META_API_3501_D: "플레이어에 토큰 데이터 추가하기",
  T_48_META_API_3501_P0_D: "대상 플레이어",
  T_48_META_API_3501_P1_D: "토큰 ID",
  T_48_META_API_3501_P2_D: "토큰 수",
  T_48_META_API_3501_P3_D: "튜플이 성공적으로 호출되었는지 여부",
  T_48_META_API_3502_D: "대상 플레이어 토큰 소비",
  T_48_META_API_3502_P0_D: "대상 플레이어",
  T_48_META_API_3502_P1_D: "토큰 ID",
  T_48_META_API_3502_P2_D: "토큰 수",
  T_48_META_API_3502_P3_D: "튜플이 성공적으로 호출되었는지 여부",
  T_48_META_API_3503_D: "지정된 위치에 토큰 추가",
  T_48_META_API_3503_P0_D: "배치",
  T_48_META_API_3503_P1_D: "토큰 ID",
  T_48_META_API_3503_P2_D: "토큰 수",
  T_48_META_API_3503_P3_D: "튜플이 성공적으로 호출되었는지 여부",
  T_48_META_API_3504_D: "Target AI가 지정된 스킬을 해제합니다.",
  T_48_META_API_3504_P0_D: "타겟 AI",
  T_48_META_API_3504_P1_D: "기술",
  T_48_META_API_3504_P2_D: "스킬 대상",
  T_48_META_API_3504_P3_D: "스킬이 성공적으로 릴리스되었는지 여부",
  T_48_META_API_3505_D: "블록을 우회하고 AI 경로 탐색에 사용할 수 있는 처음부터 끝까지 경로 탐색 경로를 생성합니다.",
  T_48_META_API_3505_P0_D: "시작점 좌표",
  T_48_META_API_3505_P1_D: "목적지의 좌표",
  T_48_META_API_3505_P2_D: "경로 찾기 경로가 성공적으로 설정되었는지 여부",
  T_48_META_API_3505_P3_D: "경로 찾기 포인트 어셈블리",
  T_48_META_API_3506_D: "동작 트리 칠판 변수 설정하기",
  T_48_META_API_3506_P0_D: "타겟 행동 트리",
  T_48_META_API_3506_P1_D: "변수 이름",
  T_48_META_API_3506_P2_D: "변수 값",
  T_48_META_API_3507_D: "행동 트리 칠판 변수 가져오기",
  T_48_META_API_3507_P0_D: "타겟 행동 트리",
  T_48_META_API_3507_P1_D: "변수 이름",
  T_48_META_API_3507_P2_D: "변수 값",
  T_48_META_API_3508_D: "행동 트리 노드 매개변수 가져오기",
  T_48_META_API_3508_P0_D: "타겟 행동 트리 노드",
  T_48_META_API_3508_P1_D: "매개변수 이름",
  T_48_META_API_3508_P2_D: "매개변수 값",
  T_48_META_API_3509_D: "대상 플레이어의 캐리어 스킨 획득",
  T_48_META_API_3509_P0_D: "대상 플레이어",
  T_48_META_API_3509_P1_D: "이동 통신사 ID",
  T_48_META_API_3509_R_D: "캐리어 스킨",
  T_48_META_API_3510_D: "대상 플레이어의 캐리어 스킨 설정하기",
  T_48_META_API_3510_P0_D: "대상 플레이어",
  T_48_META_API_3510_P1_D: "캐리어 스킨 ID",
  T_48_META_API_3511_D: "타겟 플레이어가 지정한 차량의 스킨을 삭제하십시오",
  T_48_META_API_3511_P0_D: "대상 플레이어",
  T_48_META_API_3511_P1_D: "이동 통신사 ID",
  T_48_META_API_3512_D: "대상 플레이어의 기본 캐리어 스킨 복원",
  T_48_META_API_3512_P0_D: "대상 플레이어",
  T_48_META_API_3512_P1_D: "이동 통신사 ID",
  T_48_META_API_36_D: "휴면 타깃은 동적 유형 리지드 바디에만 사용할 수 있습니다.",
  T_48_META_API_36_P0_D: "타깃 리지드 바디",
  T_48_META_API_37_D: "웨이크업 타깃은 동적 유형 리지드 바디에서만 사용할 수 있습니다.",
  T_48_META_API_37_P0_D: "타깃 리지드 바디",
  T_48_META_API_38_D: "대상 리지드가 휴면 상태인지 확인합니다.",
  T_48_META_API_38_P0_D: "타깃 리지드 바디",
  T_48_META_API_38_R_D: "최대 절전 모드 여부",
  T_48_META_API_39_D: "최대 절전 모드 임계값 설정하기",
  T_48_META_API_39_P0_D: "타깃 리지드 바디",
  T_48_META_API_39_P1_D: "휴면 임계값, 강체의 움직임과 회전이 일정 시간 동안 이 값보다 작아 휴면 상태에 들어가면 강체의 휴면 상태는 더 이상 물리적 계산을 수행하지 않습니다.",
  T_48_META_API_4_D: "모든 플레이어의 이동 가능 여부 설정",
  T_48_META_API_4_P0_D: `참: 이동 가능 
 거짓: 이동 불가`,
  T_48_META_API_40_D: "최대 절전 모드 임계값 가져오기",
  T_48_META_API_40_P0_D: "타깃 리지드 바디",
  T_48_META_API_40_R_D: "휴면 임계값, 강체의 움직임과 회전이 일정 시간 동안 이 값보다 작아 휴면 상태에 들어가면 강체의 휴면 상태는 더 이상 물리적 계산을 수행하지 않습니다.",
  T_48_META_API_4000_D: "전체 테이블의 내용을 읽고 행 순서대로 2차원 배열을 반환합니다.",
  T_48_META_API_4000_P0_D: "테이블 이름",
  T_48_META_API_4000_R_D: "표의 내용",
  T_48_META_API_4001_D: "테이블의 행을 읽고 배열을 반환합니다.",
  T_48_META_API_4001_P0_D: "테이블 이름",
  T_48_META_API_4001_P1_D: "읽을 줄 수(1부터 카운트)",
  T_48_META_API_4001_R_D: "표는 행의 내용을 지정합니다.",
  T_48_META_API_4002_D: "테이블 열의 내용을 읽고 배열을 반환합니다.",
  T_48_META_API_4002_P0_D: "테이블 이름",
  T_48_META_API_4002_P1_D: "읽을 열 수(1부터 카운트)",
  T_48_META_API_4002_R_D: "표는 열의 내용을 지정합니다.",
  T_48_META_API_4003_D: "표에서 셀의 내용 읽기",
  T_48_META_API_4003_P0_D: "테이블 이름",
  T_48_META_API_4003_P1_D: "읽을 줄 수(1부터 카운트)",
  T_48_META_API_4003_P2_D: "읽을 열 수(1부터 카운트)",
  T_48_META_API_4003_R_D: "표의 지정된 셀의 내용",
  T_48_META_API_4004_D: "표에서 행과 열 이름으로 셀의 내용 읽기",
  T_48_META_API_4004_P0_D: "테이블 이름",
  T_48_META_API_4004_P1_D: "읽을 줄 수(1부터 카운트)",
  T_48_META_API_4004_P2_D: "읽을 열의 이름입니다.",
  T_48_META_API_4004_R_D: "표의 지정된 셀의 내용",
  T_48_META_API_4005_D: "전체 테이블의 내용을 읽고 2차원 배열을 반환합니다.",
  T_48_META_API_4005_P0_D: "테이블 이름",
  T_48_META_API_4005_R_D: "테이블의 내용, 2차원 배열",
  T_48_META_API_4006_D: "테이블의 행을 읽고 배열을 반환합니다.",
  T_48_META_API_4006_P0_D: "테이블 이름",
  T_48_META_API_4006_P1_D: "읽을 줄 수(1부터 카운트)",
  T_48_META_API_4006_R_D: "테이블은 행의 내용, 배열을 지정합니다.",
  T_48_META_API_4007_D: "전체 테이블의 열 내용을 읽고 배열을 반환합니다.",
  T_48_META_API_4007_P0_D: "테이블 이름",
  T_48_META_API_4007_P1_D: "읽을 열 수(1부터 카운트)",
  T_48_META_API_4007_R_D: "테이블은 열, 배열의 내용을 지정합니다.",
  T_48_META_API_4008_D: "표에서 셀의 내용 읽기",
  T_48_META_API_4008_P0_D: "테이블 이름",
  T_48_META_API_4008_P1_D: "읽을 줄 수(1부터 카운트)",
  T_48_META_API_4008_P2_D: "읽을 열 수(1부터 카운트)",
  T_48_META_API_4008_R_D: "표의 지정된 셀의 내용",
  T_48_META_API_4009_D: "열의 수와 셀의 값으로 지정된 행을 찾습니다.",
  T_48_META_API_4009_P0_D: "테이블 이름",
  T_48_META_API_4009_P1_D: "읽을 열 수",
  T_48_META_API_4009_P2_D: "셀 값 찾기",
  T_48_META_API_4009_R_D: "발견된 행의 내용, 배열",
  T_48_META_API_4010_D: "열 이름으로 열 번호 가져오기",
  T_48_META_API_4010_P0_D: "테이블 이름",
  T_48_META_API_4010_P1_D: "일련 번호를 조회할 열의 이름",
  T_48_META_API_4010_R_D: "열, 1부터 세기",
  T_48_META_API_41_D: "새로 생성된 동적 유형의 리짓 바디에만 유효한 글로벌 슬립 임계값을 설정합니다.",
  T_48_META_API_41_P0_D: "휴면 임계값, 강체의 움직임과 회전이 일정 시간 동안 이 값보다 작아 휴면 상태에 들어가면 강체의 휴면 상태는 더 이상 물리적 계산을 수행하지 않습니다.",
  T_48_META_API_42_D: "글로벌 최대 절전 모드 임계값 가져오기",
  T_48_META_API_42_R_D: "휴면 임계값, 기본값은 0.005이며, 일정 시간 동안 강체의 움직임과 회전이 이 값보다 작으면 휴면 상태에 들어가며, 휴면 강체는 더 이상 물리적 계산을 수행하지 않습니다.",
  T_48_META_API_43_D: "주어진 쿼터니언을 오일러 각으로 변환하고, 오일러 각의 회전 순서는 YXZ이며, 들어오는 쿼터니언이 합법적이지 않으면 (0,0,0)을 반환합니다.",
  T_48_META_API_43_P0_D: "입력 쿼터니언",
  T_48_META_API_43_R_D: "반환된 오일러 각도",
  T_48_META_API_44_D: "주어진 오일러 각을 쿼터니언으로 변환하기",
  T_48_META_API_44_P0_D: "오일러 각도 입력",
  T_48_META_API_44_R_D: "반환된 쿼터니언",
  T_48_META_API_45_D: "축 방향 각도 표현의 회전을 쿼터니언으로 변환하기",
  T_48_META_API_45_P0_D: "회전축",
  T_48_META_API_45_P1_D: "회전축을 중심으로 시계 방향 회전 각도",
  T_48_META_API_45_R_D: "반환된 쿼터니언",
  T_48_META_API_46_D: "쿼터니언을 축각 표현으로 변환하기",
  T_48_META_API_46_P0_D: "입력 쿼터니언",
  T_48_META_API_46_P1_D: "회전축",
  T_48_META_API_46_P2_D: "회전축을 중심으로 시계 방향 회전 각도",
  T_48_META_API_47_D: "사용자 지정 작업 완료 진행률 설정",
  T_48_META_API_47_P0_D: "대상 플레이어",
  T_48_META_API_47_P1_D: "작업 ID",
  T_48_META_API_47_P2_D: "완료를 향한 진행률, 음수는 허용되지 않음",
  T_48_META_API_48_D: "모션 보간에 사용할 수 있는 베 지어 커브를 만듭니다.",
  T_48_META_API_48_P0_D: "커브 제어점",
  T_48_META_API_48_R_D: "베셀 곡선",
  T_48_META_API_49_D: "장면 맵 ID 가져오기",
  T_48_META_API_49_P0_D: "장면 ID",
  T_48_META_API_49_R_D: "지도 ID",
  T_48_META_API_5_D: "씬에 배치된 오브젝트 삭제(더 이상 사용되지 않음, DeleteEntity 사용)",
  T_48_META_API_5_P0_D: "삭제할 개체 개체",
  T_48_META_API_50_D: "매 프레임마다 자신을 기준으로 모션을 생성하며, 타깃 엔티티는 프레임당 한 번씩 현재 속성 값에 따라 자신의 속성을 변경합니다.",
  T_48_META_API_50_P0_D: "대상 엔티티",
  T_48_META_API_50_P1_D: "모션 변경이 필요한 속성",
  T_48_META_API_50_P2_D: "이동당 변경 금액",
  T_48_META_API_50_P3_D: `다른 모션 모드와 함께 사용할 때 구성
 참: 상대 모션과 함께 사용할 수 있음
 거짓: 절대 모션과 함께 사용할 수 있음`,
  T_48_META_API_50_P4_D: "자신을 기준으로 프레임별 모션 엔티티 생성",
  T_48_META_API_50_P5_D: "생성 후 재생이 자동으로 시작되는지 여부",
  T_48_META_API_5000_D: "데이터베이스의 테이블에서 키에 해당하는 값을 읽습니다.",
  T_48_META_API_5000_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5000_P1_D: "플레이어 태그 지정, 동시성 처리",
  T_48_META_API_5000_P2_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5000_P3_D: "판독 결과를 반환합니다.",
  T_48_META_API_5000_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5001_D: "데이터베이스의 테이블에 있는 키에 해당하는 값을 씁니다.",
  T_48_META_API_5001_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5001_P1_D: "플레이어 태그 지정, 동시성 처리",
  T_48_META_API_5001_P2_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5001_P3_D: "기록된 값",
  T_48_META_API_5001_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5002_D: "데이터베이스의 테이블에서 키에 해당하는 값을 삭제합니다.",
  T_48_META_API_5002_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5002_P1_D: "플레이어 태그 지정, 동시성 처리",
  T_48_META_API_5002_P2_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5002_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5003_D: "데이터베이스 테이블에서 키의 값을 검색합니다.",
  T_48_META_API_5003_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_5003_P1_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5003_P2_D: "판독 결과를 반환합니다.",
  T_48_META_API_5003_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5004_D: "데이터베이스의 차트 테이블에 키에 해당하는 값을 작성합니다.",
  T_48_META_API_5004_P0_D: "데이터베이스의 리더보드 테이블 이름",
  T_48_META_API_5004_P1_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5004_P2_D: "기록된 값",
  T_48_META_API_5004_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5005_D: "데이터베이스의 차트 테이블에서 키에 해당하는 값을 삭제합니다.",
  T_48_META_API_5005_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5005_P1_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5005_P2_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5006_D: "데이터베이스의 순위 테이블에서 순위에 해당하는 값을 삭제합니다.",
  T_48_META_API_5006_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5006_P1_D: "리더보드 순위",
  T_48_META_API_5006_P2_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5007_D: "데이터베이스의 차트 테이블에서 특정 순위에서 특정 순위까지의 값을 읽습니다.",
  T_48_META_API_5007_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5007_P1_D: "시작 위치",
  T_48_META_API_5007_P2_D: "마무리 위치",
  T_48_META_API_5007_P3_D: "판독 결과를 반환합니다.",
  T_48_META_API_5007_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5008_D: "누적 데이터베이스의 테이블에서 키에 해당하는 값을 읽습니다.",
  T_48_META_API_5008_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5008_P1_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5008_P2_D: "판독 결과를 반환합니다.",
  T_48_META_API_5008_P3_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_5009_D: "누적 데이터베이스의 테이블에 키에 해당하는 오프셋 값을 작성합니다.",
  T_48_META_API_5009_P0_D: "데이터베이스의 테이블 이름",
  T_48_META_API_5009_P1_D: "데이터를 식별하는 데 사용되는 사용자 지정 이름",
  T_48_META_API_5009_P2_D: "현재 지원하는 네 가지 연산 유형은 다음과 같습니다: Int 유형은 덧셈, 뺄셈, 곱셈, 나눗셈, 나머지를 지원하고, Float 유형은 덧셈, 뺄셈, 곱셈, 나눗셈을 지원합니다.",
  T_48_META_API_5009_P3_D: "오프셋 값 기록",
  T_48_META_API_5009_P4_D: "데이터베이스에 해당하는 전투장 코드",
  T_48_META_API_51_D: "재생 가능 엔티티 초기화 - 재생 상태를 변경하지 않고 재생 가능 엔티티를 초기 형태로 복원합니다.",
  T_48_META_API_51_P0_D: "대상 플레이 가능 엔티티",
  T_48_META_API_52_D: "두 개의 쿼터니언을 곱하면 A*B는 A를 회전한 다음 B를 회전하는 것을 의미하며, 회전 순서가 다르면 결과가 달라집니다.",
  T_48_META_API_52_P0_D: "왼쪽 값 쿼터니언",
  T_48_META_API_52_P1_D: "오른쪽 값 쿼터니언",
  T_48_META_API_52_R_D: "결과 쿼터니언",
  T_48_META_API_53_D: "지정된 방향을 향하는 회전 쿼터니언을 만듭니다.",
  T_48_META_API_53_P0_D: "방향 표시",
  T_48_META_API_53_P1_D: "위로",
  T_48_META_API_53_R_D: "지정된 방향으로 정렬하는 데 필요한 회전량입니다.",
  T_48_META_API_54_D: "A에서 B까지의 쿼터니언 구면 보간",
  T_48_META_API_54_P0_D: "A-값",
  T_48_META_API_54_P1_D: "B-값",
  T_48_META_API_54_P2_D: "보간 진행률, 값의 범위 [0,1], 값의 처음으로 돌아가려면 0의 값을, 목표 값으로 돌아가려면 1의 값을 입력합니다.",
  T_48_META_API_54_R_D: "결과 쿼터니언",
  T_48_META_API_57_D: "콘솔에 경고로 대상 데이터를 인쇄합니다.",
  T_48_META_API_57_P0_D: "인쇄할 내용",
  T_48_META_API_58_D: "콘솔에 대상 데이터를 오류 메시지로 인쇄합니다.",
  T_48_META_API_58_P0_D: "인쇄할 내용",
  T_48_META_API_59_D: "커브의 값 가져오기",
  T_48_META_API_59_P0_D: "로터리 방식으로",
  T_48_META_API_59_P1_D: "샘플링 지점, 값 범위 [0,1]",
  T_48_META_API_59_R_D: "결국",
  T_48_META_API_6_D: "지정된 좌표로 장면 객체 생성",
  T_48_META_API_6_P0_D: "생성된 씬 오브젝트 엔티티",
  T_48_META_API_6_P1_D: "개체 생성 위치",
  T_48_META_API_6_P2_D: "코드 스크립트에서 사용하기 위해 미리 에셋 레지스트리에 등록해야 하는 생성된 개체 유형의 ID입니다.",
  T_48_META_API_60_D: "커브 기반 보간",
  T_48_META_API_60_P0_D: "값 유형",
  T_48_META_API_60_P1_D: "시작 값",
  T_48_META_API_60_P2_D: "목표 값",
  T_48_META_API_60_P3_D: "로터리 방식으로",
  T_48_META_API_60_P4_D: "샘플링 지점, 값 범위 [0,1]",
  T_48_META_API_60_R_D: "결국",
  T_48_META_API_6000_D: "대상 엔티티에 스크립트 추가",
  T_48_META_API_6000_P0_D: "대상 엔티티",
  T_48_META_API_6000_P1_D: "스크립트 ID",
  T_48_META_API_6001_D: "대상 엔티티에 대한 스크립트 언로드",
  T_48_META_API_6001_P0_D: "대상 엔티티",
  T_48_META_API_6001_P1_D: "스크립트 ID",
  T_48_META_API_6002_D: "대상 엔티티에 대해 지정된 스크립트가 있는지 확인합니다.",
  T_48_META_API_6002_P0_D: "대상 엔티티",
  T_48_META_API_6002_P1_D: "스크립트 ID",
  T_48_META_API_6002_R_D: "지정된 스크립트의 존재 여부",
  T_48_META_API_61_D: "UI 컨트롤의 부모 노드 설정하기",
  T_48_META_API_61_P0_D: "부모 노드, UI 컨트롤 또는 커스텀 UI 지정 가능",
  T_48_META_API_61_P1_D: "자식 노드",
  T_48_META_API_62_D: "버려진",
  T_48_META_API_62_P0_D: "버려진",
  T_48_META_API_62_P1_D: "버려진",
  T_48_META_API_62_P2_D: "버려진",
  T_48_META_API_62_P3_D: "버려진",
  T_48_META_API_62_P4_D: "버려진",
  T_48_META_API_63_D: "현재 카메라에서 화면 터치 포인트까지 광선 만들기",
  T_48_META_API_63_P0_D: "화면 연락처",
  T_48_META_API_63_P1_D: "임계값",
  T_48_META_API_63_P2_D: "광선 방향",
  T_48_META_API_64_D: "사용자 지정 청구 정보 업로드",
  T_48_META_API_64_P0_D: "플레이어 엔티티",
  T_48_META_API_64_P1_D: "대회 결과",
  T_48_META_API_64_P2_D: "통합 타이틀(컴퓨팅)",
  T_48_META_API_64_P3_D: "포인트 값",
  T_48_META_API_65_D: "지정된 사운드 효과를 재생하고 설정할 속성이 더 있는 경우 해당 엔티티 속성을 설정합니다.",
  T_48_META_API_65_P0_D: "생성된 사운드 엔티티",
  T_48_META_API_65_P1_D: "대상 플레이어, 대상 플레이어만 음향 효과를 들을 수 있습니다.",
  T_48_META_API_65_P2_D: "음향 효과 유형",
  T_48_META_API_65_P3_D: "루프 유형",
  T_48_META_API_65_P4_D: "즉시 플레이할지 여부",
  T_48_META_API_66_D: "지정된 시각 효과를 생성하고 설정할 속성이 더 있는 경우 해당 엔티티 속성을 설정합니다.",
  T_48_META_API_66_P0_D: "특수 효과 개체 생성",
  T_48_META_API_66_P1_D: "타겟팅된 플레이어에게만 표시되는 타겟팅된 플레이어",
  T_48_META_API_66_P2_D: "특수 효과 유형",
  T_48_META_API_66_P3_D: "루프 유형",
  T_48_META_API_66_P4_D: "즉시 플레이할지 여부",
  T_48_META_API_67_D: "지정된 사운드 효과를 생성하고 설정할 프로퍼티가 더 있는 경우 해당 엔티티 프로퍼티를 설정합니다.",
  T_48_META_API_67_P0_D: "생성된 사운드 엔티티",
  T_48_META_API_67_P1_D: "음향 효과 유형",
  T_48_META_API_67_P2_D: "루프 유형",
  T_48_META_API_67_P3_D: "즉시 플레이할지 여부",
  T_48_META_API_68_D: "화면 좌표로 변환된 세계 좌표",
  T_48_META_API_68_P0_D: "세계 좌표",
  T_48_META_API_68_P1_D: "화면 내에 매핑되어 있는지 여부",
  T_48_META_API_68_P2_D: "매핑 위치",
  T_48_META_API_69_D: "화면 좌표를 세계 좌표로 변환",
  T_48_META_API_69_P0_D: "화면 좌표",
  T_48_META_API_69_P1_D: "화면과의 거리",
  T_48_META_API_69_P2_D: "세계 좌표",
  T_48_META_API_7_D: "대상 값을 문자열로 변환",
  T_48_META_API_7_P0_D: "변환할 문자열의 대상 값",
  T_48_META_API_7_R_D: "문자열",
  T_48_META_API_70_D: "화면 터치에 의한 광선 감지는 첫 번째 히트 엔티티를 반환합니다.",
  T_48_META_API_70_P0_D: "시작 화면 연락처",
  T_48_META_API_70_P1_D: "감지 거리",
  T_48_META_API_70_P2_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_70_P3_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_70_P4_D: "히트 엔티티",
  T_48_META_API_70_P5_D: "히트 포인트 좌표",
  T_48_META_API_70_P6_D: "시작 지점에서 적중 지점까지의 거리",
  T_48_META_API_70_P7_D: "표면 법선 타격",
  T_48_META_API_71_D: "화면 터치로 광선 감지, 모든 적중 엔티티 반환",
  T_48_META_API_71_P0_D: "시작 화면 연락처",
  T_48_META_API_71_P1_D: "감지 거리",
  T_48_META_API_71_P2_D: "레이어 마스크, 채워진 레이어만 스캔에 참여하며, 비워두면 모든 레이어가 스캔에 참여합니다.",
  T_48_META_API_71_P3_D: "트리거를 감지할 수 있는지 여부",
  T_48_META_API_71_P4_D: "히트된 엔티티 목록",
  T_48_META_API_71_P5_D: "적중 지점 좌표 목록",
  T_48_META_API_71_P6_D: "시작 지점으로부터 적중 지점까지의 거리 목록",
  T_48_META_API_71_P7_D: "서피스 노멀 히트 목록",
  T_48_META_API_72_D: "지정된 시각 효과를 생성하고 설정할 속성이 더 있는 경우 해당 엔티티 속성을 설정합니다.",
  T_48_META_API_72_P0_D: "특수 효과 개체 생성",
  T_48_META_API_72_P1_D: "특수 효과 유형",
  T_48_META_API_72_P2_D: "루프 유형",
  T_48_META_API_72_P3_D: "즉시 플레이할지 여부",
  T_48_META_API_73_D: "다른 클라이언트와 동기화되지 않는 기본 제공 UI 만들기",
  T_48_META_API_73_P0_D: "기본 제공 UI 엔티티 생성",
  T_48_META_API_73_P1_D: "기본 제공 UI 유형",
  T_48_META_API_74_D: "다른 클라이언트와 동기화되지 않는 사용자 지정 UI 만들기",
  T_48_META_API_74_P0_D: "사용자 지정 UI 엔티티 생성",
  T_48_META_API_74_P1_D: "사용자 지정 UI 색인",
  T_48_META_API_75_D: "현재 클라이언트의 해당 플레이어 가져오기",
  T_48_META_API_75_R_D: "플레이어 엔티티",
  T_48_META_API_76_D: "AI 몬스터 만들기",
  T_48_META_API_76_P0_D: "타겟 AI",
  T_48_META_API_76_P1_D: "위치 만들기",
  T_48_META_API_76_P2_D: "AI 유형",
  T_48_META_API_76_P3_D: "제휴 팀",
  T_48_META_API_76_P4_D: "적을 자동으로 점령할지 여부",
  T_48_META_API_76_P5_D: "공격 모드",
  T_48_META_API_76_P6_D: "이동 경로",
  T_48_META_API_77_D: "벡터의 첫 번째 구성 요소를 설정합니다.",
  T_48_META_API_77_P0_D: "벡터",
  T_48_META_API_77_P1_D: "첫 번째 구성 요소 값",
  T_48_META_API_77_R_D: "첫 번째 컴포넌트 수정 후 벡터",
  T_48_META_API_78_D: "벡터의 두 번째 구성 요소를 설정합니다.",
  T_48_META_API_78_P0_D: "벡터",
  T_48_META_API_78_P1_D: "두 번째 구성 요소 값",
  T_48_META_API_78_R_D: "두 번째 컴포넌트 수정 후 벡터",
  T_48_META_API_79_D: "벡터의 세 번째 구성 요소를 설정합니다.",
  T_48_META_API_79_P0_D: "벡터",
  T_48_META_API_79_P1_D: "세 번째 구성 요소 값",
  T_48_META_API_79_R_D: "세 번째 컴포넌트를 수정한 후의 벡터",
  T_48_META_API_8_D: "중앙 좌표점으로 축소되는 안전 영역을 엽니다.",
  T_48_META_API_8_P0_D: "보안 영역의 중심점",
  T_48_META_API_8_P1_D: "안전 구역 반경",
  T_48_META_API_8_P2_D: "대기 시간(초), 그 후 안전 영역이 중앙 지점을 향해 줄어들기 시작합니다.",
  T_48_META_API_8_P3_D: "안전 영역이 중심점까지 축소되는 데 걸리는 시간(초)",
  T_48_META_API_8_P4_D: "안전 지대 밖에서 받는 초당 피해량",
  T_48_META_API_80_D: "2D 벡터의 첫 번째 컴포넌트를 설정합니다.",
  T_48_META_API_80_P0_D: "2차원 벡터",
  T_48_META_API_80_P1_D: "첫 번째 구성 요소 값",
  T_48_META_API_80_R_D: "첫 번째 컴포넌트를 수정한 후의 2D 벡터",
  T_48_META_API_81_D: "2D 벡터의 두 번째 컴포넌트를 설정합니다.",
  T_48_META_API_81_P0_D: "2차원 벡터",
  T_48_META_API_81_P1_D: "두 번째 구성 요소 값",
  T_48_META_API_81_R_D: "두 번째 컴포넌트를 수정한 후의 2D 벡터",
  T_48_META_API_82_D: "캐릭터 컨트롤러를 지정된 위치로 이동하고, 플레이어에게 작용하는 경우 플레이어가 물리 효과를 사용하는 플레이어 컨트롤러를 켜야 적용됩니다.",
  T_48_META_API_82_P0_D: "대상 역할 컨트롤러",
  T_48_META_API_82_P1_D: "지정된 위치",
  T_48_META_API_83_D: "이름으로 대상 부모 엔티티의 지정된 자식 노드를 가져옵니다.",
  T_48_META_API_83_P0_D: "상위 엔티티",
  T_48_META_API_83_P1_D: "하위 노드 이름",
  T_48_META_API_83_R_D: "하위 엔티티",
  T_48_META_API_84_D: "거리와 상관없이 항상 동기화되는 AOI 특별 주의 기능 추가",
  T_48_META_API_84_P0_D: "특별 주의 대상",
  T_48_META_API_84_P1_D: "관찰자",
  T_48_META_API_85_D: "AOI 특별 주의 제거 및 시야 외 AOI 동기화 취소",
  T_48_META_API_85_P0_D: "특별 주의 대상",
  T_48_META_API_85_P1_D: "관찰자",
  T_48_META_API_86_D: "지정된 대상에 대한 모든 AOI 특수 우려 사항을 지웁니다.",
  T_48_META_API_86_P0_D: "특별 주의 대상",
  T_48_META_API_87_D: "AOI 특별 우려 사항이 있는지 확인합니다.",
  T_48_META_API_87_P0_D: "특별 주의 대상",
  T_48_META_API_87_P1_D: "버려진",
  T_48_META_API_87_R_D: "존재합니까?",
  T_48_META_API_88_D: "플레이어의 대리 옵저버 전환하기",
  T_48_META_API_88_P0_D: "플레이어",
  T_48_META_API_88_P1_D: "프록시 옵저버",
  T_48_META_API_89_D: "캐릭터 컨트롤러를 한 번 이동시키고, 플레이어에게 작용하는 경우 플레이어는 물리 효과를 사용하는 플레이어 컨트롤러를 켜야 효과를 발휘할 수 있습니다.",
  T_48_META_API_89_P0_D: "대상 오브젝트 또는 플레이어의 경우 이펙트가 적용되려면 물리 효과를 사용하는 플레이어 컨트롤러가 켜져 있어야 합니다.",
  T_48_META_API_89_P1_D: "변위 벡터",
  T_48_META_API_9_D: "안전 지대 메커니즘을 끄면 안전 지대가 최소로 줄어들면 안전 지대 밖에 있는 플레이어는 계속 피해를 입으며, 안전 지대 메커니즘이 꺼진 후 플레이어는 안전 지대로 돌아갑니다.",
  T_48_META_API_90_D: "플레이어가 자유롭게 종료할 수 있는지 설정",
  T_48_META_API_90_P0_D: "대상 플레이어",
  T_48_META_API_90_P1_D: "탈퇴의 자유",
  T_48_META_API_9000_D: "지정된 플레이어만 볼 수 있는 기본 제공 UI 만들기",
  T_48_META_API_9000_P0_D: "기본 제공 UI 엔티티 생성",
  T_48_META_API_9000_P1_D: "UI가 속한 플레이어 엔티티로, 해당 플레이어에게만 표시됩니다.",
  T_48_META_API_9000_P2_D: "기본 제공 UI 유형",
  T_48_META_API_9001_D: "기본 제공 게임 UI 제거",
  T_48_META_API_9001_P0_D: "제거할 기본 제공 UI 엔티티",
  T_48_META_API_9002_D: "지정된 아이콘 유형으로 아이콘을 생성하고, 설정할 속성이 더 있으면 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다(더 이상 사용되지 않음, CreateLevelObject 사용).",
  T_48_META_API_9002_P0_D: "코드에서는 아이콘을 생성하는 엔티티를 나타내는 데 사용되는 공식 매개 변수의 이름이며, 해당 로컬 변수 값은 아이콘을 생성하는 엔티티입니다.",
  T_48_META_API_9002_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_9002_P2_D: "리소스 경로, 플레이어가 선택한 아이콘에 해당하는 리소스 경로",
  T_48_META_API_9003_D: "지정된 아이콘 제거(더 이상 사용되지 않음, DeleteEntity 사용)",
  T_48_META_API_9003_P0_D: "제거할 아이콘 개체",
  T_48_META_API_9004_D: "지정된 텍스트 콘텐츠로 텍스트를 생성하고, 설정할 속성이 더 있으면 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다(더 이상 사용되지 않음, CreateLevelObject를 사용하세요).",
  T_48_META_API_9004_P0_D: "코드에서 텍스트를 생성하는 엔티티를 나타내는 데 사용되는 공식 매개 변수의 이름이며, 해당 로컬 변수 값은 텍스트를 생성하는 엔티티입니다.",
  T_48_META_API_9004_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_9004_P2_D: "표시할 텍스트 콘텐츠",
  T_48_META_API_9005_D: "지정된 텍스트 제거(더 이상 사용되지 않음, DeleteEntity 사용)",
  T_48_META_API_9005_P0_D: "제거할 텍스트 개체",
  T_48_META_API_9006_D: "지정된 효과 유형으로 아이콘을 생성하고 설정해야 할 속성이 더 있는 경우 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다(더 이상 사용되지 않음, CreateEffect를 사용하세요).",
  T_48_META_API_9006_P0_D: "코드에서 효과를 생성하는 엔티티를 나타내는 데 사용되는 공식 파라미터의 이름이며, 해당 로컬 변수의 값은 효과를 생성하는 엔티티입니다.",
  T_48_META_API_9006_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_9006_P2_D: "특수 효과 유형, 플레이어가 선택할 수 있는 효과의 종류",
  T_48_META_API_9007_D: "지정된 효과 제거(더 이상 사용되지 않음, 삭제 엔티티 사용)",
  T_48_META_API_9007_P0_D: "제거할 이펙트 개체",
  T_48_META_API_9008_D: "지정된 플레이어만 볼 수 있는 사용자 지정 UI 만들기",
  T_48_META_API_9008_P0_D: "사용자 지정 UI 엔티티 생성",
  T_48_META_API_9008_P1_D: "UI가 속한 플레이어 엔티티로, 해당 플레이어에게만 표시됩니다.",
  T_48_META_API_9008_P2_D: "사용자 지정 UI 색인",
  T_48_META_API_9009_D: "사용자 지정 게임 UI 제거",
  T_48_META_API_9009_P0_D: "제거할 사용자 지정 UI 엔티티",
  T_48_META_API_9010_D: "사용자 지정 UI에서 UI 컨트롤 가져오기",
  T_48_META_API_9010_P0_D: "UI가 속한 플레이어 엔티티",
  T_48_META_API_9010_P1_D: "사용자 지정 UI 엔티티",
  T_48_META_API_9010_P2_D: "고유 인덱스 제어",
  T_48_META_API_9010_R_D: "UI 제어 엔티티",
  T_48_META_API_9011_D: "지정된 사운드를 재생하고 설정해야 할 속성이 더 있는 경우 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다(더 이상 사용되지 않음, CreateSound를 사용하세요).",
  T_48_META_API_9011_P0_D: "코드에서 사운드 효과를 생성하는 엔티티를 나타내는 데 사용되는 공식 파라미터의 이름이며, 해당 로컬 변수 값은 사운드 효과를 생성하는 엔티티입니다.",
  T_48_META_API_9011_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_9011_P2_D: "사운드 유형, 플레이어가 선택할 수 있는 음향 효과의 종류",
  T_48_META_API_9012_D: "지정된 사운드 효과 제거(더 이상 사용되지 않음, DeleteEntity 사용)",
  T_48_META_API_9012_P0_D: "제거할 사운드 엔티티",
  T_48_META_API_9013_D: "경로를 사용하여 사용자 지정 UI에서 UI 컨트롤 가져오기",
  T_48_META_API_9013_P0_D: "UI가 속한 플레이어 엔티티",
  T_48_META_API_9013_P1_D: "사용자 지정 UI",
  T_48_META_API_9013_P2_D: "제어 경로",
  T_48_META_API_9013_R_D: "UI 제어 엔티티",
  T_48_META_API_9014_D: "인터럽트 재생의 사운드 엔티티(더 이상 사용되지 않음, PauseSound 사용)",
  T_48_META_API_9014_P0_D: "일시 중단해야 하는 사운드 엔티티",
  T_48_META_API_9015_D: "선택적으로 처음부터 사운드 재생 재개(더 이상 사용되지 않음, ResumeSound 사용)",
  T_48_META_API_9015_P0_D: "일시 정지된 후에도 계속 재생해야 하는 사운드 엔티티",
  T_48_META_API_9015_P1_D: "처음부터 시작할지 여부",
  T_48_META_API_9016_D: "사용자 지정 UI 컨트롤 만들기",
  T_48_META_API_9016_P0_D: "사용자 지정 제어 개체 생성",
  T_48_META_API_9016_P1_D: "생성된 컨트롤 유형",
  T_48_META_API_9016_P2_D: "관련 UI 엔티티",
  T_48_META_API_9016_P3_D: "부모 컨트롤을 입력하지 않으면 UI 엔티티가 부모 노드가 됩니다.",
  T_48_META_API_9017_D: "대상 카메라 레이어 마스크 설정",
  T_48_META_API_9017_P0_D: "대상 카메라 엔티티",
  T_48_META_API_9017_P1_D: "레이어 마스크를 사용하면 채워진 레이어만 대상 카메라에 표시되며, 비워두면 모든 레이어가 표시됩니다.",
  T_48_META_API_9018_D: "타겟 카메라 레이어 마스크 가져오기",
  T_48_META_API_9018_P0_D: "대상 카메라 엔티티",
  T_48_META_API_9018_R_D: "레이어 마스크, 레이어 마스크 내의 레이어만 대상 카메라에 표시됩니다.",
  T_48_META_API_9019_D: "지정한 레벨을 대상 카메라에 표시할지 여부를 설정합니다.",
  T_48_META_API_9019_P0_D: "대상 카메라 엔티티",
  T_48_META_API_9019_P1_D: "가시성 계층 구조",
  T_48_META_API_9019_P2_D: "가시성",
  T_48_META_API_9020_D: "대상 플레이어의 기본 인터페이스 상태 설정하기",
  T_48_META_API_9020_P0_D: "대상 플레이어",
  T_48_META_API_9020_P1_D: "플레이어 인터페이스 유형 - 플레이어 및 플레이어 관련 콘텐츠를 조작하는 데 사용되는 UI 요소입니다.",
  T_48_META_API_9020_P2_D: "스위치 값, 플레이어 인터페이스의 가시성을 결정합니다.",
  T_48_META_API_9021_D: "타임스탬프 현지화 문자열 만들기",
  T_48_META_API_9021_P0_D: "타임스탬프",
  T_48_META_API_9021_P1_D: "서식 지정 스타일",
  T_48_META_API_9021_R_D: "타임스탬프 현지화 문자열",
  T_48_META_API_9022_D: "미니 맵 아이콘 만들기",
  T_48_META_API_9022_P0_D: "미니 맵 아이콘 개체 생성",
  T_48_META_API_9022_P1_D: "자신이 속한 플레이어는 해당 플레이어에게만 표시되는 미니 맵 아이콘을 생성합니다.",
  T_48_META_API_9022_P2_D: "마인드맵 아이콘 리소스 경로",
  T_48_META_API_9023_D: "지정된 효과 유형으로 아이콘을 생성하고 설정할 속성이 더 있는 경우 엔티티를 통해 해당 엔티티 속성을 추가로 설정합니다.",
  T_48_META_API_9023_P0_D: "코드에서 효과를 생성하는 엔티티를 나타내는 데 사용되는 공식 파라미터의 이름이며, 해당 로컬 변수의 값은 효과를 생성하는 엔티티입니다.",
  T_48_META_API_9023_P1_D: "해당 플레이어에게만 표시되는 해당 플레이어가 속한 플레이어 개체",
  T_48_META_API_9023_P2_D: "특수 효과 유형, 플레이어가 선택할 수 있는 효과의 종류",
  T_48_META_API_9024_D: "지정된 효과 제거(더 이상 사용되지 않음, 삭제 엔티티 사용)",
  T_48_META_API_9024_P0_D: "제거할 이펙트 개체",
  T_48_META_API_9025_D: "대상 객체에 대해 맵에 정적 픽셀을 생성하며, 이 픽셀은 대상 객체와 함께 움직이지 않습니다.",
  T_48_META_API_9025_P0_D: "생성된 정적 픽셀 엔티티",
  T_48_META_API_9025_P1_D: "해당 플레이어가 속한 플레이어, 해당 플레이어에게만 표시되는 정적 픽셀 생성",
  T_48_META_API_9025_P2_D: "대상 개체 엔티티",
  T_48_META_API_9026_D: "대상 플레이어의 미니맵 엔티티 가져오기",
  T_48_META_API_9026_P0_D: "대상 플레이어",
  T_48_META_API_9026_R_D: "현재 플레이어 미니 맵",
  T_48_META_API_9027_D: "플레이어 낙하 데미지 설정, 높이 세그먼트에 따라 다른 데미지를 설정할 수 있습니다.",
  T_48_META_API_9027_P0_D: "대상 플레이어",
  T_48_META_API_9027_P1_D: "높이 분할 목록",
  T_48_META_API_9027_P2_D: "손상 세그먼트 목록",
  T_48_META_API_91_D: "특정 팀에 대상을 추가하면 해당 대상은 이전에 소속되어 있던 팀에서 탈퇴하게 됩니다.",
  T_48_META_API_91_P0_D: "팀에 추가해야 하는 대상",
  T_48_META_API_91_P1_D: "팀에 합류하세요",
  T_48_META_API_91_P2_D: "성공 또는 실패",
  T_48_META_API_92_D: "새로 만든 팀에 대상을 추가하면 해당 대상은 이전에 소속되어 있던 팀에서 탈퇴하게 됩니다.",
  T_48_META_API_92_P0_D: "팀에 추가해야 하는 대상",
  T_48_META_API_92_P1_D: "새 팀 이름",
  T_48_META_API_92_P2_D: "성공 또는 실패",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "대상 플레이어에게 알리는 클라이언트 측 재생 효과",
  T_48_META_API_9500_P0_D: "대상 플레이어",
  T_48_META_API_9500_P1_D: "특수 효과 리소스 경로",
  T_48_META_API_9500_P2_D: "색상",
  T_48_META_API_9500_P3_D: "확대/축소 크기, 기본값은 1",
  T_48_META_API_9500_P4_D: "이펙트가 자식 노드로 추가되는 바인딩된 오브젝트",
  T_48_META_API_9500_P5_D: "바인딩된 오브젝트를 기준으로 한 월드 좌표의 오프셋",
  T_48_META_API_9501_D: "대상 플레이어의 클라이언트에 사운드 효과 재생을 알립니다.",
  T_48_META_API_9501_P0_D: "대상 플레이어",
  T_48_META_API_9501_P1_D: "음향 효과 유형",
  T_48_META_API_9502_D: "대상 플레이어의 클라이언트에 플로팅 문자를 표시하도록 알립니다.",
  T_48_META_API_9502_P0_D: "대상 플레이어",
  T_48_META_API_9502_P1_D: "float'라는 단어의 내용",
  T_48_META_API_9502_P2_D: "부동 문자 색상, 유형 색상",
  T_48_META_API_9502_P3_D: "밀리초 단위의 부동 단어 지속 시간",
  T_48_META_API_9503_D: "대상 유닛이 감정 표현을 한 번 재생하도록 합니다.",
  T_48_META_API_9503_P0_D: "이모티콘 플레이 목표",
  T_48_META_API_9503_P1_D: "이모티콘 유형",
  T_48_META_API_9504_D: "유닛의 이모트 동작 표현 일시정지/재개",
  T_48_META_API_9504_P0_D: "이모티콘의 목표 일시 중지/재개하기",
  T_48_META_API_9504_P1_D: "참: 재생 일시 중지, 거짓: 재생 재개",
  T_48_META_EVT_1_D: "게임 시작 시 트리거되며, 서버는 클라이언트보다 일정 시간 전에 준비됩니다.",
  T_48_META_EVT_10_D: "현재 개체가 피해를 받기 전에 트리거됩니다.",
  T_48_META_EVT_10_P0_D: "공격자 엔티티, null일 수 있음",
  T_48_META_EVT_10_P1_D: "손상 유형",
  T_48_META_EVT_10_P2_D: "피해 금액",
  T_48_META_EVT_10_P3_D: "부상 부위",
  T_48_META_EVT_1000_D: "플레이어 포인트가 변경되면 트리거됩니다.",
  T_48_META_EVT_1000_P0_D: "포인트가 변동된 플레이어",
  T_48_META_EVT_1000_P1_D: "변경 포인트 유형",
  T_48_META_EVT_1000_P2_D: "적분 변경 후 적분 값",
  T_48_META_EVT_1001_D: "팀 포인트가 변경되면 트리거됩니다.",
  T_48_META_EVT_1001_P0_D: "포인트가 변경된 팀",
  T_48_META_EVT_1001_P1_D: "변경 포인트 유형",
  T_48_META_EVT_1001_P2_D: "적분 변경 후 적분 값",
  T_48_META_EVT_1002_D: "플레이어 순위가 변경되면 트리거됩니다.",
  T_48_META_EVT_1002_P0_D: "순위 변동이 있는 플레이어",
  T_48_META_EVT_1002_P1_D: "순위 변경 후 순위",
  T_48_META_EVT_1003_D: "버려진",
  T_48_META_EVT_1003_P0_D: "버려진",
  T_48_META_EVT_1003_P1_D: "순위 변경 후 순위",
  T_48_META_EVT_11_D: "플레이어가 퇴장할 때 트리거됩니다.",
  T_48_META_EVT_11_P0_D: "탈퇴한 플레이어",
  T_48_META_EVT_12_D: "플레이어 컨트롤러가 엔티티에 닿을 때 트리거되며, 컨트롤러가 활발하게 움직일 때만 트리거됩니다.",
  T_48_META_EVT_12_P0_D: "발생하는 엔티티",
  T_48_META_EVT_13_D: "현재 개체가 피해를 입히기 전에 발동합니다.",
  T_48_META_EVT_13_P0_D: "피해를 입은 단체",
  T_48_META_EVT_13_P1_D: "손상 유형",
  T_48_META_EVT_13_P2_D: "피해 금액",
  T_48_META_EVT_13_P3_D: "부상 부위",
  T_48_META_EVT_14_D: "재생 가능한 엔티티가 순환할 때마다 트리거되는 이 이벤트는 재생 가능한 엔티티가 사운드, 효과 등의 엔티티인 경우에만 클라이언트 측에서 작동합니다.",
  T_48_META_EVT_2_D: "로직 프레임이 업데이트될 때 트리거되며, 플랫폼 및 설정에 따라 이 이벤트의 발생 빈도는 달라질 수 있습니다.",
  T_48_META_EVT_2002_D: "플레이어 사망 시 발동",
  T_48_META_EVT_2002_P0_D: "죽은 플레이어",
  T_48_META_EVT_2003_D: "플레이어 어시스트 시 트리거됨",
  T_48_META_EVT_2003_P0_D: "어시스트가 있는 플레이어",
  T_48_META_EVT_2003_P1_D: "사망한 플레이어",
  T_48_META_EVT_2004_D: "플레이어가 피해를 입힐 때 발동합니다.",
  T_48_META_EVT_2004_P0_D: "피해를 입힌 플레이어",
  T_48_META_EVT_2004_P1_D: "손상된 플레이어",
  T_48_META_EVT_2004_P2_D: "손상 유형",
  T_48_META_EVT_2004_P3_D: "손상 수량",
  T_48_META_EVT_2004_P4_D: "부상 부위",
  T_48_META_EVT_2005_D: "플레이어가 처치할 때 트리거됩니다.",
  T_48_META_EVT_2005_P0_D: "히트를 유발한 플레이어",
  T_48_META_EVT_2005_P1_D: "사망한 플레이어",
  T_48_META_EVT_2005_P2_D: "손상 유형",
  T_48_META_EVT_2006_D: "플레이어가 게임에 참여할 때 트리거됩니다.",
  T_48_META_EVT_2006_P0_D: "게임에 참여하는 플레이어",
  T_48_META_EVT_2007_D: "플레이어가 부활할 때 발동합니다.",
  T_48_META_EVT_2007_P0_D: "부활한 플레이어",
  T_48_META_EVT_2007_P1_D: "부활 소스",
  T_48_META_EVT_2008_D: "플레이어가 쓰러지면 트리거됩니다.",
  T_48_META_EVT_2008_P0_D: "쓰러진 플레이어",
  T_48_META_EVT_2008_P1_D: "공격자",
  T_48_META_EVT_2009_D: "플레이어가 연결을 끊을 때 트리거됩니다.",
  T_48_META_EVT_2009_P0_D: "연결이 끊긴 플레이어",
  T_48_META_EVT_2010_D: "플레이어가 다시 연결하면 트리거됩니다.",
  T_48_META_EVT_2010_P0_D: "다시 연결된 플레이어",
  T_48_META_EVT_2100_D: "팀이 제거되면 트리거됨",
  T_48_META_EVT_2100_P0_D: "제거된 팀",
  T_48_META_EVT_2101_D: "팀 추가 시 트리거됨",
  T_48_META_EVT_2101_P0_D: "팀 추가",
  T_48_META_EVT_2102_D: "팀이 그룹에 의해 파괴되면 발동합니다.",
  T_48_META_EVT_2102_P0_D: "연대에 의해 파괴된 팀",
  T_48_META_EVT_3_D: "게임 종료 시와 서버에서 게임이 종료되기 전에 트리거됩니다.",
  T_48_META_EVT_30_D: "씬이 성공적으로 로드되면 트리거됩니다.",
  T_48_META_EVT_30_P0_D: "장면 이름",
  T_48_META_EVT_3000_D: "현재 엔티티가 생성된 후 트리거됩니다.",
  T_48_META_EVT_3001_D: "현재 엔티티가 소멸되기 전에 트리거됩니다.",
  T_48_META_EVT_3002_D: "플레이어가 트리거에 진입하면 트리거됩니다.",
  T_48_META_EVT_3002_P0_D: "트리거를 입력하는 플레이어",
  T_48_META_EVT_3003_D: "플레이어가 트리거를 떠날 때 트리거됩니다.",
  T_48_META_EVT_3003_P0_D: "트리거를 떠나는 플레이어",
  T_48_META_EVT_3004_D: "UI 버튼 컨트롤을 클릭하면 트리거됩니다.",
  T_48_META_EVT_3004_P0_D: "플레이어 클릭",
  T_48_META_EVT_3005_D: "기본 제공 UI의 버튼을 클릭하면 트리거됩니다.",
  T_48_META_EVT_3005_P0_D: "클릭할 버튼 컨트롤의 이름",
  T_48_META_EVT_3006_D: "플레이어가 수상 스키를 사용할 때 트리거됩니다.",
  T_48_META_EVT_3007_D: "현재 엔티티를 사용할 수 있게 된 후 트리거됩니다.",
  T_48_META_EVT_3008_D: "현재 엔티티를 사용할 수 없을 때 트리거됩니다.",
  T_48_META_EVT_3009_D: "엔티티가 트리거에 진입하면 트리거가 발생하면 양 당사자가 이벤트를 수신하며, 그 중 하나는 리지드 바디여야 하고 다른 하나는 트리거여야 합니다.",
  T_48_META_EVT_3009_P0_D: "트리거 이벤트 발생 시점의 상대 엔티티",
  T_48_META_EVT_3010_D: "엔티티가 트리거를 떠날 때 트리거되며, 트리거가 발생하면 양 당사자가 이벤트를 수신하며, 그 중 하나는 리지드 바디여야 하고 다른 하나는 트리거여야 합니다.",
  T_48_META_EVT_3010_P0_D: "트리거 이벤트 발생 시점의 상대 엔티티",
  T_48_META_EVT_3011_D: "현재 엔티티가 소멸될 때 트리거됩니다.",
  T_48_META_EVT_3011_P0_D: "공격자 엔티티, null일 수 있음",
  T_48_META_EVT_3011_P1_D: "손상 유형",
  T_48_META_EVT_3011_P2_D: "부상 부위",
  T_48_META_EVT_3012_D: "현재 엔티티가 공격을 받은 후 트리거됩니다.",
  T_48_META_EVT_3012_P0_D: "공격자 엔티티, null일 수 있음",
  T_48_META_EVT_3012_P1_D: "손상 유형",
  T_48_META_EVT_3012_P2_D: "피해 금액",
  T_48_META_EVT_3012_P3_D: "부상 부위",
  T_48_META_EVT_3013_D: "현재 개체가 피해를 입힌 후 발동합니다.",
  T_48_META_EVT_3013_P0_D: "피해를 입은 단체",
  T_48_META_EVT_3013_P1_D: "손상 유형",
  T_48_META_EVT_3013_P2_D: "피해 금액",
  T_48_META_EVT_3013_P3_D: "부상 부위",
  T_48_META_EVT_3014_D: "현재 엔티티가 다른 엔티티를 파괴한 후 트리거됩니다.",
  T_48_META_EVT_3014_P0_D: "제거된 엔터티",
  T_48_META_EVT_3014_P1_D: "부상 부위",
  T_48_META_EVT_3015_D: "이 플레이어가 부활할 때 발동합니다.",
  T_48_META_EVT_3015_P0_D: "플레이어 부활 소스 유형",
  T_48_META_EVT_3016_D: "생성기가 엔티티를 생성할 때 트리거됩니다.",
  T_48_META_EVT_3016_P0_D: "생성된 엔티티 목록",
  T_48_META_EVT_3016_P1_D: "파수",
  T_48_META_EVT_3017_D: "플레이어가 녹아웃 무릎 꿇기 자세를 취할 때 호출됩니다.",
  T_48_META_EVT_3018_D: "모든 팀원이 사망하면 트리거됩니다.",
  T_48_META_EVT_3019_D: "헬멧, 방탄복 또는 배낭을 착용하면 발동됩니다.",
  T_48_META_EVT_3019_P0_D: "장비 ID",
  T_48_META_EVT_3020_D: "주무기, 보조 무기 또는 근접 무기를 들고 있을 때 발동하며, 주먹으로 전환할 때도 발동합니다.",
  T_48_META_EVT_3020_P0_D: "발동 시 장착한 무기 개체",
  T_48_META_EVT_3021_D: "소품 사용 후 트리거되며, 사용하는 데 시간이 필요한 소품은 사용이 완료된 후 이 이벤트가 트리거됩니다.",
  T_48_META_EVT_3021_P0_D: "소품 ID",
  T_48_META_EVT_3021_P1_D: "소품 엔티티, null일 수 있음",
  T_48_META_EVT_3021_P2_D: "소품을 사용하여 생성된 새 소품 엔티티는 비어 있을 수 있습니다.",
  T_48_META_EVT_3022_D: "아이템 획득 시 발동",
  T_48_META_EVT_3022_P0_D: "항목 유형",
  T_48_META_EVT_3022_P1_D: "객체 엔티티, 널일 수 있음",
  T_48_META_EVT_3023_D: "엔티티 포인트가 변경되면 트리거됩니다.",
  T_48_META_EVT_3023_P0_D: "변경 포인트 유형",
  T_48_META_EVT_3023_P1_D: "적분 변경 후 적분 값",
  T_48_META_EVT_3024_D: "엔티티 순위가 변경되면 트리거됩니다.",
  T_48_META_EVT_3024_P0_D: "순위 변경 후 순위",
  T_48_META_EVT_3025_D: "어시스트 시 트리거됨",
  T_48_META_EVT_3025_P0_D: "히트",
  T_48_META_EVT_3026_D: "엔티티가 운전자 및 동승자를 포함하여 차량에 탑승할 때 트리거됩니다.",
  T_48_META_EVT_3026_P0_D: "캐리어에 진입하는 엔티티",
  T_48_META_EVT_3026_P1_D: "통신사 입력",
  T_48_META_EVT_3027_D: "엔티티가 이동 통신사를 떠날 때 트리거됩니다.",
  T_48_META_EVT_3027_P0_D: "이동 통신사를 떠나는 법인",
  T_48_META_EVT_3027_P1_D: "출발 항공사",
  T_48_META_EVT_3028_D: "실제로 캐리어를 운전할 때, 운전자로서 차 안에 있을 때 트리거됩니다.",
  T_48_META_EVT_3028_P0_D: "운송업체를 운영하는 주체",
  T_48_META_EVT_3028_P1_D: "구동 차량",
  T_48_META_EVT_3029_D: "캐리어가 물리적으로 입력되면 트리거됩니다.",
  T_48_META_EVT_3029_P0_D: "트리거 엔티티",
  T_48_META_EVT_3030_D: "이동 통신사가 떠날 때 트리거됩니다.",
  T_48_META_EVT_3030_P0_D: "트리거 엔티티",
  T_48_META_EVT_3031_D: "차량이 엔티티에 의해 운전 중일 때 트리거됩니다.",
  T_48_META_EVT_3031_P0_D: "트리거 엔티티",
  T_48_META_EVT_3032_D: "엔터티가 포털을 사용할 때 텔레포트가 발생한 후 발동됩니다 (폐기, OnBouncesOffTire 사용).",
  T_48_META_EVT_3032_P0_D: "포털을 사용하는 단체",
  T_48_META_EVT_3032_P1_D: "사용 포털",
  T_48_META_EVT_3033_D: "엔티티가 바운스될 때 트리거됩니다.",
  T_48_META_EVT_3033_P0_D: "트리거 엔티티",
  T_48_META_EVT_3033_P1_D: "사용된 바운싱 개체",
  T_48_META_EVT_3034_D: "포털을 통해 엔터티가 순간이동할 수 있게 된 후 트리거됩니다.",
  T_48_META_EVT_3034_P0_D: "전송 엔티티",
  T_48_META_EVT_3035_D: "타이어가 엔티티를 튕긴 후 트리거됩니다.",
  T_48_META_EVT_3035_P0_D: "팝업 엔티티",
  T_48_META_EVT_3036_D: "기계가 엔티티를 비행할 때 트리거됩니다.",
  T_48_META_EVT_3036_P0_D: "노크된 엔티티",
  T_48_META_EVT_3036_P1_D: "기계 생성 개체",
  T_48_META_EVT_3037_D: "엔티티가 트리거에 진입하면 발생합니다.",
  T_48_META_EVT_3037_P0_D: "진입 트리거",
  T_48_META_EVT_3038_D: "엔티티가 트리거를 벗어날 때 발생합니다.",
  T_48_META_EVT_3038_P0_D: "탈퇴 트리거",
  T_48_META_EVT_3039_D: "무기 개체를 획득할 때 발동합니다.",
  T_48_META_EVT_3039_P0_D: "무기 엔티티",
  T_48_META_EVT_3040_D: "엔티티가 기계에 의해 밀려날 때 트리거됩니다.",
  T_48_META_EVT_3040_P0_D: "노크된 엔티티",
  T_48_META_EVT_3040_P1_D: "기계 생성 개체",
  T_48_META_EVT_3041_D: "타깃팅 가능한 엔티티를 타깃팅할 때 트리거됩니다.",
  T_48_META_EVT_3041_P0_D: "대상 엔터티",
  T_48_META_EVT_3042_D: "플레이어의 표적이 되면 트리거됩니다.",
  T_48_META_EVT_3042_P0_D: "플레이어 조준",
  T_48_META_EVT_3043_D: "총알이 목표물에 맞으면 발동",
  T_48_META_EVT_3043_P0_D: "히트",
  T_48_META_EVT_3043_P1_D: "총알 충돌 위치의 세계 좌표",
  T_48_META_EVT_3044_D: "무기에 맞았을 때 발동",
  T_48_META_EVT_3044_P0_D: "무기",
  T_48_META_EVT_3044_P1_D: "히트 영역의 월드 좌표",
  T_48_META_EVT_3045_D: "플레이어가 해당 레벨의 오브젝트로 변신을 선택하면 발동됩니다.",
  T_48_META_EVT_3045_P0_D: "플레이어는 씬 오브젝트 자체가 아닌 엔티티로 변환됩니다.",
  T_48_META_EVT_3046_D: "해당 부활 지점에서 플레이어가 부활할 때 발동합니다.",
  T_48_META_EVT_3046_P0_D: "이 부활 지점에서 부활한 플레이어는 다음과 같습니다.",
  T_48_META_EVT_3047_D: "플레이어가 무기를 버릴 때 발동합니다.",
  T_48_META_EVT_3047_P0_D: "떨어뜨린 무기 개체",
  T_48_META_EVT_3048_D: "플레이어가 무기 이외의 아이템을 버릴 때 발동합니다.",
  T_48_META_EVT_3048_P0_D: "항목 유형",
  T_48_META_EVT_3048_P1_D: "객체 엔티티, 널일 수 있음",
  T_48_META_EVT_3049_D: "축구 총에 맞으면 발동",
  T_48_META_EVT_3049_P0_D: "플레이어",
  T_48_META_EVT_3049_P1_D: "피격 후 속도",
  T_48_META_EVT_3050_D: "축구와 솔리드 간 충돌 시 트리거됨",
  T_48_META_EVT_3050_P0_D: "충돌 개체",
  T_48_META_EVT_3050_P1_D: "충돌 후 속도",
  T_48_META_EVT_3051_D: "플레이어가 음성 채널에 성공적으로 참여하면 트리거됩니다.",
  T_48_META_EVT_3051_P0_D: "음성 채널 엔티티",
  T_48_META_EVT_3052_D: "플레이어가 음성 채널에 참여하지 못할 때 트리거됩니다.",
  T_48_META_EVT_3052_P0_D: "음성 채널 엔티티",
  T_48_META_EVT_3053_D: "플레이어가 음성 채널을 종료할 때 트리거됩니다.",
  T_48_META_EVT_3053_P0_D: "음성 채널 엔티티",
  T_48_META_EVT_3054_D: "공이 골대에 들어가면 트리거됩니다.",
  T_48_META_EVT_3054_P0_D: "골머스",
  T_48_META_EVT_3054_P1_D: "득점자, 골대에 들어가기 전에 마지막으로 공을 터치한 선수",
  T_48_META_EVT_3054_P2_D: "어시스턴트, 골이 득점되기 전에 공을 터치한 두 번째에서 마지막 선수",
  T_48_META_EVT_3055_D: "플레이어가 발사 버튼을 누르면 트리거됩니다.",
  T_48_META_EVT_3056_D: "플레이어가 점프할 때 트리거됩니다.",
  T_48_META_EVT_3057_D: "플레이어가 웅크리면 트리거됩니다.",
  T_48_META_EVT_3058_D: "플레이어가 쓰러지면 트리거됩니다.",
  T_48_META_EVT_3059_D: "플레이어가 전력 질주할 때 트리거됩니다.",
  T_48_META_EVT_3060_D: "상점에서 아이템이 성공적으로 구매되면 트리거됩니다.",
  T_48_META_EVT_3060_P0_D: "상품을 구매한 플레이어",
  T_48_META_EVT_3060_P1_D: "상품",
  T_48_META_EVT_3061_D: "플레이어가 무기를 장착했을 때 발동합니다.",
  T_48_META_EVT_3061_P0_D: "무기를 장착한 플레이어",
  T_48_META_EVT_3062_D: "이 무기로 유닛을 처치하면 발동합니다.",
  T_48_META_EVT_3062_P0_D: "죽인 엔터티",
  T_48_META_EVT_3063_D: "이 무기를 사용하여 유닛에게 피해를 입힐 때 발동합니다.",
  T_48_META_EVT_3063_P0_D: "부상당한 개체",
  T_48_META_EVT_3063_P1_D: "손상 수량",
  T_48_META_EVT_3064_D: "무기가 탄환을 교체할 때 발동합니다.",
  T_48_META_EVT_3065_D: "엔티티가 운전자 또는 승객으로 운송업체에 입장할 때 트리거됩니다.",
  T_48_META_EVT_3065_P0_D: "통신사 입력",
  T_48_META_EVT_3066_D: "엔티티가 이동 통신사를 떠날 때 트리거됩니다.",
  T_48_META_EVT_3066_P0_D: "출발 항공사",
  T_48_META_EVT_3067_D: "캐리어를 물리적으로 운전하는 동안 트리거됨",
  T_48_META_EVT_3067_P0_D: "구동 차량",
  T_48_META_EVT_3068_D: "엔터티가 포털을 사용할 때 텔레포트가 발생한 후 트리거됩니다.",
  T_48_META_EVT_3068_P0_D: "사용 포털",
  T_48_META_EVT_3069_D: "엔티티가 타이어에 의해 튕겨질 때 트리거됩니다.",
  T_48_META_EVT_3069_P0_D: "사용 타이어",
  T_48_META_EVT_3070_D: "엔티티가 기계에 의해 밀려날 때 트리거됩니다.",
  T_48_META_EVT_3070_P0_D: "기계 생성 개체",
  T_48_META_EVT_3071_D: "플레이어가 UI 버튼 컨트롤을 누른 후 트리거됩니다.",
  T_48_META_EVT_3071_P0_D: "트리거 플레이어",
  T_48_META_EVT_3072_D: "UI 버튼 컨트롤을 올리면 트리거됩니다.",
  T_48_META_EVT_3072_P0_D: "트리거 플레이어",
  T_48_META_EVT_3073_D: "플레이어가 UI 버튼 컨트롤을 더블클릭한 후 트리거됩니다.",
  T_48_META_EVT_3073_P0_D: "트리거 플레이어",
  T_48_META_EVT_3074_D: "탈옥 지역 시작",
  T_48_META_EVT_3075_D: "탈옥 구역 폐쇄",
  T_48_META_EVT_3076_D: "플레이어가 수상 스키 사용을 중지하면 트리거됩니다.",
  T_48_META_EVT_3077_D: "플레이어가 UI 입력 상자 컨트롤의 텍스트 콘텐츠를 변경할 때 트리거됩니다.",
  T_48_META_EVT_3077_P0_D: "트리거 플레이어",
  T_48_META_EVT_3077_P1_D: "변경된 텍스트 콘텐츠",
  T_48_META_EVT_3078_D: "플레이 가능한 엔티티가 플레이를 시작할 때 트리거됩니다.",
  T_48_META_EVT_3078_P0_D: "플레이 가능한 엔티티",
  T_48_META_EVT_3079_D: "재생 가능한 엔티티가 재생을 완료할 때 트리거되는 이 이벤트는 재생 가능한 엔티티가 사운드, 효과 등의 엔티티인 경우에만 클라이언트 측에서 작동합니다.",
  T_48_META_EVT_3079_P0_D: "플레이 가능한 엔티티",
  T_48_META_EVT_3080_D: "플레이 가능한 엔티티가 계속 플레이할 때 트리거됩니다.",
  T_48_META_EVT_3080_P0_D: "플레이 가능한 엔티티",
  T_48_META_EVT_3081_D: "재생 가능한 엔티티가 재생을 일시 중지할 때 트리거됩니다.",
  T_48_META_EVT_3081_P0_D: "플레이 가능한 엔티티",
  T_48_META_EVT_3082_D: "탈옥 플레이어 가입",
  T_48_META_EVT_3082_P0_D: "트리거 플레이어",
  T_48_META_EVT_3083_D: "탈옥 플레이어 탈퇴",
  T_48_META_EVT_3083_P0_D: "트리거 플레이어",
  T_48_META_EVT_3084_D: "카운트다운이 끝나면 트리거됩니다.",
  T_48_META_EVT_3084_P0_D: "계열사",
  T_48_META_EVT_3085_D: "아이템 수령 시 트리거됨",
  T_48_META_EVT_3085_P0_D: "아이템을 획득한 플레이어",
  T_48_META_EVT_3086_D: "아이템이 폐기될 때 트리거됩니다.",
  T_48_META_EVT_3086_P0_D: "아이템을 떨어뜨린 플레이어",
  T_48_META_EVT_3087_D: "이 아이템 착용 시 발동",
  T_48_META_EVT_3088_D: "지뢰 생성 후 오브젝트가 시작될 때 트리거됩니다.",
  T_48_META_EVT_3089_D: "지뢰가 생성된 후 오브젝트가 트리거될 때 트리거됩니다.",
  T_48_META_EVT_3089_P0_D: "지뢰 생성 후 오브젝트 타겟팅이 트리거된 경우",
  T_48_META_EVT_3090_D: "상점에서 아이템을 구매하기 전에 트리거됩니다.",
  T_48_META_EVT_3090_P0_D: "상품을 구매한 플레이어",
  T_48_META_EVT_3090_P1_D: "상품",
  T_48_META_EVT_3091_D: "이 장치를 사용할 때 트리거됩니다.",
  T_48_META_EVT_3092_D: "후크락 건이 발사되면 발동됩니다.",
  T_48_META_EVT_3093_D: "발사체가 던져진 후 폭발하면 발동합니다.",
  T_48_META_EVT_3093_P0_D: "폭발 지점",
  T_48_META_EVT_3094_D: "페인트볼 총에 맞으면 발동합니다.",
  T_48_META_EVT_3094_P0_D: "페인트 스프레이 건 개체",
  T_48_META_EVT_3094_P1_D: "적중 포인트",
  T_48_META_EVT_3094_P2_D: "목표 라인 맞추기",
  T_48_META_EVT_3095_D: "페인트 건으로 타격 시 발동",
  T_48_META_EVT_3095_P0_D: "히트 객체",
  T_48_META_EVT_3095_P1_D: "적중 포인트",
  T_48_META_EVT_3095_P2_D: "목표 라인 맞추기",
  T_48_META_EVT_3096_D: "캐리어 또는 염료 버킷이 폭발할 때 트리거됩니다.",
  T_48_META_EVT_3096_P0_D: "폭발을 일으킨 플레이어",
  T_48_META_EVT_3096_P1_D: "폭발의 영향을 받은 플레이어 목록",
  T_48_META_EVT_3097_D: "무기 발사가 중지되면 발동합니다.",
  T_48_META_EVT_3097_P0_D: "정전 시점의 현재 탄창 용량",
  T_48_META_EVT_3098_D: "추적 대상이 추적 범위 내에 들어올 때 발동합니다.",
  T_48_META_EVT_3099_D: "추적 대상이 추적 범위를 벗어날 때 발동합니다.",
  T_48_META_EVT_31_D: "장면 전환 성공 시 트리거됨",
  T_48_META_EVT_31_P0_D: "장면 이름",
  T_48_META_EVT_3100_D: "공격 대상이 공격 범위 내에 들어올 때 발동합니다.",
  T_48_META_EVT_3101_D: "공격 대상이 사거리를 벗어났을 때 발동합니다.",
  T_48_META_EVT_3102_D: "클라이언트 클릭 이벤트에 의해 카메라 광선 감지가 트리거될 때 트리거됩니다.",
  T_48_META_EVT_3102_P0_D: "트리거 플레이어",
  T_48_META_EVT_3102_P1_D: "카메라 광선이 오브젝트에 닿는지 여부",
  T_48_META_EVT_3102_P2_D: "카메라 광선 히트 위치",
  T_48_META_EVT_3102_P3_D: "클라이언트 카메라 방향",
  T_48_META_EVT_3102_P4_D: "클라이언트 카메라 위치",
  T_48_META_EVT_3102_P5_D: "목표물 명중",
  T_48_META_EVT_3103_D: "상점 화면이 열리면 트리거됩니다.",
  T_48_META_EVT_3103_P0_D: "트리거 플레이어",
  T_48_META_EVT_3104_D: "상점 화면이 닫히면 트리거됩니다.",
  T_48_META_EVT_3104_P0_D: "트리거 플레이어",
  T_48_META_EVT_3105_D: "동작 트리 로직이 노드에 진입할 때 트리거됩니다.",
  T_48_META_EVT_3105_P0_D: "노드 이름",
  T_48_META_EVT_3105_P1_D: "계열사",
  T_48_META_EVT_3106_D: "동작 트리 로직이 노드를 종료할 때 트리거됩니다.",
  T_48_META_EVT_3106_P0_D: "노드 이름",
  T_48_META_EVT_3106_P1_D: "계열사",
  T_48_META_EVT_3107_D: "강체 각성 시 발동합니다.",
  T_48_META_EVT_3108_D: "리지드 바디가 잠들 때 트리거됩니다.",
  T_48_META_EVT_3109_D: "플레이어가 움직일 때 트리거됩니다.",
  T_48_META_EVT_3109_P0_D: "서곡",
  T_48_META_EVT_3110_D: "플레이어가 대기 상태일 때 트리거됩니다.",
  T_48_META_EVT_3110_P0_D: "서곡",
  T_48_META_EVT_3111_D: "플레이어가 스킬을 사용할 때 발동됩니다.",
  T_48_META_EVT_3111_P0_D: "사용 기술",
  T_48_META_EVT_3112_D: "플레이어가 전력 질주를 완료하면 발동됩니다.",
  T_48_META_EVT_3113_D: "SwitchEquipSlot 열거형 아래의 슬롯에 해당하는 아이템을 획득하면 트리거됩니다.",
  T_48_META_EVT_3113_P0_D: "획득한 아이템 엔티티",
  T_48_META_EVT_3114_D: "주먹으로 전환할 때를 포함하여 휴대용 아이템을 전환할 때 트리거됩니다.",
  T_48_META_EVT_3114_P0_D: "전환 후 보유한 항목 엔티티",
  T_48_META_EVT_3115_D: "상점에 있는 플레이어가 다른 플레이어에게 아이템 구매를 요청할 때 트리거됩니다.",
  T_48_META_EVT_3115_P0_D: "상품을 요청하는 플레이어",
  T_48_META_EVT_3115_P1_D: "상품",
  T_48_META_EVT_3116_D: "상점에 있는 플레이어가 아이템을 요청하고 요청이 수락되면 트리거됩니다.",
  T_48_META_EVT_3116_P0_D: "구매한 플레이어를 위한 도움말",
  T_48_META_EVT_3116_P1_D: "구매 관련 도움을 요청하는 플레이어",
  T_48_META_EVT_3116_P2_D: "상품",
  T_48_META_EVT_3117_D: "초당 30회의 고정된 빈도로 고정 프레임 업데이트 시 트리거됩니다.",
  T_48_META_EVT_3118_D: "게임 일시정지 API 호출 후 트리거됩니다.",
  T_48_META_EVT_3119_D: "게임 복원 API 호출 후 트리거됩니다.",
  T_48_META_EVT_3120_D: "플레이어가 친구를 추가하거나 삭제할 때 트리거됩니다.",
  T_48_META_EVT_3121_D: "페르소나 메시지 수신 시 트리거됨",
  T_48_META_EVT_3121_P0_D: "정보 콘텐츠",
  T_48_META_EVT_3121_P1_D: "발신자 페르소나",
  T_48_META_EVT_3122_D: "플레이어의 점프가 끝날 때 트리거됩니다.",
  T_48_META_EVT_3123_D: "플레이어가 넘어지면 트리거됩니다.",
  T_48_META_EVT_3124_D: "플레이어의 낙하가 끝날 때 발동합니다.",
  T_48_META_EVT_3125_D: "페르소나 동작 수신 시 트리거됨",
  T_48_META_EVT_3125_P0_D: "행동",
  T_48_META_EVT_3125_P1_D: "발신자 페르소나",
  T_48_META_EVT_3126_D: "회원 정보 변경 시 트리거",
  T_48_META_EVT_3126_P0_D: "회원의 변경된 상태",
  T_48_META_EVT_3127_D: "회원 센터에 입장할 때 트리거됩니다.",
  T_48_META_EVT_3128_D: "회원 센터를 떠날 때 트리거됨",
  T_48_META_EVT_3129_D: "플레이어가 넉다운 상태에 진입하면 트리거됩니다.",
  T_48_META_EVT_3129_P0_D: "공격자 엔티티, null일 수 있음",
  T_48_META_EVT_3130_D: "페르소나 상태가 수신되면 트리거됩니다.",
  T_48_META_EVT_3130_P0_D: "발신자 페르소나",
  T_48_META_EVT_3130_P1_D: "오류 코드",
  T_48_META_EVT_3131_D: "UI를 통해 페르소나에게 메시지를 보낼 때 트리거됩니다.",
  T_48_META_EVT_3131_P0_D: "정보 콘텐츠",
  T_48_META_EVT_3131_P1_D: "발신자 페르소나",
  T_48_META_EVT_3132_D: "페르소나 수신이 끝날 때 트리거됩니다.",
  T_48_META_EVT_3132_P0_D: "발신자 페르소나",
  T_48_META_EVT_3132_P1_D: "오류 코드",
  T_48_META_EVT_32_D: "플레이어가 장면을 전환할 때 트리거됩니다.",
  T_48_META_EVT_32_P0_D: "장면 이름",
  T_48_META_EVT_3200_D: "애니메이션 클립 재생이 완료되면 트리거됩니다.",
  T_48_META_EVT_3200_P0_D: "애니메이션 세그먼트의 이름",
  T_48_META_EVT_3201_D: "애니메이션 상태 재생이 완료되면 트리거됩니다.",
  T_48_META_EVT_3201_P0_D: "애니메이션 상태 이름",
  T_48_META_EVT_3204_D: "토글 컨트롤의 상태가 변경되면 트리거됩니다.",
  T_48_META_EVT_3204_P0_D: "트리거 플레이어",
  T_48_META_EVT_3204_P1_D: "업무 상태",
  T_48_META_EVT_3260_D: "플레이어가 터치패드를 누르면 트리거됩니다.",
  T_48_META_EVT_3260_P0_D: "트리거 플레이어",
  T_48_META_EVT_3260_P1_D: "프레스 위치",
  T_48_META_EVT_3261_D: "터치패드를 올리면 트리거됨",
  T_48_META_EVT_3261_P0_D: "트리거 플레이어",
  T_48_META_EVT_3261_P1_D: "리프트 위치",
  T_48_META_EVT_3262_D: "터치패드가 미끄러지기 시작하면 트리거됩니다.",
  T_48_META_EVT_3262_P0_D: "트리거 플레이어",
  T_48_META_EVT_3262_P1_D: "슬라이드 시작 위치",
  T_48_META_EVT_3263_D: "터치패드 슬라이드에서 트리거되는 이 이벤트는 슬라이드가 진행되는 동안 프레임당 한 번씩 트리거됩니다.",
  T_48_META_EVT_3263_P0_D: "트리거 플레이어",
  T_48_META_EVT_3263_P1_D: "슬라이드 시작 위치",
  T_48_META_EVT_3263_P2_D: "변위",
  T_48_META_EVT_3264_D: "터치패드 슬라이드 끝에서 트리거됨",
  T_48_META_EVT_3264_P0_D: "트리거 플레이어",
  T_48_META_EVT_3264_P1_D: "슬라이드 끝 위치",
  T_48_META_EVT_3265_D: "조이스틱을 누르면 트리거됨",
  T_48_META_EVT_3265_P0_D: "트리거 플레이어",
  T_48_META_EVT_3266_D: "조이스틱을 올리면 트리거됨",
  T_48_META_EVT_3266_P0_D: "트리거 플레이어",
  T_48_META_EVT_3267_D: "조이스틱 조이스틱을 사용할 때 트리거됩니다.",
  T_48_META_EVT_3267_P0_D: "트리거 플레이어",
  T_48_META_EVT_3267_P1_D: "출력 변위",
  T_48_META_EVT_3268_D: "플레이어가 다른 자세에서 일어날 때 트리거됩니다.",
  T_48_META_EVT_3268_P0_D: "일어서기 전 플레이어의 자세",
  T_48_META_EVT_3269_D: "무기 발사 시 발동합니다.",
  T_48_META_EVT_4_D: "매 턴 시작 시 발동",
  T_48_META_EVT_4_P0_D: "라운드 인덱스, 0부터 카운트",
  T_48_META_EVT_5_D: "매 턴 종료 시 발동",
  T_48_META_EVT_5_P0_D: "라운드 인덱스, 0부터 카운트",
  T_48_META_EVT_6_D: "엔티티가 충돌했을 때 트리거되며, 리지드 바디 컴포넌트가 장착된 엔티티에서만 지원됩니다.",
  T_48_META_EVT_6_P0_D: "발생하는 엔티티",
  T_48_META_EVT_7_D: "각 단계가 시작될 때 트리거됩니다.",
  T_48_META_EVT_7_P0_D: "단계 엔티티",
  T_48_META_EVT_8_D: "각 단계가 끝날 때 트리거됩니다.",
  T_48_META_EVT_8_P0_D: "단계 엔티티",
  T_48_META_EVT_9_D: "엔티티 충돌이 끝날 때 트리거되며, 리지드 바디 컴포넌트가 장착된 엔티티에서만 지원됩니다.",
  T_48_META_EVT_9_P0_D: "발생하는 엔티티",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
